import type { AppTranslations } from './types'

export const it = {
  amenities: {
    categories: {
      culture: 'Cultura e intrattenimento',
      dining: 'Ristorazione',
      education: 'Istruzione',
      grocery: 'Alimentari',
      healthcare: 'Sanità',
      services: 'Servizi essenziali',
      shopping: 'Shopping',
      transport: 'Trasporti',
      wellness: 'Benessere',
    },
    categoryCard: {
      clearFilters: 'Cancella filtri',
      moreSubcategories: '+{{count}} altri',
      noAmenities: 'Nessun servizio trovato in questa categoria',
      noMatchingFilters: 'Nessun servizio corrisponde ai filtri attuali',
      showAll: 'Mostra tutti i {{count}} restanti',
      showingItems: 'Mostrando {{count}} di {{total}} elementi',
      showMore: 'Mostra altri 10 ({{count}} rimanenti)',
    },
    error: {
      retry: 'Riprova',
      title: 'Impossibile caricare i dati dei servizi',
    },
    livabilityScore: 'Punteggio di vivibilità',
    loading: {
      description: 'Analisi dei punti di interesse nelle vicinanze e calcolo del punteggio di vivibilità',
      title: 'Caricamento dati servizi...',
    },
    noData: 'Nessun dato sui servizi disponibile',
    pointsOfInterest: 'Punti di interesse',
    poiTypes: {
      adult_gaming_centre: 'Sala giochi per adulti',
      alcohol: 'Enoteca',
      amusement_arcade: 'Sala giochi',
      anime: 'Negozio anime',
      antiques: 'Antiquariato',
      appliance: 'Elettrodomestici',
      aquarium: 'Acquario',
      art: "Negozio d'arte",
      art_culture: 'Arte e cultura',
      art_music_hobbies: 'Arte, musica e hobby',
      arts_centre: 'Centro culturale',
      atm: 'Bancomat',
      atv: 'Negozio quad',
      baby_goods: 'Articoli per neonati',
      bag: 'Pelletteria',
      bakery: 'Panetteria',
      bandstand: 'Palco',
      bank: 'Banca',
      bar: 'Bar',
      bathroom_furnishing: 'Arredo bagno',
      beauty: 'Salone di bellezza',
      bed: 'Negozio letti',
      beverages: 'Bevande',
      bicycle: 'Negozio biciclette',
      biergarten: "Birreria all'aperto",
      boat: 'Negozio nautica',
      boat_stop: 'Imbarcadero',
      bookmaker: 'Scommesse',
      books: 'Libreria',
      books_gifts: 'Libri e regali',
      boutique: 'Boutique',
      bowling_alley: 'Bowling',
      brewing_supplies: 'Forniture birra',
      bus_stop: "Fermata dell'autobus",
      butcher: 'Macelleria',
      cable_car_stop: 'Fermata della funivia',
      cafe: 'Caffè',
      camera: 'Negozio fotografia',
      candles: 'Negozio candele',
      cannabis: 'Negozio cannabis',
      car: 'Concessionario auto',
      car_parts: 'Ricambi auto',
      car_repair: 'Officina auto',
      carpet: 'Negozio tappeti',
      casino: 'Casinò',
      cheese: 'Formaggeria',
      chemist: 'Drogheria',
      chocolate: 'Cioccolateria',
      cinema: 'Cinema',
      climbing: 'Arrampicata',
      clinic: 'Clinica',
      clothes: 'Negozio abbigliamento',
      clothing: 'Abbigliamento',
      coffee: 'Caffetteria',
      collector: 'Negozio collezionismo',
      college: 'Collegio',
      community_centre: 'Centro comunitario',
      computer: 'Negozio computer',
      confectionery: 'Pasticceria',
      convenience: 'Minimarket',
      copyshop: 'Copisteria',
      cosmetics: 'Cosmetici',
      craft: 'Negozio hobbistica',
      curtain: 'Negozio tende',
      dairy: 'Latteria',
      dance: 'Danza',
      deli: 'Gastronomia',
      dentist: 'Dentista',
      department_store: 'Grande magazzino',
      doctor: 'Medico',
      doityourself: 'Fai da te',
      doors: 'Negozio porte',
      dry_cleaning: 'Lavanderia',
      'e-cigarette': 'Sigaretta elettronica',
      electrical: 'Negozio elettrico',
      electronics: 'Elettronica',
      energy: 'Negozio energia',
      escape_game: 'Escape room',
      fabric: 'Negozio tessuti',
      farm: 'Negozio agricolo',
      fashion: 'Moda',
      fast_food: 'Fast food',
      financial: 'Servizi finanziari',
      fireplace: 'Negozio camini',
      fishing: 'Negozio pesca',
      fitness_centre: 'Palestra',
      flooring: 'Pavimenti',
      florist: 'Fiorista',
      food_court: 'Area ristoro',
      frame: 'Cornici',
      free_flying: 'Volo libero',
      frozen_food: 'Surgelati',
      fuel: 'Distributore',
      fuel_station: 'Stazione di servizio',
      funeral_directors: 'Onoranze funebri',
      furniture: 'Negozio mobili',
      gallery: 'Galleria',
      games: 'Negozio giochi',
      garden_centre: 'Garden center',
      garden_furniture: 'Arredo giardino',
      general: 'Negozio generale',
      gift: 'Negozio regali',
      golf_course: 'Campo da golf',
      greengrocer: 'Fruttivendolo',
      hairdresser: 'Parrucchiere',
      hairdresser_supply: 'Forniture parrucchiere',
      hardware: 'Ferramenta',
      health_beauty_store: 'Negozio di salute e bellezza',
      health_food: 'Alimenti biologici',
      hearing_aids: 'Apparecchi acustici',
      herbalist: 'Erboristeria',
      hifi: 'Negozio hi-fi',
      horse_riding: 'Equitazione',
      hospital: 'Ospedale',
      hospital_clinic: 'Ospedale e clinica',
      houseware: 'Casalinghi',
      hunting: 'Negozio caccia',
      ice_cream: 'Gelateria',
      ice_rink: 'Pista di pattinaggio',
      interior_decoration: 'Arredamento',
      jetski: "Moto d'acqua",
      jewelry: 'Gioielleria',
      kindergarten: 'Asilo',
      kiosk: 'Edicola',
      kitchen: 'Negozio cucine',
      lamps: 'Negozio lampade',
      laundry: 'Lavanderia',
      leather: 'Pelletteria',
      leisure_tourism: 'Tempo libero e turismo',
      library: 'Biblioteca',
      locksmith: 'Fabbro',
      lottery: 'Lotteria',
      mall: 'Centro commerciale',
      massage: 'Massaggi',
      medical_supply: 'Forniture mediche',
      metro_station: 'Stazione della metropolitana',
      miniature_golf: 'Minigolf',
      mobile_phone: 'Negozio telefonia',
      model: 'Modellismo',
      money_lender: 'Prestiti',
      motorcycle: 'Negozio moto',
      museum: 'Museo',
      music: 'Negozio musica',
      music_school: 'Scuola di musica',
      musical_instrument: 'Strumenti musicali',
      newsagent: 'Edicola',
      nightclub: 'Discoteca',
      nutrition_supplements: 'Integratori',
      optician: 'Ottico',
      organic: 'Negozio biologico',
      other_sport: 'Altro sport',
      outdoor: 'Negozio outdoor',
      outdoors_sport_vehicles: 'Attività all’aperto, sport e veicoli',
      paint: 'Negozio vernici',
      park: 'Parco',
      park_forest: 'Parco e bosco',
      party: 'Articoli per feste',
      pasta: 'Pastificio',
      pastry: 'Pasticceria',
      perfumery: 'Profumeria',
      pet: 'Negozio animali',
      pharmacy: 'Farmacia',
      photo: 'Fotografia',
      picnic_site: 'Area picnic',
      pitch: 'Campo sportivo',
      planetarium: 'Planetario',
      plant_flower: 'Piante e fiori',
      playground: 'Parco giochi',
      post_box: 'Cassetta postale',
      post_office: 'Ufficio postale',
      pub: 'Pub',
      pyrotechnics: "Fuochi d'artificio",
      radiotechnics: 'Radiotecnica',
      recycling: 'Punto raccolta',
      religion: 'Articoli religiosi',
      restaurant: 'Ristorante',
      robot: 'Negozio robot',
      running: 'Pista corsa',
      sailing: 'Vela',
      school: 'Scuola',
      scuba_diving: 'Subacquea',
      seafood: 'Pescheria',
      second_hand: 'Usato',
      security: 'Sicurezza',
      sewing: 'Merceria',
      shoes: 'Negozio scarpe',
      shooting: 'Poligono di tiro',
      shopping_others: 'Altri negozi',
      skateboard: 'Skateboard',
      ski: 'Negozio sci',
      snowmobile: 'Motoslitta',
      social_centre: 'Centro sociale',
      specialty_food: 'Negozio di specialità alimentari',
      spices: 'Spezie',
      sport_centre: 'Centro sportivo',
      sports: 'Negozio sport',
      sports_centre: 'Centro sportivo',
      stadium: 'Stadio',
      station: 'Stazione',
      stationery: 'Cartoleria',
      subway_entrance: 'Ingresso metro',
      supermarket: 'Supermercato',
      swimming: 'Nuoto',
      swimming_area: 'Area nuoto',
      swimming_pool: 'Piscina',
      tailor: 'Sarto',
      tattoo: 'Tatuaggi',
      tea: 'Negozio tè',
      theatre: 'Teatro',
      theme_park: 'Parco divertimenti',
      ticket: 'Biglietteria',
      tobacco: 'Tabaccheria',
      toys: 'Negozio giocattoli',
      trade: 'Commercio',
      train_station: 'Stazione ferroviaria',
      tram_stop: 'Fermata del tram',
      travel_agency: 'Agenzia viaggi',
      trophy: 'Trofei',
      tyres: 'Gomme',
      university: 'Università',
      vacant: 'Vuoto',
      vacuum_cleaner: 'Aspirapolvere',
      variety_store: 'Emporio',
      video: 'Videoteca',
      video_games: 'Videogiochi',
      watches: 'Orologeria',
      water: 'Acqua',
      weapons: 'Armeria',
      wholesale: 'Ingrosso',
      wine: 'Enoteca',
      wood: 'Legname',
      zoo: 'Zoo',
    },
    radius: 'Raggio',
    sources: {
      googlePlaces: 'Google Places',
      label: 'Fonti:',
      openStreetMap: 'OpenStreetMap',
      swissFederalStatisticalOffice: 'Ufficio federale di statistica',
    },
    subcategories: {
      'Art & Culture': 'Arte e cultura',
      'Art, music, hobbies': 'Arte, musica, hobby',
      Bar: 'Bar',
      'Bus & Subway': 'Bus e metro',
      Cafe: 'Caffè',
      'Clothing, shoes, accessories': 'Abbigliamento, scarpe, accessori',
      Convenience: 'Minimarket',
      Dentist: 'Dentista',
      Doctor: 'Medico',
      Electronics: 'Elettronica',
      Financial: 'Servizi finanziari',
      'Fuel Station': 'Stazione di servizio',
      'Furniture and interior': 'Mobili e arredamento',
      'Health and beauty': 'Salute e bellezza',
      'Hospital & Clinic': 'Ospedale e clinica',
      Kindergarten: 'Asilo',
      'Leisure & Tourism': 'Tempo libero e turismo',
      Mall: 'Centro commerciale',
      'Other Sport': 'Altri sport',
      Others: 'Altri',
      'Outdoor activity': "Attività all'aperto",
      'Outdoors and sport, vehicles': 'Outdoor, sport e veicoli',
      'Park and Forest': 'Parco e foresta',
      Pharmacy: 'Farmacia',
      Pitch: 'Campo sportivo',
      'Plant and flower': 'Piante e fiori',
      Playground: 'Parco giochi',
      'Public Utility': 'Servizi pubblici',
      'Railway Station': 'Stazione ferroviaria',
      Restaurant: 'Ristorante',
      School: 'Scuola',
      'Specialty food store': 'Negozio specializzato',
      'Sport Centre': 'Centro sportivo',
      'Stationery, gifts, books, newspapers': 'Cartoleria, regali, libri, giornali',
      Supermarket: 'Supermercato',
      Swimming: 'Nuoto',
      University: 'Università',
    },
    subtitle: 'Analisi dei servizi locali e dei punti di interesse',
    title: 'Servizi',
    transitModes: {
      BOAT: 'Battello',
      BUS: 'Bus',
      CABLE_CAR: 'Funivia',
      CABLE_RAILWAY: 'Funicolare',
      CHAIRLIFT: 'Seggiovia',
      METRO: 'Metro',
      RACK_RAILWAY: 'Ferrovia a cremagliera',
      TRAIN: 'Treno',
      TRAM: 'Tram',
    },
    walkTime: 'Tempo di percorrenza',
  },
  buildingAnalysis: {
    amenities: {
      loading: 'Caricamento servizi...',
      other_category: 'Altro',
      unknown_amenity: 'Sconosciuto',
    },
    building_title: 'Edificio {{egid}}',
    built_year: 'Costruito nel {{year}}',
    enums: {
      buildingCategory: {
        "Bâtiment d'habitation avec usage annexe": 'Edificio abitativo con utilizzazione accessoria',
        "Bâtiment exclusivement à usage d'habitation": 'Edificio ad uso esclusivamente abitativo',
        "Bâtiment partiellement à usage d'habitation": 'Edificio ad uso parzialmente abitativo',
        "Bâtiment sans usage d'habitation": 'Edificio ad uso non abitativo',
        'Construction particulière': 'Costruzione speciale',
        'Habitation provisoire': 'Abitazione provvisoria',
      },
      buildingClass: {
        'Autre bâtiment non classé ailleurs': 'Altri edifici',
        "Autres bâtiments d'exploitation agricole": 'Altri fabbricati rurali non residenziali',
        "Autres bâtiments d'hébergement de tourisme": 'Altri edifici per abitazione di breve durata',
        "Autres bâtiments pour l'hébergement collectif": 'Altri edifici che ospitano collettività',
        "Bâtiment d'exploitation agricole": 'Fabbricati rurali non residenziali',
        'Bâtiment industriel': 'Fabbricati industriali',
        'Bâtiments commerciaux': 'Fabbricati per il commercio',
        "Bâtiments pour la garde d'animaux": 'Edifici per la tenuta di animali',
        'Bâtiments pour les cultures végétales': 'Edifici per le colture vegetali',
        Garage: 'Fabbricati per garage',
        'Gares, aérogares, centraux téléphoniques': 'Stazioni, terminal, centrali telefoniche',
        'Habitat communautaire': 'Residenze per collettività',
        'Hôpital et établissement de santé': 'Edifici per fini ospedalieri e di assistenza sociale',
        'Immeuble à trois logements et plus': 'Edificio a tre e più abitazioni',
        'Maison à deux logements': 'Edificio a due abitazioni',
        'Maison individuelle': 'Casa unifamiliare',
        'Monument historique ou classé': 'Monumenti storici o protetti',
        'Réservoir, silo et entrepôt': 'Serbatoi, silos e depositi',
        'Salle de sport': 'Sale sportive',
        'Salles de tir': 'Sale per il tiro',
      },
      buildingStatus: {
        autorisé: 'Autorizzato',
        démoli: 'Demolito',
        'en construction': 'In costruzione',
        existant: 'Esistente',
        inutilisable: 'Inutilizzabile',
        'non réalisé': 'Non realizzato',
        projeté: 'In progetto',
      },
    },
    environment: {
      loading: 'Caricamento dati ambientali...',
      noise_levels: {
        moderate: 'Moderato',
        noisy: 'Rumoroso',
        quiet: 'Silenzioso',
        very_noisy: 'Molto rumoroso',
        very_quiet: 'Molto silenzioso',
      },
      sunlight_ratings: {
        excellent: 'Eccellente',
        fair: 'Discreto',
        good: 'Buono',
        poor: 'Scarso',
      },
    },
    error_loading_data: 'Errore nel caricamento dei dati',
    feasibility: {
      considerations: {
        excellent_transport: "Eccellente accesso ai trasporti pubblici ({{quality}}) aumenta il valore dell'immobile",
        high_energy: "L'alto consumo energetico potrebbe scoraggiare gli acquirenti attenti all'ambiente",
        minergie: 'La certificazione Minergie indica costi operativi inferiori',
        moderate_age: "Età moderata dell'edificio ({{age}} anni) potrebbe richiedere miglioramenti graduali",
        multiple_owners: 'Più proprietari ({{count}}) potrebbero complicare il processo decisionale',
        old_building: "L'età dell'edificio ({{age}} anni) potrebbe richiedere un investimento significativo in ristrutturazione",
        protected_status: 'Lo stato protetto può limitare le opzioni di ristrutturazione ma preservare il valore',
        recent_activity: "L'attività di transazione recente indica una sana domanda di mercato",
        solar_potential: 'Un significativo potenziale solare ({{area}}m²) può compensare i costi energetici',
        title: 'Considerazioni chiave',
      },
      financial: {
        appreciation: {
          description: 'Potenziale di crescita del valore a lungo termine basato su fattori di localizzazione e mercato',
          label: 'Potenziale di apprezzamento del valore',
        },
        capital: {
          description: "Costi di ristrutturazione e miglioramento previsti in base alle condizioni dell'edificio",
          label: 'Requisiti di capitale',
        },
        complexity: {
          description: 'Complessità delle transazioni e del processo decisionale basata sulla struttura proprietaria',
          label: "Complessità dell'investimento",
        },
        operating: {
          description: 'Costi energetici e di manutenzione continui basati sugli standard di efficienza',
          label: 'Costi operativi',
        },
        title: 'Indicatori di fattibilità finanziaria',
      },
      metrics: {
        building_age: {
          built_in: 'Costruito nel {{year}}',
          title: "Età dell'edificio",
          tooltip: {
            calculation: 'Anno corrente meno anno di costruzione',
            description: "Età dell'edificio dalla costruzione originale",
            importance: "Influisce sulle esigenze di ristrutturazione, le preoccupazioni strutturali e la tempistica dell'investimento",
            limitations: 'Non riflette ricostruzioni importanti o miglioramenti',
            source: 'Registro federale degli edifici (REA)',
            title: "Valutazione dell'età dell'edificio",
          },
          value: '{{years}} anni',
        },
        market_activity: {
          last_transaction: 'Ultima transazione: {{year}}',
          title: 'Attività di mercato',
          tooltip: {
            calculation: 'Conteggio delle transazioni recenti e degli annunci attivi',
            description: 'Transazioni recenti e attività di annunci',
            importance: "Indica la liquidità del mercato e l'interesse degli investitori",
            limitations: "Dati storici, non predittivi dell'attività futura",
            source: 'Database di transazioni e annunci',
            title: 'Attività di mercato recente',
          },
          value: '{{count}} annunci',
        },
        ownership: {
          breakdown: '{{private}} privati, {{public}} pubblici',
          title: 'Struttura proprietaria',
          tooltip: {
            calculation: 'Numero di proprietari terrieri registrati',
            description: 'Numero e tipo di proprietari',
            importance: 'Influisce sulla complessità decisionale e sui processi di transazione',
            limitations: 'Basato sul catasto, potrebbe non riflettere tutti gli stakeholder',
            source: 'Registro fondiario svizzero',
            title: 'Complessità della proprietà',
          },
          value: '{{count}} proprietario',
          value_plural: '{{count}} proprietari',
        },
        renovation: {
          no_renovation: 'Nessuna ristrutturazione',
          renovated_in: 'Ristrutturato nel {{year}}',
          title: 'Stato di ristrutturazione',
          tooltip: {
            calculation: "Anni dall'ultima ristrutturazione registrata",
            description: "Tempo dall'ultima ristrutturazione importante",
            importance: 'Indica le esigenze di manutenzione e i potenziali requisiti di investimento',
            limitations: 'Basato su registri ufficiali, potrebbe non includere miglioramenti minori',
            source: 'Registro federale degli edifici (REA)',
            title: 'Cronologia di ristrutturazione',
          },
          value: '{{years}} anni fa',
        },
      },
      no_data: 'Non sono disponibili dati dello studio di fattibilità per questo edificio.',
      risk_assessment: {
        energy: {
          description: 'Rischio di non conformità agli standard energetici. Potrebbe richiedere aggiornamenti per soddisfare le normative attuali.',
          title: 'Rischio di conformità energetica',
        },
        market: {
          description: 'Indicatori di liquidità e domanda del mercato. Un rischio inferiore suggerisce migliori opportunità di uscita.',
          title: 'Rischio di mercato',
        },
        renovation: {
          description: "Valutazione delle esigenze di ristrutturazione basata sull'età e sulla storia della manutenzione. Un rischio più alto indica maggiori requisiti di capitale.",
          title: 'Rischio di ristrutturazione',
        },
        structural: {
          description: "Basato sull'età dell'edificio e sugli indicatori strutturali. Gli edifici più vecchi potrebbero richiedere valutazioni strutturali più approfondite.",
          title: 'Rischio strutturale',
        },
        title: 'Valutazione dei rischi',
      },
      risk_levels: {
        high: 'Rischio alto',
        low: 'Rischio basso',
        medium: 'Rischio moderato',
      },
      subtitle: "Fattibilità dell'investimento e valutazione dei rischi",
      title: 'Studio di fattibilità',
      values: {
        high: 'Alto',
        low: 'Basso',
        moderate: 'Moderato',
        variable: 'Variabile',
      },
    },
    history: {
      empty_state: {
        no_data: {
          description: 'Nessun evento storico o dato cronologico disponibile per questo edificio. Ciò potrebbe essere dovuto a registri limitati o a una costruzione recente.',
          title: 'Nessun dato storico disponibile',
        },
        no_matches: {
          description: 'Prova a regolare i filtri per vedere più eventi storici.',
          title: 'Nessun evento corrisponde ai tuoi filtri',
        },
      },
      events: {
        building_permit: 'Permesso di costruzione',
        for_rent: '{{propertyType}} in locazione',
        for_sale: '{{propertyType}} in vendita',
        property_transaction: 'Transazione immobiliare',
        rental_listing: 'Annuncio di locazione',
        sale_listing: 'Annuncio di vendita',
      },
      filters: {
        building_permits: 'Permessi di costruzione',
        rentals: 'Locazioni',
        sales: 'Vendite',
        transactions: 'Transazioni',
      },
      labels: {
        online_days: 'Online {{count}} giorni',
        owner: 'Proprietario: {{name}}',
        participants: '{{count}} partecipanti',
        permit_number: 'Permesso n. {{number}}',
        properties_one: '{{count}} proprietà',
        properties_other: '{{count}} proprietà',
        status_active: 'Attivo',
        status_inactive: 'Inattivo',
      },
    },
    listings: {
      filters: {
        any: 'Qualsiasi',
      },
      loading: 'Caricamento annunci...',
    },
    loading: 'Caricamento analisi edificio...',
    loading_failed: "Impossibile caricare i dati di analisi dell'edificio",
    market: {
      available: 'Disponibile',
      loading: 'Caricamento dati di mercato...',
      no_listings: 'Nessun annuncio',
      properties: 'Proprietà',
      purchase: 'Acquisto',
      rental: 'Locazione',
      rentals: 'Locazioni',
    },
    overview: {
      building_overview: 'Panoramica edificio',
      elevator: 'Ascensore',
      property_features: 'Caratteristiche proprietà',
    },
    section_not_shared: {
      description: 'La sezione {{sectionName}} non è stata inclusa in questa analisi condivisa.',
      title: 'Sezione non condivisa',
    },
    sidebar: {
      items: {
        amenities: 'Servizi',
        buildingCharacteristics: "Caratteristiche dell'edificio",
        buildingPermits: 'Permessi edilizi',
        demographics: 'Demografia',
        electricity: 'Elettricità',
        employment: 'Occupazione',
        energy: 'Energia',
        history: 'Cronologia',
        noiseAnalysis: 'Analisi del rumore',
        purchaseListings: 'Annunci vendita',
        purchaseMarket: 'Mercato acquisto',
        rentalListings: 'Annunci di locazione',
        rentalMarket: 'Mercato locativo',
        summary: 'Riepilogo',
        sunlightStudy: 'Studio luce solare',
        taxes: 'Tasse',
        transactions: 'Transazioni',
        transportAccess: 'Trasporti & Accesso',
        unitDetails: 'Dettagli unità',
      },
      sections: {
        development: 'Sviluppo',
        environment: 'Ambiente',
        market: 'Mercato',
        overview: 'Panoramica',
        socialEconomic: 'Sociale & Economico',
      },
    },
    summaryTab: {
      activity: {
        buildingPermits: 'Permessi di costruire',
        listingDetail_one: '{{count}} annuncio, ultimo nel {{year}}',
        listingDetail_other: '{{count}} annunci, ultimi nel {{year}}',
        noData: 'Nessun dato disponibile',
        permitDetail_one: '{{count}} permesso, ultimo nel {{year}}',
        permitDetail_other: '{{count}} permessi, ultimi nel {{year}}',
        recentTransactions: 'Transazioni recenti',
        rentalListings: 'Annunci di locazione',
        saleListings: 'Annunci di vendita',
        transactionDetail_one: '{{count}} transazione, ultima nel {{year}}',
        transactionDetail_other: '{{count}} transazioni, ultime nel {{year}}',
      },
      error: 'Errore nel caricamento del riepilogo:',
      labels: {
        address: 'Indirizzo',
        buildingCategory: 'Categoria edificio',
        buildingType: 'Tipo di edificio',
        district: 'Distretto',
        egid: 'ID edificio (EGID)',
        institutionalOwners: 'Proprietari istituzionali',
        municipality: 'Comune',
        numberOfOwners: 'Numero di proprietari',
        privateOwners: 'Proprietari privati',
        publicOwners: 'Proprietari pubblici',
        status: 'Stato',
        unknown: 'Sconosciuto',
      },
      loading: 'Caricamento riepilogo edificio...',
      metrics: {
        buildingVolume: {
          subtext: 'm3',
          title: 'Volume edificio',
          tooltip: {
            calculation: "Calcolato dall'impronta dell'edificio e dalle misure di altezza",
            importance: 'Usato per calcoli assicurativi e regolamenti edilizi',
            shortDescription: "Volume cubico totale della struttura dell'edificio",
            source: 'Registro federale degli edifici (REA)',
            title: "Volume dell'edificio",
          },
        },
        dwellingArea: {
          subtext: 'Unita mediana: {{value}}m2',
          title: 'Superficie abitabile',
          tooltip: {
            calculation: 'Somma delle superfici abitative di tutte le unita registrate',
            importance: 'Indicatore chiave per il valore locativo e la capacita abitativa',
            shortDescription: "Somma di tutte le superfici abitative dell'edificio",
            source: 'Registro federale degli edifici (REA)',
            title: 'Superficie abitabile totale',
          },
        },
        floors: {
          subtext: 'Altezza: {{value}}m',
          title: 'Piani',
          tooltip: {
            calculation: 'Include il piano terra e tutti i livelli superiori',
            importance: "Importante per i requisiti di ascensore e le normative sull'accessibilita",
            shortDescription: 'Numero totale di piani fuori terra',
            source: 'Registro federale degli edifici (REA)',
            title: 'Numero di piani',
          },
        },
        totalArea: {
          subtext: 'Unita mediana: {{value}}m2',
          title: 'Superficie totale',
          tooltip: {
            calculation: 'Somma di tutte le superfici dal Registro federale degli edifici (REA)',
            importance: "Metrica chiave per comprendere la capacita dell'edificio e il potenziale valore di locazione/vendita",
            limitations: 'Non include aree comuni, parcheggi o spazi di deposito',
            shortDescription: "La superficie complessiva di tutte le unita dell'edificio",
            source: 'Registro federale degli edifici (REA)',
            title: 'Superficie totale edificio',
          },
        },
        units: {
          subtext: 'Mediana: {{value}} locali',
          title: 'Unita',
          tooltip: {
            calculation: 'Conteggio delle unita abitative registrate nel registro federale',
            importance: "Essenziale per comprendere la densita dell'edificio e il potenziale di investimento",
            shortDescription: "Numero totale di unita abitative nell'edificio",
            source: 'Registro federale degli edifici (REA)',
            title: 'Numero di unita',
          },
        },
        yearBuilt: {
          subtext: 'Ristrutturato: {{value}}',
          title: 'Anno di costruzione',
          tooltip: {
            importance: 'Influisce sui regolamenti edilizi, le esigenze di ristrutturazione e il valore immobiliare',
            shortDescription: "L'anno in cui l'edificio e stato originariamente costruito",
            source: 'Registro federale degli edifici (REA)',
            title: 'Anno di costruzione',
          },
        },
      },
      noData: 'Nessun dato edificio disponibile',
      sections: {
        buildingInfo: 'Informazioni edificio',
        ownership: 'Proprieta',
        recentActivity: 'Attivita recente',
      },
      subtitle: 'Panoramica di {{address}}, {{municipality}}',
      title: 'Riepilogo edificio',
    },
    tabs: {
      amenities: 'Servizi',
      history: 'Storia',
      noise: 'Rumore',
      overview: 'Panoramica',
      purchase_market: 'Mercato acquisti',
      rental_market: 'Mercato locativo',
      sunlight: 'Luce solare',
      transactions: 'Transazioni',
      units: 'Unità',
    },
    title: 'Analisi edificio',
    transactions: {
      loading: 'Caricamento dati transazioni...',
      types: {
        all_types: 'Tutti i tipi',
        auction: 'Asta',
        rental: 'Locazione',
        sale: 'Vendita',
      },
    },
    units: {
      balcony: 'Balcone',
      floor: 'Piano',
      unknown_floor: 'Piano sconosciuto',
    },
  },
  buildings: {
    characteristics: {
      common: {
        na: 'N/D',
        no: 'No',
        source: 'Dati dal Registro federale degli edifici e delle abitazioni (REA)',
        sourceCalculated: "Calcolato dai dati disponibili dell'edificio",
        years: 'anni',
        yes: 'Sì',
      },
      header: {
        subtitle: "Analisi fisica, storica e comparativa completa dell'edificio",
        title: "Caratteristiche dell'edificio",
      },
      neighborhood: {
        ageRanges: {
          '1919_1945': '1919-45',
          '1946_1960': '1946-60',
          '1961_1970': '1961-70',
          '1971_1980': '1971-80',
          '1981_1990': '1981-90',
          '1991_2000': '1991-00',
          '2001_2010': '2001-10',
          '2011_2020': '2011-20',
          post2020: 'Dopo il 2020',
          pre1919: 'Prima del 1919',
        },
        badges: {
          buildingOutlier: '⚠️ Edificio atipico',
        },
        cards: {
          ageDistribution: {
            title: "Distribuzione dell'età degli edifici",
          },
          areaComparison: {
            title: 'Confronto superficie',
            tooltip: {
              calculation: 'Confronta la superficie del piano terra di questo edificio con le superfici media e massima degli edifici vicini',
              description: 'Come la superficie di questo edificio si confronta con gli edifici circostanti',
              importance: "La superficie dell'edificio rispetto ai vicini indica l'intensità d'uso del suolo, la densità di sviluppo e se l'edificio è tipico per la zona.",
              limitations: "La superficie da sola non riflette la dimensione totale dell'edificio. Controllare il numero di piani e la superficie lorda per una valutazione completa.",
              title: 'Confronto superficie con i vicini',
            },
          },
          cohesionBreakdown: {
            title: 'Ripartizione della coesione',
          },
          comparativeAnalysis: {
            title: 'Analisi comparativa',
          },
          conformityBreakdown: {
            title: "Ripartizione della conformità dell'edificio",
            tooltip: {
              calculation: 'Confronta le caratteristiche di questo edificio con il profilo tipico del quartiere',
              description: 'Mostra quanto bene questo edificio specifico corrisponde al modello del quartiere',
              importance: "Una bassa conformità in un quartiere coeso indica un edificio atipico, che può influenzare la valutazione, le restrizioni di sviluppo o l'armonia architettonica.",
              title: "Ripartizione della conformità dell'edificio",
            },
          },
          heightComparison: {
            title: 'Confronto altezza',
            tooltip: {
              calculation: "Confronta l'altezza totale di questo edificio con le altezze media e massima degli edifici vicini entro un raggio definito (tipicamente 100-200m)",
              description: "Come l'altezza di questo edificio si confronta con gli edifici circostanti",
              importance: "L'altezza dell'edificio rispetto ai vicini influisce su viste, esposizione solare, privacy, armonia architettonica e conformità alle normative urbanistiche locali.",
              limitations: 'Confronto basato sugli edifici entro il raggio di ricerca. La topografia locale e le differenze di altitudine del terreno non sono riflesse in questa metrica.',
              title: 'Confronto altezza con i vicini',
            },
          },
          neighborhoodAnalysis: {
            title: "Analisi del quartiere e dell'edificio",
            tooltip: {
              calculation: "La coesione del quartiere misura quanto sono simili gli edifici circostanti. La conformità dell'edificio misura quanto bene QUESTO edificio corrisponde al modello del quartiere.",
              description: 'Analizza sia la coesione del quartiere che quanto bene questo edificio si inserisce nel quartiere rilevato',
              importance: "Un'alta coesione con bassa conformità indica un edificio atipico in un quartiere coeso, che può influenzare la valutazione e il potenziale di sviluppo.",
              title: "Analisi del quartiere e dell'edificio",
            },
          },
          quartierProfile: {
            title: 'Profilo del quartiere',
          },
          volumeComparison: {
            title: 'Confronto volume',
            tooltip: {
              calculation: 'Confronta il volume totale chiuso di questo edificio con i volumi medio e massimo degli edifici vicini',
              description: 'Come il volume totale di questo edificio si confronta con gli edifici circostanti',
              importance: "Il volume dell'edificio è un indicatore chiave della massa totale e dell'intensità di sviluppo. Usato per la modellazione energetica e la pianificazione della capacità HVAC.",
              limitations: 'I calcoli del volume possono utilizzare ipotesi geometriche semplificate. Il volume interno effettivo può variare a causa della geometria del tetto e delle disposizioni interne.',
              title: 'Confronto volume con i vicini',
            },
          },
        },
        chart: {
          areaAxis: 'Superficie (m²)',
          buildingsAxis: 'Edifici',
          heightAxis: 'Altezza (m)',
          neighborhoodAvg: 'Media quartiere',
          neighborhoodMax: 'Massimo quartiere',
          thisBuilding: 'Questo edificio',
          volumeAxis: 'Volume (m³)',
        },
        cohesion: {
          density: {
            label: 'Coesione di densità (10%)',
            tooltip: {
              calculation: 'Basato sul numero di edifici per chilometro quadrato. Una densità più alta suggerisce un quartiere urbano.',
              description: 'Misura la densità di sviluppo',
              title: 'Coesione di densità',
            },
          },
          physical: {
            label: 'Coesione fisica (30%)',
            tooltip: {
              calculation: 'Basato sulla similarità di altezza, superficie e numero di piani. Punteggi più alti indicano caratteristiche edilizie uniformi.',
              description: 'Misura la similarità architettonica',
              title: 'Coesione fisica',
            },
          },
          temporal: {
            label: 'Coesione temporale (40%)',
            tooltip: {
              calculation: 'Basato sulla similarità degli anni di costruzione. Punteggi più alti indicano edifici della stessa epoca.',
              description: 'Misura se gli edifici sono stati costruiti nello stesso periodo',
              title: 'Coesione temporale',
            },
          },
          typological: {
            label: 'Coesione tipologica (20%)',
            tooltip: {
              calculation: 'Basato sulla prevalenza di categorie di edifici simili (es. monofamiliare, plurifamiliare, ecc.)',
              description: 'Misura la similarità dei tipi di edificio',
              title: 'Coesione tipologica',
            },
          },
        },
        comparison: {
          aboveAverage: '{{percent}}% sopra la media',
          belowAverage: '{{percent}}% sotto la media',
          similar: 'Simile alla media',
        },
        conformity: {
          fitsWell: 'Si integra bene',
          outlier: 'Atipico',
          partialFit: 'Integrazione parziale',
          physicalMatch: {
            label: 'Corrispondenza fisica (40%)',
            tooltip: {
              calculation: 'Media della similarità di altezza, superficie e numero di piani. ±20-30% = alta corrispondenza',
              description: "Quanto bene le dimensioni e l'altezza di questo edificio corrispondono al quartiere tipico",
              title: 'Corrispondenza fisica',
            },
          },
          temporalMatch: {
            label: 'Corrispondenza temporale (40%)',
            tooltip: {
              calculation: "Confronta l'anno dell'edificio con l'anno tipico. ±5 anni = 100%, ±10 anni = 75%, ±20 anni = 50%",
              description: "Quanto bene l'anno di costruzione di questo edificio corrisponde al periodo tipico del quartiere",
              title: 'Corrispondenza temporale',
            },
          },
          typologicalMatch: {
            label: 'Corrispondenza tipologica (20%)',
            tooltip: {
              calculation: '100 se stessa categoria di tipico, 0 se diverso',
              description: 'Se il tipo di questo edificio corrisponde alla categoria dominante del quartiere',
              title: 'Corrispondenza tipologica',
            },
          },
        },
        errors: {
          loadFailed: "Impossibile caricare l'analisi del quartiere",
        },
        loading: "Caricamento dell'analisi del quartiere...",
        metrics: {
          areaVsAverage: {
            label: 'Superficie vs media',
            tooltip: {
              calculation: 'Differenza percentuale dalla superficie media degli edifici entro il raggio di ricerca',
              description: 'Come la superficie di questo edificio si confronta con gli edifici vicini',
              importance: "Indica se l'edificio è tipico o insolitamente grande/piccolo per la zona. Influisce sull'indice e sul potenziale di sviluppo.",
              title: 'Superficie vs media del quartiere',
            },
          },
          avgNeighborAge: {
            label: 'Età media vicini',
            tooltip: {
              calculation: 'Media delle età di tutti gli edifici entro il raggio di ricerca',
              description: 'Età media degli edifici circostanti',
              importance: 'Indica se il quartiere è prevalentemente vecchio (>50 anni), consolidato (20-50 anni) o nuovo (<20 anni).',
              title: 'Età media vicini',
            },
            value: '{{years}} anni',
          },
          buildingConformity: "Conformità dell'edificio",
          buildingDensity: {
            label: 'Densità degli edifici',
            tooltip: {
              calculation: "Conteggio degli edifici entro un raggio definito diviso per l'area di quel raggio",
              description: "Numero di edifici per unità di superficie nell'area circostante",
              importance: "Indica se l'area è urbana, suburbana o rurale. Un'alta densità suggerisce un ambiente urbano con edifici più vicini.",
              title: 'Densità degli edifici',
            },
            value: '{{density}} edifici/km²',
          },
          buildingsAnalyzed: 'Edifici analizzati',
          confidence: 'Affidabilità',
          heightVsAverage: {
            label: 'Altezza vs media',
            tooltip: {
              calculation: "Differenza percentuale dall'altezza media degli edifici entro il raggio di ricerca",
              description: "Come l'altezza di questo edificio si confronta con gli edifici vicini",
              importance: 'Gli edifici significativamente più alti o più bassi dei vicini possono affrontare restrizioni urbanistiche o distinguersi visivamente.',
              title: 'Altezza vs media del quartiere',
            },
          },
          neighborhoodCohesion: 'Coesione del quartiere',
          neighboringBuildings: {
            label: 'Edifici vicini',
            tooltip: {
              calculation: 'Numero di edifici trovati entro il raggio di ricerca selezionato',
              description: 'Conteggio degli edifici entro il raggio di analisi',
              importance: "Più vicini forniscono un migliore confronto statistico. Meno di 10 vicini può indicare un'area rurale o un'affidabilità dei dati limitata.",
              title: 'Edifici vicini',
            },
          },
          volumeVsAverage: {
            label: 'Volume vs media',
            tooltip: {
              calculation: 'Differenza percentuale dal volume medio degli edifici entro il raggio di ricerca',
              description: 'Come il volume di questo edificio si confronta con gli edifici vicini',
              importance: 'Volumi maggiori indicano strutture più sostanziali. Influisce sui costi di riscaldamento e sulla densità di sviluppo.',
              title: 'Volume vs media del quartiere',
            },
          },
        },
        neighboringBuildings: '{{count}} edifici vicini',
        noData: 'Nessun dato di confronto del quartiere disponibile per questo edificio',
        notes: {
          differsByPattern: 'Questo edificio differisce significativamente dal modello del quartiere.',
          physicalMismatch: 'Dimensione/altezza differisce significativamente.',
          temporalMismatch: 'Discrepanza del periodo di costruzione.',
          title: 'Nota:',
          typologicalMismatch: 'Il tipo di edificio differisce dalla categoria dominante.',
        },
        profile: {
          description: {
            label: 'Descrizione',
            tooltip: {
              calculation: "Generato dall'anno di costruzione tipico e dalla categoria dominante",
              description: 'Caratterizzazione riassuntiva del quartiere',
              importance: "Fornisce una panoramica rapida del carattere del quartiere (es. 'residenziale anni '60' o 'uso misto anni '80').",
              title: 'Descrizione del quartiere',
            },
          },
          developmentPattern: {
            categories: {
              mixed: {
                description: 'Coesione moderata, sviluppo vario (punteggio 55-74)',
                label: 'Misto',
              },
              organic: {
                description: 'Bassa coesione, sviluppo diversificato (punteggio <55)',
                label: 'Organico',
              },
              planned: {
                description: 'Alta coesione, sviluppo uniforme (punteggio ≥75)',
                label: 'Pianificato',
              },
            },
            label: 'Modello di sviluppo',
            tooltip: {
              description: 'Classificazione dello stile di sviluppo del quartiere',
              importance: 'Le aree pianificate hanno zonizzazione più rigida. Le aree organiche offrono più flessibilità di ristrutturazione.',
              title: 'Modello di sviluppo',
            },
          },
          typicalArea: {
            label: 'Superficie tipica',
            tooltip: {
              calculation: 'Superficie media degli edifici nel quartiere',
              description: "Impronta dell'edificio rappresentativa per il quartiere",
              importance: 'Indica la copertura tipica del lotto e la scala degli edifici nella zona.',
              title: 'Superficie tipica',
            },
          },
          typicalCategory: {
            label: 'Categoria tipica',
            tooltip: {
              calculation: 'Categoria di edificio più comune tra gli edifici del quartiere',
              description: 'Tipo di edificio dominante nel quartiere',
              importance: 'Definisce il carattere del quartiere: residenziale, commerciale, industriale o misto.',
              title: 'Categoria tipica',
            },
          },
          typicalHeight: {
            label: 'Altezza tipica',
            tooltip: {
              calculation: 'Altezza media degli edifici nel quartiere',
              description: "Altezza dell'edificio rappresentativa per il quartiere",
              importance: "Indica se l'area è prevalentemente bassa (<10m), media (10-25m) o alta (>25m).",
              title: 'Altezza tipica',
            },
          },
          typicalYear: {
            label: 'Anno di costruzione tipico',
            tooltip: {
              calculation: 'Anno di costruzione medio degli edifici nel quartiere',
              description: 'Anno di costruzione più rappresentativo per il quartiere',
              importance: "Definisce l'era architettonica e i probabili standard edilizi per la zona.",
              title: 'Anno di costruzione tipico',
            },
          },
        },
        radius: {
          label: 'Raggio',
          value: 'Raggio di {{radius}}m',
        },
        statistics: {
          area: {
            mean: {
              tooltip: {
                calculation: 'Media aritmetica di tutte le superfici degli edifici',
                description: 'Impronta media degli edifici nel quartiere',
                importance: 'Indica la dimensione tipica del lotto. Influenzato da valori anomali.',
                title: 'Superficie media',
              },
            },
            median: {
              tooltip: {
                calculation: '50° percentile delle superfici degli edifici',
                description: 'Valore mediano delle superfici degli edifici del quartiere',
                importance: 'Più rappresentativo della media quando esistono valori anomali.',
                title: 'Superficie mediana',
              },
            },
            range: {
              tooltip: {
                calculation: 'Impronte degli edifici più piccole e più grandi nel quartiere',
                description: 'Superfici minima e massima degli edifici',
                importance: 'Mostra la diversità delle dimensioni. Un ampio intervallo indica scale edilizie miste.',
                title: 'Intervallo di superficie',
              },
            },
            title: 'Statistiche di superficie',
          },
          floor: {
            floorsRange: '{{min}} - {{max}} piani',
            floorsValue: '{{floors}} piani',
            mean: {
              tooltip: {
                calculation: 'Media aritmetica di tutti i numeri di piani',
                description: 'Numero medio di piani nel quartiere',
                importance: 'Indica la scala tipica degli edifici. Influenzato da valori anomali.',
                title: 'Numero medio di piani',
              },
            },
            median: {
              tooltip: {
                calculation: '50° percentile dei numeri di piani',
                description: 'Valore mediano dei numeri di piani del quartiere',
                importance: 'Più rappresentativo della media quando esistono valori anomali.',
                title: 'Numero mediano di piani',
              },
            },
            range: {
              tooltip: {
                calculation: 'Numeri di piani più bassi e più alti nel quartiere',
                description: 'Numeri di piani minimo e massimo',
                importance: 'Mostra la diversità verticale. Un ampio intervallo indica livelli di altezza misti.',
                title: 'Intervallo del numero di piani',
              },
            },
            title: 'Statistiche dei piani',
          },
          height: {
            mean: {
              tooltip: {
                calculation: 'Media aritmetica di tutte le altezze degli edifici',
                description: 'Altezza media degli edifici nel quartiere',
                importance: 'Indica la scala tipica degli edifici. Influenzato da valori anomali.',
                title: 'Altezza media',
              },
            },
            median: {
              tooltip: {
                calculation: '50° percentile delle altezze degli edifici',
                description: 'Valore mediano delle altezze degli edifici del quartiere',
                importance: 'Più rappresentativo della media quando esistono valori anomali.',
                title: 'Altezza mediana',
              },
            },
            range: {
              tooltip: {
                calculation: 'Altezze degli edifici più basse e più alte nel quartiere',
                description: 'Altezze minima e massima degli edifici',
                importance: 'Mostra la diversità delle altezze. Un ampio intervallo indica sviluppo misto.',
                title: 'Intervallo di altezza',
              },
            },
            title: 'Statistiche di altezza',
          },
          mean: 'Media',
          median: 'Mediana',
          range: 'Intervallo',
        },
        title: 'Contesto del quartiere',
        tooltips: {
          source: 'Registro federale degli edifici e delle abitazioni (REA)',
          sourceCalculated: 'Calcolato dai dati del registro degli edifici',
        },
        warnings: {
          outlierDescription: 'Questo edificio non si adatta al modello coeso del quartiere. Potrebbe essere atipico in termini di età, dimensioni o tipo rispetto agli edifici circostanti.',
          outlierTitle: '⚠️ Avvertimento:',
        },
      },
      overview: {
        ageCategories: {
          contemporary: {
            description: 'Costruito con metodi e materiali relativamente recenti',
            label: 'Contemporaneo',
            range: '10-30 anni',
          },
          historic: {
            description: 'Edificio storico con potenziale valore patrimoniale e caratteristiche distintive',
            label: 'Storico',
            range: '>50 anni',
          },
          mature: {
            description: 'Edificio consolidato che potrebbe beneficiare di ristrutturazione o modernizzazione',
            label: 'Maturo',
            range: '30-50 anni',
          },
          new: {
            description: 'Costruito di recente con standard moderni ed efficienza energetica',
            label: 'Nuovo',
            range: '<10 anni',
          },
        },
        cards: {
          dimensions: {
            buildingVolume: "Volume dell'edificio",
            footprintArea: 'Superficie di base',
            grossFloorArea: 'Superficie lorda di piano',
            groundElevation: 'Elevazione del terreno',
            title: 'Dimensioni fisiche',
            tooltips: {
              elevation: {
                calculation: "Misurato da modelli digitali del terreno utilizzando l'elevazione media all'impronta dell'edificio",
                description: "Altezza del livello del suolo nella posizione dell'edificio sopra il livello del mare",
                importance: 'Importante per la valutazione del rischio di inondazione, la pianificazione del drenaggio e la comprensione della topografia locale',
                title: 'Elevazione del terreno',
              },
              footprintImportance: 'Determina la copertura del terreno ed è cruciale per calcolare il potenziale di sviluppo e la conformità alle normative urbanistiche',
              grossFloorArea: {
                calculation: 'Somma di tutte le superfici dei piani inclusi muri, scale e aree comuni. Calcolato dal registro degli edifici o superficie di base × numero di piani',
                description: 'Superficie totale di tutti i piani, misurata alla faccia esterna delle pareti esterne',
                importance: 'Metrica chiave per la valutazione immobiliare, i calcoli delle pigioni e il confronto delle dimensioni degli edifici',
                limitations: 'Può includere aree non abitabili come corridoi e locali tecnici. La superficie utile netta è tipicamente 10-25% più piccola',
                title: 'Superficie lorda di piano',
              },
              heightCalculation: 'Altezza misurata dal livello del suolo al colmo del tetto utilizzando dati LiDAR e rilievi ufficiali',
              heightImportance: "Critico per la conformità urbanistica, le relazioni di vicinato e la determinazione della classificazione dell'edificio",
              volume: {
                calculation: "Tipicamente calcolato come superficie di base × altezza media, o da modelli 3D dettagliati dell'edificio",
                description: "Volume totale racchiuso dell'edificio dalle fondamenta al tetto",
                importance: 'Usato per la modellazione energetica, il dimensionamento HVAC e i calcoli della densità di sviluppo',
                title: "Volume dell'edificio",
              },
            },
          },
          occupancy: {
            avgFloorArea: 'Superficie media del piano',
            avgFloorHeight: 'Altezza media del piano',
            buildingCategory: "Categoria dell'edificio",
            numberOfDwellings: 'Numero di alloggi',
            primaryUse: 'Uso principale',
            title: 'Occupazione e tipo',
            tooltips: {
              avgFloorArea: {
                calculation: 'Calcolato dividendo la superficie lorda per il numero di piani',
                description: "La superficie media di ogni piano dell'edificio",
                importance: "Utile per comprendere l'efficienza della pianta del piano e confrontare edifici simili",
                title: 'Superficie media del piano',
              },
              avgFloorHeight: {
                calculation: "Calcolato dividendo l'altezza totale dell'edificio per il numero di piani",
                description: "La distanza verticale media tra i piani dell'edificio",
                importance: "Indica la qualità dell'edificio e l'epoca. Soffitti più alti spesso suggeriscono costruzioni più antiche o di pregio",
                title: 'Altezza media del piano',
              },
              category: {
                calculation: "Assegnato dalle autorità cantonali in base all'uso, alla struttura e allo scopo dell'edificio",
                description: "Classificazione ufficiale dell'edificio secondo le categorie federali svizzere degli edifici",
                importance: 'Determina le normative applicabili, le valutazioni fiscali e gli usi consentiti',
                title: "Categoria dell'edificio",
              },
              dwellings: {
                calculation: 'Conteggiato dai registri ufficiali degli edifici, inclusi appartamenti, monolocali e case',
                description: "Conteggio totale delle singole unità abitative nell'edificio",
                importance: 'Fattore chiave per la gestione degli edifici, la pianificazione delle infrastrutture e la valutazione della densità',
                title: 'Numero di alloggi',
              },
              primaryUse: {
                calculation: "Determinato dal registro degli edifici in base all'uso dominante della superficie dell'edificio",
                description: "Lo scopo funzionale principale per cui l'edificio viene utilizzato",
                importance: 'Influisce sulla conformità urbanistica, i requisiti assicurativi e le potenziali opzioni di sviluppo',
                title: 'Uso principale',
              },
            },
          },
          occupancyType: {
            title: 'Occupazione e tipo',
          },
          physicalDimensions: {
            title: 'Dimensioni fisiche',
          },
          status: {
            constructionYear: 'Anno di costruzione',
            currentStatus: 'Stato attuale',
            lastRenovation: 'Ultima ristrutturazione',
            minergieCertified: 'Certificato Minergie',
            protectedStatus: 'Stato di protezione',
            title: 'Stato e condizione',
            tooltips: {
              constructionYear: {
                calculation: 'Registrato nel registro ufficiale degli edifici al completamento del permesso di costruzione',
                description: "L'anno in cui l'edificio è stato originariamente completato",
                importance: "Essenziale per i calcoli dell'età, il contesto storico e la comprensione degli standard costruttivi utilizzati",
                limitations: "Per gli edifici più vecchi, può essere stimato dall'intervallo del periodo di costruzione. Le ricostruzioni importanti potrebbero non aggiornare questa data",
                title: 'Anno di costruzione',
              },
              minergie: {
                calculation: "Assegnato dall'associazione Minergie sulla base del rispetto di rigorosi standard di efficienza energetica",
                description: 'Certificazione svizzera di efficienza energetica per gli edifici',
                importance: "Indica un'efficienza energetica superiore, maggiore comfort e costi operativi tipicamente inferiori",
                source: "Database di certificazione dell'associazione Minergie",
                title: 'Certificazione Minergie',
              },
              protected: {
                calculation: "Valutato dalle autorità cantonali del patrimonio in base all'importanza storica, architettonica o culturale",
                description: "Livello di protezione del patrimonio assegnato all'edificio dalle autorità cantonali",
                importance: 'Influisce sulle possibilità di ristrutturazione, sul potenziale di sviluppo e può fornire vantaggi fiscali',
                source: 'Ufficio cantonale del patrimonio e registro degli edifici',
                title: 'Stato di protezione',
              },
              renovation: {
                calculation: 'Registrato dai registri dei permessi di costruzione per progetti di ristrutturazione o trasformazione importanti',
                description: "L'anno più recente in cui sono stati completati lavori di ristrutturazione significativi",
                importance: 'Indica miglioramenti recenti e probabilmente condizioni migliori di quanto suggerirebbe il solo anno di costruzione',
                limitations: 'Le ristrutturazioni minori potrebbero non essere registrate. Le ristrutturazioni interne senza permesso non vengono rilevate',
                title: 'Ultima ristrutturazione',
              },
              status: {
                calculation: 'Registrato nel registro degli edifici e aggiornato in base ai permessi di costruzione o demolizione',
                description: "Lo stato operativo attuale dell'edificio",
                importance: "Conferma se l'edificio esiste, è in costruzione o è stato demolito",
                title: "Stato attuale dell'edificio",
              },
            },
          },
          statusCondition: {
            title: 'Stato e condizione',
          },
        },
        heightTypes: {
          highRise: 'Grattacielo',
          lowRise: 'Edificio basso',
          midRise: 'Edificio medio',
        },
        labels: {
          asl: 's.l.m.',
          estimated: 'stimato',
          period: 'periodo',
        },
        metrics: {
          buildingAge: {
            label: "Età dell'edificio",
            tooltip: {
              calculation: "Calcolato come anno corrente meno l'anno di costruzione dal registro ufficiale degli edifici",
              calculationEstimated: "Stimato in base al periodo di costruzione {{period}}. Il punto medio dell'intervallo viene utilizzato per il calcolo",
              description: "Il numero di anni dalla costruzione originale dell'edificio",
              importance: "Fattore chiave per valutare le esigenze di manutenzione, il potenziale di ristrutturazione, l'efficienza energetica e la valutazione immobiliare",
              limitations: "Non tiene conto delle ristrutturazioni importanti o ricostruzioni che potrebbero aver significativamente aggiornato l'edificio",
              limitationsEstimated: "L'età è stimata dal periodo di costruzione e potrebbe non essere esatta. L'anno di costruzione effettivo può variare nell'intervallo del periodo",
              title: "Età dell'edificio",
            },
          },
          buildingArea: {
            label: "Superficie dell'edificio",
            tooltip: {
              calculation: "Misurato dai dati catastali ufficiali o dal registro degli edifici come proiezione orizzontale dell'involucro edilizio",
              description: "L'area a livello del suolo coperta dalle mura esterne dell'edificio",
              importance: "Essenziale per comprendere l'efficienza d'uso del suolo, calcolare i rapporti di superficie e valutare il potenziale di sviluppo",
              limitations: 'Non include strutture esterne come terrazze, balconi o aree sotterranee. Può differire dalla superficie totale del piano',
              title: "Superficie di base dell'edificio",
            },
          },
          buildingHeight: {
            label: "Altezza dell'edificio",
            tooltip: {
              calculation: "Misurato da dati LiDAR o rilievi ufficiali, dal livello del suolo al colmo del tetto o all'elemento strutturale più alto",
              description: "La misura verticale dal livello del suolo al punto più alto dell'edificio",
              importance: "Critico per la conformità urbanistica, l'analisi delle ombre, la valutazione delle viste e la determinazione della classificazione dell'edificio",
              limitations: 'Può variare in base al metodo di misurazione. Antenne, camini e strutture temporanee possono essere inclusi o meno',
              title: "Altezza totale dell'edificio",
            },
          },
          floorCount: {
            label: 'Numero di piani',
            tooltip: {
              calculation: 'Conteggiato dai dati ufficiali del registro degli edifici, incluso il piano terra e tutti i piani superiori',
              description: "Il numero totale di piani fuori terra dell'edificio",
              importance: 'Indicatore chiave per la classificazione degli edifici, la conformità urbanistica e la stima della superficie lorda',
              limitations: 'Potrebbe non includere piani interrati, soppalchi o piani tecnici. I piani sotterranei sono conteggiati separatamente',
              title: 'Numero totale di piani',
            },
          },
          numberOfFloors: {
            label: 'Numero di piani',
          },
        },
        sizeIndicators: {
          compact: 'Compatto',
          large: 'Grande',
          medium: 'Medio',
        },
        values: {
          asl: 's.l.m.',
          estimated: '(stim.)',
          estimatedFrom: 'stimato da {{period}}',
          na: 'N/D',
          no: 'No',
          period: '(periodo)',
          years: 'anni',
          yearsAgo: 'anni fa',
          yearsCount: '{{count}} anni',
          yes: 'Sì',
        },
      },
      states: {
        error: "Errore nel caricamento delle caratteristiche dell'edificio",
        loading: "Caricamento delle caratteristiche dell'edificio...",
        noData: "Nessun dato dell'edificio disponibile",
      },
      tabs: {
        neighborhood: 'Contesto del quartiere',
        overview: 'Panoramica',
        timeline: 'Cronologia costruzione',
      },
      timeline: {
        ageComparison: {
          newerThanAverage: 'Più recente della media',
          significantlyOlder: 'Significativamente più vecchio',
          similarAge: 'Età simile',
          yearsOld: 'anni',
        },
        badges: {
          estimatedData: 'Dati stimati',
          historicalData: 'Dati storici',
        },
        cards: {
          ageAnalysis: {
            title: "Analisi dell'età",
          },
          ageComparison: {
            title: "Confronto d'età con il quartiere",
          },
          constructionPhases: {
            title: 'Fasi di costruzione',
          },
          constructionTimeline: {
            title: 'Cronologia costruzione',
          },
          renovationHistory: {
            title: 'Storico delle ristrutturazioni',
          },
          timeline: {
            title: 'Cronologia costruzione',
            tooltip: {
              calculation: 'Basato sulle date di costruzione ufficiali, i registri di ristrutturazione e i dati del registro degli edifici',
              description: "Rappresentazione visiva della storia costruttiva dell'edificio e degli eventi principali",
              importance: "Aiuta a comprendere l'evoluzione dell'edificio nel tempo e a pianificare la manutenzione futura",
              limitations: 'Alcune date potrebbero essere stimate dai periodi di costruzione quando gli anni esatti non sono disponibili',
              title: 'Cronologia costruzione',
            },
          },
        },
        events: {
          constructionPhase: 'Fase di costruzione',
          dwellingAdded: 'Alloggio aggiunto',
          majorRenovation: 'Ristrutturazione importante',
          originalConstruction: 'Costruzione originale',
          originalConstructionEst: 'Costruzione originale (stim.)',
          present: 'Presente',
        },
        labels: {
          ageCategory: 'Categoria di età',
          buildingAge: "Età dell'edificio",
          buildingPeriod: 'Periodo di costruzione',
          comparison: 'Confronto',
          constructionDates: 'Date di costruzione',
          constructionYear: 'Anno di costruzione',
          lastRenovation: 'Ultima ristrutturazione',
          neighborhoodAverage: 'Media del quartiere',
          noRecord: 'Nessun record',
          numberOfPhases: 'Numero di fasi',
          phases: 'Fasi',
          renovationPeriod: 'Periodo di ristrutturazione',
          renovationStatus: 'Stato di ristrutturazione',
          singlePhaseConstruction: 'Costruzione a fase unica',
          thisBuilding: 'Questo edificio',
          yearsSinceRenovation: 'Anni dalla ristrutturazione',
        },
        noDataMessage: 'Nessun dato sulla cronologia di costruzione disponibile',
        phaseLabels: {
          noRecord: 'Nessun record',
          singlePhase: 'Costruzione a fase unica',
        },
        renovationStatuses: {
          considerUpdates: 'Considerare aggiornamenti',
          goodCondition: 'Buone condizioni',
          noRenovation: 'Nessuna ristrutturazione',
          recentlyRenovated: 'Recentemente ristrutturato',
          renovationNeeded: 'Ristrutturazione necessaria',
        },
      },
    },
    filters: {
      buildingDetails: {
        buildingVolume: "Volume dell'edificio fuori terra (m³)",
        grossFloorArea: 'Superficie lorda di piano utile (m²)',
        groundingArea: 'Superficie di base (m²)',
        height: 'Altezza',
        numberOfFloors: 'Numero di piani',
        numberOfUnits: 'Numero di unità',
        title: "Dettagli dell'edificio",
      },
      buildingHistory: {
        buildingPeriod: 'Periodo di costruzione',
        renovationPeriod: 'Periodo di ristrutturazione',
        title: "Storia dell'edificio",
        yearOfConstruction: 'Anno di costruzione',
        yearOfRenovation: 'Anno di ristrutturazione',
      },
      buildingType: {
        buildingCategory: 'Categoria di edificio (REA)',
        buildingClass: 'Classe di edificio (REA)',
        classifications: {
          garage: 'Garage',
          industrial: 'Industriale',
          mixed1: 'Misto 1',
          mixed2: 'Misto 2',
          notClassified: 'Non classificato',
          offices: 'Uffici',
          other: 'Altro',
          public: 'Pubblico',
          residential: 'Residenziale',
          retail: 'Commercio',
        },
        constructionType: 'Tipo di costruzione',
        constructionTypes: {
          normal: 'Normale',
          projected: 'Progettato',
          underground: 'Sotterraneo',
        },
        hasCivilProtectionShelter: 'Ha rifugio di protezione civile',
        popetyClassification: 'Classificazione Popety.io',
        protectedRank: 'Grado di protezione',
        title: 'Tipo di edificio',
      },
      energy: {
        idc: 'IDC - MJ/m²/anno',
        mainHeaterGenerator: 'Generatore di calore principale',
        mainHeatingEnergySource: 'Fonte energia principale riscaldamento',
        mainHotWaterEnergySource: 'Fonte energia principale acqua calda',
        mainHotWaterGenerator: 'Generatore acqua calda principale',
        minergieLabel: 'Etichetta Minergie',
        title: 'Energia, Riscaldamento & Acqua calda',
      },
      environmental: {
        distanceToPowerlines: 'Distanza dalle linee ad alta tensione',
        lakeView: 'Vista lago',
        lakeViewArea: {
          large: 'Oltre 100 ha',
          none: '0 ha',
          small: '0 a 100 ha',
        },
        mountainView: 'Vista montagne',
        mountainViewQuality: {
          few: '0 a 4 cime',
          many: 'Oltre 13 cime',
          some: '5 a 13 cime',
        },
        noiseExposure: 'Esposizione al rumore',
        noiseExposureLevels: {
          high: 'Oltre 52 dB',
          low: 'Fino a 45 dB',
          medium: '45 a 52 dB',
        },
        powerlineDistance: {
          close: '0 a 100m',
          far: 'Oltre 100m',
        },
        publicTransportQuality: 'Qualità trasporti pubblici',
        slope: 'Pendenza',
        slopeLevels: {
          flat: '0 a 4 gradi',
          moderate: '4 a 9 gradi',
          steep: 'Oltre 9 gradi',
        },
        taxBurden: 'Carico fiscale',
        taxBurdenLevels: {
          high: 'Alto (oltre 7,1%)',
          medium: 'Medio (5,1% a 7,1%)',
          small: 'Piccolo (0 a 5,1%)',
        },
        title: 'Caratteristiche ambientali',
        transportQuality: {
          badly: 'Mal servito',
          medium: 'Mediamente servito',
          veryBadly: 'Molto mal servito',
          veryWell: 'Molto ben servito',
          well: 'Ben servito',
        },
        travelTime: {
          long: 'Lungo',
          medium: 'Medio',
          short: 'Breve',
        },
        travelTimeToCenters: 'Tempo di viaggio verso i centri',
      },
      history: {
        buildingPermitNumber: 'Numero permessi di costruzione',
        buildingPermitsClassification: 'Classificazione permessi di costruzione',
        buildingPermitsDate: 'Data permessi di costruzione',
        listingRentNumber: 'Numero annunci di locazione',
        listingSaleNumber: 'Numero annunci vendita',
        listingsListingDate: 'Data annunci',
        listingsPrice: 'Prezzo annunci',
        listingsPricePerSquareMeter: 'Prezzo annunci per metro quadrato',
        listingsRentDate: 'Data annunci di locazione',
        listingsRentDateTooltip: 'Periodo in cui le proprietà sono state messe in locazione. Trova le proprietà recentemente messe in locazione.',
        listingsSaleDate: 'Data annunci vendita',
        listingsSaleDateTooltip: 'Periodo in cui le proprietà sono state messe in vendita. Trova le proprietà recentemente messe in vendita.',
        permitClassifications: {
          development: 'Sviluppo',
          other: 'Altro',
        },
        title: 'Storico',
        transactionsDate: 'Data transazioni',
        transactionsNumber: 'Numero transazioni',
        transactionsPrice: 'Prezzo transazioni',
      },
      solar: {
        averageSolarRadiation: 'Radiazione solare media (kWh/m²/anno)',
        electricPotential: 'Potenziale elettrico (kWh/anno)',
        heatPotential: 'Potenziale termico (kWh/anno)',
        installationDate: 'Data di installazione',
        installedPower: 'Potenza installata (kW)',
        roofArea: 'Superficie del tetto (m²)',
        roofPitch: 'Inclinazione del tetto (°)',
        title: 'Energia solare',
        totalSolarRadiation: 'Radiazione solare totale (kWh/anno)',
      },
      user: {
        loadingTags: 'Caricamento tag...',
        myTags: 'I miei tag',
        noTagsAvailable: 'Nessun tag disponibile. Crea tag dal pannello dettagli edificio.',
        title: 'Filtri utente',
      },
    },
    sidebar: {
      items: {
        amenities: 'Servizi',
        buildingPermits: 'Permessi edilizi',
        characteristics: 'Caratteristiche edificio',
        demographics: 'Demografia',
        employment: 'Occupazione',
        energy: 'Energia',
        feasibilityStudy: 'Studio di fattibilità',
        history: 'Cronologia',
        land: 'Terreno',
        noiseAnalysis: 'Analisi rumore',
        potential: 'Potenziale sopraelevazione',
        purchaseListings: 'Annunci vendita',
        purchaseMarket: 'Mercato acquisto',
        rentalListings: 'Annunci di locazione',
        rentalMarket: 'Mercato locativo',
        summary: 'Riepilogo',
        sunlightStudy: 'Studio luce solare',
        transactions: 'Transazioni',
        transportAccess: 'Trasporti & Accesso',
        units: 'Dettagli unità',
      },
      sections: {
        elevation: 'Sopraelevazione',
        environment: 'Ambiente',
        market: 'Mercato',
        overview: 'Panoramica',
        socialEconomic: 'Sociale & Economico',
      },
    },
    transactionsTab: {
      filters: {
        additionalFilters: 'Filtri aggiuntivi',
        advancedFilters: 'Filtri avanzati',
        allLocations: 'Tutte le posizioni',
        clearAll: 'Cancella tutto',
        hideFilters: 'Nascondi filtri',
        landArea: 'Superficie del terreno (m²)',
        legalTypeBF: 'B-F',
        legalTypeCOP: 'COP',
        legalTypeDDP: 'DDP',
        legalTypeDP: 'DP',
        legalTypeOther: 'Altro',
        legalTypePPE: 'PPE',
        numberOfBuyers: 'Numero di acquirenti',
        numberOfSellers: 'Numero di venditori',
        others: 'Altri',
        participantAssociation: 'Associazione',
        participantCompany: 'Azienda',
        participantCooperative: 'Cooperativa',
        participantFoundation: 'Fondazione',
        participantIndividual: 'Privato',
        participantOther: 'Altro',
        participantPublicEntity: 'Ente pubblico',
        participants: 'Partecipanti',
        participantType: 'Tipo di partecipante',
        propertyLegalType: 'Tipo legale della proprietà',
        radius: 'Raggio',
        showFilters: 'Mostra filtri',
        stepTransactionPrice: 'Prezzo transazione per fase (CHF)',
        transactionDate: 'Data della transazione',
        transactionType: 'Tipo di transazione',
        typeAreaPrice: 'Tipo, Superficie & Prezzo',
        unitApartment: 'Appartamento',
        unitCommercial: 'Commerciale',
        unitHouse: 'Casa',
        unitLand: 'Terreno',
        unitOther: 'Altro',
        unitParking: 'Parcheggio',
        unitType: 'Tipo di unità',
      },
      subtitle: "Esplora la cronologia delle transazioni intorno all'edificio e salva quelle che ti interessano per questa analisi.",
      tabs: {
        aroundBuilding: "Transazioni intorno all'edificio",
        saved: 'Transazioni salvate',
      },
      title: 'Transazioni',
    },
    unitDetails: {
      actions: {
        addFirstUnit: 'Aggiungi prima unità',
        addUnit: 'Aggiungi unità',
        cancel: 'Annulla',
        edit: 'Modifica',
        save: 'Salva',
        saving: 'Salvataggio...',
      },
      common: {
        chf: 'CHF',
        minMax: 'min-max',
        na: 'N/D',
        squareMeters: 'm²',
      },
      entrance: {
        egid: 'EGID:',
        floorsCount: '{{count}} piani',
        floorsCountOne: '{{count}} piano',
        mainEntrance: 'Ingresso principale',
        unitsCount: '{{count}} unità',
        unitsCountOne: '{{count}} unità',
      },
      floor: {
        basement: 'Piano sotterraneo {{level}}',
        floorNumber: 'Piano {{number}}',
        groundFloor: 'Piano terra',
      },
      metrics: {
        dwellingArea: 'Superficie abitabile',
        floors: 'Piani',
        footprint: 'Impronta',
        units: 'Unità',
      },
      multipleFloor: {
        no: 'No',
        yes: 'Sì',
      },
      states: {
        error: 'Errore nel caricamento dei dettagli delle unità:',
        loading: 'Caricamento dettagli unità...',
        loadingConfigurations: 'Caricamento configurazioni abitazioni...',
        noBuilding: "Nessun dato dell'edificio disponibile",
        noUnits: 'Nessun dettaglio unità disponibile per questo edificio',
        noUnitsOnFloor: 'Nessuna unità su questo piano',
      },
      subtitle: 'Ripartizione completa di tutte le unità per ingresso e piano',
      table: {
        headers: {
          adminNo: 'N° AMMIN.',
          area: 'AREA',
          bathrooms: 'BAGNI',
          cYear: 'ANNO C.',
          edid: 'EDID',
          fid: 'ID F.',
          multiFloor: 'MULT. PI.',
          rentalValue: 'VALORE LOCATIVO MENSILE',
          rooms: 'STANZE',
          type: 'TIPO',
        },
      },
      title: 'Dettagli unità',
      unitTypes: {
        residential: 'Residenziale',
        roomCount: '{{count}} Locale',
        roomPlural: 'Stanze',
        roomsCount: '{{count}} Locali',
        roomSingular: 'Stanza',
      },
      validation: {
        areaPositive: "L'area deve essere positiva",
        bathroomsPositive: 'Il numero di bagni deve essere positivo',
        constructionDateFuture: 'La data di costruzione non può essere nel futuro',
        roomNumberRange: 'Il numero di stanze deve essere compreso tra 1 e 10',
      },
    },
  },
  charts: {
    actions: {
      saveAsImage: 'Salva come immagine',
    },
    categories: {
      apartment: 'Appartamento',
      apartmentTrend: 'Tendenza appartamenti',
      house: 'Casa',
      houseTrend: 'Tendenza case',
    },
    common: {
      averageValue: 'Valore medio',
      avgPrice: 'Prezzo medio',
      concentrated: 'concentrata',
      consistency: 'consistenza',
      decrease: 'diminuzione',
      decreased: 'diminuito',
      decreases: 'diminuisce',
      discount: 'uno sconto di',
      distributed: 'distribuita',
      downward: 'al ribasso',
      exponential: 'esponenziale',
      gradual: 'graduale',
      high: 'alta',
      higher: 'più alto',
      increase: 'aumento',
      increased: 'aumentato',
      increases: 'aumenta',
      lessExpensive: 'meno costoso',
      limited: 'limitato',
      linear: 'lineare',
      low: 'bassa',
      lower: 'più basso',
      moderate: 'moderata',
      mom: 'Mese su mese',
      moreExpensive: 'più costoso',
      noData: 'Nessun dato disponibile',
      otherRegions: 'altre regioni',
      smallestPremium: 'il premio più piccolo a',
      stable: 'stabile',
      steep: 'ripida',
      strong: 'forte',
      strongUpward: 'forte rialzo',
      totalTransactions: 'Transazioni totali',
      totalValue: 'Valore totale',
      totalVolume: 'Volume totale',
      transactionCount: 'Numero di transazioni',
      transactions: 'Transazioni',
      variation: 'variazione',
      weak: 'debole',
      yoy: 'Anno su anno',
    },
    empty: {
      newVsResale: 'Nessun dato nuovo vs esistente disponibile per i filtri selezionati.',
      priceEvolution: "Non sono disponibili dati sull'evoluzione dei prezzi per i filtri selezionati. Modifica i criteri di ricerca.",
      pricePerRoom: 'Non sono disponibili dati sul prezzo per locale per i filtri selezionati. Modifica i criteri di ricerca.',
      pricePerSqmPerRoom: 'Non sono disponibili dati sul prezzo/m² per locale per i filtri selezionati. Modifica i criteri di ricerca.',
      rentEvolution: "Non sono disponibili dati sull'evoluzione dei canoni per i filtri selezionati. Modifica i criteri di ricerca.",
      rentPerRoom: 'Non sono disponibili dati sul canone per locale per i filtri selezionati. Modifica i criteri di ricerca.',
      rentPerSqmPerRoom: 'Non sono disponibili dati sul canone/m² per locale per i filtri selezionati. Modifica i criteri di ricerca.',
      title: 'Nessun dato disponibile',
    },
    geographicDistribution: {
      activeCantons: 'Cantoni attivi',
      avg: 'Med',
      avgTransactionPrice: 'Prezzo medio di transazione',
      topCitiesByVolume: 'Principali città per volume di transazioni',
      totalMarketVolume: 'Volume totale di mercato',
      transactionsByCanton: 'Transazioni per cantone',
    },
    inheritanceFlow: {
      donation: 'Donazione',
      flowAnalysis: 'Analisi del flusso ereditario',
      flowAnalysisSubtext: 'Trasferimento di patrimonio da venditori ad acquirenti per tipo di proprietà',
      heritage: 'Eredità',
      inheritanceOverTime: 'Transazioni ereditarie nel tempo',
      inheritanceOverTimeSubtext: 'Tendenze trimestrali per tipo di transazione',
      noData: 'Nessun dato ereditario disponibile',
      partage: 'Divisione',
      shareDistribution: 'Analisi della distribuzione delle quote',
      shareDistributionSubtext: 'Modelli di quote di proprietà nei trasferimenti',
    },
    insights: {
      agency: {
        marketConcentration: 'Concentrazione del mercato',
        performanceDistribution: 'Distribuzione delle performance',
        valueDistribution: 'Distribuzione del valore',
      },
      bestPerformer: 'Miglior performance',
      bestValue: 'Miglior rapporto qualità-prezzo',
      city: {
        cityPriceRange: 'Fascia di prezzo per città',
        marketActivity: 'Attività di mercato',
        marketDistribution: 'Distribuzione del mercato',
        premiumSegment: 'Segmento premium',
        priceConsistency: 'Consistenza dei prezzi',
      },
      descriptions: {
        agency: {
          marketConcentration: 'Le prime 5 agenzie controllano il {{percentage}}% del mercato con {{count}} annunci combinati.',
          performanceDistribution: 'Con una media di {{avgListings}} annunci per agenzia, il mercato mostra una distribuzione {{distribution}} tra {{count}} agenzie.',
          valueDistribution: 'Le prime 10 agenzie per valore del portafoglio gestiscono il {{percentage}}% del valore totale del mercato a {{value}}.',
        },
        city: {
          cityPriceRange: 'Il prezzo per m² varia del {{variation}}% tra {{cityHigh}} ({{priceHigh}}) e {{cityLow}} ({{priceLow}}).',
          marketActivity: 'Le prime 5 città per volume rappresentano il {{percentage}}% di tutti gli annunci, con {{topCity}} in testa con {{topCount}} immobili.',
          marketDistribution: '{{count}} città hanno prezzi superiori alla media di {{average}}, rappresentando il {{percentage}}% delle località analizzate.',
          premiumSegment: '{{city}} ha il mercato premium più forte con il {{percentage}}% degli annunci sopra {{threshold}}.',
          priceConsistency: '{{city}} mostra i prezzi più costanti con {{stdDev}} di deviazione standard nel prezzo/m².',
        },
        geography: {
          marketConcentration: 'I primi 3 mercati rappresentano il {{percentage}}% di tutti gli annunci, indicando una concentrazione di mercato {{concentration}}.',
          nationalBenchmark: '{{count}} su {{total}} località hanno prezzi superiori alla media nazionale di {{average}}.',
          priceM2Consistency: 'Il prezzo per m² mostra {{consistency}} tra le regioni con un coefficiente di variazione del {{variation}}%.',
          regionalPriceDisparity: '{{location1}} è {{priceDiff}}% più costoso di {{location2}}, mostrando una significativa variazione dei prezzi regionali.',
          valueDensityLeader: '{{location}} ha il prezzo più alto per m² a {{priceM2}}, guidando il mercato nella densità di valore.',
        },
        newVsResale: {
          constructionPremiumNegative: 'Gli immobili nuovi sono venduti con uno sconto del {{discount}}% con prezzo/m² {{priceType}} di {{newPrice}} rispetto a {{existingPrice}} per gli immobili esistenti.',
          constructionPremiumPositive: 'Gli immobili nuovi hanno un premio del {{premium}}% con prezzo/m² {{priceType}} di {{newPrice}} rispetto a {{existingPrice}} per gli immobili esistenti.',
          marketComposition: 'Gli immobili di nuova costruzione rappresentano il {{newPercentage}}% del mercato con {{totalNew}} annunci, mentre gli immobili esistenti dominano con il {{existingPercentage}}% e {{totalExisting}} annunci.',
          marketTrendChanged: 'La quota di mercato delle nuove costruzioni è {{direction}} di {{change}} punti percentuali da {{startPeriod}} a {{endPeriod}}.',
          marketTrendStable: 'La quota di mercato delle nuove costruzioni è rimasta stabile da {{startPeriod}} a {{endPeriod}}.',
          premiumVariations: 'Gli immobili {{highCategory}} mostrano il premio più alto per le nuove costruzioni al {{highPremium}}%, mentre gli immobili {{lowCategory}} hanno {{lowPremiumText}}.',
          regionalActivity: "{{topRegion}} guida l'attività di nuove costruzioni con il {{topPercentage}}% degli annunci come nuovi immobili, seguito da {{secondRegion}}. La media di tutte le regioni è del {{avgPercentage}}%.",
        },
        portal: {
          geographicReach: 'I portali operano in una media di {{avgRegions}} regioni, con {{topPortal}} che ha la copertura più ampia con {{topRegions}} regioni.',
          marketEfficiency: "I primi 10 portali gestiscono il {{percentage}}% di tutti gli annunci, dimostrando un'efficienza di mercato {{efficiency}}.",
          portalEcosystem: 'Il mercato è composto da {{large}} grandi portali (>{{threshold}} annunci), {{medium}} medi e {{small}} piccoli portali.',
          portalMarketConcentration: 'I primi 5 portali controllano il {{percentage}}% del mercato con {{count}} annunci combinati.',
          pricePositioning: 'Il prezzo medio su tutti i portali è {{avgPrice}}, con {{highPortal}} posizionato più in alto a {{highPrice}}.',
        },
        priceEvolution: {
          bestPerformer: 'Gli immobili {{category}} mostrano la crescita più forte al {{growth}}%, superando le altre categorie del mercato.',
          marketStability: '{{category}} mostra i prezzi più stabili con solo {{volatility}}% di variazione, indicando condizioni di mercato costanti.',
          marketTrend: 'Il mercato complessivo è {{direction}} del {{change}}% nel periodo analizzato, con prezzi {{priceType}} da {{startPrice}} a {{endPrice}}.',
          recentMomentum: "L'ultimo anno mostra uno slancio {{momentum}} con prezzi {{direction}} del {{change}}% rispetto al periodo precedente.",
        },
        priceM2PerRoom: {
          bestValue: 'I {{category}} con {{rooms}} locali offrono il miglior rapporto prezzo/m² a {{priceM2}}, rappresentando la densità di valore ottimale nel mercato.',
          marketSweetSpot: 'I {{category}} con {{rooms}} locali dominano il mercato con {{count}} annunci a una media di {{priceM2}}/m².',
          priceM2Trend: 'Il prezzo/m² {{direction}} di circa {{change}} per ogni locale aggiuntivo nei {{category}}.',
          propertyTypePremium: 'Le case hanno un prezzo/m² {{premium}}% {{comparison}} rispetto agli appartamenti in media.',
        },
        pricePerRoom: {
          bestValue: 'I {{category}} con {{rooms}} locali offrono il miglior valore a {{price}} per immobile, rappresentando il rapporto prezzo-spazio ottimale nel mercato.',
          marketSweetSpot: 'I {{category}} con {{rooms}} locali sono la configurazione più comune con {{count}} annunci, rappresentando il {{percentage}}% del mercato.',
          priceProgression: 'Ogni locale aggiuntivo nei {{category}} aumenta il prezzo di circa {{increment}}, mostrando una progressione dei prezzi {{pattern}}.',
          propertyTypePremium: 'Le case sono in media {{premium}}% {{comparison}} rispetto agli appartamenti per tutte le configurazioni di locali.',
        },
      },
      geography: {
        marketConcentration: 'Concentrazione del mercato',
        nationalBenchmark: 'Benchmark nazionale',
        priceM2Consistency: 'Consistenza del prezzo/m²',
        regionalPriceDisparity: 'Disparità dei prezzi regionali',
        valueDensityLeader: 'Leader in densità di valore',
      },
      keyInsights: 'Approfondimenti chiave',
      marketStability: 'Stabilità del mercato',
      marketSweetSpot: 'Punto ottimale del mercato',
      marketTrend: 'Tendenza del mercato',
      newVsResale: {
        constructionPremium: 'Premio nuova costruzione',
        marketComposition: 'Composizione del mercato',
        premiumVariations: 'Variazioni premio',
        regionalActivity: 'Attività regionale',
      },
      portal: {
        geographicReach: 'Copertura geografica',
        marketEfficiency: 'Efficienza del mercato',
        portalEcosystem: 'Ecosistema dei portali',
        portalMarketConcentration: 'Concentrazione del mercato dei portali',
        pricePositioning: 'Posizionamento dei prezzi',
      },
      priceM2Trend: 'Trend prezzo/m² {{category}}',
      priceProgression: 'Progressione prezzi {{category}}',
      propertyTypePremium: 'Premio per tipo di immobile',
      recentMomentum: 'Slancio recente',
    },
    kpis: {
      averagePrice: 'Prezzo medio',
      averagePricePerSqm: 'Prezzo medio/m²',
      averagePricePerSqmPerRoom: 'Prezzo medio/m² per locale',
      averageRent: 'Canone medio',
      averageRentPerSqm: 'Canone medio/m²',
      averageRentPerSqmPerRoom: 'Canone medio/m² per locale',
      averageRooms: 'Locali medi',
      avgPricePerRoom: 'Prezzo medio per locale',
      avgRentPerRoom: 'Canone medio per locale',
      marketVolume: 'Volume di mercato',
      medianPrice: 'Prezzo mediano',
      medianPricePerRoom: 'Prezzo mediano per locale',
      medianPricePerSqm: 'Prezzo mediano/m²',
      medianPricePerSqmPerRoom: 'Prezzo mediano/m² per locale',
      medianRent: 'Canone mediano',
      medianRentPerRoom: 'Canone mediano per locale',
      medianRentPerSqm: 'Canone mediano/m²',
      medianRentPerSqmPerRoom: 'Canone mediano/m² per locale',
      mostExpensive: 'Categoria più costosa',
      priceAllTypes: 'Prezzo {{priceType}} (Tutti i tipi)',
      rentAllTypes: 'Canone {{priceType}} (Tutti i tipi)',
      totalListings: 'Annunci totali',
      yearGrowth: 'Crescita 1 anno',
    },
    labels: {
      allRooms: 'Tutti i locali',
      allTypes: 'Tutti i tipi',
      count: 'Conteggio',
      listings: 'Annunci',
      notAvailable: 'N/D',
      numberOfListings: 'Numero annunci',
      numberOfRooms: 'Numero di locali',
      percentage: 'Percentuale (%)',
      percentile10: '10° percentile',
      percentile10Short: '10° %',
      percentile30: '30° percentile',
      percentile30Short: '30° %',
      percentile50Median: '50° percentile (Mediana)',
      percentile50Short: '50° % (Mediana)',
      percentile70: '70° percentile',
      percentile70Short: '70° %',
      percentile90: '90° percentile',
      percentile90Short: '90° %',
      price: 'Prezzo',
      priceChf: 'Prezzo (CHF)',
      pricePerM2Chf: 'Prezzo al m² (CHF)',
      propertyType: 'Tipo di immobile',
      range: 'Intervallo',
      rent: 'Canone',
      rentChf: 'Canone (CHF)',
      rentPerM2Chf: 'Canone al m² (CHF)',
      rooms: 'Locali',
      stdDev: 'Dev. std.',
    },
    marketTiming: {
      activityCalendar: 'Calendario attività di mercato',
      activityCalendarSubtext: 'Volume di transazioni per giorno',
      avgLagDays: 'Ritardo medio (giorni)',
      monthlyActivity: 'Attività transazionale mensile',
      monthlyActivitySubtext: 'Volume di transazioni nel tempo',
      noActivity: 'Nessuna attività',
      noData: 'Nessun dato sul timing di mercato disponibile',
      numberOfTransactions: 'Numero di transazioni',
      publicationLag: 'Analisi del ritardo di pubblicazione',
      publicationLagSubtext: 'Giorni medi tra transazione e pubblicazione',
    },
    newVsResale: {
      kpis: {
        newShare: 'Quota nuove costruzioni',
        premium: 'Premio nuova costruzione',
        priceExisting: '{{priceType}} {{priceUnit}} - Esistente',
        priceNew: '{{priceType}} {{priceUnit}} - Nuovo',
      },
      legends: {
        existingProperties: 'Immobili esistenti',
        newConstruction: 'Nuova costruzione',
      },
      titles: {
        activity: 'Attività nuova costruzione a {{location}}',
        composition: 'Composizione del mercato: Nuovo vs Esistente nel tempo',
        premium: 'Premio {{priceType}} per nuova costruzione per categoria',
      },
      tooltips: {
        existing: 'Esistente',
        new: 'Nuovo',
        premiumLabel: 'Premio',
        total: 'Totale',
      },
    },
    participantDemographics: {
      buyersByGender: 'Acquirenti per genere',
      companies: 'Aziende',
      companyParticipants: 'Aziende partecipanti',
      female: 'Donna',
      genderDistributionOverTime: 'Distribuzione di genere degli acquirenti nel tempo',
      genderParity: 'Parità di genere 50%',
      individualParticipants: 'Partecipanti individuali',
      individuals: 'Privati',
      male: 'Uomo',
      participantTypesByLegalForm: 'Tipi di partecipanti per forma giuridica',
      personVsCompany: 'Privati vs Aziende',
      sellersByGender: 'Venditori per genere',
      totalBuyers: 'Acquirenti totali',
      totalSellers: 'Venditori totali',
    },
    priceDynamics: {
      avgTransactionPrice: 'Prezzo medio di transazione',
      priceByPropertyType: 'Prezzo per tipo di proprietà',
      priceDistribution: 'Distribuzione dei prezzi',
      priceVelocityIndex: 'Indice di velocità dei prezzi',
      totalMarketVolume: 'Volume totale di mercato',
      yearlyMarketVolume: 'Volume di mercato annuale',
    },
    priceM2PerRoom: {
      titles: {
        distribution: 'Distribuzione {{priceType}} per locali',
        roomCountVsPrice: 'Numero locali vs Prezzo/m² {{priceType}}',
        roomCountVsRent: 'Numero locali vs Canone/m² {{priceType}}',
      },
      tooltips: {
        listings: 'Annunci',
        price: 'Prezzo/m² {{priceType}}',
        range: 'Range',
        rent: 'Canone/m² {{priceType}}',
        rooms: 'Locali',
        stdDev: 'Dev. Std.',
      },
    },
    priceTypes: {
      average: 'Media',
      median: 'Mediana',
    },
    propertyCharacteristics: {
      avgSurfaceArea: 'Superficie media (m²)',
      complexityIndex: "Indice di complessità dell'edificio",
      complexityIndexSubtext: 'Prezzo e superficie per numero di piani',
      noData: 'Nessun dato sulle caratteristiche della proprietà disponibile',
      numberOfFloors: 'Numero di piani',
      performanceMatrix: 'Matrice di performance per tipo di proprietà',
      performanceMatrixSubtext: 'Superficie media vs Prezzo medio',
    },
    seasonalPatterns: {
      averageTransactionCount: 'Numero medio di transazioni',
      month: 'Mese',
      monthlyActivity: 'Attività transazionale mensile',
      monthlyActivitySubtext: 'Tendenze di volume e valore per mese',
      noData: 'Nessun dato di modello stagionale disponibile',
      quarterlyComparison: 'Confronto trimestrale',
      quarterlyComparisonSubtext: 'Volume di transazioni per trimestre',
      seasonalPatterns: 'Modelli stagionali',
      seasonalPatternsSubtext: 'Attività media per mese su tutti gli anni',
    },
    states: {
      loading: 'Caricamento dati...',
      loadingNewVsResale: 'Caricamento dati nuovo vs esistente...',
      loadingPriceM2PerRoom: 'Caricamento dati prezzo/m² per locale...',
      loadingPricePerRoom: 'Caricamento dati prezzo per locale...',
    },
    titles: {
      priceByRooms: 'Distribuzione dei prezzi per locali',
      priceDistribution: 'Distribuzione dei prezzi per quantili',
      priceDistributionByQuantiles: 'Distribuzione dei prezzi per quantili',
      priceEvolution: 'Evoluzione dei prezzi per tipo di immobile',
      priceEvolutionByType: 'Evoluzione dei prezzi per tipo di immobile',
      priceM2Distribution: 'Distribuzione del prezzo/m² per quantili',
      rentByRooms: 'Distribuzione dei canoni per locali',
      rentDistribution: 'Distribuzione dei canoni per quantili',
      rentDistributionByQuantiles: 'Distribuzione dei canoni per quantili',
      rentEvolution: 'Evoluzione dei canoni per tipo di immobile',
      rentEvolutionByType: 'Evoluzione dei canoni per tipo di immobile',
      rentM2Distribution: 'Distribuzione del canone/m² per quantili',
      roomCountVsPrice: 'Numero locali vs Prezzo {{priceType}}',
      roomCountVsRent: 'Numero locali vs Canone {{priceType}}',
    },
    titlesM2: {
      priceDistributionByRooms: 'Distribuzione del prezzo/m² per locali',
      rentDistributionByRooms: 'Distribuzione del canone/m² per locali',
      roomCountVsPrice: 'Numero locali vs Prezzo {{priceType}}/m²',
    },
    transactionType: {
      distributionTitle: 'Distribuzione per tipo di transazione',
      dominantType: 'Tipo dominante',
      trendsTitle: 'Evoluzione temporale',
    },
    unitComposition: {
      averageArea: 'Superficie media',
      noData: 'Nessun dato sulla composizione delle unità disponibile',
      numberOfRooms: 'Numero di stanze',
      numberOfUnits: 'Numero di unità',
      room: 'Stanza',
      roomDistribution: 'Distribuzione delle stanze',
      roomDistributionSubtext: 'Numero di unità per numero di stanze',
      rooms: 'Stanze',
      units: 'unità',
      unitTypeComposition: 'Composizione per tipo di unità',
      unitTypeCompositionSubtext: 'La dimensione rappresenta il numero di unità, il colore rappresenta la superficie media',
    },
    views: {
      absolute: 'Prezzi assoluti',
      growth: 'Crescita annua %',
      index: 'Indice dei prezzi (Base 100)',
      quantile: 'Distribuzione per quantile',
    },
    viewTypes: {
      percentage: 'Vista percentuale',
      sideBySide: 'Affiancato',
      stacked: 'Vista impilata',
    },
  },
  common: {
    about: 'Info',
    app_description: 'Analisi immobiliare pubblica',
    app_name: 'Popety.io',
    attachments: {
      clearSearch: 'Cancella ricerca',
      filesEmptyDescription: 'Nessun file è stato aggiunto a questa analisi.',
      filesEmptyTitle: 'Nessun file',
      noResultsDescription: "Prova un'altra ricerca.",
      noResultsTitle: 'Nessun risultato',
      notesEmptyDescription: 'Nessuna nota è stata aggiunta a questa analisi.',
      notesEmptyTitle: 'Nessuna nota',
      searchNotes: 'Cerca note...',
    },
    back: 'Indietro',
    buildingPermits: {
      saved: {
        approved: 'Approvati',
        buildingPermits: 'Permessi edilizi',
        emptyDescription: 'Salva i permessi edilizi dalla scheda "Permessi edilizi" per confrontarli in seguito',
        emptyTitle: 'Nessun permesso edilizio salvato',
        loading: 'Caricamento permessi edilizi salvati...',
        mostCommonCategory: 'Categoria più comune',
        permits: 'Permessi',
        totalSaved: 'Totale salvati',
      },
    },
    cancel: 'Annulla',
    close: 'Chiudi',
    contact: 'Contatto',
    download: 'Scarica',
    error: 'Errore',
    error_loading_data: 'Errore nel caricamento dei dati',
    export: 'Esporta',
    fields: {
      access_quality: 'Qualità di accesso',
      buildable_area: 'Area edificabile',
      building_type: 'Tipo di edificio',
      canton: 'Cantone:',
      condition: 'Condizione',
      construction_year: 'Anno di costruzione',
      coordinates: 'Coordinate',
      description: 'Descrizione',
      development_potential: 'Potenziale di sviluppo',
      elevation: 'Altitudine:',
      elevator: 'Ascensore',
      energy_efficiency: 'Efficienza energetica',
      energy_rating: 'Classe energetica',
      filters: {
        location: 'Posizione',
        price_range: 'Fascia di prezzo',
        property_type: 'Tipo di proprietà',
      },
      heating_system: 'Sistema di riscaldamento',
      land_area: 'Area del terreno',
      last_renovation: 'Ultima ristrutturazione',
      latitude: 'Latitudine:',
      location: 'Posizione',
      longitude: 'Longitudine:',
      max_floors: 'Piani massimi',
      municipality: 'Comune',
      parking_spaces: 'Posti auto',
      postal_code: 'Codice postale:',
      propertyType: {
        Commercial: 'Commerciale',
        Houseappartment: 'Casa/Appartamento',
      },
      slope: 'Pendenza:',
      street: 'Via:',
      terrain_type: 'Tipo di terreno',
      total_area: 'Area totale',
      total_floors: 'Piani totali',
      total_units: 'Unità totali',
      utilities: 'Servizi pubblici',
      zone_type: 'Tipo di zona',
    },
    filter: 'Filtra',
    help: 'Aiuto',
    languages: {
      english: 'Inglese',
      french: 'Francese',
      german: 'Tedesco',
      italian: 'Italiano',
      select_language: 'Seleziona lingua',
    },
    loading: 'Caricamento...',
    next: 'Avanti',
    no_data_available: 'Nessun dato disponibile',
    on: 'il',
    overview: {
      address_details: 'Dettagli indirizzo',
      building_overview: 'Panoramica edificio',
      geographic_information: 'Informazioni geografiche',
      key_features: 'Caratteristiche principali',
      land_overview: 'Panoramica terreno',
      location_information: 'Informazioni sulla posizione',
    },
    powered_by: 'Powered by Popety.io',
    privacy: 'Privacy',
    refresh: 'Aggiorna',
    save: 'Salva',
    scoreModal: {
      methodology: {
        dataAge: 'Alcuni dati sottostanti possono risalire a 6 mesi fa',
        dataSources: 'Le fonti dei dati includono registri catastali, regolamenti di zona, dati geografici e analisi di mercato',
        generalPotential: 'I punteggi riflettono un potenziale generale, non risultati di sviluppo garantiti',
        howCalculated: 'Come vengono calcolati i punteggi',
        limitations: 'Limitazioni',
        localRegulations: 'Le normative locali possono imporre vincoli aggiuntivi non riflessi nei punteggi',
        marketConditions: 'Le condizioni di mercato possono cambiare indipendentemente da queste metriche',
        range: 'I punteggi vanno da 0 a 100, dove 100 è ottimale per lo sviluppo',
        title: 'Metodologia e limitazioni',
        weightedCombination: 'Il punteggio di sviluppo è una combinazione ponderata dei quattro indicatori individuali',
      },
      overallScore: 'Punteggio complessivo',
      overallScoreDescription: 'Questo punteggio rappresenta il potenziale di sviluppo complessivo del terreno, calcolato come combinazione ponderata dei quattro indicatori individuali visualizzati nel grafico radar.',
      scoreBreakdown: 'Dettaglio dei punteggi',
      scores: {
        geometry: {
          description: "Basato sulla forma della parcella, superficie, pendenza e caratteristiche geografiche che influenzano l'edificabilità e l'attrattiva di mercato.",
          displayLabel: 'Forma geo.',
          radarLabel: 'Geometria',
        },
        legacy: {
          description: 'Valuta la qualità e le condizioni delle strutture esistenti sul terreno. Un punteggio più alto indica meno vincoli derivanti dagli edifici esistenti.',
          displayLabel: 'Esistente',
          radarLabel: 'Patrimonio',
        },
        livability: {
          description: "Misura i fattori di qualità della vita, tra cui la vicinanza ai servizi, l'accesso ai trasporti pubblici e la qualità ambientale.",
          displayLabel: 'Ambiente',
          radarLabel: 'Vivibilità',
        },
        potential: {
          description: 'Indica quanto del potenziale edificatorio consentito è attualmente inutilizzato. Un punteggio più alto significa che rimangono maggiori opportunità di sviluppo.',
          displayLabel: 'Sottosfruttato',
          radarLabel: 'Potenziale',
        },
      },
      scoresUpdated: 'I punteggi vengono aggiornati periodicamente in base ai dati più recenti disponibili.',
      title: 'Dettagli del punteggio di sviluppo',
    },
    search: 'Cerca',
    settings: 'Impostazioni',
    shared_by: 'da {{name}}',
    shared_on: 'Condiviso il {{date}}',
    sidebar: {
      items: {
        amenities: 'Servizi',
        buildingCharacteristics: "Caratteristiche dell'edificio",
        buildingDetails: 'Dettagli edifici',
        buildingPermits: 'Permessi edilizi',
        demographics: 'Demografia',
        electricity: 'Elettricità',
        employment: 'Occupazione',
        energy: 'Energia',
        feasibilityStudy: 'Studio di fattibilità',
        files: 'File',
        geoAnalysis: 'Analisi geo',
        history: 'Cronologia',
        noiseAnalysis: 'Analisi del rumore',
        notes: 'Note',
        purchaseListings: 'Annunci vendita',
        purchaseMarket: 'Mercato acquisto',
        rentalListings: 'Annunci di locazione',
        rentalMarket: 'Mercato locativo',
        restrictions: 'Restrizioni',
        summary: 'Riepilogo',
        sunlightStudy: 'Studio luce solare',
        taxes: 'Imposte',
        transactions: 'Transazioni',
        transportAccess: 'Trasporti & Accesso',
        unitDetails: 'Dettagli unità',
        zoningRules: 'Regole di zona',
      },
      sections: {
        development: 'Sviluppo',
        environment: 'Ambiente',
        market: 'Mercato',
        overview: 'Panoramica',
        socialEconomic: 'Sociale & Economico',
      },
    },
    sort: 'Ordina',
    status: {
      address_not_available: 'Indirizzo non disponibile',
      available: 'Disponibile',
      not_available: 'Non disponibile',
      unknown: 'Sconosciuto',
      unknown_location: 'Posizione sconosciuta',
    },
    terms: 'Termini',
    try_again: 'Riprova',
    units: {
      buildingUnits: '{{count}} unità',
      currency: 'CHF',
      floors: '{{count}} piani',
      na: 'N/D',
      rooms: 'stanze',
      spaces: 'posti',
      square_meters: 'm²',
    },
    validation: {
      failed_to_validate: 'Validazione accesso fallita',
      invalid_link: 'Link non valido',
      link_expired: 'Questo link non è valido o è scaduto.',
      validating_access: 'Validazione accesso...',
    },
    view: 'Visualizza',
    yes_no: {
      no: 'No',
      yes: 'Sì',
    },
  },
  comparables: {
    no_location_data: {
      listings: "Dati di posizione non disponibili per l'analisi comparativa",
      transactions: "Dati di posizione non disponibili per l'analisi delle transazioni",
    },
  },
  demographics: {
    charts: {
      annualizedGrowthRate: {
        subtitle: 'Tasso di crescita annuale medio su diversi periodi temporali per un confronto accurato',
        title: 'Confronto del tasso di crescita annualizzato',
      },
      axis: {
        annualGrowthRate: 'Tasso di crescita annuale (%)',
        households: 'Nuclei familiari',
        population: 'Popolazione',
      },
      communityStability: {
        descriptions: {
          established: 'Stabiliti (6-10 anni)',
          longTerm: 'Lungo terminé (10+ anni)',
          natives: 'Nativi (dalla nascita)',
          newcomers: 'Nuovi arrivati (0-1 anno)',
          settling: 'In fase di insediamento (1-5 anni)',
        },
        implications: {
          established: 'Inquilini stabili, potenziali primi acquirenti',
          longTerm: 'Orientati alla proprieta, investiti nella comunità',
          mixed: 'Esigenze abitative diversificate nella comunità',
          natives: 'Legami comunitàri profondi, spesso proprietà ereditate',
          newcomers: 'Alta domanda locativa, unità arredate, termini flessibili',
          settling: 'Transizioné a contratti più lunghi, miglioramenti qualitativi',
        },
        legend: {
          '0to1Year': '0-1 Anno',
          '10plusYears': '10+ Anni',
          '1to5Years': '1-5 Anni',
          '6to10Years': '6-10 Anni',
          sinceBirth: 'Dalla nascita',
        },
        levels: {
          high: 'Alta',
          low: 'Bassa',
          moderate: 'Moderata',
          veryHigh: 'Molto alta',
        },
        markets: {
          balanced: 'Mercato equilibrato locazione/proprieta',
          mixed: 'Mercato misto con esigenze varie',
          ownershipFocused: 'Mercato orientato alla proprieta',
          rentalFocused: 'Mercato orientato alla locazione',
        },
        subtitle: 'Modelli di durata della residenza che indicano il carattere della comunità e le dinamiche di mercato',
        summary: {
          establishedRésidents: 'Residenti consolidati',
          marketDynamics: 'Impatta sui modelli di domanda immobiliare',
          newcomers: 'Nuovi arrivati',
          ownershipPotential: 'Potenziale di mercato della proprieta',
          rentalOpportunities: 'Opportunità di mercato locativo',
          stability: 'Stabilità',
          title: 'Analisi della stabilità della comunità',
          turnoverHigh: 'Alto (mercato locativo attivo)',
          turnoverLow: 'Basso (comunità stabile)',
          turnoverModerate: 'Moderato (dinamiche equilibrate)',
          turnoverRate: 'Tasso di ricambio',
        },
        title: 'Stabilità della comunità',
        tooltips: {
          count: 'Conteggio',
          marketImpact: 'Impatto sul mercato',
          percentage: 'Percentuale',
          résidents: 'Residenti',
        },
      },
      growthComparison: {
        axis: {
          annualGrowthRate: 'Tasso di crescita annuale (%)',
        },
        descriptions: {
          exceptional: 'Crescita eccezionale - Mercato in forte espansione',
          good: 'Buona crescita - Mercato sano',
          moderateDecline: 'Declino moderato - Condizioni difficili',
          modest: 'Crescita modesta - Area stabile',
          significantDecline: 'Declino significativo - Mercato sotto pressione',
          slightDecline: 'Leggero déclino - Osservare attentamente il mercato',
          strong: 'Forte crescita - Area ad alta domanda',
        },
        implications: {
          careful: 'Analisi accurata richiesta prima delle decisioni di investimento',
          cautious: 'Approccio cauto raccomandato, monitorare le tendenze del mercato',
          excellent: 'Eccellente clima di investimento con forte potenziale di apprezzamento',
          favorable: 'Condizioni favorevoli per investimentiè sviluppo immobiliare',
          stable: 'Mercato stabile adatto per investimenti a lungo termine',
        },
        summary: {
          acrossAllPeriods: 'in tutti i periodi',
          averageGrowth: 'Crescita media',
          challengingPeriod: 'Periodo difficile',
          growthPattern: 'Modello di crescita',
          peakGrowth: 'Crescita massima',
          positiveTrend: 'Tendenza positiva',
          ppRange: 'punti percentuali',
          strongPerformance: 'Forte performance',
          title: 'Analisi dei modelli di crescita',
          volatility: 'Volatilita',
          volatilityHigh: 'Alta',
          volatilityLow: 'Bassa',
          volatilityModerate: 'Moderata',
          weakestPeriod: 'Periodo più debole',
        },
        tooltips: {
          annualized: 'Crescita annualizzata',
          marketImpact: 'Impatto sul mercato',
          perYear: "all'anno",
        },
        trends: {
          accelerating: 'In accelerazione',
          consistent: 'Costante',
          decelerating: 'In rallentamento',
        },
      },
      growthPeriods: {
        fiveYears: '5 Anni',
        oneYear: '1 Anno',
        tenYears: '10 Anni',
        twoYears: '2 Anni',
      },
      householdComposition: {
        legend: {
          '1person': '1 Persona',
          '2people': '2 Persone',
          '3people': '3 Persone',
          '4people': '4 Persone',
          '5people': '5 Persone',
          '6plusPeople': '6+ Persone',
        },
        markets: {
          diverse: 'Mix diversificato di nuclei familiari che richiede tipi di proprietà vari',
          family: 'Area dominata dalle famiglie con domanda di proprietà più grandiè case',
          modern: 'Mercato orientato alle coppie con domanda di proprietà moderné 2-3 stanze',
          rental: 'Un alto rapporto di personé singole indica un forte mercato locativo per monolocaliè piccoli appartamenti',
        },
        recommendations: {
          couple: 'Appartamenti 2-3 stanze con servizi moderni preferiti',
          extendedFamily: 'Alloggi multigenerazionali con aree abitative separate',
          family: 'Appartamenti 4-5 stanzeè case con spazio esterno',
          largeFamily: 'Grandi proprietà 5+ stanzeè case richieste',
          mixed: 'Tipi di proprietà diversificati per soddisfare le esigenze abitative varie',
          smallFamily: 'Appartamenti 3-4 stanze adatti alle famiglie necessari',
          studio: 'Monolocaliè appartamenti 1-2 stanze sono molto richiesti',
        },
        subtitle: 'Distribuzione delle dimensioni delle famiglie che mostra i modelli di domanda per tipo di proprietà',
        summary: {
          couples: 'Coppie',
          couplesUnits: 'Appartamenti moderni 2-3 stanze',
          families: 'Famiglie (3+ persone)',
          familiesUnits: 'Appartamenti 3+ stanzeè case',
          singlePerson: 'Nuclei familiari monocomponente',
          singlePersonUnits: 'Monolocaliè unità 1-2 stanze',
          title: 'Analisi della domanda immobiliare',
        },
        title: 'Composizione delle famiglie',
        tooltips: {
          count: 'Conteggio',
          households: 'Nuclei familiari',
          percentage: 'Percentuale',
          propertyDemand: 'Domanda immobiliare',
        },
      },
      householdSizes: {
        fivePeople: '5 Persone',
        fourPeople: '4 Persone',
        onePerson: '1 Persona',
        sixPlusPeople: '6+ Persone',
        threePeople: '3 Persone',
        twoPeople: '2 Persone',
      },
      legend: {
        cantonal: 'Cantonale',
        female: 'Femmine',
        foreign: 'Stranieri',
        foreignPopulation: 'Popolazioné straniera',
        households: 'Nuclei familiari',
        interCantonal: 'Intercantonale',
        international: 'Internazionale',
        local: 'Locale',
        male: 'Maschi',
        newBorn: 'Neonati',
        swiss: 'Svizzeri',
        swissPopulation: 'Popolazioné svizzera',
        totalPopulation: 'Popolazioné totale',
      },
      migrationChart: {
        descriptions: {
          cantonal: 'Dallo stesso cantonale',
          interCantonal: 'Da altri cantoni',
          international: "Dall'estero",
          local: 'Rimasto nella stessa città',
          newBorn: "Nato nell'ultimo anno",
        },
        legend: {
          cantonal: 'Cantonale',
          interCantonal: 'Intercantonale',
          international: 'Internazionale',
          local: 'Locale',
          newBorn: 'Neonati',
        },
        profiles: {
          balanced: {
            characteristics: 'Mix di ritenzioné localeè nuovi arrivi, ricambio sano',
            title: 'Migrazioné equilibrata',
          },
          highInternational: {
            characteristics: 'Forte attrazioné per i residenti internazionali, esigenze culturali diverse',
            title: 'Alta attrazioné internazionale',
          },
          régionalHub: {
            characteristics: 'Attira residenti da tutta la Svizzera, area in crescita',
            title: 'Centro régionale',
          },
          stableLocal: {
            characteristics: 'Alto tasso di ritenzione, residenti consolidati, stabilità della comunità',
            title: 'Comunità locale stabile',
          },
        },
        sources: {
          cantonal: 'Nel cantonale',
          international: 'Internazionale',
          local: 'Ritenzioné locale',
          otherCantons: 'Altri cantoni',
        },
        summary: {
          dominantSource: 'Fonte dominante',
          externalNatural: 'Esternoè naturale',
          growingInternational: 'Comunità internazionale in crescita con esigenze abitative diverse',
          healthyMix: 'Mix sano di stabilitàè crescita',
          highLocalRétention: 'Indica un forte attaccamento alla comunitàè un basso ricambio',
          internalMovement: 'Movimento interno',
          populationDynamics: 'Dinamiche della popolazione',
        },
        tooltips: {
          origin: 'Origine',
        },
      },
      migrationOrigins: {
        subtitle: "Fontiè modelli di movimento della popolazioné nell'area",
        title: 'Origini migratorie',
      },
      nationalityChart: {
        legend: {
          foreign: 'Stranieri',
          swiss: 'Svizzeri',
        },
        profiles: {
          balanced: {
            characteristics: 'Mix di residenti svizzeriè internazionali, preferenze diverse',
            title: 'Comunità equilibrata',
          },
          cosmopolitan: {
            characteristics: 'Diversità urbana, influenze culturali miste, esigenze abitative varie',
            title: 'Comunità cosmopolita',
          },
          internationalHub: {
            characteristics: 'Connésso globalmente, diversificato, preferenze di stile di vita moderno',
            title: 'Centro internazionale',
          },
          traditional: {
            characteristics: 'Prevalentemente svizzera, usanze locali, cultura della proprieta',
            title: 'Comunità svizzera tradizionale',
          },
        },
        summary: {
          balanced: 'Mercato equilibrato che serve sia le esigenze di locazione che di proprietà con preferenze diverse',
          composition: 'Composizione per nazionalità',
          highForeign: 'Forte potenziale di mercato locativo, servizi moderni apprezzati, termini di locazioné flessibili preferiti',
          lowForeign: 'Cultura della proprietà dominante, preferenze abitative tradizionali, stabilità a lungo termine',
          marketImplications: 'Implicazioni di mercato',
        },
        tooltips: {
          foreignImplication: 'Potenziale di mercato locativo, servizi moderni apprezzati, standard internazionali',
          housingImpact: "Impatto sull'alloggio",
          population: 'Popolazione',
          swissImplication: 'Preferenze tradizionali di proprieta, residenti stabili a lungo termine',
        },
      },
      nationalityComposition: {
        subtitle: "Distribuzioné dei residenti svizzeriè stranieri nell'area locale",
        title: 'Composizione per nazionalità',
      },
      populationDistribution: {
        subtitle: 'Ripartizioné per etàè genere che mostra i target demografici per lo sviluppo immobiliare',
        title: 'Distribuzioné della popolazione',
      },
      populationEvolution: {
        subtitle: 'Tendenze storiche della popolazioné che mostrano i modelli di crescitaè lo sviluppo del mercato',
        title: "Cronologia dell'evoluzioné della popolazione",
      },
      populationPyramid: {
        annotations: {
          accessibility: 'Accessibilita importante',
          familyHousing: 'Domanda di alloggi familiari',
          strongRental: 'Forte potenziale locativo',
        },
        legend: {
          female: 'Femmine',
          male: 'Maschi',
        },
        summary: {
          accessibilityNeeds: 'Esigenze di accessibilitaè ridimensionamento',
          families: 'Famiglie (30-54)',
          purchasingDemand: 'Principale segmento di acquirenti immobiliari',
          rentalDemand: 'Segmento chiave del mercato locativo',
          seniors: 'Anziani (65+)',
          title: 'Approfondimenti sulla struttura demografica',
          totalPopulation: 'Popolazioné totale',
          youngAdults: 'Giovani adulti (20-39)',
        },
        tooltips: {
          ageGroup: "Fascia d'eta",
          population: 'Popolazione',
          ratio: 'Rapporto Maschi/Femmine',
        },
      },
      populationTrend: {
        axis: {
          households: 'Nuclei familiari',
          population: 'Popolazione',
        },
        legend: {
          foreignPopulation: 'Popolazioné straniera',
          households: 'Nuclei familiari',
          swissPopulation: 'Popolazioné svizzera',
          totalPopulation: 'Popolazioné totale',
        },
        summary: {
          currentComposition: 'Composizione attuale',
          decreasing: 'In diminuzione',
          foreignPopulation: 'Popolazioné straniera',
          householdTrend: 'Tendenza delle famiglie',
          increasing: 'In aumento',
          periodAnalysis: 'Analisi del periodo',
          stable: 'Stabile',
          title: 'Riepilogo delle tendenze',
          totalGrowth: 'Crescita totale',
          years: 'anni',
        },
        tooltips: {
          change: 'variazione',
          décline: 'déclino',
          foreign: 'Stranieri',
          growth: 'crescita',
          households: 'Nuclei familiari',
          swiss: 'Svizzeri',
          total: 'Totale',
          yearOverYear: 'Anno su anno',
        },
      },
      résidentialTenure: {
        oneToFiveYears: '1-5 Anni',
        sinceBirth: 'Dalla nascita',
        sixToTenYears: '6-10 Anni',
        tenPlusYears: '10+ Anni',
        zeroToOneYear: '0-1 Anno',
      },
      series: {
        growthRate: 'Tasso di crescita',
        householdComposition: 'Composizione familiare',
        migrationOrigin: 'Origine migratoria',
        nationality: 'Nazionalità',
        residents: 'Residenti',
        zeroGrowth: 'Crescita zero',
      },
    },
    filters: {
      byBicycle: 'In bicicletta',
      byCar: 'In auto',
      byWalk: 'A piedi',
      city: 'Città',
      district: 'Distretto',
      location: 'Posizione:',
      minBike: '{{time}}min bici',
      minDrive: '{{time}}min in auto',
      minWalk: '{{time}}min à piedi',
      options: {
        radius: {
          '1km': '1km',
          '2km': '2km',
          '500m': '500m',
          '5km': '5km',
        },
        time: {
          '10min': '10 min',
          '15min': '15 min',
          '20min': '20 min',
          '30min': '30 min',
          '5min': '5 min',
        },
      },
      selectLocation: 'Seleziona posizione',
    },
    insights: {
      currentComposition: 'Composizione attuale',
      decreasing: 'In diminuzione',
      foreignPopulationGrowth: 'Popolazioné straniera',
      growth: 'crescita',
      growthDescriptions: {
        exceptionalGrowth: 'Crescita eccezionale',
        goodGrowth: 'Buona crescita',
        moderateDecline: 'Declino moderato',
        modestGrowth: 'Crescita modesta',
        significantDecline: 'Declino significativo',
        slightDecline: 'Leggero déclino',
        strongGrowth: 'Forte crescita',
      },
      growthPatternAnalysis: {
        acrossAllPeriods: 'in tutti i periodi',
        averageGrowth: 'Crescita media',
        growthPattern: 'Modello di crescita',
        patterns: {
          accelerating: 'In accelerazione',
          consistent: 'Costante',
          decelerating: 'In rallentamento',
        },
        peakGrowth: 'Crescita massima',
        performanceDescriptions: {
          challengingPeriod: '(Periodo difficile)',
          positiveTrend: '(Tendenza positiva)',
          strongPerformance: '(Forte performance)',
        },
        ppRange: 'intervallo di {{range}}pp',
        title: 'Analisi dei modelli di crescita',
        volatility: 'Volatilita',
        volatilityLevels: {
          high: 'Alta',
          low: 'Bassa',
          moderate: 'Moderata',
        },
        weakestPeriod: 'Periodo più debole',
      },
      householdMarkets: {
        couplesToModernProperties: 'Coppie: {{percentage}}% - Proprietà moderné di 2-3 stanze',
        diverseHousingNeeds: 'Esigenze abitative diverse',
        familiesToLargerProperties: 'Famiglie: {{percentage}}% - Appartamenti 3+ stanzeè case',
        highRentalMarketPotential: 'Alto potenziale di mercato locativo',
        modernApartmentDemand: 'Domanda di appartamenti moderni',
        singlePersonToStudios: 'Singoli: {{percentage}}% - Monolocaliè appartamenti 1-2 stanze',
        strongFamilyHousingDemand: 'Forte domanda di alloggi familiari',
        title: 'Implicazioni di mercato',
      },
      householdTrend: 'Tendenza delle famiglie',
      housingMarketImplications: {
        balancedMarket: 'Mercato equilibrato che serve sia le esigenze di locazione che di proprietà con preferenze diverse',
        modernAmenities: 'Servizi moderni apprezzati, potenziale di mercato locativo',
        ownershipCulture: 'Cultura della proprietà dominante, preferenze abitative tradizionali, stabilità a lungo termine',
        strongRentalMarket: 'Forte potenziale di mercato locativo, servizi moderni apprezzati, termini di locazioné flessibili preferiti',
        title: 'Implicazioni per il mercato immobiliare:',
        traditionalPreferences: 'Preferenze abitative tradizionali, cultura della proprieta',
      },
      increasing: 'In aumento',
      marketImpact: {
        carefulMarketAnalysisRequired: 'Analisi di mercato accurata richiesta',
        cautiousOptimismWarranted: 'Ottimismo cauto giustificato',
        excellentInvestmentClimate: 'Eccellente clima di investimento',
        favorableMarketConditions: 'Condizioni di mercato favorevoli',
        stableMarketPotential: 'Potenziale di mercato stabile',
      },
      marketImplications: {
        generationalOwnershipLowMobility: 'Proprietà generazionale, bassa mobilità',
        highRentalDemand: 'Alta domanda locativa, contratti flessibili',
        mixedMarketCharacteristics: 'Caratteristiche di mercato miste',
        ownershipPreferenceFamilyProperties: 'Preferenza per la proprieta, proprietà familiari',
        rentalToOwnershipTransition: 'Mercato di transizioné dalla locazione alla proprieta',
        stableOwnershipMarketLowTurnover: 'Mercato immobiliare stabile, basso ricambio',
        title: 'Implicazioni di mercato',
      },
      migrationCategories: {
        externalAndNatural: 'Esternoè naturale:',
        internalMovement: 'Movimento interno:',
      },
      migrationDescriptions: {
        bornInPastYear: "Nato nell'ultimo anno",
        fromAbroad: "Dall'estero",
        fromOtherCantons: 'Da altri cantoni',
        fromWithinCanton: 'Dallo stesso cantonale',
        stayedInSameCity: 'Rimasto nella stessa città',
      },
      migrationProfiles: {
        balancedMigration: {
          characteristics: 'Mix di ritenzioné localeè nuovi arrivi, ricambio sano',
          profile: 'Migrazioné equilibrata',
        },
        highInternationalAttraction: {
          characteristics: 'Forte attrazioné per i residenti internazionali, esigenze culturali diverse',
          profile: 'Alta attrazioné internazionale',
        },
        régionalHub: {
          characteristics: 'Attira residenti da tutta la Svizzera, area in crescita',
          profile: 'Centro régionale',
        },
        stableLocalCommunity: {
          characteristics: 'Alto tasso di ritenzione, residenti consolidati, stabilità della comunità',
          profile: 'Comunità locale stabile',
        },
      },
      nationalityComposition: 'Composizione per nazionalità:',
      nationalityProfiles: {
        balancedCommunity: {
          characteristics: 'Mix di residenti svizzeriè internazionali, preferenze diverse',
          profile: 'Comunità equilibrata',
        },
        cosmopolitanCommunity: {
          characteristics: 'Diversità urbana, influenze culturali miste, esigenze abitative varie',
          profile: 'Comunità cosmopolita',
        },
        internationalHub: {
          characteristics: 'Connésso globalmente, diversificato, preferenze di stile di vita moderno',
          profile: 'Centro internazionale',
        },
        traditionalSwissCommunity: {
          characteristics: 'Prevalentemente svizzera, usanze locali, cultura della proprieta',
          profile: 'Comunità svizzera tradizionale',
        },
      },
      populationDynamics: {
        dominantSource: 'Fonte dominante: {{source}} ({{percentage}}%)',
        dominantSources: {
          international: 'Internazionale',
          localRétention: 'Ritenzioné locale',
          otherCantons: 'Altri cantoni',
          withinCanton: 'Nel cantonale',
        },
        growingInternationalCommunity: ' - Comunità internazionale in crescita con esigenze abitative diverse',
        healthyMixOfStabilityAndGrowth: ' - Mix sano di stabilitàè crescita',
        strongCommunityAttachment: ' - Indica un forte attaccamento alla comunitàè un basso ricambio',
        title: 'Dinamiche della popolazione:',
      },
      propertyRecommendations: {
        couple: '2-3 stanze, servizi moderni',
        extendedFamily: 'Case grandi, multigenerazionali',
        family: '4-5 stanze, spazio esterno',
        largeFamily: '5+ stanze, case',
        mixed: 'Tipi di proprietà misti',
        smallFamily: '3-4 stanze, adatto alle famiglie',
        studio: 'Monolocali, 1-2 stanze',
      },
      pyramidAnnotations: {
        accessibilityImportant: 'Accessibilita\\nimportante',
        familyHousingDemand: 'Domanda di\\nalloggi familiari',
        strongRentalMarket: 'Forte potenziale\\nlocativo',
      },
      pyramidInsights: {
        seniors: 'Anziani (65+):',
        totalPopulation: 'Popolazioné totale:',
        youngAdults: 'Giovani adulti (20-39):',
      },
      stabilityAnalysis: {
        establishedRésidents: 'Residenti consolidati',
        marketDynamics: 'Dinamiche di mercato',
        marketTypes: {
          balancedMarket: 'Mercato equilibrato',
          mixedRentalOwnership: 'Locazione/proprietà misto',
          ownershipFocused: 'Orientato alla proprieta',
          rentalFocused: 'Orientato alla locazione',
        },
        newcomers: 'Nuovi arrivati',
        ownershipPotential: 'Potenziale di proprieta',
        rentalMarketOpportunities: 'Opportunità del mercato locativo',
        stability: 'Stabilità',
        stabilityLevels: {
          high: 'Alta',
          low: 'Bassa',
          moderate: 'Moderata',
          veryHigh: 'Molto alta',
        },
        title: 'Analisi della stabilità della comunità',
        turnoverLevels: {
          high: 'Alto',
          low: 'Basso',
          moderate: 'Moderato',
        },
        turnoverRate: 'Tasso di ricambio',
      },
      stabilityImplications: {
        established: 'Residenti consolidati, preferenza per la proprieta',
        longTerm: 'Residenti di lunga data, comunità stabile',
        natives: 'Nativi locali, legami comunitàri profondi',
        newcomers: 'Arrivi recenti, alta domanda locativa',
        settling: 'Stabilizzazione, transizioné dalla locazione alla proprieta',
      },
      totalGrowth: 'Crescita totale',
      trendSummary: 'Riepilogo tendenze {{years}} anni ({{startYear}}-{{endYear}})',
    },
    metrics: {
      annualGrowthRate: {
        subtitle: 'Tasso composto su 10 anni',
        title: 'Tasso di crescita annuale (CAGR)',
      },
      averageHouseholdSize: {
        people: '{{count}} persone',
        subtitle: '{{count}} nuclei familiari totali',
        title: 'Dimensioné media del nucleo familiare',
      },
      communityStability: {
        subtitle: '{{count}} residenti di lunga data',
        title: 'Stabilità della comunità',
      },
      currentPopulation: {
        subtitle: "Nell'anno {{year}}",
        title: 'Popolazioné attuale',
      },
      familyHouseholds: {
        subtitle: '{{count}} nuclei familiari',
        title: 'Nuclei familiari',
      },
      foreignResidents: {
        subtitle: '{{count}} residenti',
        title: 'Residenti stranieri',
      },
      growth10Year: {
        subtitle: 'Tendenza a lungo termine',
        title: 'Crescita su 10 anni',
      },
      growth1Year: {
        subtitle: 'Variazione recente della popolazione',
        title: 'Crescita su 1 anno',
      },
      growth2Year: {
        subtitle: 'Tendenza a breve termine',
        title: 'Crescita su 2 anni',
      },
      growth5Year: {
        subtitle: 'Tendenza a medio termine',
        title: 'Crescita su 5 anni',
      },
      householdSize: {
        subtitle: '{{count}} nuclei familiari',
        title: 'Dimensioné del nucleo familiare',
      },
      medianAge: {
        subtitle: 'Profilo età della comunità',
        title: 'Età mediana',
        years: '{{age}} anni',
      },
      newResidents: {
        subtitle: '{{count}} arrivi recenti',
        title: 'Nuovi residenti',
      },
      populationGrowth: {
        subtitle: 'Evoluzioné su 10 anni',
        title: 'Crescita demografica',
      },
      singlePersonHouseholds: {
        subtitle: '{{count}} nuclei familiari',
        title: 'Nuclei unipersonali',
      },
      totalPopulation: {
        subtitle: "Residenti dell'area locale",
        title: 'Popolazioné totale',
      },
      twoPersonHouseholds: {
        subtitle: '{{count}} nuclei familiari',
        title: 'Nuclei di due persone',
      },
    },
    states: {
      error: 'Errore nel caricamento dei dati demografici: {{error}}',
      fetchError: 'Impossibile recuperare i dati demografici',
      loading: 'Caricamento dati demografici...',
      noBuildingData: "Nessun dato edificio disponibile per l'analisi demografica",
      noData: 'I dati demografici non sono disponibili per questa posizione.',
      noTrendData: 'Nessun dato di tendenza disponibile',
    },
    subtitle: "Caratteristiche della popolazione e approfondimenti di mercato per l'area locale",
    tabs: {
      growth: 'Analisi della crescita',
      market: 'Composizione del mercato',
      overview: 'Panoramica',
    },
    title: 'Demografia',
    tooltips: {
      averageHouseholdSize: {
        calculation: 'Popolazioné totale / Numero totale di nuclei familiari',
        importance: 'Determina le dimensioni ottimali delle unitàè il mix di sviluppo immobiliare',
        limitations: "La media potrebbe non riflettere l'intera gamma delle composizioni familiari",
        shortDescription: 'Numero medio di personé per nucleo familiare',
        source: "Dati del censimento delle famiglie dell'Ufficio fédérale di statistica svizzero",
        title: 'Dimensioné media del nucleo familiare',
      },
      communityStability: {
        calculation: '(Résidenti 10+ anni + Residenti dalla nascita) / Popolazioné totale x 100',
        importance: 'Alta stabilità indica comunità mature con forte potenziale di proprieta',
        limitations: 'Basato sul tempo nel comune attuale, non nel quartiere specifico',
        shortDescription: 'Percentuale di residenti che vivono nella zona da 10+ anni o dalla nascita',
        source: "Dati sulla durata della residenza dell'Ufficio fédérale di statistica svizzero",
        title: 'Stabilità della comunità',
      },
      compoundAnnualGrowthRate: {
        calculation: '((Pop attuale / Pop 10 anni fa)^(1/10) - 1) x 100',
        importance: 'Appiana le variazioni annuali per mostrare la tendenza di crescita sottostante',
        limitations: 'Presupponé una crescita costante, la crescita effettiva potrebbe essere irregolare',
        shortDescription: 'Tasso di crescita annuale medio su 10 anni, considerando la capitalizzazione',
        source: "Calcolato dai dati dell'Ufficio fédérale di statistica svizzero",
        title: 'Tasso di crescita annuale composto',
      },
      currentPopulation: {
        calculation: 'Somma di tutti i residenti nel raggio di 500m dalla proprieta',
        importance: 'Base per calcolare i tassi di crescitaè la dimensioné del mercato',
        limitations: 'Basato su confini amministrativiè metodologia di censimento',
        shortDescription: "Popolazioné totale dell'area locale per l'anno più récente",
        source: "Dati sulla popolazioné dell'anno corrente dell'Ufficio fédérale di statistica svizzero",
        title: 'Popolazioné attuale',
      },
      familyHouseholds: {
        calculation: '(Nuclei di 3+ persone) / Totale nuclei familiari x 100',
        importance: 'Indica la domanda di proprietà più grandi con caratteristiche orientate alla famiglia',
        limitations: 'Include vari tipi di nuclei familiari, non solo famiglie con bambini',
        shortDescription: 'Percentuale di nuclei familiari con tre o più residenti',
        source: "Dati sulle dimensioni delle famiglie dell'Ufficio fédérale di statistica svizzero",
        title: 'Nuclei familiari (3+ persone)',
      },
      foreignResidents: {
        calculation: 'Popolazioné straniera / Popolazioné totale x 100',
        importance: 'Indica il carattere internazionaleè il potenziale mercato locativo',
        limitations: 'Nazionalità al momento del censimento, potrebbe non riflettere la diversità culturale',
        shortDescription: 'Percentuale di residenti con nazionalità straniera',
        source: "Dati sulla nazionalità dell'Ufficio fédérale di statistica svizzero",
        title: 'Residenti stranieri',
      },
      growth10Year: {
        calculation: '(Popolazioné attuale - 10 anni fa) / 10 anni fa x 100',
        importance: 'Rivela le tendenze demografiche a lungo terminéè i cambiamenti strutturali',
        limitations: 'Le prestazioni storiche potrebbero non prédire le tendenze future',
        shortDescription: "Variazioné della popolazioné nell'ultimo decennio",
        source: "Confronto demografico decennale dell'Ufficio fédérale di statistica svizzero",
        title: 'Crescita demografica su 10 anni',
      },
      growth1Year: {
        calculation: '(Popolazione attuale - Anno precedente) / Anno precedente x 100',
        importance: 'Mostra le tendenze immediate del mercato e i cambiamenti della domanda a breve termine',
        limitations: 'Potrebbe riflettere fattori temporanei o variazioni stagionali',
        shortDescription: "Variazione della popolazione nell'ultimo anno",
        source: "Dati annuali sulla popolazione dell'Ufficio federale di statistica svizzero",
        title: 'Crescita demografica su 1 anno',
      },
      growth2Year: {
        calculation: '(Popolazione attuale - 2 anni fa) / 2 anni fa x 100',
        importance: 'Indica le tendenze a breve termine oltre le fluttuazioni annuali',
        limitations: 'Ancora soggetto a variazioni cicliche e fattori temporanei',
        shortDescription: 'Variazione della popolazione negli ultimi due anni',
        source: "Monitoraggio demografico dell'Ufficio federale di statistica svizzero",
        title: 'Crescita demografica su 2 anni',
      },
      growth5Year: {
        calculation: '(Popolazione attuale - 5 anni fa) / 5 anni fa x 100',
        importance: 'Mostra le tendenze demografiche a medio termine e i cicli economici',
        limitations: 'Potrebbe includere gli effetti dei cicli economici o dei cambiamenti politici',
        shortDescription: 'Variazione della popolazione negli ultimi cinque anni',
        source: "Analisi demografica quinquennale dell'Ufficio federale di statistica svizzero",
        title: 'Crescita demografica su 5 anni',
      },
      medianAge: {
        calculation: "Stimato dalle distribuzioni per gruppi di età utilizzando l'interpolazione lineare",
        importance: 'Indica il mercato target per diversi tipi di proprietà e servizi',
        limitations: 'Approssimazione basata su gruppi di età, non età individuali',
        shortDescription: 'Valore età mediana quando tutti i residenti sono ordinati per età',
        source: "Dati per gruppi di età dell'Ufficio federale di statistica svizzero",
        title: 'Età mediana',
      },
      newResidents: {
        calculation: 'Residenti 0-1 anno / Popolazioné totale x 100',
        importance: 'Alte percentuali indicano aree dinamiche con opportunità locative',
        limitations: 'Include tutti i tipi di trasferimenti, dalle ricollocazioni locali alla migrazioné internazionale',
        shortDescription: "Percentuale di residenti che si sono trasferiti nella zona nell'ultimo anno",
        source: "Dati sulla migrazioné dell'Ufficio fédérale di statistica svizzero",
        title: 'Nuovi residenti (0-1 anno)',
      },
      populationGrowth: {
        calculation: '(Popolazioné attuale - Popolazioné 10 anni fa) / Popolazioné 10 anni fa',
        importance: 'La crescita indica una domanda immobiliare in aumentoè un potenziale di investimento',
        limitations: 'Le tendenze storiche potrebbero non prédire le prestazioni future',
        shortDescription: 'Variazioné della popolazioné negli ultimi 10 anni',
        source: "Dati annuali sulla popolazioné dell'Ufficio fédérale di statistica svizzero",
        title: 'Crescita demografica',
      },
      singlePersonHouseholds: {
        calculation: 'Nuclei unipersonali / Totale nuclei familiari x 100',
        importance: 'Alte percentuali indicano una forte domanda locativa per unità più piccole',
        limitations: 'Include tutte le eta, dai giovani professionisti ai residenti anziani',
        shortDescription: 'Percentuale di nuclei familiari con un solo résidente',
        source: "Dati sulla composizione delle famiglie dell'Ufficio fédérale di statistica svizzero",
        title: 'Nuclei unipersonali',
      },
      totalPopulation: {
        calculation: "Somma di tutti i residenti nell'area geografica definita",
        importance: 'Indica la dimensioné del mercatoè la densita della domanda immobiliare',
        limitations: 'Basato su statistiche ufficiali, potrebbe non riflettere le variazioni stagionali',
        shortDescription: 'Numero totale di residenti nel raggio di 500m dalla proprieta',
        source: "Dati demografici dell'Ufficio fédérale di statistica svizzero",
        title: 'Popolazioné totale',
      },
      twoPersonHouseholds: {
        calculation: 'Nuclei di due personé / Totale nuclei familiari x 100',
        importance: 'Indica la domanda di proprietà con 2-3 camere da letto, tipico per coppieè piccole famiglie',
        limitations: 'Include vari tipi di nuclei familiari: coppie, coinquilini, genitore con figlio, ecc.',
        shortDescription: 'Percentuale di nuclei familiari con due residenti',
        source: "Dati sulla composizione delle famiglie dell'Ufficio fédérale di statistica svizzero",
        title: 'Nuclei di due persone',
      },
    },
  },
  electricity: {
    categories: {
      C1: 'Microimpresa, max 8 kW',
      C2: 'Piccola impresa, max 15 kW',
      C3: 'Media impresa, max 50 kW',
      C4: 'Grande impresa, 150 kW, bassa tensione',
      C5: 'Grande impresa, 150 kW, media tensione',
      C6: 'Grande impresa, 400 kW, media tensione',
      C7: "Grande impresa, 1'630 kW, media tensione",
      H1: 'App. 2 locali, cucina elettrica',
      H2: 'App. 4 locali, cucina elettrica',
      H3: 'App. 4 locali + cucina + scaldacqua',
      H4: 'App. 5 locali + cucina + asciugatrice',
      H5: 'Casa 5 locali, tutto elettrico',
      H6: 'Casa 5 locali + riscaldamento a resistenza',
      H7: 'Casa 5 locali + pompa di calore 5 kW',
      H8: 'Grande app. condominio, altam. elettrificato',
    },
    categoryDescriptions: {
      C1: "Microimpresa, potenza max 8 kW, 8'000 kWh/anno",
      C2: "Piccola impresa, potenza max 15 kW, 30'000 kWh/anno",
      C3: "Media impresa, potenza max 50 kW, 150'000 kWh/anno",
      C4: "Grande impresa, potenza 150 kW, bassa tensione, 500'000 kWh/anno",
      C5: "Grande impresa, potenza 150 kW, media tensione, propria stazione di trasformazione, 500'000 kWh/anno",
      C6: "Grande impresa, potenza 400 kW, media tensione, propria stazione di trasformazione, 1'500'000 kWh/anno",
      C7: "Grande impresa, potenza 1'630 kW, media tensione, propria stazione di trasformazione, 7'500'000 kWh/anno",
      H1: "Appartamento di 2 locali con cucina elettrica, 1'600 kWh/anno",
      H2: "Appartamento di 4 locali con cucina elettrica, 2'500 kWh/anno",
      H3: "Appartamento di 4 locali con cucina elettrica, scaldacqua elettrico (senza asciugatrice), 4'500 kWh/anno",
      H4: "Appartamento di 5 locali con cucina elettrica, scaldacqua elettrico e asciugatrice, 4'500 kWh/anno",
      H5: "Casa indipendente, 5 locali, cucina elettrica, scaldacqua elettrico, asciugatrice, 7'500 kWh/anno",
      H6: "Casa indipendente, 5 locali, cucina elettrica, scaldacqua elettrico, asciugatrice, riscaldamento a resistenza elettrica, 25'000 kWh/anno",
      H7: "Casa indipendente, 5 locali, cucina elettrica, scaldacqua elettrico, asciugatrice, pompa di calore 5 kW, 13'000 kWh/anno",
      H8: "Grande appartamento in condominio, altamente elettrificato (cucina, scaldacqua, asciugatrice, lavastoviglie), 7'500 kWh/anno",
    },
    categoryGroups: {
      commercial: 'Imprese (C1-C7)',
      commercialSubtitle: 'Consumo commerciale / industriale',
      residential: 'Nuclei domestici (H1-H8)',
      residentialSubtitle: 'Consumo residenziale',
    },
    charts: {
      noData: 'Nessun dato grafico disponibile',
      priceEvolution: {
        axis: {
          price: 'Prezzo (ct./kWh)',
        },
        subtitle: 'Tendenze storiche delle tariffe (ct./kWh)',
        summary: {
          avgChange: 'Variazione media',
          decreasing: 'In calo',
          increasing: 'In aumento',
          stable: 'Stabile',
          title: 'Tendenze dei prezzi {{startYear}}–{{endYear}}',
          trend: 'Tendenza',
        },
        title: 'Evoluzione dei prezzi per gestore di rete',
      },
    },
    comparison: {
      aboveCantonMedian: 'sopra la mediana cantonale',
      aboveNationalMedian: 'sopra la mediana nazionale',
      belowCantonMedian: 'sotto la mediana cantonale',
      belowNationalMedian: 'sotto la mediana nazionale',
      canton: 'Mediana cantone',
      switzerland: 'Mediana Svizzera',
      thisLocation: 'Questa posizione',
      title: 'Confronto geografico dei prezzi',
    },
    efficiency: {
      high: 'Costo basso',
      low: 'Costo elevato',
      medium: 'Costo medio',
    },
    evolution: {
      '10year': '10 anni',
      '1year': '1 anno',
      '2year': '2 anni',
      '5year': '5 anni',
      na: 'N/D',
      title: "Riepilogo dell'evoluzione dei prezzi",
    },
    filters: {
      category: 'Categoria',
      categoryTrigger: 'Categoria:',
      location: 'Posizione',
    },
    gridOperators: {
      cheapest: 'Più economico',
      distribution: 'Utilizzo della rete',
      energy: 'Energia',
      name: 'Gestore di rete',
      supplement: 'Supplemento',
      taxes: 'Tasse',
      title: 'Confronto gestori di rete',
      total: 'Totale',
      unit: 'ct./kWh',
    },
    insights: {
      highEfficiency: "I prezzi dell'elettricità in questo comune sono inferiori alle mediane cantonale e nazionale. Favorevole per i costi operativi e le pompe di calore.",
      lowEfficiency: "I prezzi dell'elettricità in questo comune sono superiori alle mediane cantonale e nazionale. Ciò aumenta significativamente i costi operativi, specialmente per il riscaldamento elettrico.",
      mediumEfficiency: "I prezzi dell'elettricità in questo comune sono vicini alle mediane regionali e nazionali. I costi operativi sono nella fascia tipica per la Svizzera.",
      title: 'Valutazione costi elettricità',
    },
    metrics: {
      annualCost: {
        subtitle: 'Bolletta annuale stimata (più economico)',
        title: 'Costo annuale',
      },
      cheapestPrice: {
        subtitle: 'Miglior tariffa disponibile (ct./kWh)',
        title: 'Prezzo più basso',
      },
      priceRange: {
        subtitle: 'Min – Max tra gestori',
        title: 'Fascia di prezzo',
      },
    },
    states: {
      categoryNotAvailable: 'Nessun dato disponibile per questa categoria. Solo la categoria H4 (Casa media) è attualmente disponibile.',
      error: 'Errore: {{error}}',
      fetchError: "Impossibile caricare i dati sull'elettricità",
      loading: "Caricamento dei dati sui prezzi dell'elettricità...",
      noData: "Nessun dato sui prezzi dell'elettricità disponibile per questa posizione.",
      noHistoricalData: 'Nessun dato storico disponibile.',
    },
    subtitle: 'Dati tariffari dei gestori di rete (ElCom)',
    tabs: {
      overview: 'Panoramica',
      trends: 'Tendenze',
    },
    title: "Prezzi dell'elettricità",
    tooltips: {
      annualCost: {
        calculation: 'Tariffa più economica (ct./kWh) × consumo annuale (kWh) della categoria selezionata.',
        importance: 'Componente chiave dei costi operativi per i calcoli del costo totale di proprietà.',
        limitations: 'Il consumo effettivo può variare. Basato sui profili di consumo standard ElCom.',
        shortDescription: 'Bolletta annuale stimata basata sul gestore di rete più economico e il consumo standard.',
        source: "ElCom (Commissione federale dell'energia elettrica)",
        title: 'Costo annuale stimato',
      },
      cheapestPrice: {
        calculation: 'Include utilizzo della rete, energia, tasse e supplemento federale (RIC).',
        importance: 'Impatto diretto sui costi operativi per proprietari e inquilini.',
        limitations: 'I prezzi possono cambiare annualmente. Basato sui profili standard ElCom.',
        shortDescription: 'La tariffa elettrica totale più bassa disponibile in questo comune da qualsiasi gestore di rete.',
        source: "ElCom (Commissione federale dell'energia elettrica)",
        title: "Prezzo dell'elettricità più basso",
      },
      priceRange: {
        calculation: 'Prezzo totale minimo e massimo di tutti i gestori di rete per la categoria selezionata.',
        importance: 'Una forbice più ampia significa risparmi potenziali scegliendo il giusto gestore di rete.',
        limitations: "Non tutti i gestori di rete potrebbero servire tutti gli indirizzi all'interno di un comune.",
        shortDescription: 'La differenza tra il gestore di rete più economico e quello più costoso in questo comune.',
        source: "ElCom (Commissione federale dell'energia elettrica)",
        title: 'Fascia di prezzo',
      },
    },
  },
  elevation: {
    constraints: {
      amongTallest: {
        description: "Questo edificio è già nel top {{percentile}}% delle altezze del quartiere. Un'altezza aggiuntiva potrebbe essere oggetto di esame.",
        title: 'Tra i più alti del quartiere:',
      },
      architecturalCohesion: {
        description: "Gli edifici vicini sono di un periodo di costruzione simile. Il progetto di sopraelevazione dovrebbe mantenere l'armonia architettonica.",
        title: 'Coerenza architettonica:',
      },
      heritageProtected: {
        description: "Questo edificio ha lo status di protezione del patrimonio ({{rank}}). Qualsiasi modifica richiede un'autorizzazione speciale e potrebbe essere limitata.",
        title: 'Patrimonio protetto:',
      },
      maxHeightReached: {
        description: "L'edificio ha già raggiunto o superato l'altezza legale massima per questa zona. Non è possibile aggiungere piani aggiuntivi.",
        title: 'Altezza massima raggiunta:',
      },
      protectedNearby: {
        description: "Ci sono edifici protetti nelle immediate vicinanze. I progetti di sopraelevazione potrebbero richiedere una valutazione dell'impatto sul patrimonio.",
        title: 'Edifici protetti nelle vicinanze:',
      },
      structuralAssessment: {
        description: "L'edificio ha {{age}} anni. Si raccomanda una valutazione strutturale completa prima di qualsiasi progetto di sopraelevazione.",
        title: 'Valutazione strutturale richiesta:',
      },
    },
    elevationCharts: {
      far: {
        available: 'Disponibile',
        current: 'Attuale',
        maximum: 'Massimo',
        subtitle: 'Densità di sviluppo attuale vs massimo consentito',
        title: 'Utilizzo del rapporto di superficie ({{indiceType}})',
        used: 'I.s. utilizzato',
      },
      height: {
        available: 'Disponibile',
        availableMeters: '+{{meters}}m disponibile',
        currentBuilding: 'Edificio\nattuale',
        height: 'Altezza',
        legalMaximum: 'Massimo\nlegale',
        legend: {
          availableSpace: 'Spazio disponibile (+{{height}}m)',
          currentBuilding: 'Edificio attuale ({{height}}m)',
          legalMaximum: 'Massimo legale ({{height}}m)',
          neighborsAverage: 'Media vicini ({{height}}m)',
          neighborsMaximum: 'Max vicini ({{height}}m)',
        },
        maxAllowedByZoning: 'Massimo consentito dalla zonizzazione',
        neighborsAverage: 'Media\nvicini',
        neighborsMaximum: 'Massimo\nvicini',
        subtitle: "Altezza dell'edificio vs massimo legale e contesto del quartiere",
        title: 'Confronto delle altezze',
        utilization: 'Utilizzo',
      },
    },
    header: {
      subtitle: 'Analisi delle possibilità di espansione verticale',
      subtitleFull: 'Analisi completa del potenziale di sopraelevazione basata su regolamenti urbanistici, capacità strutturale e contesto del quartiere',
      title: 'Potenziale di sopraelevazione',
    },
    overview: {
      availableFloors: {
        label: 'Piani disponibili',
        tooltip: {
          calculation: 'Piani legali max - Piani attuali = Piani disponibili',
          importance: 'Metrica chiave per valutare il potenziale di espansione verticale',
          limitations: 'Soggetto a fattibilità strutturale e permessi di costruzione',
          shortDescription: 'Numero di piani aggiuntivi che possono potenzialmente essere aggiunti in base ai regolamenti urbanistici',
          source: 'Regolamenti urbanistici cantonali',
          title: 'Piani disponibili per sopraelevazione',
        },
      },
      availableHeight: {
        label: 'Altezza disponibile',
        limited: 'Spazio limitato',
        none: 'Nessuno spazio',
        oneFloor: '1 piano possibile',
        tooltip: {
          calculation: 'Altezza legale max - Altezza attuale = Altezza disponibile',
          importance: 'Determina lo spazio fisico disponibile per nuovi piani',
          limitations: 'Non tiene conto dei requisiti della struttura del tetto',
          shortDescription: "Altezza aggiuntiva in metri che può essere aggiunta all'edificio",
          source: "Dati sull'altezza dell'edificio e limiti di zonizzazione",
          title: 'Altezza disponibile per sopraelevazione',
        },
        twoFloors: '2+ piani possibili',
      },
      elevationScore: {
        label: 'Punteggio sopraelevazione',
        tooltip: {
          calculation: 'Combinazione ponderata di piani disponibili, conformità normativa e fattori strutturali',
          categories: {
            excellent: 'Eccellente potenziale',
            limited: 'Potenziale limitato',
            moderate: 'Potenziale moderato',
            veryLow: 'Potenziale molto basso',
          },
          importance: 'Valutazione rapida della fattibilità della sopraelevazione per decisioni di investimento',
          limitations: 'Non sostituisce la valutazione professionale strutturale e legale',
          shortDescription: "Punteggio composito che valuta il potenziale complessivo di sopraelevazione dell'edificio",
          source: 'Algoritmo proprietario Popety.io',
          title: 'Punteggio complessivo di fattibilità della sopraelevazione',
        },
      },
      feasibility: {
        buildingAge: {
          historic: 'Storico',
          label: "Età dell'edificio",
          mature: 'Maturo',
          modern: 'Moderno',
          old: 'Vecchio',
          tooltip: {
            calculation: 'Anno attuale - Anno di costruzione',
            categories: {
              historic: 'Storico (100+ anni): Valutazione completa essenziale',
              mature: 'Maturo (30-60 anni): Valutazione raccomandata',
              modern: 'Moderno (0-30 anni): Capacità strutturale standard',
              old: 'Vecchio (60-100 anni): Valutazione dettagliata richiesta',
            },
            importance: 'Gli edifici più vecchi potrebbero richiedere un rinforzo strutturale',
            shortDescription: "Come l'età dell'edificio influenza la fattibilità della sopraelevazione e le valutazioni richieste",
            source: 'Registro federale degli edifici (REA)',
            title: "Impatto dell'età dell'edificio sulla sopraelevazione",
          },
          years: '{{years}} anni',
        },
        heritageProtection: {
          label: 'Protezione del patrimonio',
          tooltip: {
            importance: 'Gli edifici protetti affrontano restrizioni significative sulle modifiche',
            shortDescription: "La classificazione di protezione del patrimonio dell'edificio, se presente",
            source: 'Registri del patrimonio cantonali',
            title: 'Stato di protezione del patrimonio',
          },
        },
        overallRating: {
          excellent: 'Eccellente',
          good: 'Buono',
          label: 'Valutazione complessiva',
          limited: 'Limitato',
          poor: 'Scarso',
          tooltip: {
            calculation: 'Combinazione ponderata di fattori normativi, strutturali e di quartiere',
            categories: {
              excellent: {
                description: 'Condizioni molto favorevoli per la sopraelevazione',
                label: 'Eccellente (70-100)',
              },
              good: {
                description: 'Favorevole con alcune considerazioni',
                label: 'Buono (40-69)',
              },
              limited: {
                description: 'Vincoli significativi da superare',
                label: 'Limitato (20-39)',
              },
              poor: {
                description: 'Ostacoli maggiori; sopraelevazione probabilmente non fattibile',
                label: 'Scarso (0-19)',
              },
            },
            importance: 'Riferimento rapido per le decisioni di investimento',
            limitations: 'Valutazione professionale raccomandata per le decisioni finali',
            shortDescription: 'Valutazione completa che combina tutti i fattori di fattibilità',
            title: 'Valutazione complessiva della fattibilità',
          },
        },
        quartierBuildings: {
          label: 'Edifici del quartiere',
          tooltip: {
            importance: 'Un campione più ampio fornisce un contesto di quartiere più affidabile',
            shortDescription: "Numero di edifici nell'area del quartiere analizzata",
            source: 'Registro federale degli edifici (REA)',
            title: 'Totale edifici nel quartiere',
          },
        },
        similarPeriod: {
          label: 'Edifici di periodo simile',
          noFlexible: 'No - Più flessibile',
          tooltip: {
            importance: 'Può influenzare i requisiti di progettazione per i progetti di sopraelevazione',
            shortDescription: 'Se gli edifici vicini sono stati costruiti in un periodo simile, richiedendo coerenza architettonica',
            source: 'Analisi delle date di costruzione del quartiere',
            title: 'Edifici vicini di periodo di costruzione simile',
          },
          yesRequired: 'Sì - Coerenza richiesta',
        },
        title: 'Valutazione di fattibilità',
      },
      legalFramework: {
        availableFarSpace: {
          label: 'Spazio I.s. disponibile',
          tooltip: {
            calculation: '(I.s. max - I.s. attuale) × Superficie del terreno',
            importance: 'Metrica chiave per determinare la superficie edificabile aggiuntiva',
            shortDescription: 'Superficie di piano aggiuntiva in m² che può essere costruita secondo i regolamenti I.s.',
            source: 'Calcolato dal catasto e dai dati di zonizzazione',
            title: 'Spazio del rapporto di superficie disponibile',
          },
        },
        currentFloors: {
          label: 'Piani attuali',
          tooltip: {
            calculation: 'Conteggio dei piani sopra il livello del suolo, escluso il seminterrato',
            importance: 'Base per calcolare il potenziale di piani aggiuntivi',
            shortDescription: "Il numero attuale di piani fuori terra nell'edificio",
            source: 'Registro federale degli edifici (REA)',
            title: 'Numero attuale di piani',
          },
        },
        currentHeight: {
          label: 'Altezza attuale',
          tooltip: {
            calculation: 'Misurata dal livello del suolo naturale alla cresta del tetto',
            importance: 'Punto di riferimento per calcolare lo spazio di sopraelevazione disponibile',
            shortDescription: "L'altezza misurata dell'edificio dal livello del suolo al punto più alto",
            source: 'Registro federale degli edifici (REA)',
            title: "Altezza attuale dell'edificio",
          },
        },
        farIndex: {
          label: 'Indice I.s. utilizzato',
          tooltip: {
            calculation: 'Determinato dai regolamenti cantonali in base al tipo di zona',
            categories: {
              sp: {
                description: 'Indice di superficie di piano - Cantone Vaud',
                label: 'Superficie di piano (S.p.)',
              },
              spd: {
                description: 'Indice di superficie di piano determinante - Cantone Ginevra',
                label: 'Superficie di piano determinante (S.p.d.)',
              },
              std: {
                description: 'Indice di superficie di terreno determinante',
                label: 'Superficie di terreno determinante (S.t.d.)',
              },
            },
            importance: 'Determina il metodo di calcolo per la superficie edificabile',
            shortDescription: 'Il tipo di indice del rapporto di superficie applicabile a questa proprietà',
            source: 'Regolamenti edilizi cantonali',
            title: 'Indice del rapporto di superficie',
          },
        },
        maxLegalFloors: {
          label: 'Piani legali max',
          tooltip: {
            calculation: "Derivato dall'altezza massima divisa per l'altezza standard del piano (3m)",
            importance: "Determina il limite superiore per l'espansione verticale",
            limitations: 'Può variare in base al tipo di edificio e alle regole specifiche della zona',
            shortDescription: 'Il numero massimo di piani consentiti per gli edifici in questa zona',
            source: 'Regolamenti urbanistici cantonali',
            title: 'Numero massimo legale di piani',
          },
        },
        maxLegalHeight: {
          label: 'Altezza legale max',
          tooltip: {
            calculation: 'Definita dai piani di zonizzazione cantonali e comunali',
            importance: 'Limite rigido che non può essere superato senza dispensa speciale',
            limitations: 'Può essere soggetta a vincoli aggiuntivi come le regole di distanza',
            shortDescription: "L'altezza massima consentita per gli edifici in questa zona secondo i regolamenti urbanistici",
            source: 'Regolamenti urbanistici comunali',
            title: "Altezza legale massima dell'edificio",
          },
        },
        title: 'Quadro giuridico',
      },
      legalStatus: {
        floorsPossible: '{{count}} piano/i possibile/i',
        label: 'Stato legale',
        noExpansion: 'Nessuna espansione possibile',
        tooltip: {
          categories: {
            allowed: {
              description: "L'edificio può essere sopraelevato entro i limiti di zonizzazione",
              label: 'Sopraelevazione consentita',
            },
            assessment: {
              description: 'Valutazione dettagliata necessaria per determinare la fattibilità',
              label: 'Richiede valutazione',
            },
            maximum: {
              description: "L'edificio ha raggiunto l'altezza massima consentita",
              label: 'Massimo raggiunto',
            },
            protected: {
              description: 'La protezione del patrimonio limita le modifiche',
              label: 'Edificio protetto',
            },
          },
          importance: 'Determina se la sopraelevazione è legalmente possibile',
          limitations: 'Basato sulle normative attuali; può cambiare nel tempo',
          shortDescription: 'Stato normativo attuale riguardo alle possibilità di sopraelevazione',
          source: 'Regolamenti edilizi cantonali e registri del patrimonio',
          title: 'Stato legale per sopraelevazione',
        },
      },
      neighborhoodFit: {
        avgHeight: {
          label: 'Altezza media vicini',
          tooltip: {
            calculation: 'Altezza media di tutti gli edifici entro il raggio del quartiere',
            importance: "Riferimento per la valutazione contestuale dell'altezza dell'edificio",
            shortDescription: "L'altezza media degli edifici nel quartiere immediato",
            source: 'Registro federale degli edifici (REA)',
            title: 'Altezza media degli edifici vicini',
          },
        },
        buildingDensity: {
          label: 'Densità degli edifici',
          tooltip: {
            calculation: "Impronta dell'edificio / Superficie del terreno, rispetto al quartiere",
            importance: "L'alta densità può limitare le opzioni di espansione",
            shortDescription: 'Quanto è densa la copertura degli edifici rispetto alla media del quartiere',
            source: "Catasto e dati sull'impronta dell'edificio",
            title: 'Percentile di densità degli edifici',
          },
        },
        contiguityRatio: {
          label: 'Rapporto di contiguità',
          tooltip: {
            calculation: 'Lunghezza delle pareti condivise / Perimetro totale × 100',
            importance: "L'alta contiguità influenza la complessità della costruzione e il coordinamento con i vicini",
            shortDescription: "Percentuale del perimetro dell'edificio condivisa con gli edifici adiacenti",
            source: "Analisi dell'impronta dell'edificio",
            title: "Rapporto di contiguità dell'edificio",
          },
        },
        heightPercentile: {
          label: 'Percentile di altezza',
          tooltip: {
            calculation: 'Percentuale di edifici del quartiere che sono più bassi',
            categories: {
              belowAvg: 'Sotto la media',
              lowerMid: 'Metà inferiore',
              tallest: 'Tra i più alti',
              upperMid: 'Metà superiore',
            },
            importance: 'Indica come la sopraelevazione potrebbe influenzare lo skyline del quartiere',
            shortDescription: "Come l'altezza di questo edificio si confronta con gli altri nel quartiere immediato",
            source: 'Analisi degli edifici vicini entro un raggio di 100m',
            title: "Percentile di altezza dell'edificio nel quartiere",
          },
        },
        protectedNearby: {
          label: 'Protetto nelle vicinanze',
          tooltip: {
            importance: "Potrebbe richiedere una valutazione dell'impatto sul patrimonio per i progetti di sopraelevazione",
            shortDescription: 'Indica se ci sono edifici protetti nelle immediate vicinanze',
            source: 'Registri del patrimonio cantonali',
            title: 'Edifici protetti nelle vicinanze',
          },
        },
        tallestNeighbor: {
          label: 'Vicino più alto',
          tooltip: {
            calculation: 'Altezza massima tra tutti gli edifici del quartiere',
            importance: 'Indica il precedente di altezza esistente nella zona',
            shortDescription: "L'altezza dell'edificio più alto nel quartiere immediato",
            source: 'Registro federale degli edifici (REA)',
            title: 'Edificio più alto nel quartiere',
          },
        },
        title: 'Integrazione nel quartiere',
      },
    },
    regulatory: {
      approvals: {
        architecturalPlans: 'Piani architettonici',
        buildingPermit: 'Permesso di costruire',
        elevator: 'Installazione ascensore',
        fireSafety: 'Approvazione sicurezza antincendio',
        heritageConsultation: 'Consultazione del patrimonio',
        heritageImpact: "Valutazione dell'impatto sul patrimonio",
        recommended: 'Raccomandato',
        required: 'Richiesto',
        structuralReview: 'Revisione strutturale',
        title: 'Approvazioni richieste',
      },
      farCompliance: {
        availableSpace: {
          label: 'Spazio I.s. disponibile',
          tooltip: {
            importance: 'Metrica chiave per determinare il potenziale di costruzione aggiuntivo',
            shortDescription: 'Superficie edificabile aggiuntiva in m² basata sui limiti I.s.',
            source: 'Calcolato dal catasto e dai dati di zonizzazione',
            title: 'Spazio di superficie di piano disponibile',
          },
        },
        indiceType: {
          label: 'Tipo di indice utilizzato',
          tooltip: {
            shortDescription: 'Il metodo di calcolo I.s. specifico utilizzato in questo cantone',
            source: 'Regolamenti edilizi cantonali',
            title: 'Tipo di indice del rapporto di superficie',
          },
        },
        sp: 'Superficie di piano (S.p.)',
        spd: 'Superficie di piano determinante (S.p.d.)',
        std: 'Superficie di terreno determinante (S.t.d.)',
        title: 'Conformità I.s.',
      },
      heightFloor: {
        availableFloors: 'Piani disponibili',
        availableHeight: 'Altezza disponibile',
        currentFloors: 'Piani attuali',
        currentHeight: {
          label: 'Altezza attuale',
          tooltip: {
            shortDescription: 'Altezza misurata dal livello del suolo al colmo del tetto',
            source: 'Registro federale degli edifici (REA)',
            title: "Altezza attuale dell'edificio",
          },
        },
        maxLegalFloors: 'Piani legali max',
        maxLegalHeight: {
          label: 'Altezza legale max',
          tooltip: {
            importance: 'Limite legale che non può essere superato senza autorizzazione speciale',
            shortDescription: "Altezza massima dell'edificio consentita dai regolamenti urbanistici",
            source: 'Regolamenti urbanistici comunali',
            title: 'Altezza legale massima',
          },
        },
        title: 'Regolamenti di altezza e piani',
      },
      timeline: {
        construction: 'Costruzione',
        constructionDuration: '{{min}}-{{max}} mesi',
        heritageReview: 'Revisione del patrimonio',
        heritageReviewDuration: '+3-6 mesi',
        permitApplication: 'Domanda di permesso',
        permitApplicationDuration: '3-6 mesi',
        preliminaryStudies: 'Studi preliminari',
        preliminaryStudiesDuration: '2-4 mesi',
        title: 'Tempistica stimata',
        totalDuration: 'Durata totale',
        totalProtected: '18-24 mesi',
        totalStandard: '12-18 mesi',
      },
    },
    score: {
      label: 'Punteggio sopraelevazione',
      tooltip: 'Valutazione complessiva della fattibilità della sopraelevazione che combina fattori normativi, strutturali e di vicinato',
    },
    shared: {
      estimated: 'stimato',
      month: 'mese',
      na: 'N/D',
      no: 'No',
      none: 'Nessuno',
      units: 'unità',
      year: 'anno',
      yes: 'Sì',
    },
    states: {
      error: 'Errore di caricamento: {{error}}',
      loading: 'Caricamento dati sopraelevazione...',
      noBuilding: 'Nessun edificio selezionato',
      noData: {
        description: "L'analisi del potenziale di sopraelevazione non è disponibile per questo edificio. Ciò potrebbe essere dovuto a dati di zonizzazione mancanti o al fatto che l'edificio si trova in una zona in cui l'analisi della sopraelevazione non è applicabile.",
        title: 'Dati sopraelevazione non disponibili',
      },
    },
    status: {
      elevationAllowed: 'Sopraelevazione consentita',
      maximumReached: 'Massimo raggiunto',
      protectedBuilding: 'Edificio protetto',
      requiresAssessment: 'Richiede valutazione',
    },
    structural: {
      condition: {
        assessmentNeeded: 'Valutazione necessaria',
        buildingAge: "Età dell'edificio",
        foundationReinforcement: 'Rinforzo delle fondazioni',
        inDepthRequired: 'Approfondita richiesta',
        likelyNotRequired: 'Probabilmente non richiesto',
        likelyRequired: 'Probabilmente richiesto',
        loadBearingWalls: 'Muri portanti',
        mature: 'Maturo',
        modern: 'Moderno',
        old: 'Vecchio',
        professionalReview: 'Revisione professionale necessaria',
        standardReview: 'Revisione standard',
        structuralCapacity: {
          label: 'Capacità strutturale',
          tooltip: {
            importance: 'Fattore critico per determinare la fattibilità della sopraelevazione',
            shortDescription: "Valutazione della capacità dell'edificio di supportare piani aggiuntivi",
            source: "Basato sull'età dell'edificio e sugli standard di costruzione",
            title: 'Capacità portante strutturale',
          },
        },
        title: "Valutazione delle condizioni dell'edificio",
        years: '{{years}} anni',
      },
      method: {
        craneAccess: 'Accesso gru',
        critical: 'Critico',
        highCarefulPlanning: 'Alto - pianificazione attenta',
        lightSteelClt: 'Telaio in acciaio leggero/CLT',
        neighborImpact: 'Impatto sui vicini',
        recommended: 'Raccomandato',
        recommendedMethod: 'Metodo raccomandato',
        siteSurveyRequired: 'Sopralluogo richiesto',
        standardMeasures: 'Misure standard',
        steelFrameConcrete: 'Telaio in acciaio + cemento',
        title: 'Metodo di costruzione',
        traditionalMasonry: 'Muratura tradizionale',
        weightOptimization: 'Ottimizzazione del peso',
      },
      reinforcement: {
        assessmentRequired: 'Valutazione richiesta',
        basicAssessment: 'Valutazione di base',
        estimatedWeight: 'Peso aggiuntivo stimato',
        foundationAssessment: 'Valutazione delle fondazioni',
        inDepthGeotechnical: 'Studio geotecnico approfondito',
        reinforcementNeeded: 'Rinforzo necessario',
        seismic: 'Conformità sismica',
        siaStandards: 'Norme SIA applicabili',
        standardSoilTest: 'Test del suolo standard',
        structuralFrame: 'Telaio strutturale',
        title: 'Necessità di rinforzo strutturale',
        typicallyAdequate: 'Generalmente adeguato',
        weightRange: '{{min}}-{{max}} kg/m²',
      },
      requirements: {
        accessDuringConstruction: 'Accesso durante la costruzione',
        elevator: 'Requisito ascensore',
        elevatorRequired: 'Ascensore richiesto (4+ piani)',
        enhancedRequirements: 'Requisiti rafforzati',
        fireSafety: 'Sicurezza antincendio',
        notRequired: 'Non richiesto',
        planningRequired: 'Pianificazione richiesta',
        standard: 'Standard',
        temporaryRoof: 'Tetto temporaneo necessario',
        title: 'Requisiti di costruzione',
        weatherProtection: 'Protezione dalle intemperie',
      },
    },
    tabs: {
      overview: 'Panoramica',
      regulatory: 'Regolamentare',
      structural: 'Strutturale',
    },
  },
  employment: {
    charts: {
      employmentTrend: {
        axis: {
          employment: 'Occupazione',
        },
        legend: {
          fullTimeEmployment: 'Occupazione a tempo pieno',
          totalEmployment: 'Occupazione totale',
        },
        noData: "Nessun dato sulla tendenza dell'occupazione disponibile",
        subtitle: "Evoluzione storica dell'occupazione mostrando la traiettoria del mercato del lavoro (2011-2022)",
        summary: {
          annualCompoundGrowth: 'crescita composta annuale',
          cagr: 'CAGR',
          currentFTRatio: 'Rapporto tempo pieno attuale',
          declining: 'In declino',
          fullTimeGrowth: 'Crescita del tempo pieno',
          growing: 'In crescita',
          jobMarketStatus: 'Stato del mercato del lavoro',
          ofJobsAreFullTime: 'dei posti di lavoro sono a tempo pieno',
          rapidGrowth: 'Crescita rapida',
          stableGrowth: 'Crescita stabile',
          title: "Tendenza dell'occupazione su {{years}} anni ({{startYear}}-{{endYear}})",
          totalJobGrowth: 'Crescita totale dei posti di lavoro',
        },
        title: "Tendenza dell'occupazione",
        tooltips: {
          fullTime: 'Tempo pieno',
          totalJobs: 'Totale posti di lavoro',
          year: 'Anno',
        },
      },
      fullTimeVsTotal: {
        subtitle: "Confronto delle tendenze di occupazione a tempo pieno e totale mostrando l'evoluzione della qualità del lavoro",
        title: 'Occupazione a tempo pieno vs totale',
      },
      jobsPerEstablishment: {
        average: 'Media',
        axis: {
          ratio: 'Posti di lavoro per stabilimento',
        },
        noData: 'Nessun dato sui posti di lavoro per stabilimento disponibile',
        subtitle: 'Indicatore di efficienza economica mostrando la dimensione media delle aziende nel tempo',
        summary: {
          balancedMix: 'Mix equilibrato di dimensioni aziendali',
          consolidating: 'Consolidamento - Emergono grandi aziende, meno piccole imprese',
          currentRatio: 'Rapporto attuale',
          fragmenting: 'Frammentazione - Più piccole imprese, crescita imprenditoriale',
          historicalChange: 'Cambiamento storico',
          interpretation: 'Interpretazione',
          jobsPerEstablishment: 'posti di lavoro per stabilimento',
          largeEmployerDominated: 'Dominato dai grandi datori di lavoro - Economia aziendale',
          periodAverage: 'Media del periodo',
          smallBusinessEconomy: 'Economia delle piccole imprese - Ambiente imprenditoriale',
          title: "Tendenza dell'efficienza economica ({{startYear}}-{{endYear}})",
        },
        title: 'Rapporto posti di lavoro per stabilimento',
        tooltips: {
          employment: 'Occupazione',
          establishments: 'Stabilimenti',
          jobsPerEstablishment: 'posti/stabilimento',
          ratio: 'Rapporto',
          year: 'Anno',
        },
      },
      publicPrivate: {
        axis: {
          employment: 'Occupazione',
          establishments: 'Stabilimenti',
        },
        legend: {
          privateSector: 'Settore privato',
          publicSector: 'Settore pubblico',
        },
        noData: 'Nessun dato sulla distribuzione pubblico/privato disponibile',
        subtitle: 'Suddivisione storica tra stabilimenti del settore pubblico e privato',
        summary: {
          balancedMix: 'Mix equilibrato pubblico-privato',
          governmentDominated: 'Economia dominata dal governo - Stabile ma crescita più lenta',
          investmentImplications: 'Implicazioni per gli investimenti',
          marketCharacter: 'Carattere del mercato',
          marketDrivenDemand: 'Domanda guidata dal mercato, maggiore potenziale di crescita, mix di inquilini diversificato',
          privateDriven: 'Economia guidata dal settore privato - Dinamica e imprenditoriale',
          privateSector: 'Settore privato',
          publicSector: 'Settore pubblico',
          stableTenantBase: 'Base inquilini stabile, minor rischio di sfitto, immobiliare orientato al governo',
          title: 'Settore pubblico vs privato ({{year}})',
        },
        title: 'Distribuzione pubblico vs privato',
        tooltips: {
          private: 'Privato',
          public: 'Pubblico',
          total: 'Totale',
          year: 'Anno',
        },
      },
      sectorComposition: {
        noData: 'Nessun dato settoriale disponibile',
        subtitle: "Struttura economica per settore mostrando la distribuzione dell'occupazione",
        summary: {
          balancedDiversified: 'Economia diversificata ed equilibrata',
          dominantSector: 'Settore dominante',
          economicCharacter: 'Carattere economico',
          highlyServiceOriented: 'Economia fortemente orientata ai servizi',
          jobs: 'posti di lavoro',
          primarySectorEconomy: 'Economia del settore primario',
          strongIndustrialBase: 'Solida base industriale',
          title: 'Struttura economica',
        },
        title: 'Composizione settoriale',
        tooltips: {
          jobs: 'Posti di lavoro',
          share: 'Quota',
        },
      },
      sectorEvolution: {
        axis: {
          employment: 'Occupazione',
        },
        legend: {
          primarySector: 'Settore primario',
          secondarySector: 'Settore secondario',
          tertiarySector: 'Settore terziario',
        },
        noData: "Nessun dato sull'evoluzione settoriale disponibile",
        subtitle: 'Composizione settoriale storica mostrando le transizioni economiche (2011-2022)',
        summary: {
          economicTransformation: 'Trasformazione economica',
          gradualTransition: 'Transizione economica graduale',
          serviceSectorTrend: 'Tendenza del settore dei servizi',
          significantStructuralChange: 'Cambiamento strutturale significativo',
          stableSectorComposition: 'Composizione settoriale stabile',
          title: 'Evoluzione settoriale ({{startYear}}-{{endYear}})',
          totalEmploymentChange: "Variazione dell'occupazione totale",
        },
        title: 'Evoluzione dei settori nel tempo',
        tooltips: {
          total: 'Totale',
          year: 'Anno',
        },
      },
      totalEmploymentTrend: {
        subtitle: 'Occupazione storica mostrando le fasi di crescita e i punti di svolta (2011-2022)',
        title: "Tendenza dell'occupazione totale",
      },
    },
    common: {
      establishments: 'stabilimenti',
      jobs: 'posti di lavoro',
    },
    filters: {
      byBicycle: 'In bicicletta',
      byCar: 'In auto',
      byWalk: 'A piedi',
      city: 'Città',
      district: 'Distretto',
      location: 'Posizione:',
      minBike: '{{minutes}}min in bicicletta',
      minDrive: '{{minutes}}min in auto',
      minWalk: '{{minutes}}min a piedi',
      selectLocation: 'Seleziona posizione',
    },
    loading: {
      employment: "Caricamento dati sull'occupazione...",
      error: "Errore nel caricamento dei dati sull'occupazione:",
      fetchFailed: "Caricamento dati sull'occupazione fallito",
      noData: "I dati sull'occupazione non sono disponibili per questa posizione.",
    },
    metrics: {
      cagr: {
        subtitle: 'Tasso composto su 10 anni',
        title: 'Tasso di crescita annuale (CAGR)',
      },
      dominantSector: {
        subtitle: "{{percentage}}% dell'occupazione totale",
        title: 'Settore dominante',
      },
      employmentGrowth: {
        subtitle: 'Evoluzione su 10 anni',
        title: "Crescita dell'occupazione",
      },
      establishmentGrowth: {
        subtitle: 'Evoluzione su 10 anni',
        title: 'Crescita degli stabilimenti',
      },
      fiveYearGrowth: {
        subtitle: 'Traiettoria a medio termine',
        title: 'Crescita su 5 anni',
      },
      fullTimeRatio: {
        subtitle: 'Indicatore di stabilità',
        title: 'Rapporto occupazione a tempo pieno',
      },
      jobsPerEstablishment: {
        subtitle: 'Efficienza economica',
        title: 'Posti di lavoro per stabilimento',
      },
      oneYearGrowth: {
        subtitle: 'Tendenza più recente',
        title: 'Crescita su 1 anno',
      },
      privateSectorShare: {
        subtitle: '{{count}} stabilimenti',
        title: 'Quota settore privato',
      },
      publicSectorShare: {
        subtitle: '{{count}} stabilimenti',
        title: 'Quota settore pubblico',
      },
      tenYearGrowth: {
        subtitle: 'Cambiamento strutturale a lungo termine',
        title: 'Crescita su 10 anni',
      },
      totalEmployment: {
        subtitle: 'Posti di lavoro nella zona',
        title: 'Occupazione totale',
      },
      totalEstablishments: {
        subtitle: 'Numero di aziende',
        title: 'Numero di aziende',
      },
      twoYearGrowth: {
        subtitle: 'Conferma della tendenza recente',
        title: 'Crescita su 2 anni',
      },
    },
    section: {
      subtitle: "Tendenze del mercato del lavoro e approfondimenti sull'attività commerciale locale",
      title: 'Occupazione',
    },
    sectors: {
      agriculture: 'Agricoltura',
      industry: 'Industria',
      primary: {
        description: 'Agricoltura, Estrazione',
        name: 'Settore primario (Agricoltura, Estrazione)',
        short: 'Primario',
      },
      privateSector: 'Settore privato',
      publicSector: 'Settore pubblico',
      secondary: {
        description: 'Industria, Costruzione',
        name: 'Settore secondario (Industria, Costruzione)',
        short: 'Secondario',
      },
      services: 'Servizi',
      tertiary: {
        description: 'Servizi',
        name: 'Settore terziario (Servizi)',
        short: 'Terziario',
      },
    },
    tabs: {
      business: 'Attività commerciale',
      growth: "Crescita dell'occupazione",
      overview: 'Panoramica',
      sectors: 'Settori economici',
    },
    tooltips: {
      cagr: {
        calculation: '((Occupazione attuale / Occupazione 10 anni fa)^(1/10) - 1) × 100',
        importance: "Livella le variazioni annuali per mostrare la tendenza di crescita dell'occupazione sottostante. Più preciso della media semplice.",
        limitations: 'Assume una crescita costante, la crescita effettiva può essere irregolare con cicli di boom/bust',
        shortDescription: "Tasso di crescita annuale medio dell'occupazione su 10 anni, tenendo conto della capitalizzazione",
        source: "Calcolato dai dati dell'Ufficio federale di statistica svizzero",
        title: 'Tasso di crescita annuale composto',
      },
      dominantSector: {
        calculation: 'Settore con max(Settore 1 %, Settore 2 %, Settore 3 %)',
        importance: "Indica il carattere economico dell'area. Le aree dominate dai servizi hanno lavoratori impiegati che supportano valori immobiliari più alti. Le aree industriali hanno bisogno di alloggi per i lavoratori. L'agricoltura indica un carattere rurale.",
        limitations: 'Il settore 3 (Servizi) è molto ampio, includendo tutto dal commercio al dettaglio alla finanza.',
        shortDescription: 'Settore economico con la quota più alta di occupazione',
        source: "Ufficio federale di statistica svizzero - Dati sull'occupazione per settore",
        title: 'Settore dominante',
      },
      employmentGrowth: {
        calculation: '(Occupazione attuale - Occupazione 10 anni fa) / Occupazione 10 anni fa',
        importance: "La crescita dell'occupazione è IL principale motore della domanda immobiliare. Una crescita positiva indica un potenziale di apprezzamento e una domanda immobiliare in aumento.",
        limitations: 'Le tendenze storiche potrebbero non prevedere le performance future. Shock esterni possono alterare la traiettoria.',
        shortDescription: "Variazione dell'occupazione negli ultimi 10 anni",
        source: "Ufficio federale di statistica svizzero - Dati storici sull'occupazione",
        title: "Crescita dell'occupazione",
      },
      establishmentGrowth: {
        calculation: '(Stabilimenti attuali - Stabilimenti 10 anni fa) / Stabilimenti 10 anni fa',
        importance: "Indicatore anticipatore della crescita dell'occupazione. Le nuove aziende spesso assumono prima del fatturato. Una crescita positiva suggerisce un ecosistema imprenditoriale e futura creazione di posti di lavoro.",
        limitations: 'La formazione di aziende può precedere il fallimento. Il conteggio netto non mostra le dinamiche di turnover.',
        shortDescription: 'Variazione del numero di aziende su 10 anni',
        source: 'Ufficio federale di statistica svizzero - Dati storici sugli stabilimenti',
        title: 'Crescita degli stabilimenti',
      },
      fiveYearGrowth: {
        calculation: '(Occupazione anno corrente - Occupazione 5 anni fa) / Occupazione 5 anni fa',
        importance: 'Indicatore di tendenza a medio termine. Più affidabile del breve termine ma ancora reattivo ai cambiamenti strutturali.',
        limitations: 'Include il periodo della pandemia COVID-19 che può distorcere le tendenze.',
        shortDescription: "Variazione dell'occupazione negli ultimi 5 anni",
        source: "Ufficio federale di statistica svizzero - Dati annuali sull'occupazione",
        title: "Crescita dell'occupazione su 5 anni",
      },
      fullTimeRatio: {
        calculation: '(Occupazione a tempo pieno / Occupazione totale) × 100',
        importance: 'Rapporti più elevati indicano occupazione e reddito più stabili. Più lavoratori a tempo pieno significa una domanda più affidabile per alloggi e spazi commerciali.',
        limitations: 'Il part-time può essere volontario o involontario. Non riflette i livelli di reddito o la sicurezza del lavoro.',
        shortDescription: "Percentuale dell'occupazione totale che è a tempo pieno",
        source: 'Ufficio federale di statistica svizzero - Statistiche sui tipi di occupazione',
        title: 'Rapporto occupazione a tempo pieno',
      },
      jobsPerEstablishment: {
        calculation: 'Occupazione totale / Numero totale di stabilimenti',
        importance: "Indica la dimensione media delle aziende e la struttura economica. Rapporti più alti suggeriscono datori di lavoro più grandi, rapporti più bassi indicano un'economia di piccole imprese.",
        limitations: 'Non distingue tra settori. I grandi datori di lavoro possono distorcere la media.',
        shortDescription: 'Numero medio di dipendenti per azienda',
        source: "Calcolato dai dati del censimento degli stabilimenti e dell'occupazione",
        title: 'Posti di lavoro per stabilimento',
      },
      oneYearGrowth: {
        calculation: '(Occupazione anno corrente - Occupazione anno precedente) / Occupazione anno precedente',
        importance: "Mostra lo slancio più recente. Una crescita recente rapida può indicare un'opportunità emergente, il declino può segnalare un avvertimento precoce.",
        limitations: 'Può essere volatile a causa del breve periodo. I dati di un singolo anno potrebbero non riflettere la tendenza.',
        shortDescription: "Variazione dell'occupazione nell'ultimo anno",
        source: "Ufficio federale di statistica svizzero - Dati annuali sull'occupazione",
        title: "Crescita dell'occupazione su 1 anno",
      },
      primarySector: {
        calculation: 'Somma di tutti i posti di lavoro nelle attività del settore NOGA 1',
        importance: 'La dominanza del settore primario indica un carattere rurale con opportunità immobiliari specializzate. Tipicamente valori immobiliari più bassi ma domanda stabile a lungo termine.',
        limitations: 'Soggetto a variazioni stagionali. Può includere lavoratori agricoli a tempo parziale.',
        shortDescription: 'Posti di lavoro in agricoltura, silvicoltura, pesca ed estrazione',
        source: 'Ufficio federale di statistica svizzero - Classificazione settoriale per codici NOGA',
        title: 'Occupazione del settore primario',
      },
      privateSectorEstablishments: {
        calculation: '(Stabilimenti del settore privato / Totale stabilimenti) × 100',
        importance: "Un elevato settore privato indica un'economia imprenditoriale, guidata dal mercato. Più dinamica ma potenzialmente volatile. Domanda immobiliare commerciale diversificata.",
        limitations: 'Non distingue tra piccole imprese e grandi società.',
        shortDescription: 'Percentuale di stabilimenti che sono imprese private',
        source: 'Ufficio federale di statistica svizzero - Classificazione settoriale',
        title: 'Stabilimenti del settore privato',
      },
      publicSectorEstablishments: {
        calculation: '(Stabilimenti del settore pubblico / Totale stabilimenti) × 100',
        importance: "Un'elevata presenza del settore pubblico indica un'economia dipendente dal governo. Più stabile ma crescita più lenta. Profilo inquilino diverso per immobili commerciali.",
        limitations: "Non riflette la dimensione dell'occupazione. Una grande entità governativa conta come un piccolo ufficio.",
        shortDescription: 'Percentuale di stabilimenti che sono enti governativi',
        source: 'Ufficio federale di statistica svizzero - Classificazione settoriale',
        title: 'Stabilimenti del settore pubblico',
      },
      secondarySector: {
        calculation: 'Somma di tutti i posti di lavoro nelle attività del settore NOGA 2',
        importance: 'La base industriale crea domanda per alloggi per la forza lavoro, strutture logistiche e proprietà commerciali. La forza lavoro operaia richiede tipicamente opzioni abitative accessibili.',
        limitations: "Può essere ciclico con le condizioni economiche. L'automazione può ridurre l'occupazione nel tempo.",
        shortDescription: 'Posti di lavoro nella manifattura, costruzione e produzione industriale',
        source: 'Ufficio federale di statistica svizzero - Classificazione settoriale per codici NOGA',
        title: 'Occupazione del settore secondario',
      },
      tenYearGrowth: {
        calculation: '(Occupazione anno corrente - Occupazione 10 anni fa) / Occupazione 10 anni fa',
        importance: 'Tendenza strutturale a lungo termine. Miglior indicatore della trasformazione economica fondamentale e della traiettoria della domanda immobiliare.',
        limitations: 'Il lungo periodo può oscurare i cambiamenti recenti. Include più cicli economici.',
        shortDescription: "Variazione dell'occupazione negli ultimi 10 anni",
        source: "Ufficio federale di statistica svizzero - Dati annuali sull'occupazione",
        title: "Crescita dell'occupazione su 10 anni",
      },
      tertiarySector: {
        calculation: 'Somma di tutti i posti di lavoro nelle attività del settore NOGA 3',
        importance: 'La dominanza del settore dei servizi indica un carattere urbano con forte domanda di proprietà residenziali e commerciali. La forza lavoro impiegatizia supporta valori immobiliari più alti.',
        limitations: 'Categoria ampia che include tipi di lavoro e livelli di reddito molto diversi.',
        shortDescription: 'Posti di lavoro nei servizi, commercio al dettaglio, finanza, istruzione, sanità e ospitalità',
        source: 'Ufficio federale di statistica svizzero - Classificazione settoriale per codici NOGA',
        title: 'Occupazione del settore terziario',
      },
      totalEmployment: {
        calculation: 'Somma di tutti i posti di lavoro (tempo pieno e parziale) in tutti i settori',
        importance: "Indica il livello di attività economica e la dimensione del mercato del lavoro. Un'occupazione più elevata suggerisce una domanda immobiliare più forte.",
        limitations: "Basato su statistiche ufficiali, potrebbe non includere l'economia informale o i lavoratori autonomi",
        shortDescription: "Numero totale di posti di lavoro nell'area geografica definita",
        source: 'Ufficio federale di statistica svizzero - Censimento delle imprese',
        title: 'Occupazione totale',
      },
      totalEstablishments: {
        calculation: 'Conteggio di tutte le sedi commerciali registrate (settore pubblico + privato)',
        importance: "Indica la dimensione dell'ecosistema aziendale e la diversità economica. Più stabilimenti suggeriscono un ambiente commerciale vivace che supporta i valori immobiliari.",
        limitations: "Non riflette la dimensione dell'azienda o il fatturato. Include aziende molto piccole.",
        shortDescription: 'Numero totale di stabilimenti commerciali nella zona',
        source: 'Ufficio federale di statistica svizzero - Censimento delle imprese',
        title: 'Totale stabilimenti',
      },
      twoYearGrowth: {
        calculation: '(Occupazione anno corrente - Occupazione 2 anni fa) / Occupazione 2 anni fa',
        importance: 'Conferma se la tendenza su 1 anno è sostenuta. Aiuta a filtrare gli eventi una tantum.',
        limitations: 'Ancora relativamente a breve termine. Può includere effetti della pandemia.',
        shortDescription: "Variazione dell'occupazione negli ultimi 2 anni",
        source: "Ufficio federale di statistica svizzero - Dati annuali sull'occupazione",
        title: "Crescita dell'occupazione su 2 anni",
      },
    },
  },
  energy: {
    dataSource: {
      egid: 'ID edificio (EGID)',
      regbl: 'Registro federale degli edifici (REA)',
      title: 'Fonte dei dati',
      viewInRegBL: 'Visualizza nel REA',
    },
    dataSourceBanner: {
      description: 'Questi dati sono raccolti e mantenuti dalle autorità federali e cantonali. Le date di ultimo aggiornamento variano per campo e sono visualizzate accanto a ogni dato.',
      title: 'Fonte dei dati: Registro federale degli edifici (REA)',
      viewCompleteRecord: "Visualizza il record completo dell'edificio nel REA",
    },
    freshness: {
      daysAgo: '{{count}} giorni fa',
      fresh: 'Aggiornato di recente',
      levels: {
        aging: 'Invecchiamento',
        outdated: 'Obsoleto',
        recent: 'Recente',
      },
      monthsAgo: '{{count}} mesi fa',
      oneYearAgo: '1 anno fa',
      stale: 'I dati potrebbero essere obsoleti',
      thisYear: "quest'anno",
      today: 'Oggi',
      yearsAgo: '{{count}} anni fa',
      yesterday: 'Ieri',
    },
    header: {
      subtitle: "Dati energetici dell'edificio dal Registro federale degli edifici (REA)",
      title: 'Analisi energetica',
    },
    heating: {
      card: {
        egidNotAvailable: 'EGID non disponibile',
        entryOf: 'Voce {{number}} di {{total}}',
        mostRecent: 'Più recente',
        title: 'Sistemi di riscaldamento',
      },
      checkRegBL: 'Verifica REA',
      metrics: {
        distributionSystem: 'Sistema di distribuzione',
        generatorType: 'Tipo di generatore',
        lastUpdated: 'Ultimo aggiornamento',
        noDataAvailable: 'Nessun dato disponibile',
        notDeclared: 'Non dichiarato',
        powerSource: 'Fonte di energia',
        status: 'Stato',
      },
      multipleEntries: {
        description: 'Questo edificio ha {{count}} voci separate nel REA, possibilmente da diverse date di registrazione o aggiornamenti. Tutte le voci sono mostrate di seguito, ordinate dalla più recente.',
        title: 'Trovate più voci nel registro',
      },
      noData: 'Nessun dato sul sistema di riscaldamento disponibile nel REA per questo edificio.',
      sections: {
        additionalHeating: 'Riscaldamento supplementare',
        additionalWaterHeating: 'Riscaldamento acqua supplementare',
        primaryHeating: 'Riscaldamento primario',
        waterHeating: 'Riscaldamento acqua',
      },
    },
    idc: {
      actionPlan: {
        heating: 'Aggiornare il sistema di riscaldamento',
        insulation: "Migliorare l'isolamento dell'edificio",
        solar: 'Installare pannelli solari',
        title: 'Azioni consigliate',
        windows: 'Sostituire le finestre con modelli ad alta efficienza energetica',
      },
      comparison: {
        buildingAge: "Età dell'edificio simile",
        canton: 'Media cantonale',
        district: 'Media del distretto',
        title: 'Confronto IDC',
      },
      costEstimator: {
        annual: 'Costo annuale',
        perM2: 'Costo al m²',
        title: 'Costi energetici stimati',
      },
      gauge: {
        current: 'IDC attuale',
        legalLimit: 'Limite legale',
        target: 'Obiettivo',
      },
      ratings: {
        average: 'Nella media',
        critical: 'Critico',
        excellent: 'Eccellente',
        good: 'Buono',
        poor: 'Scarso',
      },
      regulatory: {
        compliant: 'Conforme',
        deadline: 'Scadenza di conformità',
        nonCompliant: 'Non conforme',
        title: 'Conformità normativa',
      },
      subtitle: 'Indicatore di prestazione energetica per gli edifici di Ginevra',
      title: 'IDC - Indice di consumo di calore',
    },
    idcComparisonCard: {
      noData: 'Nessun dato di confronto disponibile per questo edificio.',
      noDataForZone: 'Nessun dato disponibile per questa zona.',
      performanceText: 'Il vostro IDC di {{idc}} MJ/m² si trova al {{percentile}}° percentile tra {{count}} edifici in {{scope}}.',
      scopeLabels: {
        municipality: 'Comune',
        npa: 'Codice postale',
        radius_500m: 'Raggio 500m',
        region: 'Cantone',
      },
      stats: {
        average: 'Media',
        maximum: 'Massimo',
        median: 'Mediana',
        minimum: 'Minimo',
        percentile25: '25° percentile',
        percentile75: '75° percentile',
      },
      title: 'Confronti IDC',
      tooltipDescription: "Confronta l'IDC di questo edificio con le statistiche di altri edifici a Ginevra. Un percentile più basso indica una migliore prestazione energetica.",
      tooltipDescriptionLoading: "Confronta l'IDC di questo edificio con le statistiche di altri edifici a Ginevra in diverse zone geografiche.",
    },
    idcDistributionChart: {
      title: 'Distribuzione IDC - {{scope}}',
      tooltipBuildings: 'Numero di edifici: <strong>{{count}}</strong>',
      xAxisName: 'IDC (MJ/m²·anno)',
      yAxisName: 'Numero di edifici',
      yourBuilding: 'Il vostro edificio',
    },
    idcGaugeChart: {
      legend: {
        compliant: 'Conforme (0-{{threshold}})',
        critical: 'Critico (>{{threshold}})',
        optimizationRequired: 'Ottimizzazione richiesta ({{min}}-{{max}})',
        warning: 'Avvertimento ({{min}}-{{max}})',
      },
      title: 'Posizione IDC',
      unit: 'MJ/m²·anno',
    },
    idcRegulatoryBanner: {
      actionTypes: {
        audit: 'Audit energetico raccomandato',
        mandatoryRenovation: 'Ristrutturazione obbligatoria richiesta',
        noObligation: 'Nessun obbligo normativo',
        optimization: 'Ottimizzazione energetica richiesta',
      },
      deadline: 'Scadenza: {{year}}',
      yearsRemaining: {
        one: '({{count}} anno rimanente)',
        other: '({{count}} anni rimanenti)',
      },
    },
    idcTab: {
      dataSourceNote: {
        description: "Ufficio cantonale dell'energia (OCEN) - Cantone di Ginevra. L'IDC viene calcolato sulla base dei consumi effettivi dichiarati e verificati. Per maggiori informazioni:",
        linkText: 'ge.ch/energia',
        title: 'Fonte dei dati:',
      },
      infoBanner: "Indice di consumo di calore (IDC) - Indicatore obbligatorio per gli edifici riscaldati del Cantone di Ginevra. L'IDC misura il consumo energetico annuale per il riscaldamento e l'acqua calda sanitaria in rapporto alla superficie di riferimento energetico (SRE).",
      metrics: {
        regulatoryThreshold: {
          title: 'Soglia regolamentare',
          tooltip: {
            calculation: 'Fissato a {{threshold}} MJ/m²/anno ({{kWh}} kWh/m²/anno) da settembre 2022',
            description: 'Soglia fissata dal Cantone di Ginevra oltre la quale sono richieste misure di ottimizzazione',
            importance: "Il superamento di questa soglia comporta l'obbligo di attuare misure di ottimizzazione energetica",
            source: "Legge sull'energia (LEn) - Cantone di Ginevra",
          },
        },
        significantExceedanceThreshold: {
          exceeded: 'Superato - Ristrutturazione obbligatoria',
          notExceeded: 'Non superato',
          periods: {
            from2031: 'dal 2031',
            until2026: 'fino al 2026',
            until2030: 'fino al 2030',
          },
          title: 'Soglia di superamento significativo',
          tooltip: {
            calculation: 'Attualmente {{threshold}} MJ/m² ({{period}}). La soglia viene progressivamente abbassata: 800 MJ/m² (2022-2026) → 650 MJ/m² (2027-2030) → 550 MJ/m² (2031+)',
            description: 'Oltre questa soglia è richiesta una ristrutturazione energetica obbligatoria',
            importance: "Il superamento di questa soglia comporta l'obbligo legale di effettuare una ristrutturazione energetica entro 3 anni dalla decisione amministrativa",
            limitations: "La soglia varia in base all'anno e verrà progressivamente ridotta per incoraggiare il miglioramento continuo del patrimonio edilizio",
            source: "Regolamento sull'energia (REn) - Cantone di Ginevra",
          },
        },
        yourPosition: {
          title: 'La vostra posizione',
          tooltip: {
            calculation: "(IDC dell'edificio - Soglia regolamentare) / Soglia regolamentare × 100",
            description: 'Scostamento dalla soglia regolamentare di {{threshold}} MJ/m²',
            importance: 'Indica se il vostro edificio è conforme ai requisiti normativi o necessita di misure di ottimizzazione',
            source: 'Calcolato dai dati OCEN',
          },
        },
      },
    },
    regblLink: {
      viewBuildingTitle: "Visualizza l'edificio {{egid}} nel Registro federale degli edifici",
      viewInRegBL: 'Visualizza nel REA',
    },
    solar: {
      comparison: {
        actual: 'Installazione attuale',
        optimal: 'Potenziale ottimale',
        title: 'Confronto del potenziale solare',
        utilizationRate: 'Tasso di utilizzo',
      },
      history: {
        title: 'Cronologia delle installazioni',
      },
      installation: {
        estimatedProduction: 'Produzione annuale stimata',
        installedPower: 'Potenza installata',
        moduleArea: 'Area dei moduli',
        title: 'Installazione solare',
        yearInstalled: 'Anno di installazione',
      },
      potential: {
        electricalEfficiency: 'Efficienza elettrica',
        roofArea: 'Area del tetto idonea',
        thermalEfficiency: 'Efficienza termica',
        title: 'Potenziale solare',
      },
    },
    solarComparison: {
      actualConditions: 'Condizioni reali',
      annualProductionPotential: 'Potenziale di produzione annuale',
      bestAnnualProduction: 'Migliore produzione annuale',
      bestCase: 'Caso migliore',
      bestSolarIrradiance: 'Miglior irraggiamento solare',
      bestSuitableArea: 'Migliore area idonea',
      estimatedCapacity: 'Capacità stimata',
      noData: 'Nessun dato sul potenziale solare disponibile per questo edificio.',
      noteDescription: 'Le condizioni reali includono tutte le aree del tetto adatte indipendentemente dall\'orientamento. Le condizioni ottimali utilizzano solo le superfici meglio orientate (tipicamente esposte a sud, pendenza ~30°). Usa "Reale" per una pianificazione realistica.',
      noteTitle: 'Qual è la differenza?',
      optimalConditions: 'Condizioni ottimali',
      realistic: 'Realistico',
      solarIrradiance: 'Irraggiamento solare',
      suitableRoofArea: 'Area del tetto idonea',
      title: 'Confronto del potenziale solare',
      titleActualVsOptimal: 'Potenziale solare: Reale vs Ottimale',
      tooltips: {
        annualProduction: {
          calculation: 'Area del tetto × Irraggiamento × Efficienza dei pannelli (~17-20%) × Perdite di sistema (~15%)',
          description: "Produzione di elettricità stimata se l'area del tetto idonea è completamente equipaggiata con pannelli solari",
          importance: "Questa è la metrica chiave per stimare i potenziali risparmi energetici e il ritorno sull'investimento",
          limitations: "Presuppone la copertura completa del tetto con pannelli standard. La produzione effettiva dipende dal tipo di pannello, dalla qualità dell'installazione e dalla manutenzione.",
          source: "Catasto solare UFE (Ufficio federale dell'energia)",
          title: 'Potenziale di produzione annuale',
        },
        bestAnnualProduction: {
          calculation: 'Migliore area idonea × Miglior irraggiamento × Efficienza dei pannelli × Perdite di sistema',
          description: 'Massima produzione di elettricità utilizzando solo le aree del tetto orientate in modo ottimale',
          importance: "Mostra l'efficienza massima teorica. Può produrre meno energia totale rispetto all'utilizzo di tutte le aree idonee se l'area ottimale è piccola.",
          limitations: "Utile per il confronto ma potrebbe non rappresentare la scelta economica migliore se l'area ottimale è limitata.",
          source: "Catasto solare UFE (Ufficio federale dell'energia)",
          title: 'Migliore produzione annuale',
        },
        bestSolarIrradiance: {
          calculation: 'Irraggiamento medio sulle superfici esposte a sud con inclinazione ottimale (~30° in Svizzera)',
          description: 'Massima radiazione solare sulle sezioni del tetto meglio orientate',
          importance: "Rappresenta il potenziale di efficienza massima. Confronta con l'irraggiamento reale per vedere quanto l'orientamento influisce sulla produzione.",
          limitations: "Raggiungibile solo su sezioni del tetto idealmente orientate. La maggior parte degli edifici ha un'area ottimale limitata.",
          source: "Catasto solare UFE (Ufficio federale dell'energia)",
          title: 'Miglior irraggiamento solare',
        },
        bestSuitableArea: {
          calculation: "Sottoinsieme filtrato dell'area totale idonea: solo le superfici esposte a sud con pendenza di ~30° ricevono la massima irradiazione annuale",
          description: 'Area del tetto con orientamento ottimale per i pannelli solari (solo sezioni meglio esposte)',
          importance: "Rappresenta le zone di posizionamento più efficienti. L'installazione qui massimizza la produzione di energia per pannello.",
          limitations: "Può essere significativamente più piccola dell'area totale idonea. Concentrarsi solo sulle aree ottimali può sottoutilizzare lo spazio disponibile sul tetto.",
          source: "Catasto solare UFE (Ufficio federale dell'energia)",
          title: 'Migliore area idonea',
        },
        estimatedCapacity: {
          calculation: 'Area del tetto idonea ÷ 6,5 m²/kWp (standard industriale: ~6,5 m² necessari per 1 kWp di capacità installata)',
          description: 'Capacità massima teorica di installazione solare in chilowatt-picco (kWp)',
          importance: "Aiuta a stimare le dimensioni dell'installazione, i costi e a confrontare con le installazioni esistenti. Una famiglia tipica necessita di 3-5 kWp.",
          limitations: "Questa è una stima approssimativa. La capacità effettiva dipende dall'efficienza dei pannelli, dai vincoli di installazione e dagli ostacoli sul tetto.",
          source: 'Stima calcolata basata sugli standard del settore',
          title: 'Capacità stimata',
        },
        estimatedCapacityOptimal: {
          calculation: 'Migliore area idonea ÷ 6,5 m²/kWp (standard industriale)',
          description: 'Capacità massima di installazione utilizzando solo le sezioni del tetto meglio orientate',
          importance: "Confronta con la stima della capacità reale per vedere quanto l'orientamento del tetto influisce sulla dimensione potenziale dell'installazione.",
          limitations: "Spesso più piccola della stima della capacità reale. Considera se è più importante massimizzare l'efficienza o la produzione totale.",
          source: 'Stima calcolata basata sugli standard del settore',
          title: 'Capacità stimata (Ottimale)',
        },
        solarIrradiance: {
          calculation: 'Modellato da dati meteorologici, topografia, orientamento del tetto e ombreggiamento locale da edifici e vegetazione',
          description: 'Energia media della radiazione solare ricevuta per metro quadrato di superficie del tetto annualmente',
          importance: 'Valori di irraggiamento più elevati indicano un migliore potenziale di energia solare. Valori superiori a 1000 kWh/m²/anno sono considerati buoni per la Svizzera.',
          limitations: 'Basato su modellazione, non su misurazioni reali. Le variazioni meteorologiche tra gli anni possono influenzare i valori reali del ±10-15%.',
          source: "Catasto solare UFE (Ufficio federale dell'energia)",
          title: 'Irraggiamento solare',
        },
        suitableRoofArea: {
          calculation: 'Analisi 3D delle superfici del tetto filtrando per pendenza (>10°), orientamento e requisiti minimi di dimensione',
          description: "Superficie totale del tetto adatta all'installazione di pannelli solari",
          importance: 'Determina il numero massimo di pannelli solari installabili e influenza direttamente la produzione energetica potenziale',
          limitations: 'Non considera ostacoli come camini, lucernari, unità HVAC o limitazioni strutturali. Valutazione professionale raccomandata.',
          source: "Catasto solare UFE (Ufficio federale dell'energia)",
          title: 'Area del tetto idonea',
        },
      },
    },
    solarInstallation: {
      added: 'aggiunto',
      firstInstallation: 'Prima installazione',
      installationCount: '{{count}} installazione',
      installationEvents: 'Eventi di installazione',
      installationHistory: 'Cronologia delle installazioni',
      installationsCount: '{{count}} installazioni',
      installationYear: 'Anno di installazione',
      installed: 'installato',
      noData: 'Nessuna installazione solare registrata per questo edificio.',
      title: 'Installazione solare',
      totalInstalledCapacity: 'Capacità totale installata',
    },
    states: {
      error: "Errore durante il caricamento dell'analisi energetica: {{error}}",
      loading: "Caricamento dell'analisi energetica...",
      noData: "Nessun dato dell'edificio disponibile",
    },
    tabs: {
      heating: 'Riscaldamento',
      idc: 'IDC Ginevra',
      solar: 'Energia solare',
    },
  },
  environment: {
    air_quality: {
      aqi: 'Indice qualità aria',
      category: 'Categoria',
      title: "Qualità dell'aria",
    },
    failed_to_fetch: 'Impossibile recuperare i dati ambientali',
    loading: 'Caricamento dati ambientali...',
    no_data: 'Nessun dato ambientale disponibile',
    no_data_description: "I dati ambientali non sono disponibili per questa posizione. Questo potrebbe essere dovuto a una copertura limitata del monitoraggio in quest'area.",
    noise: {
      aircraft: 'Rumore aereo',
      description: "Livelli di rumore e analisi dell'inquinamento acustico per questa posizione",
      guidelines: 'Linee guida livelli di rumore',
      levels: {
        moderate: 'Moderato',
        noisy: 'Rumoroso',
        quiet: 'Silenzioso',
        very_noisy: 'Molto rumoroso',
        very_quiet: 'Molto silenzioso',
      },
      railway_day: 'Rumore ferroviario (Giorno)',
      road_day: 'Rumore stradale (Giorno)',
      road_night: 'Rumore stradale (Notte)',
      title: 'Livelli di rumore',
    },
    noise_analysis: 'Analisi rumore',
    sunlight: {
      afternoon_sun: 'Sole pomeridiano',
      daily_hours: 'Sole quotidiano',
      description: 'Esposizione solare e disponibilità della luce solare durante il giorno',
      levels: {
        excellent: 'Eccellente',
        good: 'Buono',
        low: 'Basso',
        moderate: 'Moderato',
        very_low: 'Molto basso',
      },
      morning_sun: 'Sole mattutino',
      seasonal_variation: 'Variazione stagionale',
      title: 'Esposizione solare',
    },
    sunlight_study: 'Studio esposizione solare',
    title: 'Analisi ambientale',
  },
  estimate: {
    autoValuations: {
      back: 'Torna alle valutazioni',
      details: 'Dettagli',
      empty: {
        text: 'Le valutazioni automatiche dei fornitori AVM non sono disponibili per questa proprietà.',
        title: 'Nessuna valutazione automatica',
      },
      meta: {
        confidenceScore: 'Punteggio di confidenza',
        dataRange: 'Intervallo dati',
        dealType: 'Tipo di transazione',
        landArea: 'Area del terreno',
        listingsCount: 'Numero di annunci',
        method: 'Metodo',
        modelVersion: 'Versione modello',
        pricePerM2: 'Prezzo al m²',
        provider: 'Fornitore',
        unknown: 'Sconosciuto',
        valuePerM2LandConservative: 'Valore al m² di terreno (conservativo)',
        valuePerM2LandOptimistic: 'Valore al m² di terreno (ottimistico)',
        values: {
          purchase: 'Acquisto',
          rent: 'Pigione',
          sale: 'Vendita',
        },
      },
      methodDescriptions: {
        popety_io: "Valutazione automatizzata basata sull'algoritmo proprietario di Popety.io che analizza le caratteristiche dell'immobile, le transazioni recenti del mercato e i fattori specifici della posizione.",
        pricehubble: "Valutazione basata sui modelli di machine learning di PriceHubble utilizzando dati di mercato completi e attributi dell'immobile.",
        wuest_partner: 'Valutazione professionale di Wüest Partner basata sulla loro vasta esperienza nel mercato immobiliare svizzero e sui dati.',
      },
      methodology: 'Metodologia',
      subtitle: 'Valutazioni immobiliari professionali dai principali fornitori AVM',
      title: 'Valutazioni automatiche',
    },
    comparables: {
      active_listings: 'Annunci attivi',
      allSaved: 'Tutti salvati',
      averagePrice: 'Prezzo medio',
      avgLivingArea: 'Superficie media',
      avgPricePerSqm: 'Prezzo medio/m²',
      listing_price: 'Prezzo di listino',
      listings: 'Annunci',
      listingsStats: '{{count}} annunci salvati - Media {{average}}',
      listingsTitle: 'Annunci comparabili',
      livingArea: 'Superficie abitabile',
      noListingsDescription: "Nessun annuncio è stato salvato per questa stima. Gli annunci possono essere salvati dall'applicazione principale.",
      noListingsSaved: 'Nessun annuncio salvato',
      noTransactionsDescription: "Nessuna transazione è stata salvata per questa stima. Le transazioni possono essere salvate dall'applicazione principale.",
      noTransactionsSaved: 'Nessuna transazione salvata',
      perListing: 'Per annuncio',
      priceRange: 'Fascia di prezzo',
      recent_sales: 'Vendite recenti',
      similar_properties: 'Proprietà simili',
      sold_price: 'Prezzo di vendita',
      sqm: 'm²',
      title: 'Proprietà comparabili',
      to: 'a',
      totalSaved: 'Totale salvato',
      totalValue: 'Valore totale',
      transactionsStats: '{{count}} transazioni salvate - Media {{average}}',
      transactionsTitle: 'Transazioni comparabili',
    },
    confirmDelete: {
      cancel: 'Annulla',
      confirm: 'Elimina',
      defaultItem: 'questo elemento',
      deleting: 'Eliminazione...',
      message: 'Sei sicuro di voler eliminare "{{name}}"?',
      title: 'Elimina valutazione',
      warning: 'Questa azione non può essere annullata.',
    },
    error_loading_data: 'Errore nel caricamento dei dati',
    failed_to_load: "Impossibile caricare i dati di stima dell'immobile",
    land: {
      area: 'Superficie',
      buildableArea: 'Superficie edificabile',
      canton: 'Cantone',
      coordinates: 'Coordinate geografiche',
      generalInfo: 'Informazioni generali',
      latitude: 'Latitudine',
      longitude: 'Longitudine',
      maxFloors: 'Piani massimi',
      multiplePlots: '{{count}} parcelle',
      municipality: 'Comune',
      noLandData: 'Nessun dato terreno disponibile',
      plot: 'Parcella',
      plotNumber: 'Numero parcella',
      singlePlot: '1 parcella',
      title: 'Informazioni terreno',
      zoneName: 'Nome zona',
      zoneType: 'Tipo di zona',
      zoningInfo: 'Informazioni zonizzazione',
    },
    manualValuations: {
      confidence: {
        high: 'Alta',
        low: 'Bassa',
        medium: 'Media',
      },
      emptyText: 'Nessuna valutazione manuale è stata aggiunta per questa stima.',
      emptyTitle: 'Nessuna valutazione manuale',
      methods: {
        avm: 'Valutazione automatica',
        comparable: 'Vendite comparabili',
        custom: 'Valutazione personalizzata',
        dcf: 'Metodo DCF',
        developer: 'Metodo dello sviluppatore',
        intrinsic: 'Metodo del valore intrinseco',
        staticYield: 'Metodo del rendimento statico',
      },
      subtitle: 'Metodi di valutazione professionali per una valutazione accurata',
      title: 'Valutazioni manuali',
      ui: {
        chartColor: 'Colore del grafico: {{color}}',
      },
    },
    market: {
      activity: 'Attività di mercato',
      average_price: 'Prezzo medio',
      time_on_market: 'Tempo sul mercato',
      trends: 'Tendenze di mercato',
    },
    navigation: {
      amenities: 'Servizi',
      demographics: 'Demografia',
      history: 'Storia',
      listings_comparables: 'Annunci comparabili',
      noise_analysis: 'Analisi rumore',
      property_details: 'Dettagli proprietà',
      purchase_market: 'Mercato acquisti',
      rental_market: 'Mercato locativo',
      sunlight_study: 'Studio esposizione solare',
      transactions_comparables: 'Transazioni comparabili',
      valuations: 'Valutazioni',
    },
    pricePerSqm: {
      basisLabel: 'Base di calcolo',
      basisLiving: 'Superficie abitabile',
      basisUsable: 'Superficie utile',
      basisWeighted: 'Superficie ponderata',
      fallbackHint: 'Uso {{effective}} — {{requested}} non disponibile',
      gearButton: 'Impostazioni prezzo per m²',
      showToggle: 'Mostra prezzo per m²',
      unavailable: 'Non disponibile',
    },
    property: {
      address: 'Indirizzo',
      area: 'Area',
      bathrooms: 'Bagni',
      bedrooms: 'Camere da letto',
      condition: 'Condizione',
      rooms: 'Stanze',
      type: 'Tipo di proprietà',
      year_built: 'Anno di costruzione',
    },
    propertyDetails: {
      attributes: 'Attributi della proprietà',
      description: 'Descrizione',
      noDataAvailable: 'Nessun dettaglio della proprietà disponibile',
      photos: 'Foto',
      situationLocation: 'Situazione e posizione',
      subtitle: 'Panoramica delle caratteristiche della proprietà',
      title: 'Dettagli della proprietà',
    },
    sections: {
      environment: 'Ambiente',
      estimate: 'Stima',
      market: 'Mercato',
      property: 'Proprietà',
      social_economic: 'Sociale ed economico',
    },
    share: {
      section_not_available: 'Sezione non disponibile',
      section_not_shared: 'Questa sezione non è stata inclusa nel link di condivisione.',
    },
    sidebar: {
      autoValuations: 'Valutazioni automatiche',
      building: 'Edificio',
      buildingPermits: 'Permessi edilizi',
      employment: 'Occupazione',
      energy: 'Energia',
      land: 'Terreno',
      manualValuations: 'Valutazioni manuali',
      overview: 'Panoramica',
      summary: 'Riepilogo',
      transportAccess: 'Accesso trasporti',
    },
    summary: {
      checklist: {
        avmRetrieved: 'Valutazioni AVM recuperate',
        finalSelected: 'Prezzo finale selezionato',
        listingsSelected: 'Annunci comparabili selezionati',
        manualAdded: 'Valutazione manuale aggiunta',
        propertyDetails: 'Dettagli proprietà aggiunti',
        title: 'Checklist valutazione',
        transactionsSelected: 'Transazioni comparabili selezionate',
      },
      finalValuation: 'Valutazione finale',
      finalValue: 'Valore finale',
      listingsComparables: 'Annunci comparabili',
      noFinalValuation: 'Nessuna valutazione finale è stata impostata per questa stima.',
      range: 'Intervallo: {{min}} - {{max}}',
      transactionsComparables: 'Transazioni comparabili',
      valuationComparison: 'Confronto valutazioni',
    },
    title: 'Analisi immobiliare',
    valuation: {
      confidence: 'Livello di fiducia',
      estimated_value: 'Valore stimato',
      price_per_sqm: 'Prezzo al m²',
      range: 'Range di valore',
      title: 'Valutazione immobiliare',
    },
    valuations: {
      confidence: {
        high: 'Alta',
        low: 'Bassa',
        medium: 'Media',
      },
      detail: {
        confidence: 'Affidabilità',
        daysAgo: '{{days}} giorni fa',
        estimatedValue: 'Valore stimato',
        today: 'Oggi',
        valueRange: 'Intervallo di valori',
        weeksAgo: '{{weeks}} settimane fa',
        yesterday: 'Ieri',
      },
    },
  },
  explore: {
    aiFilter: {
      building: {
        description: "Descrivi l'edificio che stai cercando, e ti aiuterò a trovarlo.",
        placeholder: "es. 'Moderni edifici per uffici nel centro di Zurigo'",
        prompts: {
          '0': 'Edifici residenziali recenti (dopo il 2010) con più di 5 piani',
          '1': 'Edifici con riscaldamento a gas o petrolio ma buon potenziale solare sul tetto',
          '2': 'Edifici con annuncio di locazione negli ultimi 6 mesi',
          '3': 'Edifici residenziali con almeno 20 unità e breve tempo di viaggio verso i centri',
        },
        title: 'Assistente filtro edifici',
      },
      clearAllResponses: 'Cancella tutte le risposte ({{count}})',
      description: 'Descrivi quello che stai cercando in linguaggio naturale, e applicherò i filtri appropriati.',
      deviceSelector: {
        iphoneNotRecommended: ' (iPhone - Non raccomandato)',
        microphoneDefault: 'Microfono {{id}}',
        recommended: ' (Raccomandato)',
        selectMicrophone: '🎤 Seleziona microfono:',
      },
      errors: {
        general: 'Errore',
        processingFailed: "Errore nell'elaborazione della richiesta. Riprova.",
        voiceProcessingFailed: "Errore nell'elaborazione della richiesta vocale. Riprova.",
        voiceRecording: 'Errore registrazione vocale',
      },
      examplePrompts: {
        '0': 'Mostrami terreni liberi oltre 500m² in Zona 3',
        '1': 'Proprietà private costruite dopo il 2010',
        '2': 'Trova terreni vicino al lago con permessi di costruzione',
      },
      land: {
        description: 'Descrivi il terreno che stai cercando, e ti aiuterò a trovarlo.',
        placeholder: "es. 'Terreno di sviluppo a Zurigo con buone valutazioni'",
        prompts: {
          '0': 'Terreni oltre 1000m² con punteggio di sviluppo sopra 70% e nessun edificio protetto',
          '1': 'Terreni nudi in zone edificabili nel Canton Zurigo',
          '2': 'Terreni con edifici vecchi (<1950) ma non protetti',
          '3': 'Terreni con permesso di costruzione per progetti di sviluppo pubblicati negli ultimi 2 anni',
        },
        title: 'Assistente filtro terreni',
      },
      response: {
        filtersApplied: 'Filtri applicati',
      },
      textInput: {
        apply: 'Applica',
        placeholder: 'Digita o parla la tua richiesta di filtro...',
      },
      thinkingAnimation: {
        analyzing: 'Analizzando la tua richiesta...',
      },
      title: 'Assistente filtro IA',
      voiceInput: {
        notSupported: 'Registrazione vocale non supportata',
        recording: 'Registrazione... {{duration}}s - Clicca per fermare e inviare',
        startRecording: 'Clicca per iniziare la registrazione vocale',
      },
    },
    buildingCategories: {
      characteristics: 'Caratteristiche',
      classification: 'Classificazione',
      energy: 'Energia',
      environmental: 'Ambientale',
      history: 'Storia',
      myMaps: 'Le mie mappe',
    },
    buildingClassification: {
      garage: 'Garage',
      industrial: 'Industriale',
      mixedLow: 'Minoranza/e residenziale/i',
      mixHigh: 'Maggioranza residenziale',
      notClassified: 'Non classificato',
      office: 'Uffici',
      other: 'Altro',
      public: 'Pubblico',
      residential: 'Residenziale',
      retail: 'Commercio',
    },
    buildingClassifications: {
      Garage: 'Garage',
      Industrial: 'Industriale',
      Mixed_1: 'Uso Misto',
      Mixed_2: 'Uso Misto',
      Offices: 'Uffici',
      Other: 'Altro',
      Public: 'Pubblico',
      Residential: 'Residenziale',
      Retail: 'Commercio',
    },
    buildingLayers: {
      buildingPeriod: 'Periodo di costruzione',
      buildingPermits: 'Permessi di costruzione',
      buildingType: 'Tipo di edificio',
      constructionYear: 'Anno di costruzione',
      favorites: 'Preferiti',
      heatingSystem: 'Sistema di riscaldamento',
      lakeView: 'Vista lago',
      mountainView: 'Vista montagna',
      myTags: 'I miei tag',
      noiseExposure: 'Esposizione al rumore',
      numberOfDwellings: 'Numero di abitazioni',
      numberOfFloors: 'Numero di piani',
      numberOfUnits: 'Numero di unità',
      officialCategory: 'Categoria ufficiale',
      popetyClassification: 'Classificazione edifici',
      prospectiveBuildings: 'Edifici prospettici',
      protectionLevel: 'Livello di protezione patrimonio',
      publicTransportQuality: 'Qualità trasporti pubblici',
      renovationPeriod: 'Periodo di ristrutturazione',
      rentListings: 'Annunci di locazione',
      saleListings: 'Annunci di vendita',
      solarExposure: 'Esposizione solare',
      transactions: 'Transazioni',
      travelTimeToCenters: 'Tempo di viaggio ai centri',
      waterHeatingSystem: 'Sistema di riscaldamento acqua',
    },
    buildingPanel: {
      administrativeDetails: {
        addresses: 'Indirizzi',
        buildingName: 'Nome edificio',
        egids: 'ID Federali degli Edifici (EGIDs)',
        officialNumber: 'Numero ufficiale',
        renovationRange: 'Anno di ristrutturazione',
        title: 'Dettagli amministrativi',
        units: 'unità',
        yearRange: 'Anno di costruzione',
      },
      dwellings: {
        area: 'Superficie',
        dwellingNumber: 'Abitazione',
        features: 'Caratteristiche',
        floor: 'Piano',
        hideIndividual: 'Nascondi singole abitazioni',
        kitchen: 'Cucina',
        lastConstruction: 'Ultima costruzione',
        medianArea: 'Superficie mediana',
        medianRooms: 'Camere mediane',
        monthlyRent: 'Pigione mensile',
        multiFloor: 'Multipiano',
        noDwellings: 'Nessuna informazione sulle abitazioni disponibile',
        perMonth: '/ mese',
        pricePredictions: 'Previsioni di prezzo',
        purchasePrice: 'Prezzo di acquisto',
        rooms: 'Camere',
        singleFloor: 'Piano singolo',
        sizeRange: 'Gamma di dimensioni',
        status: 'Stato',
        title: 'Informazioni sulle abitazioni',
        totalArea: 'Superficie totale',
        totalDwellings: 'Totale abitazioni',
        viewIndividual: 'Visualizza singole abitazioni',
      },
      dwellingsLabel: 'Abitazioni',
      emptyStates: {
        noAdministrativeDetails: 'Nessun dettaglio amministrativo disponibile',
      },
      error: {
        buildingId: 'ID edificio: {{propertyId}}',
        general: "Errore nel caricamento dei dati dell'edificio",
        notFound: 'Nessun dato edificio trovato',
        retry: 'Riprova',
      },
      federalRegistry: {
        addressesLabel: 'Indirizzi',
        title: 'Registro federale degli edifici',
      },
      floorsLabel: 'Piani',
      history: {
        empty: {
          description: 'Non ci sono eventi registrati per questo edificio',
          title: 'Nessuna cronologia trovata',
        },
        error: {
          description: "Si è verificato un errore durante il caricamento dei dati cronologici dell'edificio",
          title: 'Impossibile caricare la cronologia',
        },
        filtered: {
          description: 'Prova ad aggiustare la selezione dei filtri per vedere più eventi',
          title: 'Nessun evento corrisponde ai filtri',
        },
        filters: {
          permits: 'Permessi',
          rentals: 'Locazioni',
          sales: 'Vendite',
          transactions: 'Transazioni',
        },
        loading: 'Caricamento cronologia edificio',
      },
      information: {
        buildingYear: 'Anno di costruzione',
        category: 'Categoria',
        energyEfficiency: 'Efficienza energetica',
        heatingType: 'Tipo di riscaldamento',
        height: 'Altezza',
        notAvailable: 'N/D',
        title: 'Informazioni edificio',
        type: 'Tipo',
        volume: 'Volume',
      },
      links: {
        description: "Collegamenti per l'edificio {{buildingId}}",
        title: 'Collegamenti edificio',
      },
      loading: 'Caricamento dati edificio ID: {{propertyId}}...',
      market: {
        description: "Dati di mercato per l'edificio {{buildingId}}",
        title: 'Dati di mercato',
      },
    },
    buildingStatus: {
      existing: 'Esistente',
      planned: 'Pianificato',
      under_construction: 'In Costruzione',
    },
    buildingTooltip: {
      area: 'Superficie',
      buildingInfo: 'Informazioni Edificio',
      dwellings: 'Abitazioni',
      energy: 'Energia',
      environment: 'Ambiente',
      floors: 'Piani',
      heating: 'Riscaldamento',
      height: 'Altezza',
      listings: 'Annunci',
      noAddress: 'Nessun indirizzo disponibile',
      noiseLevel: 'Livello Rumore',
      permits: 'Permessi',
      relatedData: 'Dati Correlati',
      transactions: 'Transazioni',
      transport: 'Trasporti',
      units: 'Unità',
      viewQuality: 'Qualità Vista',
      year: 'Anno di Costruzione',
    },
    categories: {
      buildings: 'Edifici',
      environmental: 'Ambientale',
      externalMaps: 'Mappe esterne',
      myMaps: 'Le mie mappe',
      noise: 'UF - Rumore',
      satelliteTimeTravel: 'UF - Viaggio nel tempo satellitare',
      score: 'Punteggio',
      urbanization: 'UF - Urbanizzazione',
      zone: 'Zona',
    },
    createDeal: {
      addContact: 'Aggiungi contatto',
      addDescription: 'Aggiungi una descrizione...',
      addNotes: 'Aggiungi note aggiuntive...',
      addParticipant: 'Aggiungi partecipante',
      addParticipantTitle: 'Aggiungi partecipante',
      addUser: 'Aggiungi utente',
      buildingTitle: 'Crea nuovo affare edificio',
      cancel: 'Annulla',
      contact: 'Contatto',
      contactRole: 'Ruolo contatto',
      created: 'Creato',
      createDeal: 'Crea affare',
      creating: 'Creazione in corso...',
      dealId: 'ID affare',
      dealInformation: 'Informazioni affare',
      dealName: 'Nome affare',
      dealType: 'Tipo affare',
      dealValue: 'Valore affare',
      description: 'Descrizione',
      editBuildingTitle: 'Modifica affare edificio',
      editTitle: 'Modifica affare',
      enterDealName: 'Inserisci nome affare',
      expectedCloseDate: 'Data chiusura prevista',
      lastModified: 'Ultima modifica',
      loadingUsers: 'Caricamento utenti...',
      metadata: 'Metadati',
      noPipelines: 'Nessuna pipeline disponibile',
      notes: 'Note',
      noUsersFound: 'Nessun utente trovato',
      optional: 'Opzionale',
      participantRole: 'Ruolo',
      participants: 'Partecipanti',
      pipeline: 'Pipeline',
      pipelineStage: 'Pipeline e fase',
      removeParticipant: 'Rimuovi partecipante',
      roleContributor: 'Collaboratore',
      roleOwner: 'Proprietario',
      roleParticipant: 'Partecipante',
      roleViewer: 'Visualizzatore',
      searchingUsers: 'Ricerca utenti...',
      searchUsers: 'Cerca utenti per nome o email...',
      selectPipelineFirst: 'Seleziona prima una pipeline',
      selectUser: 'Seleziona un utente da aggiungere',
      stage: 'Fase',
      summary: 'Riepilogo',
      title: 'Crea nuovo affare',
      updateDeal: 'Aggiorna affare',
    },
    dataSources: {
      faoData: 'Foglio ufficiale',
      faoDataHeritage: 'Patrimonio del Cantone di Ginevra',
      federalEnergyOffice: "Ufficio federale dell'energia",
      federalEnvironmentOffice: "Ufficio federale dell'ambiente",
      federalSpatialDevelopment: 'Regione federale degli edifici e delle abitazioni',
      federalStatisticalOffice: 'Ufficio federale di statistica',
      federalTransportOffice: 'Ufficio federale dei trasporti',
      marketData: 'Portali immobiliari svizzeri',
      personalCollection: 'Collezione personale',
      popetyioLabs: 'Popety.io Data Labs',
    },
    deals: {
      addDeal: 'Aggiungi affare',
      archived: 'Archiviato',
      attachError: "Errore nell'allegare gli affari. Riprova.",
      attachExisting: 'Allega affare esistente',
      attaching: 'Allegando...',
      attachSelected: 'Allega selezionati',
      availableDeals: 'Affari disponibili',
      cancel: 'Annulla',
      confirmDelete: 'Sei sicuro di voler rimuovere questo affare dalla proprietà?',
      contact: 'Contatto',
      created: 'Creato',
      createdOn: 'Creato il',
      createFirstDeal: 'Crea primo affare',
      createNewDeal: 'Crea un nuovo affare per iniziare',
      dealName: 'Nome affare',
      dealsSelected: 'affari selezionati',
      dealType: 'Tipo affare',
      dealTypeDevelopment: 'Sviluppo',
      dealTypeJointVenture: 'Joint Venture',
      dealTypeLease: 'Locazione',
      dealTypeSale: 'Vendita',
      dealValue: 'Valore affare (CHF)',
      description: 'Descrizione',
      edit: 'Modifica',
      editDeal: 'Modifica affare',
      emptyDescription: 'Inizia creando un affare per questa proprietà',
      emptyTitle: 'Nessun affare ancora',
      enterDealName: 'Inserisci nome affare',
      enterDescription: 'Inserisci descrizione',
      enterNotes: 'Inserisci note',
      expectedClose: 'Chiusura prevista',
      expectedCloseDate: 'Data chiusura prevista',
      loading: 'Caricamento affari...',
      loadingAvailableDeals: 'Caricamento affari disponibili...',
      noAvailableDeals: 'Nessun affare disponibile',
      noMatchingDeals: 'Nessun affare corrispondente trovato',
      noParticipants: 'Nessun partecipante',
      notApplicable: 'N/D',
      notes: 'Note',
      owner: 'Proprietario',
      participants: 'Partecipanti',
      pipeline: 'Pipeline',
      remove: 'Rimuovi dalla proprietà',
      removing: 'Rimozione...',
      retry: 'Riprova',
      searchForDeals: 'Cerca affari',
      searchPlaceholder: 'Cerca per nome, pipeline o tipo...',
      title: 'Affari immobiliari',
      tryDifferentSearch: 'Prova ad aggiustare i criteri di ricerca',
      type: 'Tipo',
      unassigned: 'Non assegnato',
      update: 'Aggiorna affare',
      updating: 'Aggiornamento...',
      value: 'Valore affare',
      viewInPipeline: 'Visualizza nella pipeline',
    },
    filterPanel: {
      area: {
        landArea: 'Superficie terreno',
        maxPlaceholder: 'Superficie max',
        minPlaceholder: 'Superficie min',
        title: 'Superficie',
      },
      buildingFilters: {
        common: {
          loadingTags: 'Caricamento tag...',
          noTagsAvailable: 'Nessun tag disponibile',
          noTagsHelpBuilding: 'Nessun tag disponibile. Crea tag dal pannello dettagli edificio.',
          noTagsHelpLand: 'Nessun tag disponibile. Crea tag dal pannello dettagli terreno.',
          selectPermitTypes: 'Seleziona tipi di permesso',
          selectTags: 'Seleziona tag',
        },
        environmental: {
          distanceToPowerlines: {
            '0to100m': '0 a 100m',
            over100m: 'Oltre 100m',
            placeholder: 'Seleziona distanza',
          },
          lakeView: {
            '0ha': '0 ha',
            '0to100ha': '0 a 100 ha',
            over100ha: 'Oltre 100 ha',
            placeholder: 'Seleziona vista lago',
          },
          mountainView: {
            '0to4peaks': '0 a 4 cime',
            '5to13peaks': '5 a 13 cime',
            moreThan13peaks: 'Più di 13 cime',
            placeholder: 'Seleziona vista montagna',
          },
          noiseExposure: {
            '45to52db': '45 a 52 dB',
            moreThan52db: 'Più di 52 dB',
            placeholder: 'Seleziona livelli di rumore',
            upTo45db: 'Fino a 45 dB',
          },
          publicTransport: {
            badlyServed: 'Mal servito',
            mediumServed: 'Mediamente servito',
            placeholder: 'Seleziona qualità trasporto',
            veryBadlyServed: 'Molto mal servito',
            veryWellServed: 'Molto ben servito',
            wellServed: 'Ben servito',
          },
          slope: {
            '0to4degrees': '0 a 4 gradi',
            '4to9degrees': '4 a 9 gradi',
            moreThan9degrees: 'Più di 9 gradi',
            placeholder: 'Seleziona pendenza',
          },
          taxBurden: {
            high: 'Alto (oltre 7.1%)',
            medium: 'Medio (5.1% a 7.1%)',
            placeholder: 'Seleziona carico fiscale',
            small: 'Basso (0 a 5.1%)',
          },
          travelTime: {
            long: 'Lungo',
            medium: 'Medio',
            placeholder: 'Seleziona tempi di viaggio',
            short: 'Breve',
          },
        },
        status: {
          accessible: 'Accessibile',
          active: 'Attivo',
          activeStatus: 'Stato attivo',
          approximate: 'Approssimativo',
          exactLocation: 'Posizione esatta',
          furnished: 'Arredato',
          furnishedStatus: 'Stato arredamento',
          inactive: 'Inattivo',
          newConstruction: 'Nuova costruzione',
          no: 'No',
          noPets: 'Nessun animale',
          notAccessible: 'Non accessibile',
          petsAllowed: 'Animali ammessi',
          selectAccessibility: 'Seleziona accessibilità...',
          selectActiveStatus: 'Seleziona stato attivo...',
          selectConstructionStatus: 'Seleziona stato costruzione...',
          selectFurnishedStatus: 'Seleziona stato arredamento...',
          selectLocationPrecision: 'Seleziona precisione posizione...',
          selectPetPolicy: 'Seleziona politica animali...',
          title: 'Filtri di stato',
          unfurnished: 'Non arredato',
          wheelchairAccessible: 'Accessibile in sedia a rotelle',
          yes: 'Sì',
        },
      },
      buildingFiltersTitle: 'Filtri edificio',
      buildingMode: 'Edificio',
      clearAll: 'Cancella tutti i filtri',
      close: 'Chiudi filtri',
      landFilters: {
        building: {
          buildingHeight: 'Altezza edificio',
          buildingVolume: 'Volume edificio fuori terra (m3)',
          constructionYear: 'Anno di costruzione',
          floorNumber: 'Numero di piani',
          grossFloorArea: 'Superficie lorda di pavimento',
          groundingArea: 'Superficie di appoggio al suolo (m2)',
          hideUnknownYear: 'Nascondi anno sconosciuto',
          numberOfDwellings: 'Numero di alloggi',
          title: 'Edificio',
        },
        common: {
          display: 'Mostra',
          displayOnly: 'Mostra solo',
          from: 'Da',
          hide: 'Nascondi',
          max: 'Max',
          min: 'Min',
          mixed: 'Misto',
          private: 'Privato',
          public: 'Pubblico',
          selectOption: 'Seleziona opzione',
          to: 'A',
        },
        development: {
          availableBuildableCapacity: 'Capacità edificabile disponibile (S.p. disponibile)',
          buildableCapacity: 'Capacità edificabile (S.p. zonizzazione)',
          developmentScore: 'Punteggio di sviluppo',
          title: 'Sviluppo',
          underExploitedScore: 'Punteggio di sottosfruttamento',
        },
        history: {
          buildingPermit: 'Permesso di costruire',
          buildingPermitsClassification: 'Classificazione dei permessi di costruzione',
          onlyDevelopment: 'Solo sviluppo',
          permitClassifications: {
            development: 'Sviluppo',
            other: 'Altro',
          },
          purchaseDate: 'Data di acquisto',
          purchasePrice: 'Prezzo di acquisto',
          rentDate: 'Data di locazione',
          rentPrice: 'Pigione',
          title: 'Cronologia',
          transactionDate: 'Data transazione',
          transactionPrice: 'Prezzo di transazione',
        },
        land: {
          title: 'Parcella',
        },
        landUsePlanAssignments: {
          label: 'Assegnazione piano di utilizzo del territorio',
          noAssignments: 'Nessuna assegnazione del piano di utilizzo disponibile',
          placeholder: "Seleziona un'assegnazione del piano di utilizzo",
          selectLocationFirst: 'Seleziona prima una posizione',
        },
        locationZoning: {
          landUsePlan: 'Piano di utilizzo del territorio',
          location: 'Posizione',
          noBuildingZone: 'Zona non edificabile',
          noLandUsePlans: 'Nessun piano di utilizzo disponibile',
          plan: 'Piano',
          planPlaceholder: 'Numero piano',
          selectLandUsePlan: 'Seleziona un piano di utilizzo',
          selectLocationFirst: 'Seleziona prima una posizione',
          specialZone: 'Zona speciale',
          title: 'Posizione e zonizzazione',
        },
        ownership: {
          numberOfOwners: 'Numero di proprietari',
          ownersType: 'Tipo di proprietari',
          title: 'Proprietà',
        },
        plot: {
          area: 'Superficie',
          bareLand: 'Terreno nudo',
          title: 'Parcella',
        },
        restrictions: {
          archaeologicalZone: 'Zona archeologica',
          buildingRight: 'Diritto di costruzione',
          builtSitesProtectedZone: 'Zona di protezione siti costruiti',
          dangerZone: 'Zona di pericolo',
          forestLimitZone: 'Zona limite forestale',
          forestZone: 'Zona forestale',
          mandatoryPlanningZone: 'Zona di pianificazione obbligatoria',
          natureProtectionZone: 'Zona di protezione della natura',
          noMaxCosZone: 'Zona senza C.o. max',
          notYetDefinedSpecialZone: 'Zona speciale non ancora definita',
          otherZone: 'Altra zona',
          pollutedZone: 'Zona inquinata',
          protectedBuilding: 'Edificio protetto',
          protectedObjects: 'Oggetti protetti',
          reservedZone: 'Zona riservata',
          title: 'Restrizioni',
          underwaterProtectedZone: 'Zona protetta subacquea',
          watercourseLimitZone: "Zona limite corso d'acqua",
        },
      },
      landFiltersTitle: 'Filtri terreno',
      loadFilters: 'Carica filtri salvati',
      location: {
        municipality: 'Comune',
        region: 'Regione',
        searchPlaceholder: 'Cerca regioni, comuni, città...',
        selectMunicipality: 'Seleziona un comune',
        selectPlan: 'Seleziona un piano',
        selectRegion: 'Seleziona una regione',
        title: 'Posizione',
      },
      municipalities: {
        carouge: 'Carouge',
        geneva: 'Ginevra',
        lancy: 'Lancy',
        meyrin: 'Meyrin',
        vernier: 'Vernier',
      },
      plotMode: 'Parcella',
      propertyType: {
        placeholder: 'Seleziona tipo di proprietà',
      },
      quickFilters: {
        maxArea: 'Max {{area}}m²',
        minArea: 'Min {{area}}m²',
        privateOwnership: 'Proprietà privata',
        privateProperty: 'Proprietà privata',
        title: 'Filtri rapidi',
        zone3: 'Zona 3',
      },
      regions: {
        basel: 'Regione di Basilea',
        central: 'Svizzera centrale',
        lakeGeneva: 'Regione del Lago di Ginevra',
        ticino: 'Ticino',
        zurich: 'Regione di Zurigo',
      },
      savePreset: 'Salva preimpostazione filtro',
      title: 'Filtri',
    },
    financial: {
      'Nombre de logements': 'Numero di abitazioni',
    },
    heatingTypes: {
      district: 'Teleriscaldamento',
      electric: 'Elettrico',
      gas: 'Gas',
      heat_pump: 'Pompa di Calore',
      oil: 'Olio',
      solar: 'Solare',
      wood: 'Legna',
    },
    landPlotTooltip: {
      buildings: 'Edifici',
      landArea: 'Area terreno',
      noAddress: 'Nessun indirizzo disponibile',
      noZoning: 'Nessuna informazione di zonizzazione',
      units: 'Unità',
      zoning: 'Zonizzazione',
    },
    layers: {
      availability: 'Disponibilità',
      buildingArea: 'Area edificabile',
      constructionYear: 'Anno di costruzione',
      daytimeRailwayNoise: 'Rumore ferroviario diurno',
      daytimeRoadTrafficNoise: 'Rumore stradale diurno',
      densifiableArea: 'Area densificabile',
      developmentPotential: 'Potenziale di sviluppo',
      favorites: 'Preferiti',
      legacyRiskScore: 'Punteggio rischio patrimonio',
      livabilityScore: 'Punteggio vivibilità',
      myTags: 'I miei tag',
      numberOfUnits: 'Numero di unità',
      prospectiveProperties: 'Proprietà prospettiche',
      protectedBuildings: 'Edifici protetti',
      restrictions: 'Restrizioni',
      underExploitationIndex: 'Indice di sottoutilizzo',
      zoneLayout: 'Layout della zona',
    },
    legends: {
      categoricalLabels: {
        availability: {
          available: 'Disponibile',
          notAvailable: 'Non disponibile',
        },
        buildingArea: {
          no: 'No',
          yes: 'Sì',
        },
        buildingClassification: {
          garage: 'Garage',
          industrial: 'Industriale',
          mixed1: 'Uso misto 1',
          mixed2: 'Uso misto 2',
          notClassified: 'Non classificato',
          offices: 'Uffici',
          other: 'Altro',
          public: 'Pubblico',
          residential: 'Residenziale',
          retail: 'Commerciale',
        },
        buildingPeriod: {
          '1919to1945': '1919-1945',
          '1946to1960': '1946-1960',
          '1961to1970': '1961-1970',
          '1971to1980': '1971-1980',
          '1981to1985': '1981-1985',
          '1986to1990': '1986-1990',
          '1991to1995': '1991-1995',
          '1996to2000': '1996-2000',
          '2001to2005': '2001-2005',
          '2006to2010': '2006-2010',
          '2011to2015': '2011-2015',
          '2015onward': 'Dal 2015',
          before1919: 'Prima del 1919',
        },
        buildingType: {
          exclusivelyResidential: 'Esclusivamente residenziale',
          nonResidential: 'Non residenziale',
          partiallyResidential: 'Parzialmente residenziale',
          residentialWithAnnex: 'Residenziale con annesso',
          special: 'Costruzione speciale',
          temporary: 'Abitazione provvisoria',
          unknown: 'Sconosciuto',
        },
        customContent: {
          customTags: 'Tag personalizzati',
          favoriteProperties: 'Proprietà preferite',
          prospectiveProperties: 'Proprietà prospettiche',
        },
        lakeView: {
          large: 'Vista lago grande (> 100 ha)',
          none: 'Nessuna vista lago',
          small: 'Vista lago piccola (< 100 ha)',
        },
        monumentProtection: {
          no: 'Non protetto',
          yes: 'Protetto',
        },
        mountainView: {
          few: 'Poche cime (< 5)',
          many: 'Molte cime (> 13)',
          medium: 'Cime medie (5-13)',
        },
        noiseExposure: {
          high: 'Alto (> 52 dB)',
          low: 'Basso (< 45 dB)',
          medium: 'Medio (45-52 dB)',
        },
        officialCategory: {
          agricultural: 'Edificio agricolo',
          apartment: 'Condominio (3+ unità)',
          collectiveHousing: 'Alloggio collettivo',
          commercial: 'Edificio commerciale',
          communityHousing: 'Abitazione comunitaria',
          crops: 'Edificio per coltivazioni',
          cultural: 'Cultura / Ricreazione',
          education: 'Istruzione / Ricerca',
          garage: 'Garage',
          health: 'Ospedale / Salute',
          hotel: 'Hotel',
          industrial: 'Edificio industriale',
          livestock: 'Edificio per allevamento',
          monument: 'Monumento storico',
          museum: 'Museo / Biblioteca',
          office: 'Edificio per uffici',
          otherAgricultural: 'Altro agricolo',
          otherUnclassified: 'Altro non classificato',
          religious: 'Edificio religioso',
          restaurant: 'Ristorante / Bar',
          singleFamily: 'Casa unifamiliare',
          sports: 'Struttura sportiva',
          tourism: 'Alloggio turistico',
          transport: 'Trasporti / Comunicazione',
          twoFamily: 'Casa bifamiliare',
          unknown: 'Sconosciuto',
          warehouse: 'Magazzino / Silo / Deposito',
        },
        powerSource: {
          air: 'Aria',
          districtHeating: 'Teleriscaldamento',
          electricity: 'Elettricità',
          gas: 'Gas',
          geothermal: 'Geotermico',
          none: 'Nessuno',
          oil: 'Olio',
          solar: 'Solare (termico)',
          unknown: 'Sconosciuto',
          wood: 'Legno',
        },
        protectionStatus: {
          level1: 'Livello 1',
          level2: 'Livello 2',
          level3: 'Livello 3',
          level4: 'Livello 4 (Massimo)',
          notProtected: 'Non protetto',
        },
        renovationPeriod: {
          '1919to1945': '1919-1945',
          '1946to1960': '1946-1960',
          '1961to1970': '1961-1970',
          '1971to1980': '1971-1980',
          '1981to1985': '1981-1985',
          '1986to1990': '1986-1990',
          '1991to1995': '1991-1995',
          '1996to2000': '1996-2000',
          '2001to2005': '2001-2005',
          '2006to2010': '2006-2010',
          '2011to2015': '2011-2015',
          '2015onward': 'Dal 2015',
          before1919: 'Prima del 1919',
        },
        transportQuality: {
          badly: 'Mal servito',
          medium: 'Servizio medio',
          veryBadly: 'Molto mal servito',
          veryWell: 'Molto ben servito',
          well: 'Ben servito',
        },
        travelTime: {
          long: 'Lungo',
          medium: 'Medio',
          short: 'Breve',
        },
        zoneTypes: {
          archaeological: 'Archeologico',
          danger: 'Pericolo',
          forest: 'Foresta',
          polluted: 'Inquinato',
          reserved: 'Riservato',
          watercourse: "Corso d'acqua",
        },
      },
      gradientLabels: {
        before1950: '< 1950',
        db45: '45 dB',
        db55: '55 dB',
        db65: '65 dB',
        db75Plus: '75+ dB',
        high: 'Alto',
        low: 'Basso',
        medium: 'Medio',
        older: 'Più vecchio',
        oneOrMore: '1+',
        recent: 'Recente',
        twentyOrMore: '20+',
        year1960: '1960',
        year1970: '1970',
        year1990: '1990',
        year2010: '2010',
        year2024: '2024',
      },
      titles: {
        availability: 'Disponibilità della zona',
        averageBuildingYear: 'Anno medio di costruzione',
        averageRenovationYear: 'Anno medio di ristrutturazione',
        buildingArea: 'Area edificabile',
        buildingClassification: "Classificazione dell'edificio",
        buildingPeriod: 'Periodo di costruzione',
        buildingPermitLastYear: "Permessi di costruzione dell'anno scorso",
        buildingProtectionStatus: 'Stato di protezione edificio',
        buildingType: 'Tipo di edificio',
        daytimeRailwayNoise: 'Rumore ferroviario diurno',
        daytimeRoadTrafficNoise: 'Rumore stradale diurno',
        developmentPotentialScore: 'Punteggio potenziale di sviluppo',
        favorites: 'Preferiti',
        heatingEnergySource: 'Fonte di energia per riscaldamento',
        lakeView: 'Vista lago',
        legacyRiskScore: 'Punteggio rischio patrimonio',
        listingRentLastYear: "Annunci di locazione dell'anno scorso",
        listingSaleLastYear: "Annunci di vendita dell'anno scorso",
        livabilityScore: 'Punteggio vivibilità',
        mountainView: 'Vista montagna',
        myTags: 'I miei tag',
        nighttimeRailwayNoise: 'Rumore ferroviario notturno',
        nighttimeRoadTrafficNoise: 'Rumore stradale notturno',
        noiseExposure: 'Esposizione al rumore',
        numberOfDwellings: 'Numero di abitazioni',
        numberOfFloors: 'Numero di piani',
        numberOfUnits: 'Numero di unità',
        officialCategory: 'Categoria ufficiale',
        prospects: 'Prospetti',
        publicTransportQuality: 'Qualità dei trasporti pubblici',
        renovationPeriod: 'Periodo di ristrutturazione',
        solarExposure: 'Esposizione solare',
        transactionLastYear: "Transazioni dell'anno scorso",
        travelTimeToCenters: 'Tempo di viaggio ai centri',
        underExploitationScore: 'Punteggio sottoutilizzo',
        waterHeatingSource: 'Fonte di energia per acqua calda',
        zoneRestrictions: 'Restrizioni zona',
      },
      units: {
        decibels: 'Decibel',
        dwellings: 'abitazioni',
        floors: 'piani',
        kwhPerM2: 'kWh/m²',
        score: 'Punteggio',
        units: 'unità',
      },
    },
    listView: {
      actions: {
        addTag: 'Aggiungi tag',
        addToDeal: "Aggiungi all'affare",
        addToFavorites: 'Aggiungi ai preferiti',
        export: 'Esporta',
      },
      columns: {
        activity: 'Attività',
        addLabel: '+ Aggiungi etichetta',
        address: 'Indirizzo',
        area: 'Superficie',
        building: 'Edificio',
        buildings: 'Edifici',
        floors: 'Piani',
        history: 'Storia',
        labels: 'Etichette',
        municipality: 'Comune',
        notClassified: 'Non classificato',
        otherAddresses: '+{{count}} indirizzi',
        otherZones: '+{{count}} altre zone',
        plotNumber: 'Numero di particella',
        score: 'Punteggio',
        surface: 'Superficie',
        type: 'Tipo',
        units: 'Unità',
        volume: 'Volume',
        year: 'Anno',
        zone: 'Zona',
      },
      exportSelected: 'Esporta selezionati',
      found: 'trovati',
      of: 'di',
      results: 'risultati',
      rowsPerPage: 'Righe per pagina',
      selectAll: 'Seleziona tutto',
      sortBy: 'Ordina per',
      sortOptions: {
        address: 'Indirizzo',
        buildings: 'Edifici',
        landType: 'Tipo di terreno',
        municipality: 'Comune',
        plotId: 'ID parcella',
        recentActivity: 'Attività recente',
        surfaceArea: 'Superficie',
        units: 'Unità',
        utilizationRate: 'Tasso di utilizzo',
      },
    },
    mapControls: {
      '2d': '2D',
      '3d': '3D',
      layers: 'Livelli',
      legend: 'Legenda',
      print: 'Stampa',
      satellite: 'Satellite',
      street: 'Strada',
    },
    mapLayerPanel: {
      activeLayer: {
        label: 'Livello attivo',
        neutralView: 'Vista neutra',
        noLayer: 'Nessun livello',
        noLayerSelected: 'Nessun livello selezionato',
        turnOff: 'Disattiva',
      },
      favorites: {
        add: 'Aggiungi ai preferiti',
        remove: 'Rimuovi dai preferiti',
        title: 'Livelli preferiti',
      },
      search: {
        legend: {
          category: 'Categoria',
        },
        placeholder: 'Cerca livelli...',
      },
      title: 'Livelli mappa',
      wms: {
        error: 'Impossibile caricare i livelli esterni',
        externalSource: 'Fonte esterna',
        info: 'Informazioni sul livello',
        loading: 'Caricamento livelli esterni...',
      },
    },
    propertyPanel: {
      actionLabels: {
        activity: 'Attività',
        alert: 'Avviso',
        deal: 'Affare',
        exit: 'Esci',
        favorite: 'Preferito',
        group: 'Gruppo',
      },
      activities: {
        empty: {
          description: 'Prova a modificare i filtri o i termini di ricerca',
          title: 'Nessuna attività trovata',
        },
        filters: {
          all: 'Tutte le attività',
          analysis: 'Analisi',
          favorites: 'Preferiti',
          files: 'File',
          notes: 'Note',
          tags: 'Tag',
        },
        hoursAgo: '{{count}} ora fa',
        hoursAgo_plural: '{{count}} ore fa',
        minutesAgo: '{{count}} minuto fa',
        minutesAgo_plural: '{{count}} minuti fa',
        searchPlaceholder: 'Cerca attività...',
        title: 'Attività',
        today: 'Oggi',
        yesterday: 'Ieri',
      },
      addToDeal: 'Aggiungi a trattativa',
      addToFavorites: 'Aggiungi ai preferiti',
      buildingsLabel: 'Edifici',
      createAlert: 'Crea avviso',
      creatingEstimation: 'Creazione stima...',
      deals: {
        addDeal: 'Aggiungi affare',
        allPipelines: 'Tutte le pipeline',
        allStatuses: 'Tutti gli stati',
        attachExisting: 'Allega esistente',
        attachExistingBuilding: 'Allega affare esistente',
        attachSelected: 'Allega selezionati',
        buildingTitle: "Affari dell'edificio",
        cancel: 'Annulla',
        confirmDeleteText: 'Rimuovere questo affare dalla proprietà?',
        created: 'Creato',
        createDeal: 'Crea affare',
        createFirst: 'Crea il primo affare',
        daysAgo: '{{days}}g fa',
        edit: 'Modifica',
        emptyBuildingDescription: 'Inizia creando o allegando un affare per questo edificio',
        emptyDescription: 'Inizia creando o allegando un affare per questa proprietà',
        emptyTitle: 'Ancora nessun affare',
        foundDeals_one: '{{count}} affare trovato',
        foundDeals_other: '{{count}} affari trovati',
        hoursAgo: '{{hours}}h fa',
        justNow: 'Proprio ora',
        loadingPipelines: 'Caricamento pipeline...',
        loadPipelinesError: 'Impossibile caricare le pipeline',
        lost: 'Perso',
        minsAgo: '{{mins}} min fa',
        noDealsAvailable: 'Nessun affare disponibile',
        noDealsFound: 'Nessun affare trovato',
        noPipeline: 'Nessuna pipeline',
        noResults: 'Nessun affare corrisponde alla ricerca',
        noStage: 'Nessuna fase',
        open: 'Aperto',
        participants: 'Partecipanti',
        pipeline: 'Pipeline',
        remove: 'Rimuovi',
        removeDeal: 'Rimuovi affare',
        searchDealsError: 'Ricerca affari fallita',
        searchPlaceholder: 'Cerca affari per nome, pipeline o fase...',
        selectAll: 'Seleziona tutto',
        selected: 'Selezionato',
        stage: 'Fase',
        status: 'Stato',
        summary: 'Riepilogo',
        title: 'Affari immobiliari',
        untitledDeal: 'Affare senza titolo',
        viewInPipeline: 'Visualizza in pipeline',
        won: 'Vinto',
      },
      errors: {
        noLandId: 'Nessun ID terreno disponibile',
      },
      estimateCreated: 'Stima creata con successo',
      files: {
        confirmDelete: 'Sei sicuro di voler eliminare {{name}}?',
        delete: 'Elimina',
        download: 'Scarica',
        empty: {
          description: 'Carica file per iniziare o modifica la tua ricerca',
          title: 'Nessun file trovato',
        },
        filters: {
          all: 'Tutti i file',
        },
        searchPlaceholder: 'Cerca file...',
        title: 'File',
        uploadButton: 'Sfoglia file',
        uploadText: 'Trascina e rilascia i file qui o clicca per sfogliare',
      },
      history: {
        adjustFilters: 'Prova ad adattare i tuoi filtri per vedere più eventi',
        error: 'Errore nel caricamento dei dati cronologici',
        loading: 'Caricamento dati cronologici...',
        loadingText: 'Attendere mentre recuperiamo le informazioni dettagliate',
        noEvents: 'Nessun evento trovato',
        onlineDays: 'Online: {{days}} giorni',
        permitRequest: 'Richiesta di permesso',
        permits: 'Permessi',
        rentalListing: 'Annuncio di locazione',
        rentals: 'Locazioni',
        rooms: 'Stanze',
        saleListing: 'Annuncio di vendita',
        sales: 'Vendite',
        transaction: 'Transazione',
        transactions: 'Transazioni',
      },
      information: {
        active: 'Attivo',
        beneficiary: 'Beneficiario',
        buildingCount: 'Numero di edifici',
        buildingPeriod: 'Periodo di costruzione',
        buildings: 'Edifici',
        built: 'Costruito',
        company: 'Azienda',
        conditions: 'Condizioni',
        constructible: 'Costruibile',
        created: 'Creato',
        duration: 'Durata',
        dwellings: 'Abitazioni',
        energyConsumption: 'Consumo energetico',
        energySurface: 'Superficie energetica',
        floors: 'Piani',
        foundation: 'Fondazione',
        grossFloorArea: 'Superficie lorda di pavimento',
        groundFloorArea: 'Area piano terra',
        heatingSource: 'Fonte di riscaldamento',
        inactive: 'Inattivo',
        individual: 'Privato',
        landArea: 'Area del terreno',
        landInfo: 'Informazioni del terreno',
        landType: 'Tipo di terreno',
        lastOwnerChange: 'Ultimo cambio di proprietario',
        lastRenovation: 'Ultima ristrutturazione',
        maxHeight: 'Altezza massima',
        no: 'No',
        noDataAvailable: 'Nessuna informazione dettagliata disponibile per questa proprietà',
        owners: 'Proprietari',
        plotNumber: 'Numero di parcella',
        protected: 'Protetto',
        renovated: 'Ristrutturato',
        residentialArea: 'Area residenziale',
        residentialFloors: 'Piani residenziali',
        restrictions: 'Restrizioni',
        searchGoogle: 'Cerca su Google',
        searchLinkedIn: 'Cerca su LinkedIn',
        searchLocalCh: 'Cerca su local.ch',
        solarPotential: 'Potenziale solare',
        totalResidentialArea: 'Area residenziale totale',
        type: 'Tipo',
        unitCount: 'Numero di unità',
        validity: 'Validità',
        volume: 'Volume',
        yes: 'Sì',
        zones: 'Zone',
      },
      links: {
        accessOfficialData: 'Accesso a dati ufficiali e documenti legali',
        buildingInformation: 'Informazioni edificio',
        buildingPermitsHistory: 'Permessi di costruzione e cronologia di costruzione',
        buildingStatistics: 'Statistiche edificio',
        cadastreRDPPF: 'Catasto RDPP',
        cantonalGeoportal: 'Geoportale cantonale',
        cantonalInteractiveMap: 'Mappa interattiva e dati cantonali',
        constructionHistory: 'Cronologia costruzione',
        constructionPermits: 'Permessi di costruzione',
        demographics: 'Demografia',
        detailedBuildingData: "Caratteristiche dettagliate e dati dell'edificio",
        energyAndEnvironmentalData: 'Prestazioni energetiche e dati ambientali',
        energyCertificate: 'Certificato energetico',
        energyEnvironment: 'Energia e ambiente',
        exploreWithMaps: 'Esplora la parcella con diversi strumenti cartografici',
        federalBuildingRegistry: 'Registro ferale degli edifici e delle abitazioni (REA)',
        federalGeoportal: 'Geoportale federale',
        geoAdminFederalData: 'map.geo.admin.ch - Dati federali',
        googleEarth: 'Google Earth',
        googleMaps: 'Google Maps',
        landRegistry: 'Registro fondiario',
        localBuildingRecords: 'Registri locali degli edifici e permessi',
        mapsNavigation: 'Mappe e navigazione',
        municipalPortal: 'Portale municipale',
        neighborhood: 'Vicinato',
        neighborhoodLocalMarket: 'Informazioni sul quartiere e mercato locale',
        neighborhoodStatistics: 'Demografia del quartiere e statistiche',
        noBuildingData: "I dati dell'edificio sono necessari per generare collegamenti esterni",
        noiseExposure: 'Esposizione al rumore',
        noLinksAvailable: 'Nessun collegamento esterno disponibile',
        noPropertyData: 'I dati della proprietà sono necessari per generare collegamenti esterni',
        officialBuildingData: 'Dati ufficiali degli edifici e delle abitazioni',
        officialBuildingStats: 'Statistiche ufficiali federali degli edifici',
        officialEnergyRating: 'Certificazione energetica ufficiale CECE',
        officialExtractServitudes: 'Estratto ufficiale e servitù',
        officialRegistries: 'Registri ufficiali',
        permitsHistory: 'Cronologia dei permessi rilasciati nella zona',
        publicLawRestrictions: 'Restrizioni di diritto pubblico della proprietà',
        purchaseListings: 'Annunci di vendita',
        recentSalesHistory: 'Cronologia delle vendite recenti nella zona',
        rentalListings: 'Annunci di locazione',
        rooftopSolarAnalysis: 'Analisi del potenziale solare dei tetti',
        similarPurchasePropertiesMarket: 'Annunci di vendita simili nella stessa zona sul mercato',
        similarRentalPropertiesMarket: 'Annunci di locazione simili nella stessa zona sul mercato',
        situationPlan: 'cadastre.ch - Piano di situazione',
        situationPlanDescription: 'Misurazione Ufficiale Suizzera ',
        solarPotential: 'Potenziale solare',
        streetViewRoutes: 'Street View e percorsi',
        trafficNoiseData: 'Dati sul rumore del traffico e ferroviario',
        transactions: 'Transazioni',
        view3dSatelliteHistory: 'Vista 3D e cronologia satellitare',
      },
      loading: 'Caricamento dati proprietà...',
      loadingForId: 'Caricamento dati per ID: {{id}}...',
      market: {
        all: 'Tutti',
        allResidentialProperties: 'Tutte le proprietà residenziali',
        apartment: 'Appartamento',
        avgPricePerSqm: 'Prezzo medio al m²',
        avgRentPerSqm: 'Pigione media al m²',
        canton: 'Cantone',
        cantonLevel: 'Livello cantonale',
        cityGeneva: 'Città di Ginevra',
        dataUnavailable: 'I dati di mercato non sono attualmente disponibili',
        district: 'Distretto',
        districtGeneva: 'Distretto di Ginevra',
        districtLevel: 'Livello distrettuale',
        faoData: 'Cantone di Ginevra',
        house: 'Casa',
        locationRequired: 'La posizione della proprietà è necessaria per visualizzare le informazioni di mercato',
        marketComparison: 'Confronto di mercato',
        marketOverview: 'Panoramica del mercato',
        medianPrice: 'Prezzo mediano',
        medianPricePerSqm: 'Prezzo mediano al m²',
        medianRent: 'Pigione mediana',
        medianRentPerSqm: 'Pigione mediana al m²',
        municipality: 'Comune',
        municipalityLevel: 'Livello comunale',
        noMarketData: 'Nessun dato di mercato disponibile',
        noRecentListings: 'Nessun annuncio recente disponibile',
        priceEvolution: 'Evoluzione dei prezzi',
        pricePerSqm: 'Prezzo al m²',
        pricePerSqmEvolution: 'Evoluzione del prezzo al m²',
        recentListings: 'Annunci recenti',
        rent: 'Locazione',
        rentPerSqm: 'Pigione al m²',
        rooms: 'locali',
        sale: 'Vendita',
        thisYear: "quest'anno",
        viewMoreAnalysis: 'Visualizza più analisi',
        viewMoreListings: 'Visualizza più annunci',
        yearOverYear: 'su 1 anno',
      },
      noAddress: 'Nessun indirizzo disponibile',
      noPropertyData: 'Nessun dato proprietà trovato',
      notes: 'Note',
      notesPanel: {
        addNote: 'Aggiungi nota',
        aiAssistant: 'Assistente IA',
        cancel: 'Annulla',
        clearSearch: 'Cancella ricerca',
        daysAgo: '{{count}} giorni fa',
        deleteConfirm: 'Eliminare questa nota?',
        deleteNote: 'Elimina',
        editNote: 'Modifica',
        hoursAgo: '{{count}} ora fa',
        hoursAgo_plural: '{{count}} ore fa',
        justNow: 'Proprio ora',
        loading: 'Caricamento note...',
        minutesAgo: '{{count}} minuto fa',
        minutesAgo_plural: '{{count}} minuti fa',
        newNote: 'Nuova nota',
        noNotes: 'Nessuna nota',
        noNotesText: 'Inizia aggiungendo una prima nota su questa proprietà',
        noResults: 'Nessun risultato trovato',
        noResultsText: 'Prova con altre parole chiave',
        noteHint: 'Aggiungi le tue osservazioni su questa proprietà',
        resultsInfo: '{{visible}} risultato',
        resultsInfo_plural: '{{visible}} risultati su {{total}} note',
        saveNote: 'Salva',
        searchPlaceholder: 'Cerca nelle note...',
        title: 'Note',
        weeksAgo: '{{count}} settimana fa',
        weeksAgo_plural: '{{count}} settimane fa',
        yesterday: 'Ieri',
      },
      openAnalysis: 'Apri analisi',
      openEstimation: 'Apri stima',
      propertyIdLabel: 'ID proprietà: {{id}}',
      removeFromFavorites: 'Rimuovi dai preferiti',
      retry: 'Riprova',
      surfaceLabel: 'm² Superficie',
      tabs: {
        comingSoon: 'Prossimamente...',
        history: 'Cronologia',
        information: 'Informazioni',
        links: 'Collegamenti',
        market: 'Mercato',
      },
      unitsLabel: 'Unità',
    },
    propertyTooltip: {
      buildingInformation: {
        title: 'Informazioni edificio',
      },
      buildings: {
        buildingLabel: 'Edificio {{id}}',
        buildingYear: 'Anno di costruzione',
        energyReferenceSurface: 'Superficie di riferimento energetico',
        floorNumber: 'Numero di piani',
        grossUsefulFloorArea: 'Superficie lorda utile',
        groundFloorArea: 'Superficie al suolo',
        heatingEnergySource: 'Fonte di energia per riscaldamento',
        idc: 'IDC',
        maxHeight: 'Altezza massima',
        numberOfDwellings: 'Numero di abitazioni',
        protected: 'Edificio protetto',
        renovationYear: 'Anno di ristrutturazione',
        residentialFloorNumber: 'Numero di piani residenziali',
        solarPotential: 'Potenziale solare',
        title: 'Edifici',
        totalResidentialArea: 'Superficie residenziale totale',
        units: 'unità',
        volume: 'Volume',
      },
      energy: {
        idc: 'IDC (Indice di consumo termico)',
        minergie: 'Minergie',
        title: 'Energia e sostenibilità',
      },
      landInformation: {
        area: 'Superficie',
        buildingArea: 'Area edificata',
        buildingPeriod: 'Periodo di costruzione',
        buildingRights: 'Diritti di costruzione',
        district: 'Distretto',
        egrid: 'EGRID',
        lastRenovation: 'Ultima ristrutturazione',
        municipality: 'Comune',
        notApplicable: 'Non applicabile',
        numberOfBuildings: 'Numero di edifici',
        numberOfDwellings: 'Numero di abitazioni',
        propertyNature: 'Natura della proprietà',
        propertyNatureBF: 'Fondo',
        propertyNatureDDP: 'Diritto distinto e permanente (DDP)',
        swimmingPool: 'Piscina',
        title: 'Terreno',
        totalResidentialArea: 'Superficie residenziale totale',
        type: 'Tipo',
        zone: 'Zona',
      },
      lands: {
        title: 'Terreni associati',
        unknownEgrid: 'EGRID sconosciuto',
        unknownType: 'Tipo sconosciuto',
      },
      owners: {
        company: 'Azienda',
        lastChange: 'Ultima modifica',
        localLabel: 'local',
        searchGoogle: 'Cerca su Google',
        searchLinkedIn: 'Cerca su LinkedIn',
        searchLocal: 'Cerca su local.ch',
        searchZefix: 'Cerca su Zefix (registro di commercio)',
        title: 'Proprietari',
        unknown: 'Proprietario sconosciuto',
      },
      restrictions: {
        active: 'Attivo',
        coverage: 'Copertura {{percent}}%',
        coverageArea: 'Area di copertura',
        description: 'Descrizione',
        inactive: 'Inattivo',
        newConstruction: 'Nuova costruzione autorizzata',
        status: 'Stato',
        title: 'Restrizioni',
        type: 'Tipo',
      },
      transport: {
        title: 'Trasporti e accessibilità',
      },
      view: {
        title: 'Vista e orientamento',
      },
      zones: {
        adoptedDate: 'adottato il {{date}}',
        authorizedCOS: 'C.o. autorizzato',
        authorizedCUS: 'C.s. autorizzato',
        authorizedIBUS: 'I.l.s. autorizzato',
        buildingArea: 'Area edificabile',
        category: 'Categoria',
        categoryCantonal: 'Cantonale',
        categoryGeneral: 'Comunale',
        categoryLocal: 'Locale',
        categoryPartial: 'Parziale',
        name: 'Nome',
        notApplicable: 'N/D',
        part: 'Parte',
        planType: 'Tipo di piano',
        title: 'Zone',
        zone: 'Zona',
      },
    },
    qualityLevels: {
      average: 'Medio',
      excellent: 'Eccellente',
      good: 'Buono',
      high: 'Alto',
      low: 'Basso',
      medium: 'Medio',
      poor: 'Scarso',
      very_poor: 'Molto Scarso',
    },
    viewToggle: {
      list: 'Lista',
      map: 'Mappa',
    },
    wmsLayers: {
      ' Cadastral Surveying (OpenData)': 'Misurazione ufficiale',
      airport_noise: 'Rumore aeroportuale',
      building_zones_switzerland_harmonized: 'Zone edificabili Svizzera',
      daily_railway_noise: 'Rumore ferroviario diurno',
      daily_traffic_noise: 'Rumore stradale diurno',
      nightly_railway_noise: 'Rumore ferroviario notturno',
      nightly_traffic_noise: 'Rumore stradale notturno',
      swissimage_past_1960: '1960 Immagini aeree Svizzera',
      swissimage_past_1970: '1970 Immagini aeree Svizzera',
      swissimage_past_1980: '1980 Immagini aeree Svizzera',
      swissimage_past_1990: '1990 Immagini aeree Svizzera ',
      swissimage_past_2000: '2000 Immagini aeree Svizzera ',
      swissimage_past_2010: '2010 Immagini aeree Svizzera',
      swissimage_past_2015: '2015 Immagini aeree Svizzera',
      swissimage_past_2020: '2020 Immagini aeree Svizzera',
      unconsolidated_deposits_thickness_model: 'Spessore depositi sciolti',
    },
  },
  feasibility: {
    assessment: {
      marginal: {
        description: "Il progetto è vicino alla soglia di fattibilità del {{target}} % ({{marginal}}–{{target}} %). Consideri l'ottimizzazione dei costi o dei ricavi.",
        title: 'Fattibilità marginale',
      },
      not_viable: {
        description: 'Il progetto è sotto la soglia di margine del {{marginal}} %. Sono necessari cambiamenti significativi.',
        title: 'Non fattibile',
      },
      viable: {
        description: "Il progetto raggiunge l'obiettivo di margine del promotore del {{target}} % e mostra una forte fattibilità finanziaria.",
        title: 'Progetto fattibile',
      },
    },
    empty: {
      description: 'Non sono disponibili dati di studio di fattibilità per questa analisi condivisa.',
      title: 'Nessuno studio di fattibilità',
    },
    keyMetrics: {
      belowTarget: "Sotto l'obiettivo",
      critical: 'Critico',
      developerMetrics: 'Metriche del promotore',
      internalRateOfReturn: 'Tasso interno di rendimento (annualizzato)',
      investmentOverview: "Panoramica dell'investimento",
      netProfitEquity: 'Profitto netto / Totale capitale proprio investito',
      revenueInvestment: 'Ricavi / Investimento totale',
      targetLabel: 'Obiettivo: ≥ {{target}}%',
      targetMet: 'Obiettivo raggiunto',
      totalEquityInProject: 'Totale del capitale proprio impegnato nel progetto',
    },
    metrics: {
      developerMargin: 'Margine del promotore',
      equityInvested: 'Capitale proprio investito',
      irr: 'TIR',
      profitMultiple: 'Multiplo di profitto',
      roiOnEquity: 'ROI sul capitale proprio',
    },
    quickFacts: {
      durationValue: '{{months}} mesi ({{years}} anni)',
      equityRequired: 'Capitale proprio richiesto',
      landFinancing: 'Finanziamento terreno',
      notAvailable: 'N/D',
      pricePerM2: 'Prezzo medio/m²',
      projectDuration: 'Durata del progetto',
      projectType: 'Tipo di progetto',
      saleableArea: 'Superficie vendibile',
      timelineSplit: 'Ripartizione della cronologia',
      timelineValue: '{{planning}}m pianificazione + {{build}}m costruzione',
      totalUnits: 'Unità totali',
    },
    residual: {
      interpretation: "A questo prezzo massimo l'utile obiettivo del {{pct}} % del GDV è raggiunto se le ipotesi si confermano. Il finanziamento è quello modellato e non viene iterato con il prezzo del terreno.",
      maxBid: "Prezzo d'acquisto massimo",
      negativeNote: 'Il valore residuale è negativo — costruzione, finanziamento e utile obiettivo superano il valore del progetto. Il fondo non sostiene questo programma al margine obiettivo.',
      noPlotArea: 'Superficie del fondo non disponibile — CHF/m² non mostrato',
      perM2Value: '{{value}} / m² di fondo',
      question: "Quanto posso pagare per questo fondo restando sull'utile obiettivo?",
      title: 'Valore residuale del terreno',
    },
    sections: {
      costBreakdown: 'Ripartizione dei costi',
      financialSummary: 'Riepilogo finanziario',
      keyPerformanceIndicators: 'Indicatori chiave di prestazione',
      projectQuickFacts: 'Dati essenziali del progetto',
    },
    summaryCards: {
      costBreakdown: 'Terreno: {{land}} | Costruzione: {{construction}}',
      financingCosts: 'Costi di finanziamento',
      fromSales: 'Da vendite unità e ricavi aggiuntivi',
      grossProfit: 'Lordo: {{gross}}',
      interestAndFees: 'Interessi e commissioni durante il progetto',
      netProfit: 'Profitto netto del promotore',
      totalCosts: 'Costi totali',
      totalRevenue: 'Ricavo totale',
    },
    waterfall: {
      construction: 'Costruzione',
      financing: 'Finanziamento',
      landCosts: 'Costi terreno',
      netProfit: 'Profitto netto',
      revenue: 'Ricavi',
    },
  },
  geoAnalysis: {
    charts: {
      altitude: 'Altitudine (metri)',
      distance: 'Distanza',
      flatArea: 'Area piatta',
      meters: 'm',
      plotBoundary: 'Confine del lotto',
      position: 'Posizione',
      slopedArea: 'Area in pendenza',
      status: 'Stato',
      xAxis: 'X (metri)',
      yAxis: 'Y (metri)',
    },
    directions: {
      east: 'Est',
      eastWest: 'Est-Ovest',
      flat: 'Piatto',
      north: 'Nord',
      northEast: 'Nord-Est',
      northSouth: 'Nord-Sud',
      northWest: 'Nord-Ovest',
      south: 'Sud',
      southEast: 'Sud-Est',
      southWest: 'Sud-Ovest',
      square: 'Quadrato',
      west: 'Ovest',
    },
    error: 'Impossibile caricare i dati geografici',
    header: {
      scoreLabel: 'Punteggio geo',
      scoreTooltip: 'Punteggio complessivo di idoneità geografica basato su pendenza, orientamento e forma',
      subtitle: 'Analisi topografica e geometrica completa per il lotto {{egrid}}',
      title: 'Analisi geografica',
    },
    loading: 'Caricamento dei dati geografici...',
    metrics: {
      areaEfficiency: "Efficienza dell'area",
      averageSlope: 'Pendenza media',
      buildable: 'Edificabile',
      compactness: 'Compattezza',
      compactnessScore: 'Punteggio di compattezza',
      constructionSuitability: 'Idoneità alla costruzione',
      dataPoints: 'Punti dati',
      dimensions: 'Dimensioni (L x L)',
      dominantOrientation: 'Orientamento dominante',
      elevationRange: 'Intervallo di elevazione',
      faces: 'Orientamento',
      gridSize: 'Dimensione griglia',
      lengthWidth: 'Lunghezza x Larghezza',
      maxAltitude: 'Altitudine max',
      maxFlatArea: 'Area piatta max',
      maximum: 'Massimo',
      maximumFlatArea: 'Area piatta massima',
      maximumSlope: 'Pendenza massima',
      minAltitude: 'Altitudine min',
      minimum: 'Minimo',
      percentOfTotal: '% del totale',
      perimeter: 'Perimetro',
      regularity: 'Regolarità',
      shapeFactor: 'Fattore di forma',
      shapeRegularity: 'Regolarità della forma',
      slopeThreshold: 'Soglia di pendenza',
      sunExposure: 'Esposizione solare',
      totalArea: 'Area totale',
    },
    noAltitudeData: 'Nessun dato di altitudine disponibile',
    noData: 'Nessun dato disponibile',
    noElevationData: 'Nessun dato di elevazione disponibile per questa regione',
    noPolygonData: 'Nessun dato poligono disponibile',
    noSlopeAnalysis: 'Nessuna analisi della pendenza disponibile',
    plotTooSmall: "Lotto troppo piccolo per l'analisi della pendenza",
    plotTooSmallDescription: "Il lotto è troppo piccolo per eseguire un'analisi dettagliata della pendenza. Area minima richiesta: 100m².",
    sections: {
      altitudeProfile: 'Profilo altimetrico',
      developmentAnalysis: 'Analisi dello sviluppo',
      flatAreaAnalysis: 'Analisi delle aree piatte',
      geometryAnalysis: 'Analisi della geometria',
      orientationAnalysis: "Analisi dell'orientamento (Esposizione solare)",
      plotBoundaryVisualization: 'Visualizzazione dei confini del lotto',
      shapeMetrics: 'Metriche della forma',
      slopeDistribution: 'Distribuzione della pendenza',
      slopeSunOrientation: 'Pendenza ed esposizione solare',
      topographicVisualization: 'Visualizzazione topografica 3D',
    },
    slopeRanges: {
      flat: 'Piatto (0-5°)',
      gentle: 'Leggera (5-10°)',
      moderate: 'Moderata (10-15°)',
      range0_5: '0-5° (Piatto)',
      range10_15: '10-15° (Moderata)',
      range15_25: '15-25° (Ripida)',
      range5_10: '5-10° (Leggera)',
      rangeOver25: '>25° (Molto ripida)',
      steep: 'Ripida (15-25°)',
      verysteep: 'Molto ripida (>25°)',
    },
    status: {
      challenging: 'Impegnativo',
      excellent: 'Eccellente',
      good: 'Buono',
      irregular: 'Irregolare',
      loading: 'Caricamento...',
      moderate: 'Moderato',
      na: 'N/D',
      neutral: 'Neutro',
      noData: 'Nessun dato',
      poor: 'Scarso',
      realData: 'Dati reali',
      regular: 'Regolare',
    },
    sunExposureNotes: {
      excellent: 'Potenziale di riscaldamento passivo',
      moderate: 'Luce equilibrata',
      neutral: 'Nessuna pendenza dominante',
      poor: 'Poco sole diretto',
    },
    tabs: {
      analysis: 'Pendenza e orientamento',
      overview: 'Panoramica',
      shape: 'Forma e geometria',
      topography: 'Topografia 3D',
    },
    tooltips: {
      areaEfficiency: {
        calculation: 'Area piatta / Area totale × 100%',
        importance: 'Maggiore efficienza significa che più del lotto è immediatamente utilizzabile.',
        shortDescription: "Percentuale di area piatta ed edificabile rispetto all'area totale del lotto.",
        source: 'Analisi composita da dati di elevazione e catastali',
        title: "Efficienza dell'area",
      },
      averageSlope: {
        calculation: 'Media ponderata dei valori di pendenza dai punti della griglia di elevazione.',
        categories: [
          {
            description: 'Ideale per la costruzione, richiede lavori di sterro minimi',
            label: 'Piatto',
            range: '0-5°',
          },
          {
            description: 'Buono per la costruzione con adattamenti minori',
            label: 'Leggera',
            range: '5-10°',
          },
          {
            description: 'Richiede significativi lavori di sterro e strutture di contenimento',
            label: 'Moderata',
            range: '10-15°',
          },
          {
            description: 'Costruzione impegnativa, tecniche specializzate necessarie',
            label: 'Ripida',
            range: '>15°',
          },
        ],
        importance: 'Critico per la fattibilità costruttiva e la pianificazione del drenaggio.',
        limitations: "Non mostra le variazioni locali della pendenza all'interno del lotto.",
        shortDescription: "L'angolo di pendenza medio sull'intera superficie del lotto.",
        source: 'Dati di elevazione SwissTopo (swissALTI3D)',
        title: 'Pendenza media',
      },
      compactness: {
        calculation: '4π × Area / Perimetro² (1.0 = cerchio perfetto)',
        importance: 'Le forme più compatte hanno costi di confine inferiori per unità di area.',
        shortDescription: "Rapporto tra area e perimetro del lotto, che indica l'efficienza della forma.",
        source: 'Calcolato dai dati poligonali catastali',
        title: 'Compattezza',
      },
      compactnessScore: {
        calculation: 'Quoziente isoperimetrico: 4π × Area / Perimetro²',
        categories: [
          {
            description: 'Forma molto compatta, uso efficiente dello spazio',
            label: 'Alto',
            range: '>0.7',
          },
          {
            description: 'Compattezza moderata, tipica per la maggior parte dei lotti',
            label: 'Medio',
            range: '0.4-0.7',
          },
          {
            description: 'Forma allungata o complessa, meno efficiente',
            label: 'Basso',
            range: '<0.4',
          },
        ],
        importance: "Una maggiore compattezza significa meno confine rispetto all'area, riducendo i costi.",
        shortDescription: 'Misura quanto compatta (simile a un cerchio) è la forma del lotto.',
        source: 'Calcolato dai dati poligonali catastali',
        title: 'Punteggio di compattezza',
      },
      constructionSuitability: {
        calculation: 'Punteggio composito basato su pendenza, forma e percentuale di area piatta.',
        categories: [
          {
            description: 'Condizioni ideali per la costruzione',
            label: 'Eccellente',
            range: '>80%',
          },
          {
            description: 'Condizioni favorevoli con sfide minori',
            label: 'Buono',
            range: '60-80%',
          },
          {
            description: 'Necessari significativi lavori di sterro o adattamenti',
            label: 'Moderato',
            range: '40-60%',
          },
          {
            description: 'Requisiti di costruzione complessi',
            label: 'Impegnativo',
            range: '<40%',
          },
        ],
        importance: 'Indicatore rapido del potenziale di sviluppo e dei costi di costruzione.',
        shortDescription: "Valutazione complessiva dell'idoneità del lotto alla costruzione.",
        source: 'Analisi composita da più fonti di dati',
        title: 'Idoneità alla costruzione',
      },
      dimensions: {
        calculation: 'Calcolato dal rettangolo di delimitazione minimo.',
        importance: "Aiuta a determinare le dimensioni massime dell'edificio che può stare sul lotto.",
        shortDescription: 'Lunghezza e larghezza del rettangolo di delimitazione del lotto.',
        source: 'Calcolato dai dati poligonali catastali',
        title: 'Dimensioni',
      },
      dominantOrientation: {
        calculation: "Determinato analizzando l'aspetto (direzione della pendenza) del terreno.",
        importance: "Influisce sul guadagno solare, l'illuminazione naturale e l'efficienza energetica degli edifici.",
        shortDescription: "La direzione principale verso cui è orientato il lotto, che influenza l'esposizione al sole.",
        source: 'Dati di elevazione SwissTopo (swissALTI3D)',
        title: 'Orientamento dominante',
      },
      flatAreaAnalysis: {
        calculation: 'Analisi a griglia per identificare zone piatte contigue.',
        importance: 'Le aree piatte sono ottimali per il posizionamento degli edifici e richiedono meno lavori di sterro.',
        shortDescription: 'Identifica e misura le aree con pendenza inferiore a 5°.',
        source: 'Dati di elevazione SwissTopo (swissALTI3D)',
        title: 'Analisi delle aree piatte',
      },
      maxFlatArea: {
        calculation: 'Analisi della componente connessa più grande delle celle di griglia piatte.',
        importance: "Determina l'impronta massima dell'edificio possibile senza scavo.",
        shortDescription: 'La più grande area piatta contigua sul lotto.',
        source: 'Dati di elevazione SwissTopo (swissALTI3D)',
        title: 'Area piatta massima',
      },
      maximumSlope: {
        calculation: "Valore massimo dall'analisi della griglia di pendenza.",
        importance: 'Identifica le aree potenzialmente problematiche per la costruzione.',
        shortDescription: "L'angolo di pendenza più ripido trovato ovunque sul lotto.",
        source: 'Dati di elevazione SwissTopo (swissALTI3D)',
        title: 'Pendenza massima',
      },
      perimeter: {
        calculation: 'Somma di tutte le lunghezze dei lati del poligono di confine.',
        importance: 'Influisce sui costi di recinzione e sulle considerazioni sui confini.',
        shortDescription: 'La lunghezza totale del confine del lotto.',
        source: 'Calcolato dai dati poligonali catastali',
        title: 'Perimetro',
      },
      regularity: {
        calculation: 'Area del lotto / Area del rettangolo di delimitazione × 100%',
        importance: 'Maggiore regolarità significa più spazio utilizzabile per la costruzione.',
        shortDescription: 'Quanto bene il lotto riempie il suo rettangolo di delimitazione.',
        source: 'Calcolato dai dati poligonali catastali',
        title: 'Regolarità',
      },
      shapeFactor: {
        calculation: 'Lunghezza / Larghezza del rettangolo di delimitazione minimo.',
        categories: [
          {
            description: 'Lunghezza e larghezza quasi uguali',
            label: 'Quadrato',
            range: '1.0-1.5',
          },
          {
            description: 'Rapporto lunghezza/larghezza moderato',
            label: 'Rettangolare',
            range: '1.5-3.0',
          },
          {
            description: 'Forma lunga e stretta',
            label: 'Allungato',
            range: '>3.0',
          },
        ],
        importance: 'Indica se il lotto è quadrato, rettangolare o allungato.',
        shortDescription: 'Rapporto tra lunghezza e larghezza del rettangolo di delimitazione del lotto.',
        source: 'Calcolato dai dati poligonali catastali',
        title: 'Fattore di forma',
      },
      shapeRegularity: {
        calculation: "Rapporto tra l'area del lotto e l'area del suo rettangolo di delimitazione minimo.",
        categories: [
          {
            description: 'Quasi rettangolare, ottimale per il posizionamento degli edifici',
            label: 'Regolare',
            range: '>80%',
          },
          {
            description: 'Forma complessa, può limitare le opzioni di costruzione',
            label: 'Irregolare',
            range: '<80%',
          },
        ],
        importance: 'Le forme regolari sono più facili e convenienti da costruire.',
        shortDescription: 'Quanto la forma del lotto è vicina a un rettangolo regolare.',
        source: 'Calcolato dai dati poligonali catastali',
        title: 'Regolarità della forma',
      },
      slopeDistribution: {
        calculation: 'Analisi della pendenza basata su griglia con categorizzazione.',
        importance: 'Mostra la varietà delle condizioni del terreno sul lotto.',
        shortDescription: 'Suddivisione del lotto per categorie di pendenza.',
        source: 'Dati di elevazione SwissTopo (swissALTI3D)',
        title: 'Distribuzione della pendenza',
      },
      totalArea: {
        calculation: 'Calcolato utilizzando la formula del laccio sulle coordinate del poligono.',
        importance: 'Essenziale per determinare il potenziale costruttivo e il valore della proprietà.',
        limitations: 'Può differire leggermente dalle misurazioni catastali ufficiali.',
        shortDescription: 'La superficie totale del lotto calcolata dal suo poligono di confine.',
        source: 'Calcolato dai dati poligonali catastali',
        title: 'Area totale',
      },
    },
  },
  history: {
    actions: {
      exportCSV: 'Esporta in CSV',
      exportExcel: 'Esporta in Excel',
      filterByType: 'Filtra per tipo',
      sortByDate: 'Ordina per data',
      sortByPrice: 'Ordina per prezzo',
      viewDetails: 'Visualizza dettagli',
    },
    adjustFilters: 'Prova a modificare i tuoi filtri',
    back: 'Indietro',
    buildingHistory: "Storico dell'edificio",
    buildingHistorySubtitle: "Tutti gli eventi raccolti da Popety.io riguardanti l'edificio {{egid}} negli ultimi anni.",
    detailView: {
      active: 'Attivo',
      addressNotSpecified: 'Indirizzo non specificato',
      available: 'Disponibile',
      balcony: 'Balcone',
      bathrooms: 'Bagni',
      built: 'Anno di costruzione',
      constructionYear: 'Anno di costruzione',
      days: 'giorni',
      description: 'Descrizione',
      elevator: 'Ascensore',
      energyLabel: 'Etichetta energetica',
      featuresAndAmenities: 'Caratteristiche e servizi',
      floor: 'Piano',
      furnished: 'Arredato',
      garage: 'Garage',
      garden: 'Giardino',
      heatingType: 'Tipo di riscaldamento',
      immediately: 'Immediatamente',
      inactive: 'Inattivo',
      landArea: 'Superficie terreno',
      livingArea: 'Superficie abitabile',
      onlineFor: 'Online da',
      parking: 'Parcheggio',
      petsAllowed: 'Animali ammessi',
      propertyAgents: 'Agenti immobiliari',
      propertyCategory: 'Categoria proprietà',
      propertyDetails: 'Dettagli proprietà',
      propertyForRent: 'Proprietà in locazione',
      propertyForSale: 'Proprietà in vendita',
      propertyType: 'Tipo di proprietà',
      published: 'Pubblicato',
      renovationYear: 'Anno di ristrutturazione',
      rooms: 'Stanze',
      statusLabel: 'Stato',
      terrace: 'Terrazza',
    },
    error: 'Errore',
    eventDetails: 'Dettagli evento',
    fields: {
      address: 'Indirizzo',
      architect: 'Architetto',
      area: 'Area',
      availableDate: 'Disponibile',
      balcony: 'Balcone',
      bathrooms: 'Bagni',
      broker: 'Mediatore',
      buildingClassification: 'Classificazione edificio',
      buyers: 'Acquirenti',
      classification: 'Classe',
      constructionYear: 'Anno di costruzione',
      date: 'Data',
      description: 'Descrizione',
      elevator: 'Ascensore',
      energyLabel: 'Energia',
      floor: 'Piano',
      furnished: 'Arredato',
      garage: 'Garage',
      garden: 'Giardino',
      heatingType: 'Riscaldamento',
      inquiryEnd: 'Data di fine',
      inquiryStart: 'Data di inizio',
      landArea: 'Terreno',
      listingType: 'Tipo di annuncio',
      onlineDays: 'Giorni online',
      owner: 'Proprietario',
      ownersType: 'Tipo di proprietari',
      parking: 'Parcheggio',
      permitNumber: 'Permesso',
      permitType: 'Tipo di permesso',
      petsAllowed: 'Animali ammessi',
      previousTransaction: 'Transazione precedente',
      price: 'Prezzo',
      pricePerSqm: 'Prezzo/m²',
      projectArea: 'Area',
      projectValue: 'Valore',
      propertyCategory: 'Categoria',
      propertyType: 'Tipo di proprietà',
      reason: 'Motivo',
      renovationYear: 'Rinnovato',
      rooms: 'Stanze',
      sellers: 'Venditori',
      status: 'Stato',
      terrace: 'Terrazza',
      type: 'Tipo',
      units: 'Unità',
      workDescription: 'Descrizione lavori',
      workType: 'Tipo',
    },
    filters: {
      allTime: 'Tutto il tempo',
      buildingPermits: 'Permessi di costruzione',
      dateRange: 'Periodo',
      export: 'Esporta',
      listings: 'Annunci',
      rentalListings: 'Annunci di locazione',
      saleListings: 'Annunci di vendita',
      searchPlaceholder: 'Cerca nella storia...',
      transactions: 'Transazioni',
    },
    loading: 'Caricamento...',
    noBuildingDataAvailable: "Nessun dato dell'edificio disponibile",
    noDataAvailable: 'Nessun dato disponibile',
    noEstimateDataAvailable: 'Nessun dato di stima disponibile',
    noEvents: 'Nessun evento storico trovato',
    noLandDataAvailable: 'Nessun dato della parcella disponibile',
    ownershipType: 'Tipo di proprietà',
    plotHistory: 'Storico della parcella',
    plotHistorySubtitle: 'Tutti gli eventi raccolti da Popety.io riguardanti la parcella {{egrid}} negli ultimi anni.',
    propertyHistory: 'Storico della proprietà',
    propertyHistorySubtitle: 'Tutti gli eventi raccolti da Popety.io riguardanti questa proprietà negli ultimi anni.',
    propertyTypes: {
      apartment: 'Appartamento',
      commercial: 'Commerciale',
      house: 'Casa',
      land: 'Terreno',
      office: 'Ufficio',
      other: 'Altro',
      parking: 'Parcheggio',
    },
    sections: {
      inquiryPeriod: 'Periodo di inchiesta pubblica',
      parties: 'Parti coinvolte',
      permitDetails: 'Dettagli permesso',
      projectInfo: 'Informazioni progetto',
      propertyInfo: 'Informazioni proprietà',
      transactionDetails: 'Dettagli transazione',
      workDescription: 'Descrizione lavori',
    },
    status: {
      active: 'Attivo',
      approved: 'Approvato',
      inactive: 'Inattivo',
      pending: 'In attesa',
      rejected: 'Rifiutato',
    },
    subtitle: 'Cronologia degli eventi per {{address}}',
    timeline: {
      active: 'Attivo',
      buildingPermit: 'Permesso di costruzione',
      completed: 'Completato',
      days: 'giorni',
      expired: 'Scaduto',
      noEvents: 'Nessun evento storico trovato',
      online: 'Online',
      pending: 'In attesa',
      permitRequest: 'Richiesta di permesso',
      rentalListing: 'Annuncio di locazione',
      saleListing: 'Annuncio di vendita',
      transaction: 'Transazione',
    },
    title: 'Storia',
    transactionDetail: {
      fields: {
        city: 'Città',
        legalType: 'Tipo legale',
        numberOfBuyers: 'Numero di acquirenti',
        numberOfProperties: 'Numero di proprietà',
        numberOfSellers: 'Numero di venditori',
        officialId: 'ID ufficiale',
        participant: 'Partecipante',
        participantType: 'Tipo',
        postalCode: 'Codice postale',
        property: 'Proprietà',
        propertyNumber: 'Numero di proprietà',
        publicationDate: 'Data di pubblicazione',
        role: 'Ruolo',
        share: 'Quota',
        totalPrice: 'Prezzo totale',
        totalSurface: 'Superficie totale',
        transactionDate: 'Data della transazione',
        transactionId: 'ID della transazione',
        transactionType: 'Tipo di transazione',
      },
      sections: {
        participants: 'Partecipanti',
        properties: 'Proprietà',
        summary: 'Riepilogo',
        transactionInfo: 'Informazioni sulla transazione',
      },
    },
  },
  landAnalysis: {
    buildingDetails: {
      actions: {
        analysis: 'Analisi',
        cancel: 'Annulla',
        edit: 'Modifica',
        explore: 'Esplora',
        noBuildingId: 'ID edificio non disponibile',
        noEgid: 'EGID non disponibile per questo edificio',
        regbl: 'REA',
        save: 'Salva',
      },
      card: {
        building: 'Edificio {{number}}',
        egid: 'EGID {{egid}}',
        floor: 'Piano',
        floors: 'Piani',
      },
      header: {
        scoreLabel: 'Punteggio esistente',
        scoreTooltip: 'Punteggio esistente basato sugli anni di costruzione e ristrutturazione',
        subtitle: 'Informazioni complete su tutti gli edifici in {{address}}',
        title: 'Dettagli degli edifici',
      },
      legend: {
        estimatedValues: 'Valori stimati',
        fullCoverage: 'Copertura totale',
        garage: 'Garage',
        industrial: 'Industriale',
        offices: 'Uffici',
        other: 'Altro',
        partialCoverage: 'Copertura parziale',
        public: 'Pubblico',
        residential: 'Residenziale',
        residentialMajority: 'Residenziale maggioritario',
        residentialMinority: 'Residenziale minoritario',
        retail: 'Commercio',
      },
      sections: {
        dimensions: {
          estFloorArea: 'Superficie stimata',
          grossFloorArea: 'Superficie lorda di piano',
          groundArea: 'Superficie al suolo',
          height: 'Altezza',
          title: 'Dimensioni',
          volume: 'Volume',
        },
        energy: {
          mainHeating: 'Riscaldamento principale',
          secondaryHeating: 'Riscaldamento secondario',
          solarPotential: 'Potenziale solare',
          title: 'Energia',
          waterHeating: 'Acqua calda',
        },
        propertyInfo: {
          classification: 'Classificazione UST',
          officialNumber: 'Numero ufficiale',
          ofsCategory: 'Categoria UST',
          title: 'Info proprietà',
          units: 'Unità',
        },
        status: {
          compliance: 'Conformità',
          constructionStatus: 'Stato di costruzione',
          lastRenovation: 'Ultima ristrutturazione',
          protectionStatus: 'Stato di protezione',
          title: 'Stato',
        },
      },
      states: {
        loading: 'Caricamento dei dettagli degli edifici...',
        noData: 'Nessun dato disponibile',
        unknownLocation: 'Posizione sconosciuta',
      },
      summary: {
        buildingsNumber: 'Numero di edifici',
        protectedBuildings: 'Edifici protetti',
        unitsNumber: 'Numero di unità',
      },
      summaryBar: {
        other: 'altre strutture',
        plannedConstruction: 'pianificati/costruzione',
        protected: 'protetti',
        registered: 'registrati',
        total: 'edifici totali',
        underground: 'sotterranei',
      },
      units: {
        cubicMeters: 'm³',
        meters: 'm',
        notAvailable: 'N/D',
        squareMeters: 'm²',
      },
      values: {
        building: 'Edificio {{index}}',
        compliant: 'Conforme',
        good: 'Buono',
        heritageProtected: 'Patrimonio protetto',
        na: 'N/D',
        notClassified: 'Non classificato',
        notProtected: 'Non protetto',
        notSpecified: 'Non specificato',
        projected: 'Previsto',
        solarExcellent: 'Eccellente',
        solarGood: 'Buono',
        solarLow: 'Basso',
        solarMedium: 'Medio',
      },
    },
    buildingsOverview: {
      aboveGroundVolume: 'Volume fuori terra',
      buildingCoverage: "Copertura dell'edificio (IDC)",
      constructionYear: 'Anno di costruzione',
      dimensions: 'Dimensioni',
      general: 'Generale',
      maximumFloors: 'Piani massimi',
      maximumHeight: 'Altezza massima',
      notAvailable: 'N/D',
      numberOfBuildings: 'Numero di edifici',
      title: 'Panoramica degli edifici',
      totalFloorArea: 'Superficie totale dei piani',
      totalGroundArea: 'Superficie totale del terreno',
    },
    common: {
      no: 'No',
      notAvailable: 'N/D',
      yes: 'Sì',
    },
    filesPanel: {
      title: 'File',
    },
    header: {
      addTags: 'Aggiungi tag',
      addToDeal: 'Aggiungi a trattativa',
      buildingAnalysis: "Analisi dell'edificio",
      built: 'Costruito',
      createNewBuildingAnalysis: "Crea nuova analisi dell'edificio",
      createNewLandAnalysis: 'Crea nuova analisi del terreno',
      favorite: 'Preferito',
      files: 'File',
      floors: 'piani',
      groupLandAnalysis: 'Analisi di terreno raggruppata',
      landAnalysis: 'Analisi del terreno',
      newBuildingAnalysis: "Nuova analisi dell'edificio",
      newLandAnalysis: 'Nuova analisi del terreno',
      notes: 'Note',
      pdfReports: 'Report PDF',
      share: 'Condividi',
      subtitle: 'Informazioni sulla particella',
      subtitleMultiplePlots: '{{count}} particelle per {{address}}',
      subtitleSinglePlot: 'Dettagli della particella per {{address}}',
      subtitleWithAddress: 'Informazioni sul terreno per {{address}}',
      tags: 'Tag',
      title: 'Terreno',
      units: 'unità',
    },
    info: {
      area: 'Superficie',
      buildable: 'Edificabile',
      buildingAreaPresent: 'Zona edificabile presente',
      egridNumber: 'Numero EGRID',
      officialArea: 'Superficie ufficiale',
      plotNumber: 'Numero particella',
      propertyNature: 'Natura del bene',
      propertyNatureBF: 'Fondo',
      propertyNatureDDP: 'ds – Diritto per sé stante e permanente',
      title: 'Informazioni terreno',
      type: 'Tipo di proprietà',
    },
    links: {
      openLandAnalysis: 'Apri analisi terreno',
      title: 'Link rapidi',
      viewInExplore: 'Visualizza in Esplora',
    },
    marketActivity: {
      activeListings: 'Annunci attivi',
      buildingPermits: 'Permessi di costruzione',
      recentActivity: 'Attività recente',
      title: 'Attività di mercato',
      transactions: 'Transazioni',
    },
    metrics: {
      buildings: {
        subtext: 'Su questo terreno',
        title: 'Edifici',
      },
      landArea: {
        subtext: 'Superficie totale',
        title: 'Superficie del terreno',
      },
      underExploitedScore: {
        subtext: 'Potenziale di sviluppo',
        title: 'Sottoutilizzato',
        tooltip: {
          calculation: 'Basato sul rapporto superficie attuale vs. consentita.',
          description: 'Misura quanto del potenziale edificabile è attualmente utilizzato.',
          importance: 'Punteggi più alti indicano maggiori opportunità di sviluppo.',
          source: 'Calcolato dai regolamenti di zona e dagli edifici attuali.',
          title: 'Punteggio di sottoutilizzo',
        },
      },
      units: {
        subtext: 'Unità abitative',
        title: 'Unità',
      },
    },
    owners: {
      lastChange: 'Ultima modifica',
      names: 'Nomi proprietari',
      number: 'Numero proprietari',
      ownershipType: 'Tipo di proprietà',
      title: 'Proprietari',
    },
    ownership: {
      contact: 'Contatto',
      lastChange: 'Ultima modifica:',
      noOwnerInfo: 'Nessuna informazione sul proprietario disponibile',
      owners: 'Proprietari:',
      title: 'Proprietà',
      unknown: 'Sconosciuto',
      unknownOwner: 'Proprietario sconosciuto',
      viewProfile: 'Visualizza profilo',
    },
    propertyInformation: {
      addresses: 'Indirizzi',
      area: 'Superficie',
      bareLand: 'Terreno nudo',
      basicInformation: 'Informazioni di base',
      municipality: 'Comune',
      no: 'No',
      notAvailable: 'N/D',
      plotNumber: 'Numero di particella',
      privateLand: 'Terreno privato',
      propertyId: 'ID proprietà (EGRID)',
      publicLand: 'Terreno pubblico',
      title: 'Informazioni sulla proprietà',
      type: 'Tipo',
      unknown: 'Sconosciuto',
      viewAllAddresses: 'Visualizza tutti i {{count}} indirizzi',
      viewOnGeoPortal: 'Visualizza sul geoportale',
      yes: 'Sì',
    },
    restrictions: {
      activeRestrictions: {
        one: '{{count}} restrizione attiva',
        other: '{{count}} restrizioni attive',
      },
      affected: 'Interessato',
      affectedTypes: 'Tipi interessati',
      noActiveRestrictions: 'Nessuna restrizione attiva',
      notAffected: 'Non interessato',
      notAvailable: 'Non disponibile',
      title: 'Restrizioni (RDPP)',
      typesChecked: '{{total}} tipi controllati, {{affected}} interessati',
      viewDetailedRestrictions: 'Visualizza restrizioni dettagliate',
    },
    scoreOverview: {
      developmentScore: 'Punteggio di sviluppo',
      legacyScore: 'Punteggio esistente',
      livabilityScore: 'Punteggio di vivibilità',
      underExploitedScore: 'Punteggio di sottoutilizzo',
    },
    sidebar: {
      items: {
        amenities: 'Servizi',
        buildingDetails: 'Dettagli edifici',
        buildingPermits: 'Permessi edilizi',
        demographics: 'Demografia',
        electricity: 'Elettricità',
        employment: 'Occupazione',
        feasibilityStudy: 'Studio di fattibilità',
        geoAnalysis: 'Analisi geo',
        history: 'Cronologia',
        noiseAnalysis: 'Analisi rumore',
        purchaseListings: 'Annunci vendita',
        purchaseMarket: 'Mercato acquisto',
        rentalListings: 'Annunci di locazione',
        rentalMarket: 'Mercato locativo',
        restrictions: 'Restrizioni',
        summary: 'Riepilogo',
        sunlightStudy: 'Studio luce solare',
        taxes: 'Imposte',
        transactions: 'Transazioni',
        transportAccess: 'Trasporti & Accesso',
        zoning: 'Zonizzazione',
        zoningRules: 'Regole di zona',
      },
      sections: {
        development: 'Sviluppo',
        environment: 'Ambiente',
        market: 'Mercato',
        overview: 'Panoramica',
        socialEconomic: 'Sociale & Economico',
      },
    },
    states: {
      empty: {
        description: 'Nessuna informazione sul terreno disponibile per questa proprietà.',
        title: 'Nessun dato sul terreno',
      },
      error: {
        retry: 'Riprova',
        title: 'Errore di caricamento',
      },
      errorLoadingData: 'Errore nel caricamento dei dati del terreno',
      loading: 'Caricamento dati del terreno...',
      noDataAvailable: 'Nessun dato del terreno disponibile',
      notAvailable: 'N/D',
      retry: 'Riprova',
    },
    summaryTab: {
      loading: 'Caricamento dati...',
      noData: 'Nessun dato disponibile',
      subtitle: 'Panoramica e informazioni chiave per {{address}}',
      title: 'Riepilogo della proprietà',
      unknownLocation: 'Posizione sconosciuta',
    },
    tagsPanel: {
      add: 'Aggiungi',
      adding: 'Aggiunta in corso...',
      addNewTag: 'Aggiungi nuovo tag',
      buildingTags: "Tag dell'edificio",
      closePanel: 'Chiudi pannello',
      currentTags: 'Tag attuali ({{count}})',
      emptyStateHint: 'Aggiungi tag sopra per organizzare e categorizzare questa proprietà',
      enterTagName: 'Inserisci il nome del tag...',
      groupLandTags: 'Tag del gruppo di terreni',
      landTags: 'Tag del terreno',
      loadingTags: 'Caricamento tag...',
      manageTags: 'Gestisci tag',
      noTagsAssigned: 'Nessun tag assegnato',
      title: 'Tag',
    },
    transactionsTab: {
      filters: {
        additionalFilters: 'Filtri aggiuntivi',
        advancedFilters: 'Filtri avanzati',
        allLocations: 'Tutte le posizioni',
        clearAll: 'Cancella tutto',
        hideFilters: 'Nascondi filtri',
        landArea: 'Superficie del terreno (m²)',
        legalTypeBF: 'B-F',
        legalTypeCOP: 'COP',
        legalTypeDDP: 'DDP',
        legalTypeDP: 'DP',
        legalTypeOther: 'Altro',
        legalTypePPE: 'PPE',
        numberOfBuyers: 'Numero di acquirenti',
        numberOfSellers: 'Numero di venditori',
        others: 'Altri',
        participantAssociation: 'Associazione',
        participantCompany: 'Azienda',
        participantCooperative: 'Cooperativa',
        participantFoundation: 'Fondazione',
        participantIndividual: 'Privato',
        participantOther: 'Altro',
        participantPublicEntity: 'Ente pubblico',
        participants: 'Partecipanti',
        participantType: 'Tipo di partecipante',
        propertyLegalType: 'Tipo legale della proprietà',
        radius: 'Raggio',
        showFilters: 'Mostra filtri',
        stepTransactionPrice: 'Prezzo transazione per fase (CHF)',
        transactionDate: 'Data della transazione',
        transactionType: 'Tipo di transazione',
        typeAreaPrice: 'Tipo, Superficie & Prezzo',
        unitApartment: 'Appartamento',
        unitCommercial: 'Commerciale',
        unitHouse: 'Casa',
        unitLand: 'Terreno',
        unitOther: 'Altro',
        unitParking: 'Parcheggio',
        unitType: 'Tipo di unità',
      },
      subtitle: 'Esplora la cronologia delle transazioni intorno al terreno e salva quelle che ti interessano per questa analisi.',
      tabs: {
        aroundPlot: 'Transazioni intorno al terreno',
        saved: 'Transazioni salvate',
      },
      title: 'Transazioni',
    },
    units: {
      percent: '%',
      score: '/100',
      squareMeters: 'm²',
    },
    zoneAssignment: {
      buildable: 'Edificabile',
      nonBuildable: 'Non edificabile',
      title: 'Assegnazione della zona',
      unknownZone: 'Zona sconosciuta',
    },
    zones: {
      adopted: 'Adottato',
      buildingArea: 'Area edificabile',
      cos: 'C.o.',
      coverageArea: 'Copertura',
      cus: 'C.s.',
      defaultName: 'Zona {{number}}',
      ibus: 'I.l.s.',
      planTypeAdoption: 'Tipo di piano',
      title: 'Zonizzazione',
      zoneName: 'Nome zona',
    },
  },
  listings: {
    aiFilter: {
      description: 'Descrivi la proprietà che stai cercando, e ti aiuterò a trovarla.',
      errors: {
        processingFailed: "Si è verificato un errore durante l'elaborazione della richiesta",
      },
      examplePrompts: {
        '0': 'Mostrami appartamenti in locazione a Zurigo sotto 3000 CHF',
        '1': 'Trova case in vendita a Ginevra con 4+ stanze',
      },
      placeholder: "es. 'Appartamento 2 locali in locazione a Losanna sotto 2500 CHF'",
      processing: 'Elaborazione...',
      recentSearches: 'Ricerche recenti',
      search: 'Cerca',
      title: 'Assistente filtro annunci',
    },
    common: {
      active: 'Attivo',
      addressNotAvailable: 'Indirizzo non disponibile',
      allLocations: 'Tutte le posizioni',
      built: 'costruito',
      days: 'giorni',
      distance: 'Distanza',
      expired: 'Scaduto',
      km: 'km',
      m: 'm',
      na: 'N/D',
      perSqm: '/ m²',
      priceOnRequest: 'Prezzo su richiesta',
      propertyImage: 'Immagine della proprietà',
      propertyListing: 'Annuncio immobiliare',
      radius: 'Raggio',
      rooms: 'stanze',
      sqm: 'm²',
      to: 'a',
      unknown: 'Sconosciuto',
    },
    dates: {
      daysAgo: '{{count}} giorni fa',
      listed: 'Pubblicato',
      monthsAgo: '{{count}} mesi fa',
      today: 'Oggi',
      weeksAgo: '{{count}} settimane fa',
      yearsAgo: '{{count}} anni fa',
      yesterday: 'Ieri',
    },
    detail: {
      agents: {
        unknownAgent: 'Agente sconosciuto',
      },
      buttons: {
        addToFavorites: 'Aggiungi ai preferiti',
        estimate: 'Stima',
        findAddress: 'Trova indirizzo',
        findExactAddress: "Trova l'indirizzo esatto",
        goToAnalysis: "Vai all'analisi",
        goToEstimate: 'Vai alla stima',
        goToExplore: 'Vai a Esplora',
        viewInLandAnalysis: 'Visualizza in Analisi terreno',
        viewOnExplore: 'Visualizza su Esplora',
      },
      error: 'Errore',
      fallbacks: {
        addressNotSpecified: 'Indirizzo non specificato',
        day: 'giorno',
        days: 'giorni',
        house: 'Casa',
        immediately: 'Immediatamente',
        listedOnPlatform: 'Pubblicato su questa piattaforma',
        noAdditionalImages: 'Nessuna immagine aggiuntiva disponibile',
        noDescriptionAvailable: 'Nessuna descrizione disponibile',
        property: 'Immobile',
        propertyId: 'ID immobile',
        propertyImage: 'Immagine immobile',
      },
      labels: {
        agency: 'Agenzia',
        available: 'Disponibile',
        bathrooms: 'Bagni',
        buildingYear: 'Anno di costruzione',
        category: 'Categoria',
        constructionYear: 'Anno di costruzione',
        floor: 'Piano',
        id: 'ID',
        landSurface: 'Superficie del terreno',
        listedOn: 'Pubblicato su',
        mandateType: 'Tipo di mandato',
        newConstruction: 'Nuova costruzione',
        onlineFor: 'Online da',
        published: 'Pubblicato',
        status: 'Stato',
        type: 'Tipo',
      },
      loading: 'Caricamento dettagli annuncio...',
      metrics: {
        bathrooms: 'Bagni',
        buildYear: 'Anno di costruzione',
        landArea: 'Superficie terreno',
        livingArea: 'Superficie abitabile',
        price: 'Prezzo',
        rooms: 'Locali',
      },
      sections: {
        description: 'Descrizione',
        features: 'Caratteristiche e servizi',
        listedOnPortals: 'Pubblicato sui portali',
        listingInformation: 'Informazioni annuncio',
        propertyAgents: 'Agenti immobiliari',
        propertyDetails: 'Dettagli immobile',
        propertyGallery: 'Galleria immobile',
      },
      status: {
        active: 'Attivo',
        expired: 'Scaduto',
      },
      vendorTypes: {
        private: 'Privato',
        professional: 'Professionale',
        unknown: 'Sconosciuto',
      },
    },
    detailPanel: {
      columns: {
        change: 'Variazione',
        date: 'Data',
        price: 'Prezzo',
        pricePerSqm: 'Prezzo/m²',
      },
      empty: {
        noDescription: 'Nessuna descrizione disponibile',
        noFeatures: 'Nessuna caratteristica elencata',
        noPriceHistory: 'Nessuno storico prezzi disponibile',
      },
      labels: {
        address: 'Indirizzo',
        availability: 'Disponibilità',
        daysOnMarket: 'Giorni sul mercato',
        description: 'Descrizione',
        features: 'Caratteristiche',
        floor: 'Piano',
        listingDate: 'Data pubblicazione',
        livingArea: 'Superficie abitabile',
        price: 'Prezzo',
        pricePerSqm: 'Prezzo al m²',
        propertyDetails: 'Dettagli proprietà',
        propertyListing: 'Annuncio immobiliare',
        propertyType: 'Tipo di proprietà',
        rooms: 'Stanze',
        status: 'Stato',
        usableArea: 'Superficie utile',
        viewOriginal: 'Visualizza annuncio originale',
        yearBuilt: 'Anno di costruzione',
      },
      tabs: {
        details: 'Dettagli',
        location: 'Posizione',
        overview: 'Panoramica',
        priceHistory: 'Storico prezzi',
      },
    },
    distanceOptions: {
      '1km': '1km',
      '2km': '2km',
      '500m': '500m',
      '5km': '5km',
    },
    filter: {
      activeFilter: 'filtro attivo',
      activeFilters: 'filtri attivi',
      additionalFilters: 'Filtri aggiuntivi',
      advancedFilters: 'Filtri avanzati',
      allLocations: 'Tutte le posizioni',
      clearAll: 'Cancella tutto',
      customPriceRange: 'Intervallo di prezzo personalizzato (CHF)',
      floorLevel: 'Piano',
      from: 'Da',
      hideFilters: 'Nascondi filtri',
      listingDate: 'Data di pubblicazione',
      livingArea: 'Superficie abitabile (m²)',
      max: 'Max',
      min: 'Min',
      priceSizeRooms: 'Prezzo, Superficie & Stanze',
      propertyType: 'Tipo di proprietà',
      propertyTypes: {
        apartment: 'Appartamento',
        commercial: 'Commerciale',
        garageParking: 'Garage/Parcheggio',
        house: 'Casa',
        other: 'Altro',
        plot: 'Terreno',
        residential: 'Residenziale',
      },
      radius: 'Raggio',
      rooms: 'Stanze',
      roomsLabel: 'stanze',
      showFilters: 'Mostra filtri',
      to: 'A',
      yearBuilt: 'Anno di costruzione',
    },
    filters: {
      actions: {
        activeFilters: 'Filtri attivi',
        apply: 'Applica',
        clearAll: 'Cancella tutto',
        clearAllFilters: 'Cancella tutti i filtri',
        closeFilters: 'Chiudi filtri',
        lessFilters: 'Meno filtri',
        loadSavedFilters: 'Carica filtri salvati',
        moreFilters: 'Altri filtri',
        openFilters: 'Apri filtri',
        saveCurrentFilters: 'Salva filtri correnti',
      },
      ai: {
        textSearchError: 'Impossibile elaborare la richiesta. Riprova.',
        voiceSearchError: 'Impossibile elaborare la richiesta vocale. Riprova.',
      },
      fields: {
        area: 'Superficie',
        floor: 'Piano',
        from: 'Da',
        listingDate: 'Data annuncio',
        listingDuration: 'Durata annuncio',
        mandateType: 'Tipo di mandato',
        max: 'Max',
        min: 'Min',
        price: 'Prezzo',
        pricePerSqm: 'Prezzo al m²',
        status: 'Stato',
        to: 'A',
        typeOfProperty: 'Tipo di immobile',
        vendorType: 'Tipo di venditore',
        yearOfConstruction: 'Anno di costruzione',
      },
      loading: 'Caricamento filtri...',
      mandateTypes: {
        exclusive: 'Esclusivo',
        simple: 'Semplice',
        unknown: 'Sconosciuto',
      },
      placeholders: {
        enterValue: 'Inserisci valore',
        from: 'Da',
        max: 'Max',
        min: 'Min',
        searchLocation: 'Cerca posizione...',
        selectOption: 'Seleziona opzione',
        to: 'A',
      },
      propertyTypes: {
        apartment: 'Appartamento',
        commercial: 'Commerciale',
        garageParking: 'Garage/Parcheggio',
        house: 'Casa',
        other: 'Altro',
        plot: 'Terreno',
      },
      quickFilters: {
        listed: 'Pubblicato',
        propertyCategory: 'Categoria immobile',
      },
      saved: {
        appliedFilter: 'Filtro applicato: {{name}}',
        failedToSave: 'Impossibile salvare il filtro',
        savedFilter: 'Filtro salvato: {{name}}',
        savedOn: 'Salvato il {{date}}',
      },
      sections: {
        brokerInfo: 'Info intermediario',
        buildingYear: 'Anno di costruzione',
        dateRange: 'Periodo',
        floor: 'Piano',
        landArea: 'Superficie terreno',
        livingArea: 'Superficie abitabile',
        location: 'Posizione',
        locationDate: 'Posizione e data',
        mandateType: 'Tipo di mandato',
        portals: 'Portali',
        price: 'Prezzo',
        priceRange: 'Fascia di prezzo',
        propertyCharacteristics: "Caratteristiche dell'immobile",
        propertyType: 'Tipo di immobile',
        rooms: 'Locali',
        status: 'Stato',
        vendorType: 'Tipo di venditore',
      },
      title: 'Filtri annunci',
      validation: {
        invalidRange: 'Intervallo non valido',
        requiredField: 'Campo obbligatorio',
      },
      vendorTypes: {
        private: 'Privato',
        professional: 'Professionale',
        unknown: 'Sconosciuto',
      },
    },
    list: {
      columns: {
        area: 'Superficie',
        date: 'Data',
        duration: 'Durata',
        image: 'Immagine',
        location: 'Posizione',
        mandateType: 'Tipo di mandato',
        portals: 'Portali',
        price: 'Prezzo',
        property: 'Immobile',
        rooms: 'Locali',
        status: 'Stato',
        vendor: 'Venditore',
        year: 'Anno',
      },
      duration: {
        day: 'giorno',
        days: 'giorni',
      },
      export: {
        filename: 'annunci_export',
        toExcel: 'Esporta in Excel',
        toPdf: 'Esporta in PDF',
      },
      fallbacks: {
        dash: '—',
        noData: 'Nessun dato',
        noImage: 'Nessuna immagine',
        unknown: 'Sconosciuto',
      },
      mandate: {
        exclusive: 'Esclusivo',
        shared: 'Condiviso',
        unknown: 'Sconosciuto',
      },
      status: {
        active: 'Attivo',
        expired: 'Scaduto',
      },
      vendor: {
        individual: 'Privato',
        pro: 'Professionale',
        unknown: 'Sconosciuto',
      },
    },
    map: {
      errorLoadingMapData: 'Errore durante il caricamento dei dati mappa',
      loading: 'Caricamento...',
      loadingMapData: 'Caricamento dati mappa...',
      tooltip: {
        area: 'Superficie',
        forRent: 'In locazione',
        forSale: 'In vendita',
        listingAlt: 'Annuncio',
        location: 'Posizione',
        noImageAvailable: 'Nessuna immagine disponibile',
        priceOnRequest: 'Prezzo su richiesta',
        propertyId: 'ID immobile',
        rooms: 'locali',
      },
    },
    priceRanges: {
      '1MTo2M': '1M - 2M',
      '500kTo1M': '500k - 1M',
      over2M: '> 2M',
      under500k: '< 500k',
    },
    print: {
      about: {
        realTimeData: 'Questo report fornisce analisi di mercato in tempo reale basate su annunci aggregati dai principali portali immobiliari svizzeri.',
      },
      contact: {
        email: 'Email',
        forQuestions: 'Per domande su questo report, contatta:',
        popetyContact: 'Popety.io | info@popety.io | www.popety.io',
        title: 'Informazioni di contatto',
        website: 'Sito web',
        yourContact: 'Il tuo contatto',
      },
      cover: {
        aboutThisReport: 'Informazioni su questo report',
        analyticsFooter: 'Piattaforma di analisi del mercato immobiliare',
        appliedFilters: 'Filtri applicati',
        createdOnPopety: 'Creato su Popety.io - Piattaforma di analisi del mercato immobiliare',
        dealType: 'Tipo di transazione',
        generated: 'Generato',
        generatedOn: 'Generato il',
        listingDate: 'Data annuncio',
        listingsList: 'Elenco annunci',
        listingsSelectedOn: 'Annunci selezionati il',
        location: 'Posizione',
        priceRange: 'Fascia di prezzo',
        propertyType: 'Tipo di immobile',
        realEstateMarketReport: 'Report mercato immobiliare',
        rentalListingsReport: 'Report statistico annunci locazione',
        rentals: 'Locazioni',
        sales: 'Vendite',
        salesListingsReport: 'Report statistico annunci vendita',
        switzerland: 'Svizzera',
        timePeriod: 'Periodo',
      },
      dataSource: {
        collectionPeriod: 'Periodo di raccolta dati: Continuo, con aggiornamenti regolari',
        description: 'Questo report aggrega dati dalle seguenti fonti:',
        includesOutlierFiltering: "Fonti dati: Annunci immobiliari ufficiali e transazioni di mercato. L'analisi include il filtraggio degli outlier per maggiore precisione.",
        lastRefresh: 'Ultimo aggiornamento dati: In tempo reale al momento della generazione del report',
        popetyAnalytics: 'Piattaforma di analisi proprietaria Popety.io',
        publicListings: 'Annunci immobiliari pubblici e dati di mercato',
        statisticalAnalysis: 'Analisi statistica eseguita dagli algoritmi di Popety.io',
        swissPortals: 'Principali portali immobiliari svizzeri tra cui Homegate, ImmoScout24 e altri',
        title: 'Fonti dati',
      },
      details: {
        built: 'Costruito',
        listingOf: 'Annuncio {{current}} di {{total}}',
        noImageAvailable: 'Nessuna immagine disponibile',
        propertyListing: 'Annuncio immobiliare',
        unknownAddress: 'Indirizzo sconosciuto',
      },
      disclaimer: {
        accuracyOfInformation: {
          content: "Le informazioni contenute in questo report sono fornite solo a scopo informativo generale. Sebbene ci sforziamo di mantenere le informazioni aggiornate e accurate, non facciamo dichiarazioni o garanzie di alcun tipo, esplicite o implicite, circa la completezza, l'accuratezza, l'affidabilità, l'idoneità o la disponibilità del report o delle informazioni, prodotti, servizi o grafici correlati contenuti nel report per qualsiasi scopo.",
          title: 'Accuratezza delle informazioni',
        },
        copyrightNotice: {
          content: '© {{year}} Popety.io. Tutti i diritti riservati. Questo report e i suoi contenuti sono protetti da copyright e altri diritti di proprietà intellettuale. La riproduzione, distribuzione o utilizzo non autorizzato di questo report è severamente vietato.',
          title: 'Avviso di copyright',
        },
        dataPrivacy: {
          content: 'Rispettiamo la tua privacy e ci impegniamo a proteggere i tuoi dati personali. Questo report potrebbe contenere dati di mercato aggregati e anonimizzati raccolti da fonti pubblicamente disponibili.',
          title: 'Privacy dei dati',
        },
        noInvestmentAdvice: {
          content: 'Questo report non costituisce consulenza in materia di investimenti, legale, fiscale o altri consigli professionali. Non dovresti fare affidamento su questo report come unica base per prendere decisioni di investimento. Consulta sempre professionisti qualificati prima di prendere decisioni di investimento.',
          title: 'Nessun consiglio di investimento',
        },
        title: 'Disclaimer e avviso legale',
      },
      format: {
        details: 'Dettagli',
        fullPage: 'Una pagina per annuncio',
        summary: 'Riepilogo',
        tableView: 'Vista tabella, più per pagina',
      },
      modal: {
        cancel: 'Annulla',
        close: 'Chiudi',
        downloadPdf: 'Scarica PDF',
        exportListingsToPdf: 'Esporta annunci in PDF',
        failedToGeneratePdf: 'Generazione PDF non riuscita. Riprova.',
        fullMarketReport: 'Report di mercato completo',
        generatePdf: 'Genera PDF',
        generatingPdf: 'Generazione PDF...',
        listing: 'annuncio',
        listings: 'annunci',
        pageOf: 'Pagina {{current}} di {{total}}',
        pagesTotal: 'pagine in totale',
        preview: 'Anteprima',
        previewAndDownload: 'Anteprima e scarica un report di mercato completo con tutte le sezioni',
        priceEvolution: 'Evoluzione dei prezzi',
        rentEvolution: 'Evoluzione delle pigioni',
        resetZoom: 'Reimposta zoom',
        zoomIn: 'Ingrandisci',
        zoomOut: 'Riduci',
      },
      progress: {
        addingContent: 'Aggiunta contenuti',
        addingPageNumbers: 'Aggiunta numeri pagina e rifiniture finali',
        addingTitleAndBranding: 'Aggiunta titolo, info azienda e branding',
        convertingCharts: 'Conversione grafici in immagini alta qualità',
        creatingCoverPage: 'Creazione pagina di copertina',
        exportingCharts: 'Esportazione grafici',
        finalizingPdf: 'Finalizzazione PDF',
        generatingPdfReport: 'Generazione report PDF',
        generatingSections: 'Generazione sezioni, analisi e dati',
        initializingPdf: 'Inizializzazione PDF',
        pleaseWait: 'Attendere mentre creiamo la tua analisi di mercato completa',
        settingUpDocument: 'Configurazione struttura e stili documento',
      },
      sections: {
        tableOfContents: 'Indice',
      },
      summary: {
        area: '{{value}} m²',
        builtYear: 'Costruito nel {{year}}',
        id: 'ID',
        pageOfListings: 'Pagina {{page}} di {{total}} • Annunci {{start}}-{{end}}',
        rooms: '{{count}} locali',
        type: 'Tipo',
      },
    },
    propertyTypes: {
      apartment: 'Appartamento',
      commercial: 'Commerciale',
      house: 'Casa',
      parking: 'Parcheggio',
      plot: 'Terreno',
    },
    roomOptions: {
      '1room': '1 stanza',
      '2rooms': '2 stanze',
      '3rooms': '3 stanze',
      '4rooms': '4 stanze',
      '5plusRooms': '5+ stanze',
    },
    saved: {
      addressNotAvailable: 'Indirizzo non disponibile',
      allSaved: 'Tutti salvati',
      averagePrice: 'Prezzo medio',
      avgLivingArea: 'Superficie abitabile media',
      avgPricePerSqm: 'Prezzo medio/m²',
      avgRooms: 'Stanze medie',
      empty: 'Nessun annuncio salvato',
      emptyDescription: 'Salva annunci dalla scheda "Annunci intorno al terreno" per confrontarli in seguito',
      emptyTitle: 'Nessun annuncio salvato',
      listings: 'Annunci',
      livingArea: 'Superficie abitabile',
      loading: 'Caricamento annunci salvati...',
      perListing: 'Per annuncio',
      perListing2: 'Per annuncio',
      perSqm: '/m²',
      priceOnRequest: 'Prezzo su richiesta',
      priceRangeLabel: 'Fascia di prezzo',
      propertyImage: 'Immagine proprietà',
      propertyListing: 'Annuncio immobiliare',
      removeFromSaved: 'Rimuovi dai salvati',
      saveListing: 'Salva annuncio',
      sqm: 'm²',
      to: 'a',
      totalSaved: 'Totale salvato',
      totalValue: 'Valore totale',
    },
    sections: {
      purchaseSubtitleBuilding: 'Visualizza annunci di vendita intorno a questo edificio',
      purchaseSubtitleLand: 'Visualizza annunci di vendita intorno a questo terreno',
      purchaseTitle: 'Annunci di vendita',
      rentSubtitleBuilding: 'Visualizza annunci di locazione intorno a questo edificio',
      rentSubtitleLand: 'Visualizza annunci di locazione intorno a questo terreno',
      rentTitle: 'Annunci di locazione',
    },
    stats: {
      actions: {
        showLess: 'Mostra meno',
        showMore: 'Mostra altro',
      },
      charts: {
        byPropertyType: 'per tipo di immobile',
        distributionByQuantiles: 'Distribuzione per quantili',
        distributionByRooms: 'Distribuzione per locali',
        geographicVolumeDistribution: 'Distribuzione geografica dei volumi',
        portalMarketShareEvolution: 'Evoluzione quote di mercato per portale',
        pricePerSquareMeter: 'Prezzo al metro quadrato',
        rankingsByPrice: 'Classifiche per prezzo',
        rankingsByRent: 'Classifiche per pigione',
        rentPerSquareMeter: 'Pigione al metro quadrato',
      },
      dataSource: {
        description: 'Dati aggregati dai principali portali immobiliari svizzeri',
        disclaimer: 'Disclaimer',
        title: 'Fonti dati',
      },
      defaults: {
        allProperties: 'Tutti gli immobili',
        allSwitzerland: 'Tutta la Svizzera',
      },
      descriptions: {
        agencyAnalysis: 'Valuta le prestazioni e la quota di mercato delle diverse agenzie immobiliari per identificare i leader di mercato.',
        agencyAnalysisRental: 'Valuta le prestazioni e la quota di mercato delle diverse agenzie attive nella locazione.',
        cityAnalysis: 'Analisi dei modelli di densità dei prezzi nelle principali città per comprendere le variazioni del mercato e identificare opportunità.',
        cityAnalysisRental: 'Analisi dei modelli di densità delle locazioni nelle principali città per comprendere le variazioni del mercato locativo.',
        newVsResale: 'Confronta le tendenze dei prezzi e le dinamiche di mercato tra proprietà di nuova costruzione e proprietà in rivendita.',
        newVsResaleRental: 'Confronta i canoni di locazione tra proprietà di nuova costruzione e proprietà più vecchie.',
        portalAnalysis: "Valuta l'efficacia e la portata dei diversi portali di annunci immobiliari per il marketing immobiliare.",
        portalAnalysisRental: "Valuta l'efficacia dei diversi portali di annunci di locazione per il marketing immobiliare.",
        priceEvolution: "Monitora l'evoluzione dei prezzi immobiliari nel tempo per identificare tendenze e modelli nel mercato immobiliare.",
        priceGeography: 'Visualizza i prezzi immobiliari in diverse aree geografiche per identificare regioni di alto valore e accessibili.',
        priceM2Evolution: "Analizza l'evoluzione dei prezzi immobiliari al metro quadro per comprendere le tendenze di valore tra diverse dimensioni di proprietà.",
        priceM2PerRoom: 'Esplora come il prezzo al metro quadro varia con il numero di stanze per identificare le configurazioni immobiliari più efficienti.',
        pricePerRoom: 'Analizza come i prezzi immobiliari variano in base al numero di stanze per comprendere i modelli di prezzo per dimensione.',
        rentEvolution: 'Monitora le tendenze delle pigioni nel tempo per comprendere le dinamiche del mercato locativo.',
        rentGeography: 'Visualizza le pigioni in diverse aree per identificare posizioni premium e accessibili.',
        rentM2Evolution: 'Monitora le pigioni al metro quadro per analizzare le tendenze di valore nel mercato locativo.',
        rentM2PerRoom: 'Esplora come la pigione al metro quadro varia con il numero di stanze per identificare le configurazioni locative più efficienti.',
      },
      footer: {
        dataSources: 'Homegate, ImmoScout24, Newhome, Acheter-Louer',
        dataSourcesLabel: 'Fonti dei dati:',
        description: 'Questo report statistico è generato sulla base di dati in tempo reale raccolti dai portali immobiliari svizzeri. I dati vengono continuamente aggiornati e analizzati per fornire informazioni accurate sul mercato.',
        title: 'Informazioni su questo report',
      },
      interface: {
        chartPlaceholder: 'Segnaposto grafico per',
        downloadFullReport: 'Scarica report completo',
        hideSection: 'Nascondi sezione',
        showSection: 'Mostra sezione',
        sources: 'Fonti:',
        sourcesList: 'Portali immobiliari svizzeri • Popety.io',
      },
      kpi: {
        keyInsights: 'Approfondimenti chiave',
        keyMetrics: 'Metriche chiave',
        oneYearGrowth: 'Crescita a 1 anno',
      },
      periods: {
        allAvailable: 'Tutti i dati disponibili',
        fullHistory: 'Cronologia completa',
        last12Months: 'Ultimi 12 mesi',
        since2022: 'Dal 2022',
        sinceJanuary2022: 'Da gennaio 2022',
      },
      sections: {
        agencyAnalysis: 'Analisi delle agenzie',
        cityAnalysis: 'Analisi per città',
        marketShare: 'Quota di mercato',
        newVsResale: 'Nuova costruzione vs rivendita',
        portalAnalysis: 'Analisi dei portali',
        priceDistribution: 'Distribuzione dei prezzi',
        priceEvolution: 'Evoluzione dei prezzi',
        priceGeography: 'Geografia dei prezzi',
        priceM2Evolution: 'Evoluzione prezzo/m²',
        priceM2PerRoom: 'Prezzo/m² per stanza',
        pricePerRoom: 'Prezzo per stanza',
        rentDistribution: 'Distribuzione delle pigioni',
        rentEvolution: 'Evoluzione delle pigioni',
        rentGeography: 'Geografia delle pigioni',
        rentM2Evolution: 'Evoluzione pigione/m²',
        rentM2PerRoom: 'Pigione/m² per stanza',
      },
      table: {
        city: 'Città',
        listings: 'Annunci',
        medianChfM2: 'Mediana CHF/m²',
        percentile25: '25° percentile',
        percentile75: '75° percentile',
        stdDeviation: 'Deviazione standard',
      },
    },
    statusOptions: {
      all: 'Tutti',
    },
    tabs: {
      aroundPlot: 'Annunci intorno al terreno',
      saved: 'Annunci salvati',
    },
    views: {
      list: 'Lista',
      map: 'Mappa',
      stats: 'Statistiche',
    },
  },
  market: {
    common: {
      currency: {
        chf: 'CHF',
        chfPerM2: 'CHF/m²',
      },
      errors: {
        loadingData: 'Errore durante il caricamento dei dati. Riprova più tardi.',
      },
      filters: {
        advancedFilters: 'Filtri avanzati',
        city: 'Comune',
        district: 'Distretto',
        hideFilters: 'Nascondi filtri',
        location: 'Posizione',
        postalCode: 'Codice Postale',
        propertyType: 'Tipo di immobile',
      },
      month: 'mese',
      na: 'N/D',
      placeholder: {
        chartPlaceholder: 'Segnaposto grafico per {{section}}',
      },
      propertyTypes: {
        apartment: 'Appartamento',
        commercial: 'Commerciale',
        house: 'Casa',
        houseApartment: 'Casa & App',
        plot: 'Terreno',
      },
      year: 'anno',
    },
    distribution: {
      charts: {
        area: 'Distribuzione delle superfici',
        constructionYear: 'Anno di costruzione',
        price: 'Distribuzione dei prezzi',
        priceM2: 'Distribuzione del prezzo/m²',
        rent: 'Distribuzione dei canoni',
        rentM2: 'Distribuzione del canone/m²',
        rooms: 'Distribuzione delle stanze',
        timeOnMarket: 'Tempo sul mercato',
      },
      empty: {
        description: 'Non sono disponibili dati di distribuzione per la selezione corrente.',
        title: 'Nessun dato disponibile',
      },
      insights: {
        areaRange: 'Panoramica delle superfici',
        areaRangeDesc: 'La superficie media è di {{avg}} m² con una mediana di {{median}} m².',
        mostCommonRooms: 'Configurazione più comune',
        mostCommonRoomsDesc: 'Gli immobili con {{rooms}} locali rappresentano il {{percentage}}% degli annunci in questa zona.',
        priceRange: 'Panoramica dei prezzi',
        priceRangeDesc: 'Il prezzo medio è di {{avg}} CHF con una mediana di {{median}} CHF.',
        rentRange: 'Panoramica dei canoni',
      },
      kpis: {
        medianArea: 'Superficie mediana',
        medianPrice: 'Prezzo mediano',
        medianRent: 'Canone mediano',
        medianRooms: 'Locali mediana',
        totalListings: 'Annunci totali',
      },
      states: {
        loading: 'Caricamento dei dati di distribuzione...',
      },
      stats: {
        avg: 'Media',
        median: 'Mediana',
        total: 'Totale',
      },
      units: {
        days: 'giorni',
        rooms: 'locali',
        year: 'anno',
      },
    },
    distributionView: {
      combined: 'Combinato',
      listings: 'annunci',
      perMonth: '/mese',
      perYear: '/anno',
      separate: 'Per tipo di immobile',
    },
    purchase: {
      header: {
        subtitle: "Analizza le tendenze e i modelli di mercato per gli acquisti immobiliari nell'area selezionata",
        title: 'Analisi del mercato immobiliare',
      },
      sections: {
        distribution: {
          description: 'Esplora la composizione del mercato in base ai locali, fasce di prezzo, superfici, anni di costruzione e tempo sul mercato per comprendere le caratteristiche del mercato locale.',
          title: 'Distribuzione del mercato',
        },
        newVsResale: {
          description: 'Confronta le tendenze dei prezzi e le dinamiche di mercato tra immobili di nuova costruzione e immobili in rivendita.',
          title: 'Nuova costruzione vs rivendita',
        },
        priceEvolution: {
          description: "Segui l'evoluzione dei prezzi immobiliari nel tempo per identificare tendenze e modelli nel mercato immobiliare.",
          title: 'Evoluzione dei prezzi',
        },
        priceM2Evolution: {
          description: "Analizza l'evoluzione dei prezzi immobiliari al metro quadro per comprendere le tendenze di valore nelle diverse dimensioni degli immobili.",
          title: 'Evoluzione del prezzo/m²',
        },
        priceM2PerRoom: {
          description: 'Esplora come varia il prezzo al metro quadro con il numero di locali per identificare le configurazioni immobiliari più efficienti.',
          title: 'Prezzo/m² per locale',
        },
        pricePerRoom: {
          description: "Analizza come variano i prezzi immobiliari in base al numero di locali per comprendere i modelli di prezzo secondo la dimensione dell'immobile.",
          title: 'Prezzo per locale',
        },
      },
    },
    readOnly: {
      purchaseDescription: "L'analisi del mercato immobiliare con l'evoluzione dei prezzi, i confronti tra immobili e le tendenze di mercato è disponibile nell'applicazione completa. Questa vista pubblica mostra un riepilogo della stima dell'immobile.",
      rentalDescription: "L'analisi del mercato locativo con l'evoluzione dei prezzi, i confronti tra immobili e le tendenze di mercato è disponibile nell'applicazione completa. Questa vista pubblica mostra un riepilogo della stima dell'immobile.",
      title: 'Analisi di mercato',
    },
    rental: {
      header: {
        subtitle: "Analizza le tendenze e i modelli del mercato locativo per gli immobili nell'area selezionata",
        title: 'Analisi del mercato locativo',
      },
      sections: {
        availability: {
          description: 'Monitora la disponibilità del mercato locativo, i tassi di sfitto e i modelli di turnover per comprendere le dinamiche di domanda e offerta.',
          title: 'Disponibilità e turnover delle locazioni',
        },
        distribution: {
          description: 'Esplora la composizione del mercato locativo in base ai locali, fasce di canone, superfici, anni di costruzione e tempo sul mercato per comprendere le caratteristiche del mercato locale.',
          title: 'Distribuzione del mercato',
        },
        priceEvolution: {
          description: "Segui l'evoluzione dei canoni di locazione nel tempo per identificare tendenze e modelli nel mercato locativo.",
          title: 'Evoluzione dei canoni di locazione',
        },
        priceM2Evolution: {
          description: "Analizza l'evoluzione dei canoni di locazione al metro quadro per comprendere le tendenze di valore nelle diverse dimensioni degli immobili.",
          title: 'Evoluzione del canone/m²',
        },
        priceM2PerRoom: {
          description: 'Esplora come varia il canone al metro quadro con il numero di locali per identificare le configurazioni locative più efficienti.',
          title: 'Canone/m² per locale',
        },
        pricePerRoom: {
          description: "Analizza come variano i canoni di locazione in base al numero di locali per comprendere i modelli di prezzo secondo la dimensione dell'immobile.",
          title: 'Canone per locale',
        },
      },
      summary: {
        marketVolume: {
          subtitle: 'Annunci attivi (12 mesi)',
          title: 'Volume di mercato',
        },
        medianRent: {
          subtitle: 'Per {{period}}',
          title: 'Canone mediano',
        },
        medianRentM2: {
          subtitle: 'Per {{period}}',
          title: 'Canone mediano/m²',
        },
      },
    },
    shared: {
      average: 'Media',
      avgPrice: 'Prezzo medio',
      keyInsights: 'Informazioni chiave',
      listings: 'annunci',
      marketShare: 'Quota di mercato',
      median: 'Mediana',
      noData: 'Nessun dato disponibile',
      totalListings: 'Annunci totali',
    },
    summary: {
      marketVolume: {
        subtitle: 'Annunci attivi (12 mesi)',
        title: 'Volume di mercato',
      },
      medianPrice: {
        subtitle: 'Tutti i tipi di immobili',
        title: 'Prezzo mediano',
      },
      medianPriceM2: {
        subtitle: 'Tutti i tipi di immobili',
        title: 'Prezzo mediano/m²',
      },
    },
  },
  noise: {
    dataSources: {
      federal: "Ufficio federale dell'ambiente",
      geneva: 'Stato di Ginevra - DALE',
      sitg: 'SITG',
    },
    descriptions: {
      day: 'Livello massimo di rumore durante il giorno',
      night: 'Livello massimo di rumore di notte',
    },
    periods: {
      day: 'GIORNO',
      night: 'NOTTE',
    },
    scale: {
      examples: {
        breathing: 'Respirazione, fruscio di foglie',
        conversation: 'Conversazione normale',
        lawnmower: 'Tosaerba, ambulanza',
        sleepInterference: 'Iniziano i disturbi del sonno',
        traffic: 'Aspirapolvere, traffico urbano',
        whispering: 'Sussurro, frigorifero',
      },
      indicators: {
        day: 'Giorno: {{value}} dB',
        night: 'Notte: {{value}} dB',
      },
      levels: {
        harmful: 'Dannoso',
        loud: 'Forte',
        moderate: 'Moderato',
        quiet: 'Tranquillo',
        silent: 'Silenzioso',
        veryLoud: 'Molto forte',
      },
      ranges: {
        '0-20': '0-20 dB',
        '30-40': '30-40 dB',
        '40+': '40+ dB',
        '50-60': '50-60 dB',
        '70-80': '70-80 dB',
        '90-100': '90-100 dB',
      },
      title: 'Riferimento scala decibel',
    },
    sources: {
      railway: 'Ferrovia',
      roadTraffic: 'Traffico stradale',
    },
    states: {
      error: 'Errore durante il caricamento dei dati sul rumore',
      errorDescription: 'Impossibile caricare i dati di analisi del rumore. Riprovare più tardi.',
      loading: 'Caricamento dati rumore...',
      noData: 'Nessun dato sul rumore disponibile',
      noDataDescription: 'I dati di analisi del rumore non sono disponibili per questa posizione.',
    },
    subtitle: 'Livelli di rumore e disturbo stimati a questo indirizzo',
    title: 'Analisi del rumore',
    unit: 'dB',
  },
  property: {
    analysis_types: {
      building_analysis: {
        description: "Analisi completa dell'edificio inclusi unità, dati di mercato, servizi e fattori ambientali.",
        title: 'Analisi edificio',
      },
      land_analysis: {
        description: 'Analisi dettagliata del terreno con regole di zonizzazione, potenziale di sviluppo e insight di mercato.',
        title: 'Analisi terreno',
      },
      property_estimate: {
        description: 'Valutazione immobiliare e stima di mercato con analisi comparativa.',
        title: 'Stima proprietà',
      },
    },
    available_analysis: 'Analisi disponibile',
    available_sections: 'Sezioni disponibili:',
    loading: 'Caricamento dati proprietà...',
    loading_failed: 'Impossibile caricare i dati della proprietà',
    title: 'Panoramica proprietà',
    view_analysis: 'Visualizza analisi',
  },
  restrictions: {
    affected: 'Interessato',
    affectedTypes: 'Tipi interessati',
    categories: {
      affecting: 'Restrizioni che interessano la parcella',
      notAffecting: 'Restrizioni che non interessano la parcella',
    },
    error: 'Impossibile caricare le restrizioni regionali',
    heritage: {
      buildingUnderProtection: 'Edificio sotto protezione patrimoniale',
      heritageProtection: 'Protezione del patrimonio',
      protectedBuilding: 'Edificio protetto',
      protectedObjects: 'Oggetti protetti',
    },
    instances: {
      instanceNumber: 'Istanza {{number}}',
      multiple: '{{count}} istanze',
      single: '1 istanza',
    },
    labels: {
      additionalInformation: 'Informazioni aggiuntive',
      additionalText: 'Testo aggiuntivo',
      affectedArea: 'Area interessata',
      area: 'Area',
      class: 'Classe',
      classification: 'Classificazione',
      content: 'Contenuto',
      heritageDatabase: 'Database del patrimonio',
      integrationDate: 'Data di integrazione',
      registryNumber: 'Numero di registro',
      servitudeClass: 'Tipo di servitù',
      servitudeRegistryNumber: 'N. registro servitù',
      status: 'Stato',
      type: 'Tipo',
      validity: 'Validità',
      viewDocumentation: 'Visualizza documentazione',
      viewInSipatrimoine: 'Visualizza in SIPATRIMOINE',
    },
    legalNotice: {
      disclaimer: "Le informazioni sopra riportate non sono esaustive. Si prega di consultare l'RDPPF e contattare il dipartimento di pianificazione del comune interessato per ulteriori informazioni.",
      rdppfOfficialReport: 'Rapporto ufficiale RDPPF',
      sources: 'Fonti:',
      sourcesList: 'SITG • RDPPF • SIPATRIMOINE • État de Genève - DALE',
    },
    loading: 'Caricamento dati delle restrizioni...',
    messages: {
      coverage: 'Copertura: {{percent}}%',
      notApplicable: 'Questa restrizione non si applica alla parcella attuale.',
    },
    metrics: {
      affectingPlot: 'Che interessa la parcella',
      notAffecting: 'Senza effetto',
      typesAnalyzed: 'Tipi analizzati',
    },
    noData: 'Nessun dato disponibile',
    notAffected: 'Non interessato',
    notAvailable: 'Non disponibile',
    restrictionTypes: {
      archaeologicalZone: 'Zona di protezione archeologica',
      buildingRight: 'Diritto distinto e permanente (DDP)',
      builtSitesProtectedZone: 'Zona di protezione dei siti costruiti',
      dangerZone: 'Zona di pericolo',
      forestLimitZone: 'Limite forestale',
      forestZone: 'Zona forestale',
      heritageInventory: 'Inventario del patrimonio',
      mandatoryPlanningZone: 'Zona di pianificazione obbligatoria',
      natureProtectionZone: 'Zona di protezione della natura',
      noiseSensibilityLevel: 'Livello di sensibilità al rumore',
      noiseSensitivityLevel: 'Grado di sensibilità al rumore',
      noMaxCosZone: 'Zona senza C.o. massimo',
      notYetDefinedSpecialZone: 'Zona speciale non ancora definita',
      otherZone: 'Altra zona',
      pollutedZone: 'Zona inquinata',
      protectedBuilding: 'Edificio protetto',
      protectedObjects: 'Oggetti protetti',
      protectionZone: 'Zona di protezione',
      reservedZone: 'Zona riservata',
      servitude: 'Servitù',
      underwaterProtectedZone: 'Zona di protezione delle acque',
      watercourseLimitZone: "Limite corso d'acqua",
    },
    status: {
      active: 'Attivo',
      clear: 'Libero',
      inactive: 'Inattivo',
      protected: 'Protetto',
      valid: 'Valido',
    },
    subtitle: 'Analisi delle restrizioni legali e di sviluppo per {{address}}',
    title: 'Restrizioni (RDPP)',
  },
  sunlight: {
    common: {
      blueHour: 'Ora blu',
      daylight: 'luce diurna',
      goldenHour: "Ora d'oro",
      hours: 'ore',
      location: 'Posizione',
      ofDaylight: 'di luce diurna',
      solarNoon: 'Mezzogiorno solare',
    },
    dataSources: {
      label: 'Fonti:',
      list: 'MétéoSuisse • Ufficio federale di meteorologia • Algoritmi di calcolo solare',
    },
    header: {
      subtitle: "Dati completi sull'esposizione solare per {{latitude}}°, {{longitude}}°",
      title: 'Studio luce solare',
    },
    legalNotice: {
      text: "Queste sono ore di sole teoriche basate su calcoli astronomici. L'esposizione solare effettiva può variare significativamente a causa della topografia locale, degli edifici circostanti, degli alberi e di altre ostruzioni. Si consiglia di controllare la mappa interattiva per un'analisi dettagliata delle ombre e delle condizioni di luce solare reali durante il giorno e l'anno.",
    },
    overview: {
      annualAverage: {
        longestDay: 'Giorno più lungo',
        shortestDay: 'Giorno più corto',
        subtitle: 'luce media al giorno',
        title: 'Media annuale',
        totalAnnual: 'Totale annuale',
      },
      lightQuality: {
        evening: {
          title: 'Qualità della luce serale',
        },
        morning: {
          title: 'Qualità della luce mattutina',
        },
      },
      solarEnergy: {
        efficiencyPotential: 'potenziale di efficienza',
        optimalAngle: 'Angolo ottimale',
        peakHoursDay: 'Ore di picco/giorno',
        title: 'Energia solare',
        yearlyAverage: 'Media annuale',
      },
      todaySunlight: {
        title: 'Luce solare di oggi',
      },
    },
    seasonal: {
      average: {
        title: 'Media Annuale',
      },
      duration: 'Durata',
      summer: {
        title: "Solstizio d'Estate",
      },
      sunrise: 'Alba',
      sunset: 'Tramonto',
      title: 'Confronto Stagionale della Luce Diurna',
      winter: {
        title: "Solstizio d'Inverno",
      },
    },
    seasons: {
      analysis: {
        daylightDuration: 'Durata della luce',
        energyEfficiency: 'Efficienza energetica',
        high: 'Alto',
        limited: 'Limitato',
        low: 'Basso',
        medium: 'Medio',
        moderate: 'Moderato',
        optimal: 'Ottimale',
        propertyImpact: 'Impatto immobiliare',
        sunriseTime: "Ora dell'alba",
        sunsetTime: 'Ora del tramonto',
        title: 'Analisi {{season}}',
        vsAnnualAverage: 'vs Media annuale',
      },
      autumn: {
        equinox: "Equinozio d'autunno",
        name: 'Autunno',
      },
      spring: {
        equinox: 'Equinozio di primavera',
        name: 'Primavera',
      },
      summer: {
        name: 'Estate',
        solstice: "Solstizio d'estate",
      },
      winter: {
        name: 'Inverno',
        solstice: "Solstizio d'inverno",
      },
    },
    section: {
      subtitle: 'Ore di sole stimate e analisi della luce diurna per questa posizione',
      title: 'Studio della Luce Solare',
    },
    solar: {
      energySavings: {
        annualProduction: {
          label: 'Produzione annuale',
          tooltip: {
            calculation: 'Ore di sole di picco × 5 kWp × 20% efficienza pannelli',
            importance: "Critico per calcolare il ritorno sull'investimento e determinare la dimensione ottimale del sistema per le tue esigenze energetiche",
            limitations: "Solo calcolo teorico. Non considera la disponibilità effettiva dello spazio sul tetto, l'orientamento dei pannelli, l'ombreggiamento da strutture vicine, la copertura nevosa, il degrado dei pannelli nel tempo o le perdite del sistema inverter/batteria.",
            shortDescription: 'Produzione annuale stimata di energia per kWp di capacità solare installata',
            source: "Calcoli dell'irradianza solare basati su dati astronomici",
            title: 'Produzione annuale',
          },
        },
        co2Reduction: {
          label: 'Riduzione CO2',
          tooltip: {
            calculation: 'Produzione annuale × 0,4 kg CO2/kWh ÷ 1000 (basato sui fattori di emissione medi della rete svizzera)',
            importance: "Quantifica il beneficio ambientale dell'installazione solare per gli obiettivi di riduzione dell'impronta di carbonio",
            limitations: "Basato sulle emissioni medie della rete svizzera. I risparmi effettivi di CO2 dipendono dalla tua attuale fonte di energia, dai modelli di consumo basati sull'orario e dai cambiamenti nella composizione della rete nel tempo.",
            shortDescription: "Riduzione annuale stimata delle emissioni di anidride carbonica dall'energia solare",
            source: "Fattori di emissione della rete svizzera - Ufficio federale dell'ambiente UFAM",
            title: 'Riduzione CO2',
          },
          unit: 'tonnellate/anno',
        },
        estimated: 'Stimato',
        propertyValue: {
          label: 'Impatto sul valore immobiliare',
          tooltip: {
            calculation: 'Basato su studi del mercato immobiliare svizzero che mostrano un tipico aumento del valore del 3-5%',
            categories: {
              buyerPreferences: {
                description: 'Coscienza ambientale e priorità di efficienza energetica',
                label: 'Preferenze degli acquirenti',
              },
              locationFactors: {
                description: 'Preferenze del mercato regionale e costi energetici',
                label: 'Fattori di localizzazione',
              },
              marketTrends: {
                description: 'Condizioni attuali del mercato immobiliare ed energetico',
                label: 'Tendenze del mercato',
              },
              systemCondition: {
                description: 'Età, prestazioni e stato di manutenzione',
                label: 'Condizione del sistema',
              },
            },
            importance: 'Potenziale beneficio finanziario aggiuntivo oltre ai risparmi energetici',
            limitations: "Solo medie degli studi di mercato. L'impatto effettivo sul valore immobiliare varia significativamente e non è garantito. Si consiglia una valutazione immobiliare professionale per una valutazione accurata.",
            shortDescription: "Aumento stimato del valore immobiliare dall'installazione solare",
            source: 'Studi del mercato immobiliare svizzero',
            title: 'Impatto sul valore immobiliare',
          },
          value: '+3-5%',
        },
        roiPeriod: {
          label: 'Periodo ROI',
          tooltip: {
            calculation: 'Basato sulle medie del mercato svizzero per sistemi residenziali da CHF 15.000-25.000',
            categories: {
              electricityPrices: {
                description: 'Tariffe energetiche attuali e previste',
                label: "Prezzi dell'elettricità",
              },
              feedInTariffs: {
                description: "Pagamento per l'energia in eccesso venduta alla rete",
                label: 'Tariffe di immissione',
              },
              installationCosts: {
                description: 'Prezzo del sistema, permessi e installazione',
                label: 'Costi di installazione',
              },
              maintenanceCosts: {
                description: 'Pulizia, riparazioni e sostituzione componenti',
                label: 'Costi di manutenzione',
              },
              subsidies: {
                description: 'Incentivi governativi e locali',
                label: 'Sovvenzioni',
              },
            },
            importance: 'Metrica finanziaria critica per le decisioni di investimento',
            limitations: 'Stima generica del mercato. Il ROI effettivo richiede una valutazione finanziaria professionale che consideri la configurazione specifica del sistema, gli incentivi locali e i modelli di consumo energetico individuali.',
            shortDescription: "Tempo stimato per recuperare l'investimento iniziale nel sistema solare",
            source: 'Studi finanziari del mercato solare svizzero',
            title: "Periodo di ritorno sull'investimento",
          },
          value: '7-10 anni',
        },
        selfSufficiency: {
          label: 'Autosufficienza',
          tooltip: {
            calculation: 'Stima residenziale generica basata su modelli di installazione tipici',
            categories: {
              batteryCapacity: {
                description: 'Accumulo di energia per la notte e i giorni nuvolosi',
                label: 'Capacità della batteria',
              },
              consumptionPatterns: {
                description: 'Abitudini di consumo energetico giornaliere e stagionali',
                label: 'Modelli di consumo',
              },
              electricVehicle: {
                description: 'Requisiti energetici aggiuntivi',
                label: 'Ricarica veicolo elettrico',
              },
              heatPumpUsage: {
                description: 'Alta domanda di elettricità in inverno',
                label: 'Utilizzo della pompa di calore',
              },
              seasonalVariations: {
                description: 'Eccesso estivo vs deficit invernale',
                label: 'Variazioni stagionali',
              },
            },
            importance: "Metrica chiave per l'indipendenza energetica e la riduzione della dipendenza dalla rete",
            limitations: "Solo stima generica. L'autosufficienza effettiva varia significativamente in base alle circostanze individuali e richiede un'analisi dettagliata dei consumi.",
            shortDescription: 'Percentuale stimata del fabbisogno energetico coperto dalla produzione solare',
            source: "Medie statistiche dell'industria solare svizzera",
            title: 'Autosufficienza',
          },
          value: '60-80%',
        },
        title: 'Potenziale risparmio energetico',
      },
      monthlyGeneration: {
        perDay: 'h/giorno',
        quarterAverage: 'Media {{quarter}}',
        title: 'Potenziale di generazione solare mensile',
      },
      panelInstallation: {
        efficiencyRating: {
          label: 'Valutazione efficienza',
          tooltip: {
            calculation: '(Ore di picco medie ÷ 6,5h) × 100 - dove 6,5h rappresenta le condizioni equatoriali ottimali',
            importance: "Indica quanto la tua posizione sia adatta all'energia solare rispetto alle condizioni ideali",
            limitations: "Basato puramente su calcoli di latitudine. Non tiene conto della copertura nuvolosa reale, condizioni meteorologiche, qualità dell'aria o condizioni climatiche locali che impattano significativamente l'efficienza effettiva.",
            shortDescription: "Valutazione dell'efficienza solare basata sulla posizione geografica (100% = ottimo equatoriale)",
            source: "Calcoli dell'irradianza solare basati su dati astronomici",
            title: 'Valutazione efficienza',
          },
        },
        highPotential: 'Alto potenziale',
        monthlyAverage: {
          label: 'Media mensile',
          tooltip: {
            calculation: "Basato su calcoli astronomici utilizzando i dati della posizione del sole durante l'anno",
            importance: 'Fornisce informazioni sulle variazioni stagionali della produzione di energia solare per scopi di pianificazione',
            limitations: "Solo calcolo teorico. Non considera i modelli climatici locali, le condizioni meteorologiche effettive o l'ombreggiamento specifico del sito da edifici, alberi o terreno.",
            shortDescription: 'Ore di sole di picco giornaliere medie calcolate su un mese tipico',
            source: "Calcoli dell'irradianza solare basati su dati astronomici",
            title: 'Media mensile',
          },
        },
        optimalPanelAngle: {
          label: 'Angolo ottimale pannelli',
          tooltip: {
            calculation: 'Formula: Latitudine ({{latitude}}°) × 0,9 + 29° per prestazioni annuali',
            importance: "L'angolo corretto dei pannelli massimizza la produzione di energia ottimizzando l'esposizione solare durante l'anno",
            limitations: "Non considera la topografia locale, l'orientamento effettivo del tetto, le limitazioni strutturali o le opzioni di regolazione stagionale. Si consiglia una valutazione professionale del sito per risultati ottimali.",
            shortDescription: "L'angolo di inclinazione teorico ideale per i pannelli solari in base alla posizione",
            source: 'Calcoli astronomici basati sulle coordinate geografiche',
            title: 'Angolo ottimale pannelli',
          },
        },
        peakSunHours: {
          label: 'Ore di picco/giorno',
          tooltip: {
            calculation: 'Ore di sole di picco teoriche a cielo sereno a 1000 W/m² di intensità, calcolate dalla latitudine e dagli angoli solari stagionali',
            importance: 'Le ore di sole di picco sono direttamente correlate al potenziale di produzione di energia solare e aiutano a stimare le prestazioni del sistema',
            limitations: 'Basato solo su condizioni teoriche di cielo sereno. Non tiene conto della copertura nuvolosa, nebbia, inquinamento atmosferico, ombre di edifici o alberi o condizioni meteorologiche locali effettive.',
            shortDescription: "Ore giornaliere di luce solare diretta all'efficienza ottimale dei pannelli solari",
            source: "Calcoli dell'irradianza solare basati su dati astronomici",
            title: 'Ore di sole di picco al giorno',
          },
        },
        title: 'Installazione pannelli solari',
        yearlyTotal: {
          label: 'Totale annuale',
          tooltip: {
            calculation: 'Media mensile × 365 giorni',
            importance: "Aiuta a stimare il potenziale di produzione annuale di energia solare per il dimensionamento del sistema e l'analisi costi-benefici",
            limitations: 'Questo rappresenta il limite superiore teorico in condizioni di cielo perfettamente sereno. I valori reali sono tipicamente del 30-50% inferiori a causa di condizioni meteorologiche, variazioni stagionali e condizioni atmosferiche.',
            shortDescription: "Totale ore di sole di picco previste durante l'intero anno",
            source: "Calcoli dell'irradianza solare basati su dati astronomici",
            title: 'Totale annuale',
          },
        },
      },
    },
    states: {
      error: 'Errore nel caricamento dei dati di luce solare',
      errorDescription: 'Impossibile caricare i dati di analisi della luce solare. Riprova più tardi.',
      loading: 'Caricamento dati di luce solare...',
      noData: 'Nessun dato di luce solare disponibile',
      noDataDescription: 'I dati di analisi della luce solare non sono disponibili per questa posizione.',
    },
    sunPath: {
      dawn: 'Aurora',
      dusk: 'Crepuscolo',
      noon: 'Mezzogiorno',
    },
    tabs: {
      overview: 'Panoramica',
      seasonal: 'Stagionale',
      solar: 'Potenziale solare',
      yearly: 'Analisi annuale',
    },
    today: {
      badge: 'Vicino al picco estivo',
      dayDuration: 'Durata del giorno',
      sunrise: 'Alba',
      sunset: 'Tramonto',
      title: 'Oggi - {{date}}',
    },
    yearly: {
      bestMonths: {
        averagePeak: 'Media di picco',
        excellent: 'Eccellente',
        peakPeriod: 'Maggio - Agosto',
        peakSeason: 'Alta stagione',
        qualityRating: 'Valutazione qualità',
        title: 'Mesi migliori',
      },
      challengingMonths: {
        averageLow: 'Media bassa',
        limited: 'Limitato',
        lowPeriod: 'Nov - Febbraio',
        lowSeason: 'Bassa stagione',
        title: 'Mesi difficili',
      },
      chartTitle: "Ore di luce durante l'anno",
      daylightHours: 'Ore di luce',
      months: {
        apr: 'Apr',
        aug: 'Ago',
        dec: 'Dic',
        feb: 'Feb',
        jan: 'Gen',
        jul: 'Lug',
        jun: 'Giu',
        mar: 'Mar',
        may: 'Mag',
        nov: 'Nov',
        oct: 'Ott',
        sep: 'Set',
      },
      variation: {
        leastSunlight: 'Minima luce solare',
        maxVariation: 'Variazione massima',
        mostSunlight: 'Massima luce solare',
        title: 'Analisi delle variazioni',
      },
    },
  },
  taxes: {
    calculatorLink: {
      description: 'Utilizzare il calcolatore fiscale ufficiale svizzero per stimare le imposte in base a una situazione specifica.',
      title: "Calcolare un'imposta personalizzata",
    },
    charts: {
      noData: 'Nessun dato disponibile',
      taxAmountEvolution: {
        axis: {
          amount: 'Importo tasse (CHF)',
        },
        subtitle: 'Importi fiscali storici in CHF per profilo',
        summary: {
          title: 'Variazioni ({{startYear}}-{{endYear}})',
        },
        title: "Evoluzione dell'importo annuale delle tasse",
      },
      taxBurdenEvolution: {
        axis: {
          burden: 'Carico fiscale (%)',
        },
        subtitle: 'Percentuale storica del carico fiscale per profilo',
        summary: {
          avgChange: 'Variazione media',
          decreasing: 'In diminuzione - le tasse stanno scendendo',
          increasing: 'In aumento - le tasse stanno salendo',
          stable: 'Stabile - le tasse rimangono relativamente costanti',
          title: 'Analisi di tendenza ({{startYear}}-{{endYear}})',
          trend: 'Tendenza',
        },
        title: 'Evoluzione del carico fiscale',
      },
      taxRateEvolution: {
        subtitle: 'Coefficienti cantonali e comunali nel tempo',
        summary: {
          title: 'Variazioni delle aliquote ({{startYear}}-{{endYear}})',
        },
        title: 'Evoluzione delle aliquote fiscali',
      },
    },
    common: {
      downloadChart: 'Scarica grafico',
    },
    comparison: {
      aboveCantonAvg: 'sopra la media cantonale',
      aboveNationalAvg: 'sopra la media nazionale',
      belowCantonAvg: 'sotto la media cantonale',
      belowNationalAvg: 'sotto la media nazionale',
      canton: 'Cantone',
      profileFamily: 'Carico fiscale (Famiglia - reddito {{income}})',
      profileMarried: 'Carico fiscale (Sposato - reddito {{income}})',
      profileSingle: 'Carico fiscale (Single - reddito {{income}})',
      switzerland: 'Svizzera',
      thisLocation: 'Questa posizione',
      title: 'Confronto geografico',
    },
    efficiency: {
      high: 'Alta',
      low: 'Bassa',
      medium: 'Media',
    },
    filters: {
      location: 'Posizione',
      year: 'Anno',
    },
    insights: {
      highEfficiency: 'Questa posizione offre tasse inferiori rispetto alle medie cantonali e nazionali, rendendola una scelta attraente per gli acquirenti attenti alle tasse.',
      lowEfficiency: 'Il carico fiscale in questa posizione è superiore alle medie cantonali e nazionali. Considera questo fattore nella valutazione del costo totale di proprietà.',
      mediumEfficiency: 'I livelli fiscali in questa posizione mostrano risultati misti nel confronto tra medie cantonali e nazionali. Le tasse sono favorevoli a un livello ma non a entrambi.',
      title: "Valutazione dell'efficienza fiscale",
    },
    metrics: {
      annualTax: {
        subtitle: 'Tasse totali medie',
        title: 'Imposta annuale',
      },
      taxBurden: {
        subtitle: 'Media di tutti i profili',
        title: 'Carico fiscale',
      },
      taxFreedomDay: {
        subtitle: 'Data media',
        title: 'Giorno di liberazione fiscale',
      },
    },
    profileDetails: {
      annualTax: 'Imposta annuale',
      profile: 'Profilo',
      taxBurden: 'Carico fiscale',
      taxFreedomDay: 'Giorno di liberazione',
      title: 'Dettagli profilo',
    },
    profiles: {
      all: 'Tutti i profili',
      family: 'Famiglia',
      married: 'Sposato',
      single: 'Single',
    },
    states: {
      error: 'Errore nel caricamento dei dati fiscali: {{error}}',
      fetchError: 'Impossibile caricare i dati fiscali',
      loading: 'Caricamento dati fiscali...',
      noData: 'I dati fiscali non sono disponibili per questa posizione.',
      noHistoricalData: 'Nessun dato fiscale storico disponibile',
    },
    subtitle: 'Analisi del carico fiscale per questa posizione',
    tabs: {
      overview: 'Panoramica',
      trends: 'Tendenze storiche',
    },
    taxRates: {
      canton: 'Cantone',
      cantonRate: 'Aliquota cantonale',
      churchChrist: 'Cattolica cristiana',
      churchNote: 'Imposte ecclesiastiche (opzionale)',
      churchProtestant: 'Protestante',
      churchRoman: 'Cattolica romana',
      city: 'Comune',
      cityRank: 'Classifica comunale',
      cityRate: 'Aliquota comunale',
      cityRateComparison: 'Aliquota comunale tra {{total}} comuni in {{canton}}',
      inCanton: 'in {{canton}}',
      ofCities: 'su {{total}} comuni',
      rateAxis: 'Aliquota (%)',
      subtitle: "Moltiplicatori applicati sull'imposta cantonale di base",
      title: "Coefficienti d'imposta",
    },
    title: 'Fiscalità',
    tooltips: {
      annualTax: {
        calculation: "Somma dell'imposta federale diretta + imposta cantonale sul reddito + imposta comunale sul reddito. Profili: Single = CHF 84'000 (salario mediano svizzero), Coniugato = coppia senza figli a CHF 168'000, Famiglia = coppia sposata con 2 figli a CHF 168'000.",
        importance: "L'importo assoluto in CHF aiuta i clienti a comprendere le reali differenze di costo tra le posizioni. Una differenza annuale di CHF 5'000 rappresenta risparmi significativi sulla durata della proprietà.",
        limitations: "Non include l'imposta sul patrimonio, le tasse sulla proprietà o altre tasse indirette. Basato su profili standardizzati (Single: CHF 84'000, Coniugato/Famiglia: CHF 168'000) senza deduzioni individuali.",
        shortDescription: "Tasse totali pagate all'anno, incluse tasse federali, cantonali e comunali",
        source: 'Amministrazione federale delle contribuzioni (AFC) - Statistiche annuali sul carico fiscale',
        title: 'Imposta annuale',
      },
      taxBurden: {
        calculation: "Imposta annuale totale / Reddito lordo annuale × 100. Profili: Single = CHF 84'000 (salario mediano svizzero), Coniugato = coppia senza figli a CHF 168'000, Famiglia = coppia sposata con 2 figli a CHF 168'000.",
        calculation_family: "Imposta annuale totale / Reddito lordo annuale × 100. Basato su una coppia sposata con 2 figli con un reddito lordo combinato di CHF 168'000.",
        calculation_married: "Imposta annuale totale / Reddito lordo annuale × 100. Basato su una coppia sposata senza figli con un reddito lordo combinato di CHF 168'000.",
        calculation_single: "Imposta annuale totale / Reddito lordo annuale × 100. Basato su una persona single con un reddito lordo di CHF 84'000 (salario mediano svizzero).",
        importance: "Impatto diretto sul potere d'acquisto e sul reddito disponibile. Un carico fiscale inferiore significa più denaro disponibile per pagamenti ipotecari e spese di vita. Fattore chiave per le decisioni di investimento immobiliare.",
        limitations: "Basato su profili di reddito standardizzati (Single: CHF 84'000, Coniugato/Famiglia: CHF 168'000). Il carico fiscale effettivo può variare in base alle circostanze individuali, alle deduzioni e al patrimonio.",
        limitations_family: "Basato su un reddito combinato standardizzato di CHF 168'000 per una coppia con 2 figli. Il carico fiscale effettivo può variare in base alle circostanze individuali, alle deduzioni e al patrimonio.",
        limitations_married: "Basato su un reddito combinato standardizzato di CHF 168'000 per una coppia senza figli. Il carico fiscale effettivo può variare in base alle circostanze individuali, alle deduzioni e al patrimonio.",
        limitations_single: "Basato su un reddito standardizzato di CHF 84'000. Il carico fiscale effettivo può variare in base alle circostanze individuali, alle deduzioni e al patrimonio.",
        shortDescription: 'Percentuale del reddito lordo pagata in tasse (federale, cantonale, comunale)',
        source: 'Amministrazione federale delle contribuzioni (AFC) - Statistiche annuali sul carico fiscale',
        title: 'Carico fiscale',
      },
      taxFreedomDay: {
        calculation: 'Carico fiscale × 365 giorni. Se il carico fiscale è del 18,9%, il Giorno di liberazione fiscale = Giorno 69 (10 marzo). Data precedente = tasse più basse.',
        importance: "Modo intuitivo per comunicare il carico fiscale ai clienti. 'Lavori fino al 10 marzo per pagare le tasse' è più tangibile di 'carico fiscale del 18,9%'. Metrica ampiamente utilizzata in Svizzera.",
        limitations: "Rappresentazione simbolica. I pagamenti fiscali effettivi sono distribuiti durante l'anno. Non tiene conto dei contributi sociali obbligatori.",
        shortDescription: "Il giorno dell'anno in cui smetti di lavorare per pagare le tasse e inizi a guadagnare per te stesso",
        source: 'Amministrazione federale delle contribuzioni (AFC) - Pubblicazione del Giorno di liberazione fiscale',
        title: 'Giorno di liberazione fiscale',
      },
    },
  },
  transactions: {
    actions: {
      removeFromSaved: 'Rimuovi dai salvati',
      saveTransaction: 'Salva transazione',
    },
    aiFilter: {
      description: 'Descrivi le transazioni che stai cercando, e ti aiuterò a trovarle.',
      examplePrompts: {
        '0': 'Transazioni di acquisto degli ultimi 12 mesi sopra 5 milioni CHF',
        '1': 'Transazioni con un solo acquirente',
      },
      placeholder: 'Mostrami le transazioni di acquisto degli ultimi mesi',
      title: 'Assistente filtro transazioni',
    },
    columns: {
      address: 'Indirizzo',
      area: 'Superficie',
      buyers: 'Acquirenti',
      buyersCount: 'N. acquirenti',
      date: 'Data',
      ownershipType: 'Tipo di proprietà',
      parcel: 'Parcella {{number}}',
      previousTransaction: 'Transazione precedente',
      price: 'Prezzo',
      pricePerM2: 'Prezzo/m²',
      reason: 'Motivo',
      sellers: 'Venditori',
      sellersCount: 'N. venditori',
      transactionId: 'ID transazione',
    },
    dataSources: {
      label: 'Fonti:',
      list: 'Registro fondiario • Stato di Ginevra • Estratto del registro delle mutazioni',
    },
    detail: {
      backToList: 'Torna alla lista',
      description: 'Descrizione',
      details: 'Dettagli',
      landInfo: 'Informazioni sul terreno',
      multipleLotsWarning: 'Questa transazione coinvolge diversi lotti di terreno',
      parcel: 'Parcella',
      propertiesInvolved: 'Proprietà coinvolte',
      transaction: 'Transazione',
      transactionInfo: 'Informazioni sulla transazione',
    },
    detailPanel: {
      initializingMap: 'Inizializzazione mappa...',
      labels: {
        buyers: 'Acquirenti',
        capacity: 'Capacità',
        floors: 'Piani',
        land: 'Terreno',
        landArea: 'Superficie terreno',
        language: 'Lingua',
        location: 'Posizione',
        officialId: 'ID ufficiale',
        participants: 'Partecipanti',
        previous: 'Precedente',
        properties: 'Proprietà',
        property: 'Proprietà {{index}}',
        publicationDate: 'Data di pubblicazione',
        region: 'Regione',
        sellers: 'Venditori',
        share: 'Quota',
        stepPrice: 'Prezzo fase',
        surface: 'Superficie',
        totalPrice: 'Prezzo totale',
        totalSurface: 'Superficie totale',
        transactionDate: 'Data transazione',
        transactionId: 'ID transazione',
        units: 'Unità',
        unitsCount: 'Unità ({{count}})',
      },
      legalTypes: {
        BF: 'B-F - Fondo fondiario',
        COP: 'COP - Comproprietà',
        DDP: 'DDP - Diritto permanente',
        DP: 'DP - Pubblico dominio',
        PPE: 'PPE - Proprietà per piani',
      },
      loading: 'Caricamento dettagli transazione...',
      loadingMap: 'Caricamento mappa...',
      locationsNotAvailable: 'Posizioni esatte delle proprietà non disponibili',
      mapPopup: {
        land: 'Terreno: {{area}} m²',
        propertiesAtLocation: '{{count}} proprietà in questa posizione',
        propertyNumber: 'Proprietà {{index}}',
        surface: 'Superficie: {{area}} m²',
      },
      mapTokenNotConfigured: 'Token mappa non configurato',
      notFound: 'Transazione non trovata',
      participantTypes: {
        company: 'Azienda',
        estate: 'Successione',
        individual: 'Privato',
        nonProfit: 'No-profit',
        other: 'Altro',
        publicBody: 'Ente pubblico',
        unknown: 'Sconosciuto',
      },
      removeFromSaved: 'Rimuovi dai salvati',
      saveTransaction: 'Salva transazione',
      sections: {
        participants: 'Partecipanti',
        properties: 'Proprietà',
        propertiesCount: 'Proprietà ({{count}})',
        rawTransactionData: 'Dati grezzi transazione',
        transactionDescription: 'Descrizione transazione',
        transactionDetails: 'Dettagli transazione',
      },
      title: 'Dettagli',
      transactionNumber: 'Transazione n. {{id}}',
      type: 'Transazione',
      unitTypes: {
        appartement: 'Appartamento',
        balcon: 'Balcone',
        box: 'Box deposito',
        cave: 'Cantina',
        garage: 'Garage',
        loggia: 'Loggia',
        privateGarage: 'Garage privato',
        singleFamily: 'Casa unifamiliare',
      },
    },
    empty: {
      message: 'Prova ad aggiustare i tuoi filtri per vedere più risultati',
      title: 'Nessuna transazione trovata',
    },
    errors: {
      loadFailed: 'Caricamento transazioni fallito',
      tryAgain: 'Riprova più tardi',
    },
    fields: {
      assignmentArea: 'Area di assegnazione',
      buildingClassification: 'Tipo di edificio',
      buyers: 'Acquirenti',
      landInfo: 'Informazione terreno',
      livingArea: 'Superficie abitabile',
      numberOfBuyers: 'Numero di acquirenti',
      numberOfSellers: 'Numero di venditori',
      numberOfUnits: 'Numero di unità',
      parcelNumber: 'Numero parcella',
      parties: 'Parti',
      previousTransaction: 'Transazione precedente',
      price: 'Prezzo',
      pricePerM2: 'Prezzo per m²',
      propertyType: 'Tipo di proprietà',
      publishedOn: 'Pubblicato il',
      reason: 'Motivo',
      sellers: 'Venditori',
      transactionDate: 'Data transazione',
      transactionOn: 'Transazione il',
    },
    filter: {
      additionalFilters: 'Filtri aggiuntivi',
      advancedFilters: 'Filtri avanzati',
      allLocations: 'Tutte le posizioni',
      clearAll: 'Cancella tutto',
      hideFilters: 'Nascondi filtri',
      landArea: 'Superficie del terreno (m²)',
      legalTypeBF: 'B-F',
      legalTypeCOP: 'COP',
      legalTypeDDP: 'DDP',
      legalTypeDP: 'DP',
      legalTypeOther: 'Altro',
      legalTypePPE: 'PPE',
      numberOfBuyers: 'Numero di acquirenti',
      numberOfSellers: 'Numero di venditori',
      others: 'Altri',
      participantAssociation: 'Associazione',
      participantCompany: 'Azienda',
      participantCooperative: 'Cooperativa',
      participantFoundation: 'Fondazione',
      participantIndividual: 'Privato',
      participantOther: 'Altro',
      participantPublicEntity: 'Ente pubblico',
      participants: 'Partecipanti',
      participantType: 'Tipo di partecipante',
      propertyLegalType: 'Tipo legale di proprietà',
      radius: 'Raggio',
      showFilters: 'Mostra filtri',
      stepTransactionPrice: 'Prezzo di transazione (CHF)',
      transactionDate: 'Data di transazione',
      transactionType: 'Tipo di transazione',
      typeAreaPrice: 'Tipo, Superficie & Prezzo',
      unitApartment: 'Appartamento',
      unitCommercial: 'Commerciale',
      unitHouse: 'Casa',
      unitLand: 'Terreno',
      unitOther: 'Altro',
      unitParking: 'Parcheggio',
      unitType: 'Tipo di unità',
    },
    filterPanel: {
      appliedFilter: 'Filtro applicato: {{name}}',
      clearAllFilters: 'Cancella tutti i filtri',
      closeFilters: 'Chiudi filtri',
      failedToSave: 'Impossibile salvare il filtro',
      loadSavedFilters: 'Carica filtri salvati',
      saveCurrentFilters: 'Salva filtri attuali',
      savedFilter: 'Filtro salvato: {{name}}',
      savedOn: 'Salvato il {{date}}',
      title: 'Filtri transazioni',
    },
    filters: {
      any: 'Tutti',
      apply: 'Applica',
      area: 'Superficie abitabile',
      areaQuickOptions: {
        '100to150': '100-150m²',
        '50to100': '50-100m²',
        over150: 'Oltre 150m²',
        under50: 'Sotto 50m²',
      },
      areaRange: 'Superficie abitabile (m²)',
      clear: 'Cancella',
      clearAll: 'Cancella tutti i filtri',
      labels: {
        buyers: 'Acquirenti',
        city: 'Città',
        district: 'Distretto',
        floors: 'Piani',
        landArea: 'Superficie terreno',
        legalType: 'Tipo giuridico',
        mapSearchLocation: 'Ricerca posizione mappa',
        municipality: 'Comune',
        npa: 'NPA (Codice postale)',
        numberOfBuyers: 'Numero di acquirenti',
        numberOfFloors: 'Numero di piani',
        numberOfProperties: 'Numero di proprietà',
        numberOfRooms: 'Numero di stanze',
        numberOfSellers: 'Numero di venditori',
        participantLegalForm: 'Forma giuridica partecipante',
        participantName: 'Nome partecipante',
        participantType: 'Tipo di partecipante',
        propertyPrice: 'Prezzo immobile',
        publicationDate: 'Data di pubblicazione',
        reason: 'Motivo',
        region: 'Regione',
        rooms: 'Stanze',
        sellers: 'Venditori',
        stepPrice: 'Prezzo fase',
        stepTransactionPrice: 'Prezzo fase transazione',
        surfaceArea: 'Superficie',
        totalPrice: 'Prezzo totale',
        totalSurfaceArea: 'Superficie totale',
        totalTransactionPrice: 'Prezzo totale transazione',
        transactionDate: 'Data transazione',
        unitArea: 'Superficie unità',
        unitType: 'Tipo di unità',
      },
      legalTypes: {
        BF: 'B-F - Fondo fondiario',
        COP: 'COP - Comproprietà',
        DDP: 'DDP - Diritto permanente',
        DP: 'DP - Pubblico dominio',
        PPE: 'PPE - Proprietà per piani',
      },
      lessFilters: 'Meno filtri',
      location: 'Posizione',
      locationOptions: {
        geneva1205: '1205 Ginevra',
        genevaCanton: 'Cantone di Ginevra',
        genevaCity: 'Città di Ginevra',
        within100m: 'Entro 100m',
        within1km: 'Entro 1km',
        within2km: 'Entro 2km',
        within300m: 'Entro 300m',
        within500m: 'Entro 500m',
      },
      locationSections: {
        location: 'Posizione',
        radius: 'Raggio dalla proprietà',
      },
      max: 'MAX',
      min: 'MIN',
      moreFilters: 'Altri filtri',
      participantTypes: {
        company: 'Azienda',
        estate: 'Successione',
        individual: 'Individuo',
        nonProfit: 'No-profit',
        other: 'Altro',
        others: 'Altri',
        publicBody: 'Ente pubblico',
      },
      placeholders: {
        enterCity: 'Inserire nome città...',
        enterDistrict: 'Inserire nome distretto...',
        enterLegalForm: 'Inserire forma giuridica...',
        enterMunicipality: 'Inserire nome comune...',
        enterNpa: 'Inserire NPA...',
        enterRegion: 'Inserire nome regione...',
        from: 'Da',
        max: 'Max',
        min: 'Min',
        searchParticipants: 'Cerca nomi partecipanti...',
        to: 'A',
      },
      price: 'Prezzo (CHF)',
      priceQuickOptions: {
        '1MTo2M': '1M - 2M',
        '500kTo1M': '500k - 1M',
        over2M: 'Oltre 2M',
        under500k: 'Sotto 500k',
      },
      priceRange: 'Fascia di prezzo (CHF)',
      propertyType: 'Tipo di proprietà',
      propertyTypeOptions: {
        bienFonds: 'Parcelle di terreno',
        ppe: 'Proprietà condominiale',
      },
      reason: 'Tipo di transazione',
      reasonOptions: {
        achat: 'Transazioni di acquisto',
        donation: 'Trasferimenti di donazione',
        heritage: 'Trasferimenti ereditari',
        vente: 'Transazioni di vendita',
      },
      sections: {
        locationDate: 'Posizione e data',
        participants: 'Partecipanti',
        price: 'Prezzo',
        properties: 'Proprietà',
        propertyLocation: 'Posizione immobile',
        transactionDetails: 'Dettagli transazione',
        units: 'Unità',
      },
      unitTypes: {
        apartment: 'Appartamento',
        balcony: 'Balcone',
        cellar: 'Cantina',
        garage: 'Garage',
        loggia: 'Loggia',
        privateGarage: 'Garage privato',
        singleFamily: 'Casa unifamiliare',
        storageBox: 'Box deposito',
      },
      year: 'Anno',
      yearOptions: {
        all: 'Tutto il tempo',
        last10Years: 'Ultimi 10 anni',
        last2Years: 'Ultimi 2 anni',
        last5Years: 'Ultimi 5 anni',
        lastYear: 'Ultimo anno',
      },
    },
    placeholders: {
      searchBuyers: 'Cerca acquirenti...',
      searchSellers: 'Cerca venditori...',
    },
    print: {
      cover: {
        generatedOn: 'Generato il {{date}}',
        subtitle: 'Analisi di mercato completa',
        title: 'Report statistiche transazioni',
      },
      dataSource: {
        description: "Le statistiche sulle transazioni presentate in questo report sono derivate da registri completi delle transazioni immobiliari raccolti da fonti ufficiali. I dati includono tutte le transazioni immobiliari registrate nell'area geografica e nel periodo selezionati.",
        lastUpdated: 'Ultimo aggiornamento: {{date}} | Fonti dati: Registri pubblici, Database governativi',
        title: 'Informazioni sui dati',
      },
      disclaimer: {
        dataAccuracy: {
          description: "Sebbene siano stati compiuti tutti gli sforzi per garantire l'accuratezza delle informazioni presentate in questo report, Popety.io non può garantire la completezza o l'accuratezza di tutti i dati. Le statistiche e le analisi si basano sui dati disponibili al momento della generazione e potrebbero essere soggette a revisione.",
          title: 'Accuratezza dei dati',
        },
        dataSources: {
          description: 'Questo report si basa su dati di transazione raccolti da varie fonti pubbliche e private, tra cui:',
          items: {
            databases: 'Database del mercato immobiliare',
            records: 'Registri pubblici delle transazioni',
            registries: 'Registri immobiliari ufficiali',
            statistical: 'Uffici statistici governativi',
          },
          title: 'Fonti dati',
        },
        footer: '© {{year}} Popety.io - Tutti i diritti riservati | www.popety.io',
        intellectualProperty: {
          description: 'Tutto il contenuto di questo report, inclusi ma non limitati a testo, grafica, grafici e visualizzazioni di dati, è proprietà di Popety.io ed è protetto dalle leggi sul copyright. La riproduzione o distribuzione senza autorizzazione scritta è vietata.',
          title: 'Proprietà intellettuale',
        },
        title: 'Avviso legale e fonti dati',
        usageLimitations: {
          description: 'Questo report è fornito solo a scopo informativo e non deve essere considerato come:',
          items: {
            complete: 'Una rappresentazione completa di tutte le transazioni di mercato',
            guarantee: 'Una garanzia di performance futura del mercato',
            investment: 'Consigli o raccomandazioni di investimento',
            legal: 'Consulenza legale o finanziaria',
          },
          title: "Limitazioni d'uso",
        },
      },
    },
    propertyTypeBadges: {
      bienFonds: 'Fondo fondiario',
      commune: 'Comunità ereditaria',
      individuelle: 'Individuale',
      ppe: 'Proprietà per piani',
    },
    propertyTypes: {
      all: 'Tutte le proprietà',
      bienFonds: 'Fondo fondiario',
      commune: 'Comunità ereditaria',
      individuelle: 'Individuale',
      ppe: 'PPE',
    },
    quickFilters: {
      buyers: 'Acquirenti',
      city: 'Città',
      district: 'Distretto',
      floors: 'Piani',
      landArea: 'Superficie terreno',
      legalForm: 'Forma giuridica',
      legalType: 'Tipo giuridico',
      municipality: 'Comune',
      npa: 'NPA',
      participant: 'Partecipante',
      participantType: 'Tipo partecipante',
      properties: 'Proprietà',
      propertyPrice: 'Prezzo immobile',
      publicationDate: 'Data di pubblicazione',
      reason: 'Motivo',
      region: 'Regione',
      rooms: 'Stanze',
      sellers: 'Venditori',
      stepPrice: 'Prezzo fase',
      surfaceArea: 'Superficie',
      totalPrice: 'Prezzo totale',
      transactionDate: 'Data transazione',
      unitArea: 'Superficie unità',
      unitType: 'Tipo di unità',
    },
    resultsCount: '{{count}} transazioni trovate {{location}} {{timeframe}}',
    sections: {
      parties: 'Parti',
      propertyDetails: 'Dettagli proprietà',
      transactionInfo: 'Informazioni transazione',
    },
    sorting: {
      distance: 'Distanza',
      priceHigh: 'Prezzo: da alto a basso',
      priceLow: 'Prezzo: da basso ad alto',
      recent: 'Più recente',
      sortBy: 'Ordina per:',
    },
    stats: {
      charts: {
        geographicDistribution: {
          activeCantons: 'Cantoni attivi',
          avg: 'Media',
          avgTransactionPrice: 'Prezzo medio transazioni',
          noData: 'Nessun dato disponibile',
          topCitiesByVolume: 'Principali città per volume di transazioni',
          totalMarketVolume: 'Volume totale del mercato',
          totalTransactions: 'Transazioni totali',
          transactions: 'transazioni',
          transactionsByCanton: 'Transazioni per cantone',
        },
        inheritanceAnalysis: {
          donation: 'Donazione',
          flowAnalysis: 'Analisi dei flussi ereditari',
          flowAnalysisSubtext: 'Trasferimento di patrimonio dai venditori agli acquirenti per tipo di proprietà',
          heritage: 'Eredità',
          inheritanceOverTime: 'Transazioni ereditarie nel tempo',
          inheritanceOverTimeSubtext: 'Tendenze trimestrali per tipo di transazione',
          noData: 'Nessun dato ereditario disponibile',
          partage: 'Divisione',
          shareDistribution: 'Analisi della distribuzione delle quote',
          shareDistributionSubtext: 'Modelli di quote di proprietà nei trasferimenti',
          transactionCount: 'Numero di transazioni',
          transactions: 'transazioni',
        },
        marketTiming: {
          activityCalendar: 'Calendario attività di mercato',
          activityCalendarSubtext: 'Volume delle transazioni per giorno',
          avgLagDays: 'Ritardo medio (giorni)',
          monthlyActivity: 'Attività mensile delle transazioni',
          monthlyActivitySubtext: 'Volume delle transazioni nel tempo',
          noActivity: 'Nessuna attività',
          noData: 'Nessun dato sul timing del mercato',
          numberOfTransactions: 'Numero di transazioni',
          publicationLag: 'Analisi del ritardo di pubblicazione',
          publicationLagSubtext: 'Giorni medi tra transazione e pubblicazione',
          totalTransactions: 'Transazioni totali',
          transactions: 'Transazioni',
        },
        participantDemographics: {
          buyersByGender: 'Acquirenti per genere',
          companies: 'Aziende',
          companyParticipants: 'Aziende partecipanti',
          female: 'Femmina',
          genderDistributionOverTime: 'Distribuzione per genere degli acquirenti nel tempo',
          genderParity: 'Parità di genere 50%',
          individualParticipants: 'Partecipanti individuali',
          individuals: 'Privati',
          male: 'Maschio',
          noData: 'Nessun dato disponibile',
          participantTypesByLegalForm: 'Tipi di partecipanti per forma giuridica',
          personVsCompany: 'Privati vs Aziende',
          sellersByGender: 'Venditori per genere',
          totalBuyers: 'Totale acquirenti',
          totalSellers: 'Totale venditori',
        },
        priceDynamics: {
          avgTransactionPrice: 'Prezzo medio delle transazioni',
          mom: 'M/M',
          noData: 'Nessun dato disponibile',
          priceByPropertyType: 'Prezzo per tipo di proprietà',
          priceDistribution: 'Distribuzione dei prezzi',
          priceVelocityIndex: 'Indice di velocità dei prezzi',
          totalMarketVolume: 'Volume totale del mercato',
          yearlyMarketVolume: 'Volume annuale del mercato',
          yoy: 'A/A',
        },
        propertyCharacteristics: {
          avgPrice: 'Prezzo medio',
          avgSurfaceArea: 'Superficie media (m²)',
          avgSurfaceAreaM2: 'Superficie media (m²)',
          complexityIndex: 'Indice di complessità degli edifici',
          complexityIndexSubtext: 'Prezzo e superficie per numero di piani',
          noData: 'Nessun dato sulle caratteristiche delle proprietà',
          numberOfFloors: 'Numero di piani',
          performanceMatrix: 'Matrice delle performance per tipo di proprietà',
          performanceMatrixSubtext: 'Superficie media vs Prezzo medio',
          transactions: 'Transazioni',
        },
        seasonalPatterns: {
          averageTransactionCount: 'Numero medio di transazioni',
          month: 'Mese',
          monthlyActivity: 'Attività mensile delle transazioni',
          monthlyActivitySubtext: 'Tendenze di volume e valore per mese',
          noData: 'Nessun dato sui modelli stagionali',
          quarterlyComparison: 'Confronto trimestrale',
          quarterlyComparisonSubtext: 'Volume delle transazioni per trimestre',
          seasonalPatterns: 'Modelli stagionali',
          seasonalPatternsSubtext: 'Attività media per mese in tutti gli anni',
          totalValue: 'Valore totale',
          transactionCount: 'Numero di transazioni',
          transactions: 'Transazioni',
        },
        transactionTypes: {
          averageValue: 'Valore medio',
          distributionTitle: 'Distribuzione per tipo di transazione',
          dominantType: 'Tipo dominante',
          totalTransactions: 'Transazioni totali',
          totalVolume: 'Volume totale',
          trendsTitle: 'Evoluzione temporale',
        },
        unitComposition: {
          averageArea: 'Superficie media',
          noData: 'Nessun dato sulla composizione delle unità',
          numberOfRooms: 'Numero di stanze',
          numberOfUnits: 'Numero di unità',
          room: 'Stanza',
          roomDistribution: 'Distribuzione delle stanze',
          roomDistributionSubtext: 'Numero di unità per numero di stanze',
          rooms: 'Stanze',
          units: 'unità',
          unitTypeComposition: 'Composizione per tipo di unità',
          unitTypeCompositionSubtext: 'La dimensione rappresenta il numero di unità, il colore la superficie media',
        },
      },
      description: 'Statistiche e analisi delle transazioni saranno presto disponibili qui.',
      errors: {
        loadFailed: 'Caricamento statistiche fallito',
        loginRequired: 'Effettua il login per visualizzare le statistiche delle transazioni',
        noData: 'Nessun dato disponibile per i criteri selezionati',
        noTransactionData: 'Nessun dato di transazione disponibile',
        retryError: 'Caricamento statistiche fallito. Riprova.',
      },
      indicators: {
        allProperties: 'Tutti gli immobili',
        allSwitzerland: 'Tutta la Svizzera',
        location: 'Posizione',
        type: 'Tipo',
      },
      periods: {
        all: 'Storico completo',
        last12Months: 'Ultimi 12 mesi',
        since2022: 'Da gennaio 2022',
      },
      sections: {
        geographicDistribution: {
          description: 'Esplora i modelli di transazione in diverse regioni e comuni.',
          title: 'Distribuzione geografica',
        },
        inheritanceAnalysis: {
          description: "Analizza i modelli di eredità, donazione e trasferimento patrimoniale, inclusa l'analisi dei flussi e le quote di proprietà.",
          title: 'Eredità e trasferimento patrimoniale',
        },
        marketTiming: {
          description: 'Analizza il ritardo di pubblicazione, i modelli di attività del mercato e la velocità delle transazioni nel tempo.',
          title: 'Tempistica e velocità del mercato',
        },
        participantDemographics: {
          description: 'Comprendi i profili di acquirenti e venditori, i dati demografici e i modelli di transazione.',
          title: 'Dati demografici dei partecipanti',
        },
        priceDynamics: {
          description: 'Monitora le metriche chiave dei prezzi, inclusi i prezzi medi delle transazioni, il prezzo al metro quadro e le tendenze del volume di mercato.',
          title: 'Dinamica dei prezzi',
        },
        propertyCharacteristics: {
          description: 'Analizza i tipi di proprietà, la complessità degli edifici, la distribuzione delle unità e le caratteristiche fisiche.',
          title: 'Caratteristiche degli immobili',
        },
        seasonalPatterns: {
          description: 'Esplora le tendenze stagionali, i modelli di attività mensile e i confronti trimestrali nel tempo.',
          title: 'Modelli stagionali e temporali',
        },
        transactionTypes: {
          description: 'Analizza la distribuzione dei diversi tipi di transazione per comprendere le dinamiche e i modelli di mercato.',
          title: 'Tipi di transazione',
        },
        unitComposition: {
          description: "Esplora i tipi di unità, la distribuzione delle stanze e l'analisi per piano delle proprietà residenziali.",
          title: 'Composizione delle unità',
        },
      },
    },
    subtitle: 'Transazioni immobiliari storiche trovate nel quartiere',
    title: 'Transazioni',
    tooltip: {
      additionalProperties: '(+{{count}} proprietà)',
      area: 'Superficie',
      buyersSellers: '{{buyers}} acquirenti / {{sellers}} venditori',
      date: 'Data',
      parcel: 'Particella {{code}} {{city}}',
      parties: 'Parti',
      price: 'Prezzo',
      pricePerM2: 'Prezzo/m²',
      properties: '{{count}} proprietà',
      property: '1 proprietà',
      transactionNumber: 'Transazione n. {{id}}',
      type: 'Tipo',
      unknownLocation: 'Posizione sconosciuta',
    },
    transactionTypes: {
      achat: 'Acquisto',
      all: 'Tutti i tipi',
      donation: 'Donazione',
      exchange: 'Scambio',
      heritage: 'Successione',
      vente: 'Vendita',
    },
  },
  transport: {
    emptyStates: {
      noBuilding: "Nessun dato dell'edificio disponibile",
      noEstimate: "Nessun dato dell'edificio disponibile per l'analisi trasporti e accessibilità",
      noLand: 'Nessun dato del terreno disponibile',
    },
    evCharging: {
      charger: {
        plural: 'caricatori',
        singular: 'caricatore',
      },
      chargingTypes: {
        fast: 'Ricarica rapida',
        medium: 'Ricarica media',
        standard: 'Ricarica standard',
      },
      metrics: {
        fastCharging: {
          title: 'Ricarica rapida',
        },
        freeAccess: {
          title: 'Accesso libero',
        },
        nearestStation: {
          title: 'Stazione più vicina',
        },
        totalStations5km: {
          title: 'Stazioni totali (5km)',
        },
      },
      more: '+{{count}} altri',
      nearbyStations: 'Stazioni di ricarica vicine',
      overview: 'Panoramica ricarica VE',
      plugTypes: {
        ccsCombo2: 'Spina CCS Combo 2 (Cavo integrato)',
        chademo: 'CHAdeMO',
        schuko: 'Schuko',
        type1Connector: 'Connettore Tipo 1 (Cavo integrato)',
        type1Outlet: 'Presa Tipo 1',
        type2Connector: 'Connettore Tipo 2 (Cavo integrato)',
        type2Outlet: 'Presa Tipo 2',
        unknown: 'Sconosciuto',
      },
      unknownOperator: 'Operatore sconosciuto',
    },
    header: {
      scoreLabel: 'Punteggio TP',
      scoreTooltip: 'Punteggio complessivo di accessibilità dei trasporti basato su trasporto pubblico, accesso stradale e opzioni di mobilità attiva',
      subtitle: "Analisi completa delle infrastrutture di trasporto e dell'accessibilità",
      title: 'Trasporti & Accesso',
    },
    overview: {
      class: 'Classe',
      keyMetrics: 'Metriche chiave',
      metrics: {
        cyclingRoutes: {
          subtext: 'Nel raggio di 2km',
          title: 'Percorsi ciclabili',
        },
        evCharging: {
          title: 'Ricarica VE',
        },
        highwayAccess: {
          title: 'Accesso autostrada',
        },
        mainRoad: {
          title: 'Strada principale',
        },
        nearestBusStop: {
          title: 'Fermata bus più vicina',
        },
        nearestTrainStation: {
          title: 'Stazione ferroviaria più vicina',
        },
        ptQualityClass: {
          title: 'Classe qualità TP',
        },
        stopsWithin500m: {
          subtext: 'Fermate del trasporto pubblico',
          title: 'Fermate entro 500m',
        },
      },
    },
    publicTransport: {
      everyMinutes_one: 'ogni minuto',
      everyMinutes_other: 'ogni {{minutes}} min',
      metrics: {
        busStops: {
          title: 'Fermate bus',
        },
        qualityClass: {
          none: 'Nessuna classe di qualità',
          title: 'Classe di qualità',
        },
        stopsUnder500m: {
          title: 'Fermate < 500m',
        },
        totalStops1km: {
          title: 'Fermate totali (1km)',
        },
        trainStations: {
          title: 'Stazioni ferroviarie',
        },
        tramStops: {
          title: 'Fermate tram',
        },
      },
      nearbyStops: 'Fermate vicine',
      noStopsFound: 'Nessuna fermata del trasporto pubblico trovata entro 1,5km',
      overview: 'Panoramica trasporto pubblico',
      stopTypes: {
        bus: 'Bus',
        other: 'Altro',
        train: 'Treno',
        tram: 'Tram',
      },
      unknownOperator: 'Operatore sconosciuto',
      unknownStop: 'Fermata sconosciuta',
    },
    scores: {
      activeMobility: {
        description: "Valuta le infrastrutture pedonali, ciclabili e le opzioni di mobilità elettrica (stazioni di ricarica, bike-sharing) attorno all'immobile.",
        title: 'Mobilità attiva',
        tooltip: {
          shortDescription: 'Punteggio di accessibilità della mobilità attiva',
        },
      },
      common: {
        calculation: 'Media ponderata di più fattori',
        importance: 'Punteggi più alti indicano una migliore accessibilità',
        outOf100: '/ 100',
        source: 'Swiss Geo Admin e Mapbox APIs',
      },
      details: {
        cycling: 'Ciclismo',
        diversity: 'Diversità',
        eMobility: 'E-Mobilità',
        frequency: 'Frequenza',
        highwayAccess: 'Accesso autostrada',
        mainRoadDistance: 'Distanza strada principale',
        proximity: 'Prossimità',
      },
      publicTransport: {
        title: 'Trasporto pubblico',
        tooltip: {
          shortDescription: 'Punteggio di accessibilità del trasporto pubblico',
        },
      },
      qualityClassDescriptions: {
        A: 'Ottimo collegamento ai trasporti pubblici',
        B: 'Buon collegamento ai trasporti pubblici',
        C: 'Collegamento moderato ai trasporti pubblici',
        D: 'Collegamento base ai trasporti pubblici',
        E: 'Collegamento limitato ai trasporti pubblici',
        F: 'Scarso o nessun collegamento ai trasporti pubblici',
        unknown: 'Nessun dato disponibile',
      },
      qualityClassLabels: {
        A: 'Eccellente',
        B: 'Buono',
        C: 'Moderato',
        D: 'Base',
        E: 'Limitato',
        F: 'Scarso',
        unknown: 'Sconosciuto',
      },
      roadAccess: {
        title: 'Accesso stradale',
        tooltip: {
          shortDescription: 'Punteggio di accessibilità stradale',
        },
      },
      scoreLabels: {
        basic: 'Base',
        excellent: 'Eccellente',
        good: 'Buono',
        limited: 'Limitato',
        moderate: 'Moderato',
        poor: 'Scarso',
        unknown: 'Sconosciuto',
      },
    },
    states: {
      error: 'Impossibile caricare i dati di trasporto. Riprova.',
      loading: 'Caricamento dati trasporto...',
      noData: 'Nessun dato di trasporto disponibile',
    },
    tabs: {
      evCharging: 'Ricarica VE',
      overview: 'Panoramica',
      publicTransport: 'Trasporto pubblico',
    },
    units: {
      kilometers: 'km',
      kw: 'kW',
      meters: 'm',
      na: 'N/D',
    },
  },
  valuations: {
    chart: {
      estimated_value: 'Valore stimato',
      final_value: 'Valore finale',
      hide_from_chart: 'Nascondi dal grafico',
      range: 'Range',
      show_in_chart: 'Mostra nel grafico',
      value: 'Valore',
      value_range: 'Range di valore',
      variance: 'Varianza',
    },
    confidence: {
      high: 'Alto',
      high_confidence: 'Alta fiducia',
      low: 'Basso',
      low_confidence: 'Bassa fiducia',
      medium: 'Medio',
      medium_confidence: 'Media fiducia',
    },
    fields: {
      automated_valuation: 'Valutazione automatizzata',
      average_estimate: 'Stima media',
      avm: 'AVM',
      building_year: 'Anno di costruzione',
      confidence_level: 'Livello di fiducia',
      confidence_score: 'Punteggio di fiducia',
      conservative: 'Conservativo',
      conservative_estimate: 'Stima conservativa',
      currency: 'Valuta',
      data_range: 'Range dati',
      deal_type: 'Tipo di transazione',
      listings_count: 'Numero di annunci',
      living_area: 'Superficie abitabile',
      market_value_type: 'Tipo di valore di mercato',
      method: 'Metodo',
      model_version: 'Versione modello',
      number_of_rooms: 'Numero di stanze',
      optimistic: 'Ottimistico',
      optimistic_estimate: 'Stima ottimistica',
      price_per_sqm: 'Prezzo al m²',
      property_type: 'Tipo di proprietà',
      scenario: 'Scenario',
      status: 'Stato',
      value_before_correction: 'Valore prima della correzione',
    },
    loading: 'Caricamento valutazioni...',
    no_data: 'Nessun dato di valutazione disponibile',
    no_valuations: 'Nessuna valutazione disponibile',
    providers: {
      manual: {
        name: 'Valutazione personalizzata',
      },
      popety_io: {
        description: "Valutazione automatizzata basata sull'algoritmo proprietario di Popety.io che analizza le caratteristiche della proprietà, le transazioni di mercato recenti e i fattori specifici della posizione.",
        name: 'Valutazione Popety.io',
      },
      pricehubble: {
        description: 'Valutazione automatizzata utilizzando il metodo AVM di PriceHubble basato su algoritmi di machine learning e dati di mercato completi.',
        name: 'Valutazione PriceHubble',
      },
      wuest_partner: {
        conservative_description: 'Valutazione automatizzata conservativa utilizzando la metodologia Wüest Partner.',
        description: 'Valutazione automatizzata utilizzando la metodologia Wüest Partner con range di mercato da scenari conservativi a ottimistici.',
        name: 'Valutazione Wüest Partner',
        optimistic_description: 'Valutazione automatizzata ottimistica utilizzando la metodologia Wüest Partner.',
      },
    },
  },
  zoning: {
    buildable: 'Edificabile',
    cancel: 'Annulla',
    developingArea: 'Area di sviluppo',
    documents: {
      clearSearchAriaLabel: 'Cancella ricerca',
      documentTypes: {
        map: 'Mappa',
        rule: 'Regolamento',
      },
      important: 'Importante',
      loading: 'Caricamento documenti...',
      modalTitle: 'Documenti di zona',
      noDocuments: 'Nessun documento disponibile',
      noDocumentSelected: 'Nessun documento selezionato',
      noPreviewAvailable: 'Anteprima non disponibile',
      noPreviewHint: 'Questo documento non ha un URL di anteprima PDF disponibile',
      searchAriaLabel: 'Cerca documenti',
      searchPlaceholder: 'Cerca documenti...',
      selectDocumentHint: 'Seleziona un documento dalla lista per visualizzarne il contenuto',
      sourceLabels: {
        country: 'Federale',
        lup: 'Piano comunale',
        lupa: 'Piano locale',
        lupc: 'Piano cantonale',
        lupo: 'Piano di sovrapposizione',
        region: 'Cantonale',
      },
      sourceTitles: {
        country: 'Documenti federali (Svizzera)',
        lup: 'Documenti del piano comunale',
        lupa: 'Documenti del piano locale',
        lupc: 'Documenti del piano cantonale',
        lupo: 'Documenti del piano di sovrapposizione',
        region: 'Documenti cantonali',
      },
      title: 'Documenti',
      view: 'Visualizza',
    },
    edit: 'Modifica',
    header: {
      abrogated: 'Abrogato',
      adopted: 'Adottato',
      buildingArea: 'Area edificabile',
      constructionArrangement: 'Disposizione costruttiva',
      constructionArrangementValues: {
        C: 'Contiguo',
        'C / NC': 'Contiguo / Non contiguo',
        NC: 'Non contiguo',
      },
      nonBuildingArea: 'Area non edificabile',
      plotCoverage: 'della parcella',
      purpose: 'Scopo',
    },
    legalNotice: {
      blackText: 'Il testo nero indica valori esatti estratti direttamente dal PGA o dal registro fondiario.',
      blueText: 'Il testo blu indica valori stimati calcolati dagli algoritmi di PROPETY.IO.',
      disclaimer: 'Sebbene ci sforziamo di fornire i dati più accurati possibili, tutte le informazioni dovrebbero essere verificate indipendentemente. Si prega di consultare i documenti ufficiali e contattare il dipartimento di pianificazione del comune interessato per una conferma ufficiale.',
      greenText: 'Il testo verde indica valori modificati da te.',
      title: 'Fonti dei dati:',
    },
    legend: {
      agreement: {
        conflict: 'Fonti in conflitto',
        conflictNote: '(valore barrato = fonte non selezionata)',
        identical: 'Fonti identiche',
        title: 'Accordo delle fonti',
        unique: 'Fonte unica',
      },
      authorizedValues: {
        clickForDetails: 'Clicca per i dettagli',
        notAvailable: 'Non disponibile',
        title: 'Valori autorizzati',
      },
      difference: {
        exceeded: 'Superato',
        remaining: 'Potenziale rimanente',
        title: 'Differenza',
      },
      sources: {
        algorithm: 'Stima algoritmica',
        geoportal: 'Geoportale ufficiale',
        manual: 'Sostituito manualmente',
        regulation: 'Estratto dal regolamento',
        title: 'Fonti dei dati',
        userEdit: "Sostituito dall'utente",
      },
      title: 'Legenda',
    },
    messages: {
      error: 'Impossibile caricare i dati di zonizzazione',
      loading: 'Caricamento dati di zonizzazione...',
      noData: 'Nessun dato di zonizzazione disponibile per questo terreno',
      noZonesForType: 'Nessuna zona trovata per questo tipo',
      sectionDescription: 'Regolamenti di zonizzazione e potenziale di sviluppo per questa parcella',
    },
    metricLabels: {
      altitude: 'Altitudine',
      atticFloors: 'Piani mansardati',
      bigSetback: 'Grande distanza',
      buildingDepth: "Profondità dell'edificio",
      commercialRatio: 'Rapporto commerciale',
      constructionArrangement: 'Disposizione costruttiva',
      cos: 'Coefficiente di occupazione (C.o.)',
      cus: 'Coefficiente di sfruttamento (C.s.)',
      density: 'Densità',
      distanceLimit: 'Limite di distanza',
      greenRatio: 'Rapporto verde',
      heightWithoutRoof: 'Altezza senza tetto',
      ibus: 'Indice lordo di sfruttamento (I.l.s.)',
      im: 'Indice di massa (I.m.)',
      ios: 'Indice di occupazione (I.o.)',
      ius: 'Indice di sfruttamento (I.s.)',
      livingRatio: 'Rapporto abitativo',
      mainFloors: 'Piani principali',
      maxLength: 'Lunghezza max',
      noiseSensitivityLevel: 'Livello di sensibilità al rumore',
      numberOfUnits: 'Numero di unità',
      officeRatio: 'Rapporto uffici',
      openSpaceRatio: 'Rapporto spazio aperto',
      roofHeight: 'Altezza del tetto',
      roofSlope: 'Pendenza del tetto',
      smallSetback: 'Piccola distanza',
      totalFloors: 'Piani totali',
      totalHeight: 'Altezza totale',
      undergroundFloors: 'Piani interrati',
      vbr: 'Volume edilizio di riferimento (V.e.r.)',
    },
    metrics: {
      authorised: 'Autorizzato',
      current: 'Attuale',
      determiningBuiltArea: 'Superficie edificata determinante (S.e.d.)',
      determiningBuiltAreaInfo: 'Superficie edificata determinante',
      determiningFloorArea: 'Superficie di piano determinante (S.p.d.)',
      determiningFloorAreaInfo: 'Superficie di piano determinante',
      determiningSurfaceArea: 'Superficie di terreno determinante (S.t.d.)',
      difference: 'Differenza',
      landOccupationIndex: 'Indice di occupazione (I.o.)',
      landOccupationIndexInfo: 'Indice di occupazione',
      landUseIndex: 'Indice di sfruttamento (I.s.)',
      landUseIndexInfo: 'Indice di sfruttamento',
    },
    metricsTable: {
      confirmReset: 'Sei sicuro di voler ripristinare tutti i valori predefiniti? Questa azione non può essere annullata.',
      derivedSurfaces: {
        builtArea: 'Superficie edificata (S.e.)',
        builtAreaDesc: 'Superficie edificata',
        builtVolume: 'Volume edilizio di riferimento (V.e.r.)',
        builtVolumeDesc: 'Volume edilizio di riferimento',
        determiningBuiltArea: 'Superficie edificata determinante (S.e.d.)',
        determiningBuiltAreaDesc: 'Superficie edificata determinante',
        determiningFloorArea: 'Superficie di piano determinante (S.p.d.)',
        determiningFloorAreaDesc: 'Superficie di piano determinante',
        floorArea: 'Superficie di piano (S.p.)',
        floorAreaDesc: 'Superficie di piano',
        grossUsefulFloorArea: 'Superficie utile lorda (S.u.l.)',
        grossUsefulFloorAreaDesc: 'Superficie utile lorda',
      },
      editAuthorizedValues: 'Modifica valori autorizzati',
      groups: {
        environmental: 'AMBIENTALE',
        floors: 'PIANI',
        heights: 'ALTEZZE',
        other: 'ALTRO',
        setbacks: 'DISTANZE & DIMENSIONI',
        usageRatios: 'RAPPORTI DI UTILIZZO',
      },
      headers: {
        authorized: 'Autorizzato',
        current: 'Attuale',
        difference: 'Differenza',
        indices: 'Indici',
      },
      noneOption: 'Nessuno (nascondi questa metrica)',
      resetToDefault: 'Ripristina predefiniti',
      saveChanges: 'Salva modifiche',
      title: 'Metriche di zonizzazione',
      unitLabels: {
        floors: 'piani',
        units: 'unità',
      },
    },
    metricsTitle: 'Superfici e Indici',
    parameters: {
      limitDistances: 'Distanze limite',
      maxFloor: 'Piano max',
      maxHeight: 'Altezza max',
      noiseSensibilityLevel: 'Livello di sensibilità al rumore',
    },
    planDetails: {
      affectationName: 'Nome di destinazione',
      part: 'Parte',
      planName: 'Nome del piano',
      planType: 'Tipo di piano',
    },
    progressBar: {
      authorized: 'Autorizzato',
      available: 'Disponibile',
      currentSituation: 'Situazione attuale',
      remainingPotential: 'Potenziale rimanente',
      used: 'Utilizzato',
      utilization: 'Utilizzo',
    },
    purpose: 'Scopo',
    save: 'Salva',
    sourceLabels: {
      estimate: 'Stimato',
      geoportal: 'Geoportale',
      llm: 'Generato da IA',
      manual: 'Manuale',
      old: 'Legacy',
    },
    specialPlans: 'Piano(i) speciale(i)',
    status: {
      current: 'In vigore',
      future: 'Futuro',
      past: 'Passato',
    },
    subtitle: 'Regolamenti di zonizzazione attuali e potenziale di sviluppo per',
    title: 'Zonizzazione e Regole',
    underExploited: 'Sottosfruttato',
    underExploitedInfo: 'Calcolo basato su un indice di sfruttamento informato',
    underExploitedScore: 'Punteggio sottosfruttato',
    unknownZone: 'Zona sconosciuta',
    viewDocuments: 'Visualizza documenti',
    zoneDescriptions: {
      cantonal: 'Regolamenti di zonizzazione cantonali (PAC, Kantonaler Nutzungsplan) stabiliti dalle autorità regionali. Queste regole hanno la precedenza assoluta su tutti i piani comunali e definiscono vincoli di sviluppo generali come aree protette, corridoi infrastrutturali regionali e interessi cantonali.',
      general: 'Zonizzazione comunale di base (PGA, PAL, BZO, Nutzungszonenplan) che stabilisce la categoria di uso del suolo fondamentale per questa parcella, definendo se è destinata a uso residenziale, commerciale, industriale, agricolo o se è una zona non edificabile.',
      local: "Piani di sviluppo di quartiere dettagliati (PQ, PLQ, Quartierplan, Gestaltungsplan) che specificano requisiti di costruzione precisi, incluso il posizionamento degli edifici, le dimensioni, gli accessi e le linee guida di progettazione per quartieri specifici all'interno del comune.",
      partial: 'Zone di sovrapposizione speciali (PPA, Sondernutzungsplan, zone I.l.s.) che applicano restrizioni o modifiche aggiuntive alla zonizzazione base. Queste possono includere protezione del patrimonio, rapporti di densità modificati, vincoli ambientali o requisiti di sviluppo specifici.',
    },
    zonePriorityLabels: {
      cantonal: 'Autorità cantonale - Priorità assoluta',
      general: 'Zonizzazione base - Uso fondamentale del suolo',
      local: 'Pianificazione dettagliata - Regole di quartiere',
      partial: 'Zone speciali - Restrizioni aggiuntive',
    },
    zoneTypes: {
      cantonal: 'Cantonale',
      general: 'Comunale',
      local: 'Locale',
      partial: 'Parziale',
    },
  },
} satisfies AppTranslations
